webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	var _angular = __webpack_require__(10);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _main = __webpack_require__(11);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Importing external angular
	_angular2.default.element(document).ready(function () {
	  // IF IE11 timeout... to catch painting issues
	  if (window.navigator.userAgent.indexOf('Trident/7.0') >= 0) {
	    window.setTimeout(bootStrap, 100);
	  } else {
	    bootStrap();
	  }
	});
	
	// Importing the datacenter app
	// Importing aggregated styles
	
	
	function bootStrap() {
	  _angular2.default.bootstrap(document.querySelector('[kff-datacenter]'), [_main2.default.name], { strictDi: true });
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/css-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/autoprefixer-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/sass-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/app/styles/main.scss", function() {
			var newContent = require("!!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/css-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/autoprefixer-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/sass-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/app/styles/main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	__webpack_require__(5)(exports, __webpack_require__(6), "");
	__webpack_require__(5)(exports, __webpack_require__(7), "");
	__webpack_require__(5)(exports, __webpack_require__(8), "");
	exports.push([module.id, "[kff-datacenter] [datacenter-refine-distributions] .check-boxes{position:relative;padding-top:35px!important}[kff-datacenter] [datacenter-refine-distributions] .check-boxes .clear-selections{right:20px}[kff-datacenter] .clear-selections{cursor:pointer;float:right;color:#1a3863;font-size:10px;position:absolute;top:0;right:0}[kff-datacenter] .check-boxes-dropdown-scroller{max-height:9999px;transition:all 300ms ease}[kff-datacenter] .check-boxes-dropdown-scroller.ng-hide-add.ng-hide-add-active,[kff-datacenter] .check-boxes-dropdown-scroller.ng-hide-remove{max-height:0;overflow:hidden}[kff-datacenter] .check-boxes-dropdown-scroller.ng-hide-add,[kff-datacenter] .check-boxes-dropdown-scroller.ng-hide-remove.ng-hide-remove-active{max-height:9999px}[kff-datacenter] .check-boxes-dropdown-scroller.ng-hide-add{overflow:auto}.ag-datacenter{color:#000;line-height:20px}.ag-datacenter div{color:inherit;font:inherit;line-height:inherit}.ag-datacenter img{border:0;vertical-align:middle}.ag-datacenter div.ag-root{font:13px/20px \"Source Sans Pro\",helvetica,sans-serif}.ag-datacenter .ag-scrolls .ag-header-container,.ag-datacenter .ag-scrolls .ag-row,.ag-datacenter .ag-cell,.ag-datacenter .ag-no-scrolls .ag-header-container{white-space:normal}.ag-datacenter .ag-cell{background:#fff;border-right:1px solid #ccc;padding:5px}.ag-datacenter .ag-cell.ag-cell-no-focus{border-bottom:1px solid #ccc}.ag-datacenter .ag-cell.ag-cell-first-right-pinned{border-left:1px solid #ccc}.ag-datacenter .ag-cell.ag-cell-last-left-pinned{border-right:1px solid #ccc}.ag-datacenter .wrapup .ag-cell{color:#464646;background-color:#EFEFEF;font-weight:700}.ag-datacenter .multiline .ag-cell{white-space:normal}.ag-datacenter .ag-pinned-left-cols-container{border-left:1px solid #ccc}.ag-datacenter div.ag-header,.ag-datacenter div.ag-header-container{border-left:1px solid #ccc;color:#fff;font:700 14px/20px \"Source Sans Pro\",helvetica,sans-serif!important}.ag-datacenter .ag-header-container{position:relative}.ag-datacenter .ag-filter-icon{display:none}.ag-datacenter .ag-header-cell,.ag-datacenter .ag-header-group-cell{background:#024f88;border-right:1px solid #ccc;border-top:1px solid #ccc}.ag-datacenter .ag-header-cell.ag-header-group-cell-with-group,.ag-datacenter .ag-header-group-cell.ag-header-group-cell-with-group{border-bottom:1px solid #ccc}.ag-datacenter .ag-header-container .ag-header-row:nth-child(2) .ag-header-cell,.ag-datacenter .ag-pinned-left-header .ag-header-row:nth-child(2) .ag-header-cell{border-top:none}.ag-datacenter .ag-header-cell-label{box-sizing:border-box;cursor:pointer;height:100%;padding:15px 20px 0 8px;position:absolute;width:100%}.ag-datacenter .ag-header-cell-text{bottom:5px;left:8px;line-height:20px;position:absolute;width:calc(100% - 30px)}.ag-datacenter .ag-header-group-cell-label{line-height:20px;padding:5px 8px;text-align:center}.ag-datacenter .ag-header-cell-menu-button{display:none}.ag-datacenter .ag-pinned-left-header{border-right:1px solid #ccc}.ag-datacenter .ag-pinned-right-header{border-left:1px solid #ccc}.ag-datacenter .ag-header-icon{position:absolute;content:'';top:auto;bottom:16px;height:0;width:0;right:5px;border-left:4px solid transparent;border-right:4px solid transparent}.ag-datacenter .ag-header-icon span{display:block}.ag-datacenter .ag-header-icon span:after{position:absolute;content:'';top:8px;left:-4px;height:0;width:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:6px solid #959595}.ag-datacenter .ag-header-icon.ag-sort-ascending-icon{border-bottom:6px solid #de5a02}.ag-datacenter .ag-header-icon.ag-sort-descending-icon{border-bottom:6px solid #959595}.ag-datacenter .ag-header-icon.ag-sort-descending-icon span:after{border-top:6px solid #de5a02}.ag-datacenter .ag-header-icon.ag-sort-none-icon{border-bottom:6px solid #959595}.ag-datacenter .ag-body{background-color:#fff}.ag-datacenter .ag-overlay-loading-wrapper{background-color:rgba(255,255,255,.5)}.ag-datacenter .ag-overlay-loading-center{color:#000}.ag-datacenter .ag-overlay-loading-center,.ag-datacenter .ag-overlay-no-rows-center{background-color:#fff;border:1px solid #ccc;border-radius:10px;padding:10px}.ag-datacenter .ag-scroll-shadow-top,.ag-datacenter .ag-scroll-shadow-bottom{height:10px;position:absolute;width:100%}.ag-datacenter .ag-scroll-shadow-left,.ag-datacenter .ag-scroll-shadow-right{height:100%;position:absolute;top:0;width:10px}.ag-datacenter .ag-scroll-shadow-left{box-shadow:8px 0 10px -4px rgba(0,0,0,.25)}.ag-datacenter .ag-scroll-shadow-right{right:-10px;box-shadow:-8px 0 10px -4px rgba(0,0,0,.25)}.ag-datacenter .ag-scroll-shadow-top{box-shadow:0 8px 10px -4px rgba(0,0,0,.25);top:0}.ag-datacenter .ag-scroll-shadow-bottom{bottom:-10px;box-shadow:0 -8px 10px -4px rgba(0,0,0,.25)}[kff-datacenter]{position:relative}[kff-datacenter] .indicator-start-wrapper{display:block}[kff-datacenter] .box.full-post table tbody tr td{padding:5px 10px}[kff-datacenter] .timeframe{margin-top:-25px;padding-left:25px}[kff-datacenter] .column-selector{display:block;width:100%}", ""]);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = function() {
		var list = [];
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
		return list;
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = function(list, importedList, media) {
		for(var i = 0; i < importedList.length; i++) {
			var item = importedList[i];
			if(media && !item[2])
				item[2] = media;
			else if(media) {
				item[2] = "(" + item[2] + ") and (" + media + ")";
			}
			list.push(item);
		}
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	exports.push([module.id, "div.datamaps-legend{left:0;width:100%;padding:25px 25px 0;box-sizing:border-box;display:block;clear:both}div.datamaps-legend .key{float:left;list-style:none;width:25%;display:block;padding:0 10px 0 30px;position:relative;box-sizing:border-box;font-size:12px;font-weight:700;font-family:Arial,Helvetica,sans-serif}div.datamaps-legend .data-icon{height:20px;width:20px;top:-1px;left:0;position:absolute}div.datamaps-legend .data-background{height:20px;width:20px;top:2px;left:3px;position:absolute;background:#e7e7e7}", ""]);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	exports.push([module.id, ".chartWrap{margin:0;padding:0;overflow:hidden}.nvtooltip.with-3d-shadow,.with-3d-shadow .nvtooltip{-moz-box-shadow:0 5px 10px rgba(0,0,0,.2);-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px}.nvtooltip{width:200px;position:absolute;background-color:rgba(255,255,255,.85);border:1px solid #666;z-index:10000;padding:5px;font-family:Arial,Helvetica,sans-serif;font-size:12px;text-align:left;pointer-events:none;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.front-triangle,.back-triangle{position:absolute;display:block;margin:0 auto;right:0;left:0;width:0;height:0}.back-triangle{border-left:20px solid transparent;border-right:20px solid transparent;border-top:20px solid rgba(0,0,0,.2);z-index:9999;bottom:-20px}.front-triangle{border-left:19px solid transparent;border-right:19px solid transparent;border-top:19px solid rgba(255,255,255,1);z-index:10010;bottom:-18px}.nvtooltip.with-transitions,.with-transitions .nvtooltip{transition:opacity 250ms linear;-moz-transition:opacity 250ms linear;-webkit-transition:opacity 250ms linear;transition-delay:250ms;-moz-transition-delay:250ms;-webkit-transition-delay:250ms}.nvtooltip.x-nvtooltip,.nvtooltip.y-nvtooltip{padding:8px}.nvtooltip h3{margin:0;padding:4px 14px;line-height:18px;font-weight:400;background-color:rgba(247,247,247,.75);text-align:center;border-bottom:1px solid #ebebeb;-webkit-border-radius:5px 5px 0 0;-moz-border-radius:5px 5px 0 0;border-radius:5px 5px 0 0}.nvtooltip p{width:100%;word-wrap:break-word;margin:0;text-align:left}.nvtooltip span{display:inline-block;margin:2px 0}.nvtooltip table{margin:6px;border-spacing:0}.nvtooltip table td{padding:2px 9px 2px 0;vertical-align:middle}.nvtooltip table td.key{font-weight:400}.nvtooltip table td.value{text-align:right;font-weight:700}.nvtooltip table tr.highlight td{padding:1px 9px 1px 0;border-bottom-style:solid;border-bottom-width:1px;border-top-style:solid;border-top-width:1px}.nvtooltip table td.legend-color-guide div{width:8px;height:8px;vertical-align:middle}.nvtooltip .footer{padding:3px;text-align:center}.nvtooltip-pending-removal{position:absolute;pointer-events:none}svg{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;width:100%;overflow:visible}svg text{font:12px Arial}svg .title{font:700 14px Arial}.nvd3 .nv-background{fill:#fff;fill-opacity:0}.nvd3.nv-noData{font-size:18px;font-weight:700}.nv-brush .extent{fill-opacity:.125;shape-rendering:crispEdges}.nvd3 .nv-legend .nv-series{cursor:pointer}.nvd3 .nv-legend .disabled circle{fill-opacity:0}.nvd3 .nv-axis{pointer-events:none}.nvd3 .nv-axis path{fill:none;stroke:#e5e5e5;stroke-opacity:.75;shape-rendering:crispEdges}.nvd3 .nv-axis path.domain{stroke-opacity:.75}.nvd3 .nv-axis.nv-x path.domain{stroke-opacity:0}.nvd3 .nv-axis line{fill:none;stroke:#e5e5e5;shape-rendering:crispEdges}.nvd3 .nv-axis .zero line,.nvd3 .nv-axis line.zero{stroke-opacity:.75}.nvd3 .nv-axis .nv-axisMaxMin text{font-weight:700}.nvd3 .x .nv-axis .nv-axisMaxMin text,.nvd3 .x2 .nv-axis .nv-axisMaxMin text,.nvd3 .x3 .nv-axis .nv-axisMaxMin text{text-anchor:middle}.nv-brush .resize path{fill:#eee;stroke:#666}.nvd3 .nv-bars .negative rect{zfill:brown}.nvd3 .nv-bars rect{zfill:steelblue;fill-opacity:.75;transition:fill-opacity 250ms linear;-moz-transition:fill-opacity 250ms linear;-webkit-transition:fill-opacity 250ms linear}.nvd3 .nv-bars rect.hover{fill-opacity:1}.nvd3 .nv-bars .hover rect{fill:lightblue}.nvd3 .nv-bars text{fill:rgba(0,0,0,0)}.nvd3 .nv-bars .hover text{fill:rgba(0,0,0,1)}.nvd3 .nv-multibar .nv-groups rect,.nvd3 .nv-multibarHorizontal .nv-groups rect,.nvd3 .nv-discretebar .nv-groups rect{stroke-opacity:0;transition:fill-opacity 250ms linear;-moz-transition:fill-opacity 250ms linear;-webkit-transition:fill-opacity 250ms linear}.nvd3 .nv-multibar .nv-groups rect:hover,.nvd3 .nv-multibarHorizontal .nv-groups rect:hover,.nvd3 .nv-discretebar .nv-groups rect:hover{fill-opacity:1}.nvd3 .nv-discretebar .nv-groups text,.nvd3 .nv-multibarHorizontal .nv-groups text{font-weight:700;fill:rgba(0,0,0,1);stroke:rgba(0,0,0,0)}.nvd3.nv-pie path{transition:fill-opacity 250ms linear,stroke-width 250ms linear,stroke-opacity 250ms linear;-moz-transition:fill-opacity 250ms linear,stroke-width 250ms linear,stroke-opacity 250ms linear;-webkit-transition:fill-opacity 250ms linear,stroke-width 250ms linear,stroke-opacity 250ms linear}.nvd3.nv-pie .nv-slice text{stroke:#000;stroke-width:0}.nvd3.nv-pie path{stroke:#fff;stroke-width:1px;stroke-opacity:1}.nvd3.nv-pie .hover path{fill-opacity:.7}.nvd3.nv-pie .nv-label{pointer-events:none}.nvd3.nv-pie .nv-label rect{fill-opacity:0;stroke-opacity:0}.nvd3 .nv-groups path.nv-line{fill:none;stroke-width:1.5px}.nvd3 .nv-groups path.nv-line.nv-thin-line{stroke-width:1px}.nvd3 .nv-groups path.nv-area{stroke:none}.nvd3 .nv-line.hover path{stroke-width:6px}.nvd3.nv-line .nvd3.nv-scatter .nv-groups .nv-point{fill:#FFF;fill-opacity:1;stroke-width:2px}.nvd3.nv-scatter.nv-single-point .nv-groups .nv-point{stroke-opacity:.5!important}.with-transitions .nvd3 .nv-groups .nv-point{transition:stroke-width 250ms linear,stroke-opacity 250ms linear;-moz-transition:stroke-width 250ms linear,stroke-opacity 250ms linear;-webkit-transition:stroke-width 250ms linear,stroke-opacity 250ms linear}.nvd3.nv-scatter .nv-groups .nv-point.hover,.nvd3 .nv-groups .nv-point.hover{stroke-width:9px!important;fill-opacity:.95!important;stroke-opacity:.95!important}.nvd3 .nv-point-paths path{stroke:#aaa;stroke-opacity:0;fill:#eee;fill-opacity:0}.nvd3 .nv-indexLine{cursor:ew-resize}.nvd3 .nv-distribution{pointer-events:none}.nvd3 .nv-scatter .nv-point.hover{fill-opacity:1}.nvd3.nv-stackedarea path.nv-area{fill-opacity:.7;stroke-opacity:0;transition:fill-opacity 250ms linear,stroke-opacity 250ms linear;-moz-transition:fill-opacity 250ms linear,stroke-opacity 250ms linear;-webkit-transition:fill-opacity 250ms linear,stroke-opacity 250ms linear}.nvd3.nv-stackedarea path.nv-area.hover{fill-opacity:.9}.nvd3.nv-stackedarea .nv-groups .nv-point{stroke-opacity:0;fill-opacity:0}.nvd3.nv-linePlusBar .nv-bar rect{fill-opacity:.75}.nvd3.nv-linePlusBar .nv-bar rect:hover{fill-opacity:1}.nvd3.nv-bullet{font:10px sans-serif}.nvd3.nv-bullet .nv-measure{fill-opacity:.8}.nvd3.nv-bullet .nv-measure:hover{fill-opacity:1}.nvd3.nv-bullet .nv-marker{stroke:#000;stroke-width:2px}.nvd3.nv-bullet .nv-markerTriangle{stroke:#000;fill:#fff;stroke-width:1.5px}.nvd3.nv-bullet .nv-tick line{stroke:#666;stroke-width:.5px}.nvd3.nv-bullet .nv-range.nv-s0{fill:#eee}.nvd3.nv-bullet .nv-range.nv-s1{fill:#ddd}.nvd3.nv-bullet .nv-range.nv-s2{fill:#ccc}.nvd3.nv-bullet .nv-title{font-size:14px;font-weight:700}.nvd3.nv-bullet .nv-subtitle{fill:#999}.nvd3.nv-bullet .nv-range{fill:#bababa;fill-opacity:.4}.nvd3.nv-bullet .nv-range:hover{fill-opacity:.7}.nvd3.nv-sparkline path{fill:none}.nvd3.nv-sparklineplus g.nv-hoverValue{pointer-events:none}.nvd3.nv-sparklineplus .nv-hoverValue line{stroke:#333;stroke-width:1.5px}.nvd3.nv-sparklineplus,.nvd3.nv-sparklineplus g{pointer-events:all}.nvd3 .nv-hoverArea{fill-opacity:0;stroke-opacity:0}.nvd3.nv-sparklineplus .nv-xValue,.nvd3.nv-sparklineplus .nv-yValue{stroke-width:0;font-size:.9em;font-weight:400}.nvd3.nv-sparklineplus .nv-yValue{stroke:#f66}.nvd3.nv-sparklineplus .nv-maxValue{stroke:#2ca02c;fill:#2ca02c}.nvd3.nv-sparklineplus .nv-minValue{stroke:#d62728;fill:#d62728}.nvd3.nv-sparklineplus .nv-currentValue{font-weight:700;font-size:1.1em}.nvd3.nv-ohlcBar .nv-ticks .nv-tick{stroke-width:2px}.nvd3.nv-ohlcBar .nv-ticks .nv-tick.hover{stroke-width:4px}.nvd3.nv-ohlcBar .nv-ticks .nv-tick.positive{stroke:#2ca02c}.nvd3.nv-ohlcBar .nv-ticks .nv-tick.negative{stroke:#d62728}.nvd3.nv-historicalStockChart .nv-axis .nv-axislabel{font-weight:700}.nvd3.nv-historicalStockChart .nv-dragTarget{fill-opacity:0;stroke:none;cursor:move}.nvd3 .nv-brush .extent{fill-opacity:0!important}.nvd3 .nv-brushBackground rect{stroke:#000;stroke-width:.4;fill:#fff;fill-opacity:.7}.nvd3.nv-indentedtree .name{margin-left:5px}.nvd3.nv-indentedtree .clickable{color:#08C;cursor:pointer}.nvd3.nv-indentedtree span.clickable:hover{color:#005580;text-decoration:underline}.nvd3.nv-indentedtree .nv-childrenCount{display:inline-block;margin-left:5px}.nvd3.nv-indentedtree .nv-treeicon,.nvd3.nv-indentedtree .nv-treeicon.nv-folded{cursor:pointer}.nvd3 .background path{fill:none;stroke:#ccc;stroke-opacity:.4;shape-rendering:crispEdges}.nvd3 .foreground path{fill:none;stroke:steelblue;stroke-opacity:.7}.nvd3 .brush .extent{fill-opacity:.3;stroke:#fff;shape-rendering:crispEdges}.nvd3 .axis line,.axis path{fill:none;stroke:#000;shape-rendering:crispEdges}.nvd3 .axis text{text-shadow:0 1px 0 #fff}.nvd3 .nv-interactiveGuideLine{pointer-events:none}.nvd3 line.nv-guideline{stroke:#ccc}", ""]);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	exports.push([module.id, "ag-grid-ng2{display:inline-block}.ag-select-agg-func-popup{position:absolute}.ag-body-no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-root{position:relative;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.ag-font-style{cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-no-scrolls{white-space:nowrap;display:inline-block}.ag-scrolls{height:100%}.ag-popup-backdrop{position:fixed;left:0;top:0;width:100%;height:100%}.ag-header{position:absolute;top:0;left:0;white-space:nowrap;width:100%}.ag-header,.ag-pinned-left-header{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.ag-pinned-left-header{float:left;display:inline-block;height:100%}.ag-pinned-right-header{float:right;display:inline-block}.ag-pinned-right-header,.ag-header-viewport{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:hidden;height:100%}.ag-scrolls .ag-header-row{position:absolute}.ag-scrolls .ag-header-container{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;white-space:nowrap;height:100%}.ag-no-scrolls .ag-header-container{white-space:nowrap}.ag-header-overlay{display:block;position:absolute}.ag-header-cell{vertical-align:bottom;text-align:center;display:inline-block;height:100%}.ag-header-cell,.ag-dnd-ghost{position:absolute;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.ag-dnd-ghost{font-size:14px;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;background:#e5e5e5;border:1px solid #000;cursor:move;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;padding:3px;line-height:1.4}.ag-dnd-ghost-icon{float:left;padding-left:2px;padding-right:2px}.ag-dnd-ghost-icon,.ag-dnd-ghost-label{display:inline-block}.ag-header-group-cell{height:100%;display:inline-block;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute}.ag-header-group-cell,.ag-header-group-cell-label,.ag-header-cell-label{-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden}.ag-header-cell-resize{height:100%;width:4px;float:right;cursor:col-resize}.ag-header-expand-icon{padding-left:4px}.ag-header-cell-menu-button{float:right}.ag-overlay-panel{display:table;width:100%;height:100%;pointer-events:none}.ag-overlay-wrapper{display:table-cell;vertical-align:middle;text-align:center}.ag-bl-overlay{pointer-events:none;position:absolute;height:100%;width:100%;top:0;left:0}.ag-bl-full-height{height:100%;overflow:auto;position:relative}.ag-bl-full-height-west{height:100%;float:left}.ag-bl-full-height-east{height:100%;float:right}.ag-bl-full-height-center{height:100%}.ag-bl-normal{height:100%;position:relative}.ag-bl-normal-center-row{height:100%;overflow:hidden}.ag-bl-normal-west{height:100%;float:left}.ag-bl-normal-east{height:100%;float:right}.ag-bl-normal-center{height:100%}.ag-bl-dont-fill{position:relative}.ag-body{height:100%;width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute}.ag-floating-top{position:absolute;left:0;width:100%;white-space:nowrap}.ag-floating-top,.ag-pinned-left-floating-top{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.ag-pinned-left-floating-top{float:left;display:inline-block;height:100%}.ag-pinned-right-floating-top{float:right;display:inline-block}.ag-pinned-right-floating-top,.ag-floating-top-viewport{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:hidden;height:100%}.ag-floating-top-container{position:relative}.ag-floating-top-container,.ag-floating-bottom{white-space:nowrap;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.ag-floating-bottom{position:absolute;left:0;width:100%;overflow:hidden}.ag-pinned-left-floating-bottom{float:left}.ag-pinned-left-floating-bottom,.ag-pinned-right-floating-bottom{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:inline-block;overflow:hidden;height:100%}.ag-pinned-right-floating-bottom{float:right}.ag-floating-bottom-viewport{overflow:hidden;height:100%}.ag-floating-bottom-viewport,.ag-floating-bottom-container{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.ag-floating-bottom-container{position:relative;white-space:nowrap}.ag-pinned-left-cols-viewport{float:left;overflow:hidden}.ag-pinned-left-cols-container{display:inline-block;position:relative}.ag-pinned-right-cols-viewport{float:right;overflow-x:hidden;overflow-y:auto}.ag-pinned-right-cols-container{display:inline-block;position:relative}.ag-body-viewport-wrapper{height:100%}.ag-body-viewport{overflow-x:auto;overflow-y:auto;height:100%}.ag-full-width-viewport{height:100%;width:100%;position:absolute;top:0;left:0;display:inline;pointer-events:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.ag-full-width-container{overflow:hidden;position:relative;width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{height:100%;width:100%;position:absolute;top:0;left:0;pointer-events:none;overflow:hidden;display:inline}.ag-full-width-row{pointer-events:all;overflow:hidden}.ag-scrolls .ag-body-container{position:relative;display:inline-block}.ag-scrolls .ag-row{white-space:nowrap;position:absolute;width:100%}.ag-no-scrolls .ag-row{position:relative}.ag-column-drop{width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.ag-column-drop-vertical .ag-column-drop-cell,.ag-column-drop-vertical .ag-column-drop-empty-message{display:block}.ag-column-drop-vertical .ag-column-drop-cell-button{float:right;line-height:16px}.ag-column-drop-horizontal,.ag-cell{white-space:nowrap}.ag-cell{display:inline-block;height:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;position:absolute}.ag-fade-out{opacity:1;-ms-filter:none;filter:none;margin-right:5px;-webkit-transition:opacity 3s,margin-right 3s;-moz-transition:opacity 3s,margin-right 3s;-o-transition:opacity 3s,margin-right 3s;-ms-transition:opacity 3s,margin-right 3s;transition:opacity 3s,margin-right 3s;-webkit-transition-timing-function:linear;-moz-transition-timing-function:linear;-o-transition-timing-function:linear;-ms-transition-timing-function:linear;transition-timing-function:linear}.ag-fade-out-end{opacity:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);margin-right:10px}.ag-cell-edit-input{width:100%;height:100%}.ag-group-cell-entire-row,.ag-footer-cell-entire-row{width:100%;display:inline-block;white-space:nowrap;height:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden}.ag-large .ag-root{font-size:20px}.ag-popup-editor,.ag-menu{position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-menu-column-select-wrapper{width:200px;height:300px;overflow:auto}.ag-menu-list{display:table;border-collapse:collapse}.ag-menu-option{display:table-row}.ag-menu-option-text,.ag-menu-option-shortcut,.ag-menu-option-icon,.ag-menu-option-popup-pointer{display:table-cell}.ag-menu-separator{display:table-row}.ag-menu-separator-cell{display:table-cell}.ag-virtual-list-viewport{overflow-x:auto;height:100%;width:100%}.ag-virtual-list-container{position:relative;overflow:hidden}.ag-rich-select{outline:none}.ag-rich-select-list,.ag-set-filter-list{width:200px;height:200px}.ag-set-filter-item{-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.ag-virtual-list-item{position:absolute;width:100%}.ag-filter-filter{width:170px;margin:4px}.ag-filter-select{width:110px;margin:4px 4px 0}.ag-no-vertical-scroll .ag-scrolls,.ag-no-vertical-scroll .ag-body,.ag-no-vertical-scroll .ag-body-viewport-wrapper,.ag-no-vertical-scroll .ag-body-viewport{height:unset}.ag-list-selection,.ag-tool-panel{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.ag-tool-panel{width:200px;height:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:auto}.ag-column-select-indent{display:inline-block}.ag-column-select-column{margin-left:14px;white-space:nowrap}.ag-column-select-column-group{white-space:nowrap}.ag-hidden{display:none}.ag-faded{opacity:.3;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30)}.ag-width-half{width:50%;display:inline-block}.ag-shake-left-to-right{-webkit-animation-name:ag-shake-left-to-right;-moz-animation-name:ag-shake-left-to-right;-o-animation-name:ag-shake-left-to-right;-ms-animation-name:ag-shake-left-to-right;animation-name:ag-shake-left-to-right;-webkit-animation-duration:.2s;-moz-animation-duration:.2s;-o-animation-duration:.2s;-ms-animation-duration:.2s;animation-duration:.2s;-webkit-animation-iteration-count:infinite;-moz-animation-iteration-count:infinite;-o-animation-iteration-count:infinite;-ms-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-direction:alternate;-moz-animation-direction:alternate;-o-animation-direction:alternate;-ms-animation-direction:alternate;animation-direction:alternate}@-moz-keyframes ag-shake-left-to-right{from{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}@-webkit-keyframes ag-shake-left-to-right{from{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}@-o-keyframes ag-shake-left-to-right{from{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}@keyframes ag-shake-left-to-right{from{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}", ""]);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isIE9 = memoize(function() {
			return /msie 9\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isIE9();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function () {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	function replaceText(source, id, replacement) {
		var boundaries = ["/** >>" + id + " **/", "/** " + id + "<< **/"];
		var start = source.lastIndexOf(boundaries[0]);
		var wrappedReplacement = replacement
			? (boundaries[0] + replacement + boundaries[1])
			: "";
		if (source.lastIndexOf(boundaries[0]) >= 0) {
			var end = source.lastIndexOf(boundaries[1]) + boundaries[1].length;
			return source.slice(0, start) + wrappedReplacement + source.slice(end);
		} else {
			return source + wrappedReplacement;
		}
	}
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(styleElement.styleSheet.cssText, index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap && typeof btoa === "function") {
			try {
				css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(JSON.stringify(sourceMap)) + " */";
				css = "@import url(\"data:text/css;base64," + btoa(css) + "\")";
			} catch(e) {}
		}
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(10);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _agGrid = __webpack_require__(12);
	
	var _agGrid2 = _interopRequireDefault(_agGrid);
	
	var _angularUiRouter = __webpack_require__(13);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ngRedux = __webpack_require__(14);
	
	var _ngRedux2 = _interopRequireDefault(_ngRedux);
	
	var _reduxUiRouter = __webpack_require__(54);
	
	var _reduxUiRouter2 = _interopRequireDefault(_reduxUiRouter);
	
	var _reduxConfig = __webpack_require__(67);
	
	var _reduxConfig2 = _interopRequireDefault(_reduxConfig);
	
	var _routeConfig = __webpack_require__(85);
	
	var _routeConfig2 = _interopRequireDefault(_routeConfig);
	
	var _datacenterWrapper = __webpack_require__(87);
	
	var _datacenterWrapper2 = _interopRequireDefault(_datacenterWrapper);
	
	var _services = __webpack_require__(151);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _directives = __webpack_require__(155);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	var _filters = __webpack_require__(107);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(192);
	
	// redux
	
	
	// config
	
	
	// wrapper directive
	
	
	_agGrid2.default.initialiseAgGridWithAngular1(_angular2.default);
	
	// core directives
	
	
	var mainModule = _angular2.default.module('datacenterMain', [_angularUiRouter2.default, _ngRedux2.default, _reduxUiRouter2.default, 'ngAnimate', 'ngSanitize', 'agGrid', _services2.default, _directives2.default, _filters2.default]);
	
	mainModule.directive('datacenterWrapper', _datacenterWrapper2.default);
	
	mainModule.config(['$locationProvider', function ($locationProvider) {
	  $locationProvider.hashPrefix('!');
	  $locationProvider.html5Mode({
	    enabled: true,
	    requireBase: false
	  });
	}]);
	
	mainModule.config((0, _routeConfig2.default)());
	
	mainModule.config(_reduxConfig2.default);
	
	mainModule.run();
	
	exports.default = mainModule;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = store;
	
	var _rootReducer = __webpack_require__(68);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	var _reduxThunk = __webpack_require__(84);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create the store with middlewares:
	 *
	 * redux-thunk: which allows us to do asyncronous things in the actions.
	 * ngUiRouter: intercepts route change methods from ui-router.
	 * devToolsExtension: use the chrome browser extension
	 */
	
	store.$inject = ['$ngReduxProvider'];
	function store($ngReduxProvider) {
	  $ngReduxProvider.createStoreWith(_rootReducer2.default, ['ngUiRouterMiddleware', _reduxThunk2.default], [window.devToolsExtension ? window.devToolsExtension() : function (fn) {
	    return fn;
	  }]);
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(19);
	
	var _reduxUiRouter = __webpack_require__(54);
	
	var _dataReducer = __webpack_require__(69);
	
	var _dataReducer2 = _interopRequireDefault(_dataReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// the built-in reducer for redux-ui-router
	exports.default = (0, _redux.combineReducers)({ router: _reduxUiRouter.router, data: _dataReducer2.default });
	
	// our custom data reducer for the data points
	/**
	 * Combine all reducers in this file and export the combined reducers.
	 */

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Reducers update a specific prop in the application state, by operating
	                                                                                                                                                                                                                                                                   * after the action which describes what to change.
	                                                                                                                                                                                                                                                                   * To add a new action, add it to the switch statement in the dataReducer function
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @example
	                                                                                                                                                                                                                                                                   * case NEW_ACTION_CONSTANT:
	                                                                                                                                                                                                                                                                   *   return assign({}, state, {
	                                                                                                                                                                                                                                                                   *     stateVariable: action.var,
	                                                                                                                                                                                                                                                                   *   });
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * To add a new reducer, add another file like this to the reducers folder, and
	                                                                                                                                                                                                                                                                   * add it in rootReducer.js.
	                                                                                                                                                                                                                                                                   */
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Assign the next id and add the item to data collection
	    case types.BUILD_DATA:
	      return buildSpreadsheetData(action.data.data, action.data.options);
	    default:
	      return state;
	  }
	};
	
	exports.buildSpreadsheetData = buildSpreadsheetData;
	
	var _constants = __webpack_require__(70);
	
	var types = _interopRequireWildcard(_constants);
	
	var _config = __webpack_require__(71);
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _transducers = __webpack_require__(73);
	
	var _columnFilters = __webpack_require__(78);
	
	var _columnFilters2 = _interopRequireDefault(_columnFilters);
	
	var _timeframeFilters = __webpack_require__(80);
	
	var _timeframeFilters2 = _interopRequireDefault(_timeframeFilters);
	
	var _dataviewFilters = __webpack_require__(81);
	
	var _dataviewFilters2 = _interopRequireDefault(_dataviewFilters);
	
	var _distributionFilters = __webpack_require__(82);
	
	var _distributionFilters2 = _interopRequireDefault(_distributionFilters);
	
	var _countyReducer = __webpack_require__(83);
	
	var _countyReducer2 = _interopRequireDefault(_countyReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Set up an initial state to hold data. Use count to assign ids so we can
	// remove items from the collection
	var initialState = {
	  items: [],
	  count: 0
	};
	
	function buildSpreadsheetData(data, options) {
	  if (data.geoDefinitions) {
	    return (0, _countyReducer2.default)(data);
	  }
	
	  var config = (0, _transducers.getConfig)(data);
	  var timeframes = (0, _timeframeFilters2.default)(data);
	
	  var _buildHeaders = (0, _transducers.buildHeaders)(data, config),
	      immutableHeaders = _buildHeaders.immutableHeaders,
	      immutableHeadersAll = _buildHeaders.immutableHeadersAll,
	      hasDataviews = _buildHeaders.hasDataviews;
	
	  var _getDatacenterDatavie = (0, _dataviewFilters2.default)(immutableHeaders, config, immutableHeadersAll),
	      immutableDataviews = _getDatacenterDatavie.immutableDataviews,
	      immutableDataviewsAll = _getDatacenterDatavie.immutableDataviewsAll;
	
	  var immutableData = buildData(data, immutableHeadersAll);
	
	  config = _mori2.default.assocIn(config, ['settings', 'globalSettings', 'hasDataviews'], hasDataviews);
	  if (timeframes.length < 2) {
	    config = _mori2.default.assocIn(config, ['globalRules', 'Graph'], false);
	  }
	
	  var _getDatacenterDistrib = (0, _distributionFilters2.default)(immutableHeaders, [], immutableHeadersAll),
	      immutableDistributions = _getDatacenterDistrib.immutableDistributions,
	      immutableDistributionsAll = _getDatacenterDistrib.immutableDistributionsAll;
	
	  var _getDatacenterParentC = (0, _columnFilters2.default)(data, config, options),
	      columns = _getDatacenterParentC.columns,
	      columnsAll = _getDatacenterParentC.columnsAll;
	
	  var metaData = Object.keys(immutableHeadersAll).reduce(function (acc, curr) {
	    return _extends(_defineProperty({}, curr, {
	      immutableHeaders: immutableHeadersAll[curr].immutableHeaders,
	      immutableDataviews: immutableDataviewsAll[curr].immutableDataviews,
	      immutableDistributions: immutableDistributionsAll[curr].immutableDistributions,
	      columns: columnsAll[curr]
	    }), acc);
	  }, {});
	
	  return {
	    config: config,
	    metaData: metaData,
	    immutableHeaders: immutableHeaders,
	    immutableData: immutableData,
	    immutableDataviews: immutableDataviews,
	    immutableDistributions: immutableDistributions,
	    // vanilla js objects for template binding
	    columns: columns,
	    timeframes: timeframes,
	    globalRules: _mori2.default.toJs(_mori2.default.get(config, 'globalRules', _mori2.default.hashMap())),
	    globalSettings: _mori2.default.toJs(_mori2.default.getIn(config, ['settings', 'globalSettings'], _mori2.default.hashMap())),
	    // TODO:  dist count for all sheets
	    distributionCount: _mori2.default.count(immutableDistributions)
	  };
	}
	
	/**
	 * ***************
	 * Sheets are transduced into an arrays of objects with complex keys
	 * so it's easier to filter by dataview and type
	 * @example
	 * [ 'js#{ "Location" "geography" }': 'Alaska', 'js#{ "Marketplace Type" "text"}': 'State' ]
	 * ***************
	 */
	function buildData(data, headersAll) {
	  // a set of header tuples to use as data keys
	  var headerMap = function headerMap(headerItems) {
	    return _mori2.default.mapcat(function (header) {
	      return _mori2.default.vector(_mori2.default.set(_mori2.default.get(header, 'headerGroup') === null ? [_mori2.default.get(header, 'characteristic'), _mori2.default.get(header, 'label')] : [_mori2.default.get(header, 'headerGroup'), _mori2.default.get(header, 'characteristic'),
	      // If label and char. are the same (ie. years - make the label unique)
	      // Label/Char will be same if Doc uses only Year values (2016, etc.)
	      // TODO: find a better way to handle this
	      _mori2.default.get(header, 'label') === _mori2.default.get(header, 'characteristic') ? '_' + _mori2.default.get(header, 'label') : _mori2.default.get(header, 'label')]));
	    }, headerItems);
	  };
	
	  return _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (sheet) {
	    return _mori2.default.set([_mori2.default.first(sheet), _mori2.default.map(function (row) {
	      return _mori2.default.zipmap(headerMap(getHeadersForSheet(headersAll, _mori2.default.first(sheet))),
	      // Pass through everything except cell values that are explicitly
	      // ints or floats. Everything else should be kept as a string.
	      _mori2.default.map(function (x) {
	        return (/^(-)?[\d]+(\.[\d]+)?[\s]?$/.test(x) ? parseFloat(x) : x
	        );
	      }, row));
	    }, _mori2.default.dropWhile(function (x) {
	      return !_mori2.default.first(x);
	    }, _mori2.default.first(_mori2.default.rest(sheet))))]);
	  },
	  // remove config sheet
	  _mori2.default.filter(function (x) {
	    return _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) === -1;
	  }, data)));
	}
	
	function getHeadersForSheet(headers, sheetTitle) {
	  var key = Object.keys(headers).filter(function (headerKey) {
	    return headerKey === sheetTitle;
	  })[0];
	
	  return headers[key].immutableHeaders;
	}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOADING_DATA = exports.LOADING_DATA = 'LOADING_DATA';
	var BUILD_DATA = exports.BUILD_DATA = 'BUILD_DATA';

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Setting up configuration constants
	 */
	
	// Values we need to parse the google docs
	var sheetParseConfig = exports.sheetParseConfig = {
	  configHeader: '1',
	  dataHeader: 'A',
	  configTitles: ['config', 'notes', 'sources'],
	  sourceTypes: ['notes', 'sources', 'definitions'],
	  headerTypes: ['characteristic', 'type'],
	  headerSymbols: {
	    'percent-unformatted': /\%|percent/,
	    'currency': /\$|USD|currency/
	  },
	  // These are special options on the config which apply to components at
	  // many levels regardless of context. For example, locked will change the
	  // behavior of table and filter rendering and the types of options that can
	  // be selected
	  globalRules: ['locked', 'graph', 'map', 'geomulti', 'context', 'map base column', 'link column', 'link target', 'related columns'],
	  // This serves as a reverse dictionary for data types, enabling look up and
	  // type assignment by alias
	  dataTypes: {
	    'text': ['urban area', 'name', 'zip code', 'city', 'county', 'msa'],
	    'year': ['year'],
	    'percent': ['% of us total', '% of fpl', 'percent change', '% change', 'mlr', 'ratio'],
	    'currency': ['income'],
	    'number': ['rate', 'net change', 'rank'],
	    'date-format': ['mm/dd/yyyy', 'mon dd, yyyy', 'month yyyy', 'month dd yyyy'],
	    'fiscal year': null,
	    'default': null,
	    'geography': ['state'],
	    'yes/no': null
	  }
	};
	
	// Defaults and special case configuration for Datacenter app
	var appDefault = exports.appDefault = {
	  distributionName: 'Characteristics',
	  hideMap: false,
	  hideGraph: false,
	  isLocked: false,
	  // Values which can be selected on their own as rows, and should be given
	  // checkboxes outside the fieldgroup list
	  specialWrapups: ['United States', 'World', 'All Urban Counties', 'All Rural Counties', 'All MSAs'],
	  // The values which are used to represent N/A, and the order in which
	  // they should appear when in the same collection
	  dataNotAvailable: ['*', '**', 'NSD', '(NSD)', 'NR', 'NA', '(NA)', 'N/A', '-', '--', ''],
	  // Territories, for categorization when sorting
	  kffTerritories: ['Puerto Rico', 'Virgin Islands', 'Guam', 'Northern Mariana Islands', 'American Samoa', 'Residence Unknown', 'Federated States of Micronesia', 'Marshall Islands', 'Republic of Palau', 'U.S. Virgin Islands'],
	  countyOrder: ['states', 'counties', 'msas', 'ma-regions', 'pdp-regions'],
	  wrapupOrder: ['united-states', 'world', 'all-urban-counties', 'all-rural-counties', 'all-msas', 'all-ma-regions', 'all-pdp-regions'],
	  normalizedKffTerritories: ['puerto-rico', 'virgin-islands', 'guam', 'northern-mariana-islands', 'american-samoa', 'residence-unknown', 'federated-states-of-micronesia', 'marshall-islands', 'republic-of-palau', 'us-virgin-islands'],
	  // Tests for a few different common row types
	  isSpecialGeo: /^MA\sRegion|PDP\sRegion/,
	  isStateCategory: /^All\s/,
	  isSummaryRow: /[\s+]?\(All\)[\s+]?$/,
	  decimalPlacesMap: {
	    10000: -4,
	    1000: -3,
	    100: -2,
	    10: -1,
	    1: 0,
	    0.1: 1,
	    0.01: 2,
	    0.001: 3,
	    0.0001: 4,
	    0.00001: 5,
	    0.000001: 6,
	    0.0000001: 7
	  },
	  // CSS for padding Table Header Cells
	  // We need to take this into account when wrapping header text
	  // right and left padding: 20 and 10, respectively
	  //
	  headerPadding: 30,
	
	  // CSS for padding Table Cells
	  // We need to take this into account when wrapping cell text
	  // right and left padding: 10 and 10, respectively
	  //
	  cellPadding: 20,
	
	  // Max number of natural breaks for map
	  maxBreaks: 4,
	
	  // For known data types, we want to sort descending first.
	  descSortFirst: ['number', 'percent', 'currency', 'year'],
	
	  defaultWidths: {
	    'text': {
	      'default': 225,
	      'narrow': 175,
	      'wide': 300
	    },
	    'year': {
	      'default': 80,
	      'narrow': 60,
	      'wide': 140
	    },
	    'percent': {
	      'default': 100,
	      'narrow': 75,
	      'wide': 150
	    },
	    'currency': {
	      'default': 140,
	      'narrow': 100,
	      'wide': 180
	    },
	    'number': {
	      'default': 140,
	      'narrow': 100,
	      'wide': 180
	    },
	    'date-format': {
	      'default': 100,
	      'narrow': 75,
	      'wide': 150
	    },
	    'fiscal year': {
	      'default': 100,
	      'narrow': 75,
	      'wide': 150
	    },
	    'default': {
	      'default': 125
	    },
	    'geography': {
	      'default': 160
	    },
	    'yes/no': {
	      'default': 70,
	      'narrow': 50,
	      'wide': 125
	    }
	  },
	
	  // State Lookup For SHF Landing Page
	  stateLookup: {
	    'AL': 'Alabama',
	    'AK': 'Alaska',
	    'AS': 'American Samoa',
	    'AZ': 'Arizona',
	    'AR': 'Arkansas',
	    'CA': 'California',
	    'CO': 'Colorado',
	    'CT': 'Connecticut',
	    'DE': 'Delaware',
	    'DC': 'District Of Columbia',
	    'FL': 'Florida',
	    'FM': 'Federated States of Micronesia',
	    'GA': 'Georgia',
	    'GU': 'Guam',
	    'HI': 'Hawaii',
	    'ID': 'Idaho',
	    'IL': 'Illinois',
	    'IN': 'Indiana',
	    'IA': 'Iowa',
	    'KS': 'Kansas',
	    'KY': 'Kentucky',
	    'LA': 'Louisiana',
	    'ME': 'Maine',
	    'MH': 'Marshall Islands',
	    'MD': 'Maryland',
	    'MA': 'Massachusetts',
	    'MI': 'Michigan',
	    'MN': 'Minnesota',
	    'MS': 'Mississippi',
	    'MO': 'Missouri',
	    'MT': 'Montana',
	    'NE': 'Nebraska',
	    'NV': 'Nevada',
	    'NH': 'New Hampshire',
	    'NJ': 'New Jersey',
	    'NM': 'New Mexico',
	    'NY': 'New York',
	    'NC': 'North Carolina',
	    'ND': 'North Dakota',
	    'MP': 'Northern Mariana Islands',
	    'OH': 'Ohio',
	    'OK': 'Oklahoma',
	    'OR': 'Oregon',
	    'PA': 'Pennsylvania',
	    'PR': 'Puerto Rico',
	    'PW': 'Republic of Palau',
	    'RI': 'Rhode Island',
	    'SC': 'South Carolina',
	    'SD': 'South Dakota',
	    'TN': 'Tennessee',
	    'TX': 'Texas',
	    'VI': 'U.S. Virgin Islands',
	    'UT': 'Utah',
	    'VT': 'Vermont',
	    'VA': 'Virginia',
	    'WA': 'Washington',
	    'WV': 'West Virginia',
	    'WI': 'Wisconsin',
	    'WY': 'Wyoming'
	  },
	
	  // GeoMulti symbol lookup for footnotes
	  footnoteSymbols: ['*', '†', '‡', 'θ', '¶', 'χ', 'Δ', 'Ψ', 'β', 'Ω']
	};

/***/ }),
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.buildHeaders = buildHeaders;
	exports.getOneSheet = getOneSheet;
	exports.getConfig = getConfig;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	var _isDatatypeRow = __webpack_require__(74);
	
	var _isDatatypeRow2 = _interopRequireDefault(_isDatatypeRow);
	
	var _headerUtils = __webpack_require__(75);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function buildHeaders(data, config) {
	  function immutableHeadersSingleSheet(headerData) {
	    var headersRaw = headerData;
	    var headerDataTypes = (0, _headerUtils.getHeaderDataTypes)(_config.sheetParseConfig.dataTypes);
	    var rowTypes = void 0;
	    // repeats in the first row means nested
	    var nestedRow = _mori2.default.count(_mori2.default.first(headersRaw)) >= _mori2.default.count(_mori2.default.distinct(_mori2.default.first(headersRaw)));
	    var datatypeRow = _mori2.default.some(function (row) {
	      return (0, _isDatatypeRow2.default)(row, headerDataTypes);
	    }, headersRaw);
	
	    // to find out what type of header setup we're dealing with
	    // and fill out the appropriate properties
	    if (nestedRow && !datatypeRow && headersRaw.length === 2) {
	      rowTypes = ['headerGroup', 'characteristic'];
	    } else if (datatypeRow && headersRaw.length === 2) {
	      rowTypes = ['characteristic', 'type'];
	    } else if (datatypeRow && headersRaw.length === 3) {
	      rowTypes = ['headerGroup', 'characteristic', 'type'];
	    } else {
	      rowTypes = ['characteristic'];
	    }
	
	    // Make sure to map defaults to types
	    var typeRow = rowTypes.indexOf('type');
	    var charRow = rowTypes.indexOf('characteristic');
	    var groupRow = rowTypes.indexOf('headerGroup');
	    if (typeRow !== -1) {
	      rowTypes.push('label');
	      rowTypes.push('width');
	      var labels = headersRaw[typeRow].map(function (item) {
	        return (item || 'Default').split('--')[0];
	      });
	      var types = headersRaw[typeRow].map(function (item) {
	        var type = (0, _headerUtils.getHeaderTypeObject)(item, headerDataTypes);
	        return type.type ? type : item;
	      });
	      // Because of the lookup these need to get flipped
	      headersRaw[typeRow] = types.map(function (x) {
	        return (x || {}).type || x;
	      });
	      headersRaw.push(labels);
	      headersRaw.push(types.map(function (x) {
	        return (x || {}).width;
	      }));
	    } else {
	      typeRow = rowTypes.length;
	      rowTypes.push('type', 'label');
	      var _types = headersRaw[charRow].map(function (item) {
	        var inferredType = (0, _util.getInferredType)(item);
	        return inferredType || 'default';
	      });
	
	      var _labels = _types;
	      headersRaw.push(_types, _labels);
	    }
	
	    // For nested rows, we want to build a compound header name
	    // to get distinct headers.  Otherwise, nested tables will mistakenly
	    // have data views listed when there is only 1 data view
	    var composedNestedHeaders = groupRow !== -1 ? headersRaw[groupRow].reduce(function (acc, curr, idx) {
	      acc.push('' + (curr + headersRaw[charRow][idx]));
	      return acc;
	    }, []) : null;
	
	    // To check for the presence of data views, we compare the distinct
	    // headers to all the headers.  If we have nested headers,
	    // use the built composed headers above to get distinct header count
	    var hasDataviews = _mori2.default.count(_mori2.default.distinct(nestedRow && composedNestedHeaders ? composedNestedHeaders : headersRaw[charRow])) < _mori2.default.count(headersRaw[charRow]);
	
	    // Add 'idx' to the generated props
	    rowTypes.push('idx');
	
	    // There are cases where the last header(s) do not have header groups.
	    // With these cases, we need to pad the group row with nulls.
	    // This will accurately build the headers based on how many characteristics
	    // there are
	    if (nestedRow && headersRaw[groupRow]) {
	      headersRaw[groupRow] = headersRaw[charRow].reduce(function (acc, curr, idx) {
	        return acc.concat(headersRaw[groupRow][idx] || null);
	      }, []);
	    }
	
	    var immutableHeaders = _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (col) {
	      return _mori2.default.zipmap(rowTypes, col);
	    }, _mori2.default.map.apply(_mori2.default, [_mori2.default.vector].concat(_toConsumableArray(headersRaw), [_mori2.default.range(_mori2.default.count(_mori2.default.first(headersRaw)))]))));
	
	    // Set default base column if not explicitly defined
	    if (!_mori2.default.get('characteristic', _mori2.default.first(immutableHeaders))) {
	      var baseType = 'geography';
	      var context = _mori2.default.getIn(config, ['globalRules', 'Context'], false);
	      if (!context) {
	        immutableHeaders = _mori2.default.assoc(immutableHeaders, 0, _mori2.default.hashMap(_config.sheetParseConfig.headerTypes[0], 'Location', _config.sheetParseConfig.headerTypes[1], baseType, 'label', baseType && baseType[0].toUpperCase() + baseType.slice(1), 'idx', 0));
	      } else {
	        if (!/^state|country$/i.test(_mori2.default.first(context))) {
	          baseType = 'text';
	        }
	        immutableHeaders = _mori2.default.assoc(immutableHeaders, 0, _mori2.default.hashMap(_config.sheetParseConfig.headerTypes[0], _mori2.default.first(context), _config.sheetParseConfig.headerTypes[1], baseType, 'label', baseType && baseType[0].toUpperCase() + baseType.slice(1), 'idx', 0));
	      }
	    }
	
	    // For settings targeted at specific columns assign them where needed
	    if (_mori2.default.count(_mori2.default.get(config, 'settings')) || _mori2.default.count(_mori2.default.get(config, 'globalSettings'))) {
	      immutableHeaders = _mori2.default.map(function (header) {
	        var characteristic = _mori2.default.get(header, 'characteristic');
	        var headerGroup = _mori2.default.get(header, 'headerGroup', false);
	        var headerType = _mori2.default.get(header, 'label', 'default');
	        var lowerHeaderType = headerType.toLowerCase();
	
	        // Progressivly determine the specificity of the selector
	        // If the column already has a type, it can't be overridden by a
	        // global rule
	        var headerTypeSelector = lowerHeaderType !== 'default' ? headerType : characteristic;
	
	        // Selector that best targets column rules
	        // For nested tables, we want the group header and the characteristic
	        // becomes the "data format"
	        var fullSelector = _mori2.default.conj(headerGroup ? _mori2.default.hashMap('Distribution', headerGroup) : _mori2.default.hashMap('Distribution', characteristic), headerTypeSelector !== 'default' && headerGroup ? _mori2.default.hashMap('Data Format', headerTypeSelector.toLowerCase()) : _mori2.default.hashMap());
	
	        // Data Format settings are special because they can be either selectors
	        // or settings. For example:
	        //
	        // any,Characteristic Name,Percent,any,Type,Setting
	        //
	        // can set the Data Format equal to "Percent" and add a Type:Setting pair
	        // to a column, or it can add the Type:Setting pair to a column by
	        // selecting on an already defined Data Format ("Percent")
	        var dataFormat = _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Data Format', lowerHeaderType)),
	        // if headerType doesn't have a match, also check what counts for the
	        // characteristic for this column
	        _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.assoc(fullSelector, 'Data Format', (headerGroup ? characteristic : headerTypeSelector).toLowerCase())), _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Data Format', (headerGroup ? characteristic : headerTypeSelector).toLowerCase())),
	        // try && syntax
	        _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Distribution', headerGroup + ' && ' + characteristic, 'Data Format', headerTypeSelector.toLowerCase())),
	        // try global settings as well
	        _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Data Format', lowerHeaderType)), _mori2.default.hashMap())))));
	
	        // Using the best selector, get matching rules
	        var filteredSettings = _mori2.default.filter(
	        // don't use loose selector for now
	        /*
	        (setting) => (
	          mori.equals(mori.first(setting), fullSelector) ||
	          mori.equals(mori.dissoc(mori.first(setting), 'Data Format'),
	            fullSelector)
	        ),
	        */
	        function (setting) {
	          return _mori2.default.equals(_mori2.default.first(setting), fullSelector);
	        }, _mori2.default.getIn(config, ['settings', 'settings']));
	
	        // Finds rules that apply to only the distribution
	        var selector = _mori2.default.getIn(config, ['settings', 'settings', _mori2.default.dissoc(fullSelector, 'Data Format')], _mori2.default.hashMap());
	
	        // a hack to ensure the dataview label retains it's original formatting
	        if (_mori2.default.get(dataFormat, 'label') !== headerType) {
	          dataFormat = _mori2.default.assoc(dataFormat, 'label', headerType);
	        }
	        // Apply found rules
	        return _mori2.default.reduce(
	        // extend column def with found rules
	        function (acc, value) {
	          return _mori2.default.conj(acc, _mori2.default.first(_mori2.default.rest(value)));
	        },
	        // extend column def with global settings, then data format
	        _mori2.default.into(header, _mori2.default.vector(_mori2.default.getIn(config, ['settings', 'globalSettings'], _mori2.default.hashMap()), selector, dataFormat)), filteredSettings);
	      }, immutableHeaders);
	    }
	    return { immutableHeaders: immutableHeaders, hasDataviews: hasDataviews, js: _mori2.default.toJs(immutableHeaders) };
	  }
	
	  return _extends({}, immutableHeadersSingleSheet((0, _headerUtils.getHeadersOnly)(getOneSheet(data))), {
	    immutableHeadersAll: data
	    // Get Raw Headers
	    .map(function (dataItem) {
	      return [dataItem[0], (0, _headerUtils.getHeadersOnly)(getOneSheet([dataItem]))];
	    })
	    // Filter out empty header sets (Notes tab)
	    .filter(function (dataItem) {
	      return dataItem[1].length;
	    })
	    // Reduce to a map of {Shee_name: {headers}}
	    .reduce(function (acc, curr) {
	      return _extends(_defineProperty({}, curr[0], _extends({}, immutableHeadersSingleSheet((0, _headerUtils.getHeadersOnly)(getOneSheet([curr]))))), acc);
	    }, {})
	  });
	}
	
	/**
	 * A transducer that grabs the first data sheet from the google doc.
	 * @param {object} data - The gdocs json data
	 * @return {array} - The "sheet" array from the data sheet
	 */
	function getOneSheet(data) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return _mori2.default.first(_mori2.default.intoArray(_mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (x) {
	    return config ? _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) > -1 : _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) === -1;
	  }), _mori2.default.map(function (x) {
	    return x[1];
	  })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), data)));
	}
	
	/**
	 * Returns the config array
	 * @param {object} data - The gdocs json data
	 * @return {object} The config object
	 */
	function getConfig(data) {
	  var configSheet = getOneSheet(data, true);
	
	  return _mori2.default.reduce(function (acc, next) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(next), _mori2.default.reduce(
	    // Each type of config object get processed differently
	    getRuleReducer(_mori2.default.first(next)), _mori2.default.hashMap(), _mori2.default.first(_mori2.default.rest(next)))));
	  }, _mori2.default.hashMap(), _mori2.default.groupBy(configGroupBy, cleanAndBuildConfigSheet(configSheet)));
	}
	
	/**
	 * Return the appropriate reducing function
	 *
	 * @param {string} type The name of the bucket we're currently building
	 *
	 * @return {function} A reducer function
	 */
	function getRuleReducer(type) {
	  switch (type) {
	    case 'globalRules':
	      return buildGlobalRules;
	    case 'notesSources':
	      return buildNotesSources;
	    case 'footnotes':
	      return buildFootnotes;
	    case 'settings':
	      return buildSettings;
	    default:
	      return _mori2.default.conj;
	  }
	}
	
	/**
	 * Builds settings objects from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of settings objects for lookup and rendering
	 */
	function buildSettings(acc, next) {
	  var settings = _mori2.default.get(acc, 'settings', _mori2.default.hashMap());
	  var globalSettings = _mori2.default.get(acc, 'globalSettings', _mori2.default.hashMap());
	
	  /**
	   * settings stored by complex key key
	   *
	   * ("Timeframe", "Distribution", "Data Format", "Geography"): Type:Note[Setting:Value]
	   */
	  var paths = _mori2.default.reduce(function (pathAcc, key) {
	    var addValues = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, key), ['any']);
	
	    return _mori2.default.mapcat(function (val) {
	      var dataVal = key === 'Data Format' ? val.toLowerCase() : val;
	      var newTuple = dataVal !== 'any' ? _mori2.default.hashMap(key, dataVal) : _mori2.default.hashMap();
	      if (!_mori2.default.count(pathAcc)) {
	        return _mori2.default.vector(newTuple);
	      }
	      return _mori2.default.map(function (parentVal) {
	        return _mori2.default.conj(parentVal, newTuple);
	      }, pathAcc);
	    }, addValues);
	  }, _mori2.default.vector(), _mori2.default.vector('Timeframe', 'Distribution', 'Data Format', 'Geography'));
	
	  var currSetting = _mori2.default.hashMap(_mori2.default.get(next, 'Type'), _mori2.default.get(next, 'Note'));
	
	  // unspecific rules classified as global
	  if (_mori2.default.every(function (item) {
	    return item === 'any';
	  }, _mori2.default.first(paths))) {
	    globalSettings = _mori2.default.into(globalSettings, currSetting);
	  } else {
	    var headerDataTypes = (0, _headerUtils.getHeaderDataTypes)(_config.sheetParseConfig.dataTypes);
	    // extends settings objects when complex keys match
	    settings = _mori2.default.reduce(function (acc2, curr2) {
	      return _mori2.default.reduce(function (acc3, curr3) {
	        return _mori2.default.assoc(acc3, _mori2.default.first(curr3), _mori2.default.merge(_mori2.default.get(acc2, _mori2.default.first(curr3)), _mori2.default.last(curr3)));
	      }, acc2, curr2);
	    }, settings, _mori2.default.map(function (vect) {
	      return _mori2.default.hashMap(vect, getSettingWithDefaults(vect, currSetting, headerDataTypes));
	    }, paths));
	  }
	
	  return _mori2.default.hashMap('settings', settings, 'globalSettings', globalSettings);
	}
	
	/**
	 * Builds data format options by label type
	 *
	 * @param {hashMap} current The hashMap representing the path this rule will
	 *  be assigned to
	 * @param {hashMap} setting The base setting to extend
	 * @param {object} datatypes The datatypes list from config
	 *
	 * @return {hashMap} Extended setting for this rule path
	 */
	function getSettingWithDefaults(current, setting, datatypes) {
	  var dataFormat = _mori2.default.get(current, 'Data Format', 'any');
	  var dataFormatType = (0, _headerUtils.getHeaderTypeObject)(dataFormat, datatypes);
	
	  var dataFormatSetting = dataFormat && dataFormat !== 'any' ? _mori2.default.hashMap('label', dataFormat || 'Default', 'type', dataFormatType ? dataFormatType.type : 'default') : _mori2.default.hashMap();
	
	  return _mori2.default.conj(setting, dataFormatSetting);
	}
	
	/**
	 * Builds footnote reference objects from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of footnote reference structures for lookup
	 * and rendering
	 */
	function buildFootnotes(acc, next) {
	  var footnotes = _mori2.default.get(acc, 'footnotes', _mori2.default.hashMap());
	  var footnoteList = _mori2.default.get(acc, 'footnoteList', _mori2.default.hashMap());
	  var foundFootnotes = _mori2.default.get(acc, 'foundFootnotes', _mori2.default.hashMap());
	  var note = _mori2.default.get(next, 'Note', false);
	
	  // Footnotes go in a nested hashMap for us to look up
	  // find by the set of selectors
	  var isUsed = _mori2.default.get(foundFootnotes, _mori2.default.hash(note.toLowerCase()), false);
	  var footnoteUid = isUsed || _mori2.default.count(foundFootnotes) + 1;
	  if (isUsed === false) {
	    foundFootnotes = _mori2.default.assoc(foundFootnotes, _mori2.default.hash(note.toLowerCase()), footnoteUid);
	  }
	  var timeframes = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, 'Timeframe'), ['any']);
	  var geographies = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, 'Geography'), ['any']);
	  var distributions = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, 'Distribution'), ['any']);
	
	  timeframes.forEach(function (timeframe) {
	    geographies.forEach(function (geo) {
	      distributions.forEach(function (dist) {
	        // Normalize base column header for footnote targets
	        var mapDist = dist === 'Region' ? 'Location' : dist;
	        var locationSplit = geo.match(/^([^[]+)\[(.*)\]$/);
	        if (mapDist.indexOf(' && ') > -1) {
	          var splitDist = mapDist.split(' && ');
	          footnotes = _mori2.default.updateIn(footnotes, [timeframe, geo, _mori2.default.hashMap.apply(_mori2.default, _toConsumableArray(splitDist))],
	          // add multiple footnotes in place
	          function (value) {
	            return _mori2.default.conj(value || _mori2.default.vector(), _mori2.default.hashMap('note', note, 'id', footnoteUid, 'value', locationSplit ? locationSplit[2] : false));
	          });
	        } else {
	          footnotes = _mori2.default.updateIn(footnotes, [timeframe, geo, mapDist],
	          // add multiple footnotes in place
	          function (value) {
	            return _mori2.default.conj(value || _mori2.default.vector(), _mori2.default.hashMap('note', note, 'id', footnoteUid, 'value', locationSplit ? locationSplit[2] : false));
	          });
	        }
	
	        footnoteList = _mori2.default.assoc(footnoteList, footnoteUid, note);
	      });
	    });
	  });
	
	  return _mori2.default.hashMap('footnotes', footnotes, 'footnoteList', footnoteList, 'foundFootnotes', foundFootnotes);
	}
	
	/**
	 * Builds notes and sources arrays from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of vectors for each type of Notes/Sources
	 */
	function buildNotesSources(acc, next) {
	  var type = _mori2.default.get(next, 'Type');
	  return _mori2.default.conj(acc, _mori2.default.hashMap(type, _mori2.default.into(_mori2.default.get(acc, type, _mori2.default.vector()), _mori2.default.vector(next))));
	}
	
	/**
	 * Builds global rules hash map from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of rules in `Type: Note` form
	 */
	function buildGlobalRules(acc, next) {
	  var type = _mori2.default.get(next, 'Type');
	  var typeLower = type.toLowerCase();
	  var note = _mori2.default.get(next, 'Note');
	  var multiGeoTypes = ['map base column', 'link column', 'link target'];
	  var rule = void 0;
	
	  // Context rules can be joined
	  if (typeLower === 'context') {
	    rule = note.split('+');
	  } else if (typeLower === 'related columns') {
	    rule = (0, _util.getAndCleanCSVValues)(note);
	  } else if (multiGeoTypes.indexOf(typeLower) > -1) {
	    rule = note;
	  } else {
	    rule = note.toLowerCase() === 'yes';
	  }
	
	  return _mori2.default.conj(acc, _mori2.default.hashMap(type, rule));
	}
	
	/**
	 * Cleans the config sheet to remove presentational rows and builds objects
	 * from headers for parsing
	 *
	 * @param {array} sheet The config sheet removed from the original data
	 *
	 * @return {vector} A list of rows that have been mapped to headers
	 */
	function cleanAndBuildConfigSheet(sheet) {
	  // normalize Note/Notes in header keys
	  var headers = _mori2.default.map(function (key) {
	    return ['Notes', 'Note'].indexOf(key) > -1 ? 'Note' : key;
	  }, _mori2.default.first(sheet));
	  return _mori2.default.map(
	  // Create an object from the row so we can lookup by name
	  function (row) {
	    return _mori2.default.zipmap(headers, row);
	  },
	  // Discard blank dividing rows and row without a Note value
	  _mori2.default.remove(function (row) {
	    return _mori2.default.every(function (x) {
	      return x === null;
	    }, _mori2.default.rest(row)) || _mori2.default.last(row) === null;
	  }, _mori2.default.rest(sheet)));
	}
	
	/**
	 * A groupBy function to split config sheets into proper buckets.
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {string} The bucket name for this row
	 */
	function configGroupBy(row) {
	  if (configIsGlobalRule(row)) {
	    return 'globalRules';
	  } else if (configIsNotesSources(row)) {
	    return 'notesSources';
	  } else if (configIsFootnote(row)) {
	    return 'footnotes';
	  }
	  return 'settings';
	}
	
	/**
	 * Function to test whether current row is a global rule
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {bool} isGlobalRule?
	 */
	function configIsGlobalRule(row) {
	  var distribution = _mori2.default.get(row, 'Distribution', 'any');
	  return _mori2.default.hasKey(row, 'Type') && _mori2.default.hasKey(row, 'Note') && (!distribution || distribution === 'any') && !_mori2.default.get(row, 'Data Format', false) && _config.sheetParseConfig.globalRules.indexOf(_mori2.default.get(row, 'Type', '').toLowerCase()) > -1;
	}
	
	/**
	 * Function to test whether current row is Notes/Sources
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {bool} isNotesSources?
	 */
	function configIsNotesSources(row) {
	  return _mori2.default.hasKey(row, 'Type') && _mori2.default.hasKey(row, 'Note') && _config.sheetParseConfig.sourceTypes.indexOf((_mori2.default.get(row, 'Type', '') || '').toLowerCase()) > -1;
	}
	
	/**
	 * Function to test whether current row is a footnote
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {bool} isFootnote?
	 */
	function configIsFootnote(row) {
	  return (_mori2.default.get(row, 'Type', '') || '').toLowerCase() === 'footnote';
	}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (row, types) {
	  if (!types) {
	    return false;
	  }
	  return _mori2.default.every(function (x) {
	    var tempX = (x || '').split('--');
	    var rowValue = tempX.length === 2 && ['narrow', 'wide'].indexOf(tempX[1].toLowerCase()) > -1 ? tempX[0] : x;
	    return rowValue === null || _mori2.default.some(function (type) {
	      return _mori2.default.first(type) === rowValue.toLowerCase();
	    }, types) || /^Date-/.test(rowValue);
	  }, _mori2.default.rest(row));
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHeaderDataTypes = getHeaderDataTypes;
	exports.getHeadersOnly = getHeadersOnly;
	exports.getHeaderTypeObject = getHeaderTypeObject;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A reducer that unfolds the default datatypes map so we can look up
	 * all possible types and their parent.
	 * @param {object} defaultDatatypes - An object containing parent type keys
	 *  and arrays of input options
	 * @return {array} An array of tuples containing child and parent
	 */
	function getHeaderDataTypes(defaultDatatypes) {
	  return _mori2.default.intoArray(_mori2.default.transduce(_mori2.default.mapcat(function (x) {
	    if (_mori2.default.first(_mori2.default.rest(x))) {
	      return _mori2.default.intoArray(_mori2.default.transduce(_mori2.default.map(function (y) {
	        return [y, _mori2.default.first(x)];
	      }), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector([_mori2.default.first(x), _mori2.default.first(x)]), // start with the parent
	      _mori2.default.first(_mori2.default.rest(x))));
	    }
	    return [[_mori2.default.first(x), _mori2.default.first(x)]];
	  }), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), _mori2.default.toClj(defaultDatatypes)));
	}
	
	/**
	 * A transducer that slices the header rows from the given datasheet
	 * @param {array} sheet - A datasheet from the gdoc
	 * @return {array} An array of only header rows
	 */
	/* eslint no-loop-func: 1 */
	function getHeadersOnly(sheet) {
	  return _mori2.default.intoArray(_mori2.default.takeWhile(function (x) {
	    return !x[0] || x[0].toLowerCase() === 'location';
	  }, sheet));
	}
	
	function getHeaderTypeObject(type, types) {
	  if (!type) {
	    return false;
	  }
	
	  var typeSplit = type.split('--');
	  var typeValue = typeSplit.length === 2 && ['narrow', 'wide'].indexOf(typeSplit[1].toLowerCase()) > -1 ? typeSplit[0] : type;
	  var mappedType = types.filter(function (x) {
	    return x[0] === typeValue.toLowerCase();
	  }).shift();
	
	  if (mappedType) {
	    return {
	      type: mappedType[1],
	      label: typeValue,
	      width: (typeSplit[1] || '').toLowerCase()
	    };
	  }
	
	  return false;
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.kffIsNumber = kffIsNumber;
	exports.kffNumericValue = kffNumericValue;
	exports.commatize = commatize;
	exports.getSelectedItem = getSelectedItem;
	exports.getPrecision = getPrecision;
	exports.numberPrecision = numberPrecision;
	exports.getInferredType = getInferredType;
	exports.pluck = pluck;
	exports.modZip = modZip;
	exports.getEstTextLength = getEstTextLength;
	exports.getEstTextRows = getEstTextRows;
	exports.digColumnValue = digColumnValue;
	exports.getAndCleanCSVValues = getAndCleanCSVValues;
	exports.log = log;
	exports.getScrollbarWidth = getScrollbarWidth;
	exports.safeDeepDelete = safeDeepDelete;
	exports.isObject = isObject;
	exports.deepMerge = deepMerge;
	exports.deepDelete = deepDelete;
	exports.deepFind = deepFind;
	exports.isUrlSelected = isUrlSelected;
	exports.isAllSelected = isAllSelected;
	exports.isIE = isIE;
	exports.indexOf = indexOf;
	exports.maxWordWidth = maxWordWidth;
	exports.escapeHTML = escapeHTML;
	
	var _d = __webpack_require__(77);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function round(number, precision) {
	  var factor = Math.pow(10, precision);
	  var tempNumber = number * factor;
	  var roundedTempNumber = Math.round(tempNumber);
	  return roundedTempNumber / factor;
	}
	
	function kffIsNumber(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	function kffNumericValue(n) {
	  if (!n && n !== 0) {
	    return false;
	  } else if (kffIsNumber(n)) {
	    return parseFloat(n);
	  }
	
	  var pattern = /\,|\%|\$|<|>/g;
	  var d = parseFloat(n.toString().replace(pattern, ''));
	  if (isFinite(d) && !n.toString().match(/[a-zA-Z]/g)) {
	    return d;
	  }
	  return null;
	}
	
	/**
	 * This takes a number/float and inserts the **US** formatting
	 * of a number w/ commas, ie: a comma every 3 nums and a period for a decimal
	 * @param  {Number} number number to "commatize"
	 * @param  {String} sym    symbol to insert before the number
	 * @return {String}        "commatized" number
	 */
	function commatize(number) {
	  var sym = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var negativeSign = '-';
	  return number.toString().split('').reverse() // Flip it!
	  .reduce(function (acc, str, idx, arr) {
	    var pointLoc = arr.indexOf('.');
	    if (idx > pointLoc) {
	      // Do period check
	      var loc = pointLoc > -1 ? idx - pointLoc : idx;
	
	      if (loc % 3 === 0 && loc !== 0 && str !== negativeSign) {
	        acc.push(',');
	      }
	    }
	    acc.push(str);
	    return acc;
	  }, []).concat([sym]) // push on symbole
	  .reverse() // Flip it back!
	  .join('') // Join it!
	  .replace(sym + '-', '-' + sym); // If number is negative, swap the symbol and the negative sign.
	}
	
	function getSelectedItem(items) {
	  return items.filter(function (x) {
	    return x.selected;
	  }).shift();
	}
	
	function getPrecision(column) {
	  return _config.appDefault.decimalPlacesMap[column ? column.Precision || 0 : 0] || 0;
	}
	
	function numberPrecision(value, precision, percent) {
	  var multiplier = percent ? 100 : 1;
	  var number = round(+value * multiplier, precision || 0);
	
	  // Return formatted number, accounting for possible '-0'
	  return +number.toString().replace(+number === 0 ? '-' : '', '');
	}
	
	function getInferredType(name) {
	  if (/%/.test(name) || /percent/i.test(name)) {
	    return 'percent';
	  }
	
	  if (/\$/.test(name) || /USD/.test(name) || /currency/i.test(name)) {
	    return 'currency';
	  }
	
	  if (name && name.toLowerCase() === 'year') {
	    return 'year';
	  }
	
	  if (/states in/i.test(name)) {
	    return 'geography';
	  }
	  return 'default';
	}
	
	/**
	 * Reduces an array of objects into an array of a field
	 * @param  {array} tree     object/array to reduce
	 * @param  {string} field   key of object to extract
	 * @return {array}          array of fields
	 */
	function pluck(tree, field) {
	  if ((typeof tree === 'undefined' ? 'undefined' : _typeof(tree)) !== 'object') {
	    return [];
	  }
	
	  return tree.reduce(function (arr, item) {
	    return arr.indexOf(item[field]) < 0 ? arr.concat(item[field]) : arr;
	  }, []);
	}
	
	/**
	 * Maps two arrays to an object key-value, and runs
	 * modulus on values array if it is shorter than the key array
	 * @param  {array} keyArray     Array of values that should be the keys
	 * @param  {array} valueArray   Array of values that should map to values
	 * @return {object}             key-value object
	 */
	function modZip(keyArray, valueArray) {
	  return keyArray.reduce(function (obj, d, idx) {
	    var key = idx < valueArray.length ? idx : idx % valueArray.length;
	    obj[d] = valueArray[key];
	    return obj;
	  }, {});
	}
	
	// Measuring state, shared across every call to getEstTextLength below.
	// A trend table measures the same few fonts over tens of thousands of
	// cells, so both the canvas and the resulting widths are worth keeping.
	var measureContext = null;
	var measureCache = Object.create(null);
	var measureCacheSize = 0;
	var measureCacheLimit = 20000;
	
	/**
	 * Uses canvas.measureText to compute and return the width
	 * of the given text of given font in pixels.
	 *
	 * Results are memoised and a single canvas context is reused. Creating
	 * one canvas element per measurement previously allocated ~150k elements
	 * on a full trend table, which dominated ag-grid's row height pass.
	 *
	 * @param {String} text The text to be rendered.
	 * @param {String} font The css font descriptor that text is
	 *                 to be rendered with (e.g. "bold 14px verdana").
	 * @return {int}   the width of the text element
	 */
	function getEstTextLength(text, font) {
	  // \u0000 cannot occur in a font descriptor or cell value, so it
	  // separates the two parts of the key without risk of collision.
	  var cacheKey = font + '\0' + text;
	  var cached = measureCache[cacheKey];
	  if (cached !== undefined) {
	    return cached;
	  }
	
	  if (!measureContext) {
	    measureContext = document.createElement('canvas').getContext('2d');
	  }
	  // Always reassign. If a descriptor ever fails to parse the canvas keeps
	  // its previous font, and skipping this would measure against that.
	  measureContext.font = font;
	  var width = measureContext.measureText(text).width;
	
	  if (measureCacheSize >= measureCacheLimit) {
	    measureCache = Object.create(null);
	    measureCacheSize = 0;
	  }
	  measureCache[cacheKey] = width;
	  measureCacheSize += 1;
	
	  return width;
	}
	
	/**
	 * Get the estimated amount of rows of text
	 * @param  {string}  text  the test to calculate rows of
	 * @param  {String}  font  the css font descriptor that the text is
	 *                         to be rendered with (e.g. "bold 14px verdana").
	 * @param  {int}  width  the width the text should wrap in
	 * @return {int}  the number of rows that would be needed to see all text
	 */
	function getEstTextRows(text, font, width) {
	  return !text.split ? 1 : text.split(' ').reduce(function (acc, curr) {
	    var splitHyphen = curr.split('-');
	
	    if (splitHyphen.length === 1) {
	      acc.push(curr);
	      return acc;
	    }
	
	    splitHyphen.forEach(function (item, index, array) {
	      return acc.push(index === array.length - 1 ? item : item + '-');
	    });
	
	    return acc;
	  }, []).reduce(function (acc, curr, idx) {
	    return textRowsReducer(font, width)(acc, curr, idx);
	  }, [[]]).length;
	}
	
	/**
	 * Reducer helper for getEstTextRows
	 * @param  {String} font  the css font descriptor that the text is
	 *                        to be rendered with (e.g. "bold 14px verdana").
	 * @param  {int} width    the width the text should wrap in
	 * @return {function}     the reducer function which builds an array of text rows
	 */
	function textRowsReducer(font, width) {
	  return function (acc, curr, idx) {
	    var line = [].concat(_toConsumableArray(acc[(acc.length - 1) % idx || 0]), [curr]).join(' ').replace(/-\s/g, '-'); // Accounts for hyphenated text joining with ' '
	    var lineLength = getEstTextLength(line, font);
	    if (lineLength > width || width - lineLength < 1) {
	      acc.push([curr]);
	    } else {
	      acc[(acc.length - 1) % idx || 0].push(curr);
	    }
	    return acc;
	  };
	}
	
	/**
	 * Digs into an object, for a property, setup for digging into columns
	 * @param {Object} the object to dig into,
	 * @param {curried strings} 2, 2+nth elements are the keys to dig.
	 *
	 * @return {ANY} value of the deepest depth
	 */
	// @TODO, replace this so it uses the `...keys` syntax vs arguments
	function digColumnValue() {
	  var args = Array.prototype.slice.call(arguments);
	  var keys = args.slice(1, args.length);
	  var ret = keys.reduce(function (prev, curr) {
	    return prev ? prev[curr] : prev;
	  }, args[0]);
	
	  if (ret === undefined) {
	    ret = ['nested'].concat(_toConsumableArray(keys)).reduce(function (prev, curr) {
	      if (prev[curr]) {
	        return prev[curr].children !== undefined ? prev[curr].children : prev[curr];
	      }
	      return prev;
	    }, args[0]);
	  }
	  return ret;
	}
	
	/**
	 * Trim csv
	 */
	function getAndCleanCSVValues(csvStr, nullValue) {
	  if (!csvStr || !csvStr.length) {
	    return nullValue;
	  }
	  if (csvStr.indexOf(' && ') > -1) {
	    return [].concat(csvStr.split(' && ').map(function (parse) {
	      return getAndCleanCSVValues(parse, nullValue);
	    }).join(' && '));
	  }
	
	  return _d2.default.csv.parseRows(csvStr).shift().map(function (value) {
	    return value.trim().replace(/"([^"]+(?="))"/g, '$1');
	  });
	}
	
	/**
	 * Logging function for mori pass through
	 */
	function log(text, immutable) {
	  /* eslint-disable no-console */
	  console.log(text + ': ', _mori2.default.toJs(immutable));
	  /* eslint-enable no-console */
	  return immutable;
	}
	
	function getScrollbarWidth() {
	  var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  var outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  // force scrollbars
	  outer.style.overflow = 'scroll';
	
	  // add innerdiv
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	
	  // remove divs
	  outer.parentNode.removeChild(outer);
	
	  return widthNoScroll - widthWithScroll + padding;
	}
	
	/**
	 * Safe deep delete (don't delete parents that have children)
	 * @param  {array} targets   Keys to iterate through
	 * @param  {object} context  Object to delete from
	 * @param  {bool}   unsafe   force unsafe deletion mode
	 * @return {bool}            Returns deleted status (or itself)
	 */
	function safeDeepDelete(targets, context) {
	  var unsafe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (typeof context === 'undefined') {
	    return false;
	  }
	
	  if (unsafe && targets.length > 1) {
	    return deepDelete(targets.slice(1), context[targets[0]]);
	  } else if (!unsafe && targets.length > 1) {
	    return safeDeepDelete(targets.slice(1), context[targets[0]]);
	  }
	
	  if (context[targets[0]] && (unsafe || Object.keys(context[targets[0]]).length === 0)) {
	    delete context[targets[0]];
	    return Object.keys(context).length > 0;
	  }
	  return false;
	}
	
	/**
	 * Simple is object check.
	 * @param item
	 * @returns {boolean}
	*/
	function isObject(item) {
	  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
	}
	
	/**
	 * Deep merge two objects.
	 * https://gist.github.com/Salakar/1d7137de9cb8b704e48a
	 * @param target
	 * @param source
	*/
	function deepMerge(target, source) {
	  if (isObject(target) && isObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      if (isObject(source[key])) {
	        if (!target[key]) {
	          _extends(target, _defineProperty({}, key, {}));
	        }
	        deepMerge(target[key], source[key]);
	      } else {
	        _extends(target, _defineProperty({}, key, source[key]));
	      }
	    });
	  }
	  return target;
	}
	
	/**
	 * Delete a deep nested object property
	 * @param  {array} targets   Keys to iterate through
	 * @param  {object} context  Object to delete from
	 * @return {bool}            Returns deleted status (or itself)
	 */
	function deepDelete(targets, context) {
	  if (typeof context === 'undefined') {
	    return false;
	  }
	  if (targets.length > 1) {
	    return deepDelete(targets.slice(1), context[targets[0]]);
	  }
	  if (context[targets[0]]) {
	    delete context[targets[0]];
	    return Object.keys(context).length > 0;
	  }
	  return false;
	}
	
	/**
	 * Find a deep nested object value
	 * @param  {array} targets    keys to iterate through
	 * @param  {object} context   object to find in
	 * @return {bool}             if key has a solution
	 */
	function deepFind(targets, context) {
	  if (typeof context === 'undefined') {
	    return false;
	  }
	  if (targets.length > 1) {
	    return deepFind(targets.slice(1), context[targets[0]]);
	  }
	  return context[targets[0]] || false;
	}
	
	// Check if rows is url selected
	function isUrlSelected(keys, rows) {
	  return !!keys.reduce(function (prev, curr) {
	    return prev ? prev[curr] : prev;
	  }, rows);
	}
	
	// Check if rows is all selected
	function isAllSelected(keys, rows) {
	  if (typeof rows === 'undefined') {
	    return false;
	  }
	  var temp = rows;
	  return [].concat(_toConsumableArray(keys.slice(0, keys.length - 1))).some(function (curr) {
	    if (!temp) {
	      return false;
	    }
	    if (temp[curr] && (temp[curr].hasOwnProperty('all') || Object.keys(temp[curr]).length === 0)) {
	      return true;
	    }
	    temp = temp[curr];
	    return false;
	  });
	}
	
	/**
	 * Detects if browser is IE11
	 * modified from the Angular methods for doing this
	 */
	function isIE() {
	  var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
	  if (isNaN(msie)) {
	    msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
	  }
	  return !isNaN(msie);
	}
	
	/**
	 * Use with mori.filter for an indexOf
	 * @param  {collection} haystack
	 * @param  {value} needle
	 * @return {bool}
	 */
	function indexOf(haystack, needle) {
	  return _mori2.default.some(function (x) {
	    return _mori2.default.isCollection(x) && _mori2.default.isCollection(needle) ? _mori2.default.equals(_mori2.default.first(x), _mori2.default.first(_mori2.default.first(needle))) && _mori2.default.equals(_mori2.default.last(x), _mori2.default.last(_mori2.default.first(needle))) : _mori2.default.equals(x, needle);
	  }, haystack);
	}
	
	function maxWordWidth(string, fontStyle) {
	  return string.split(' ').reduce(function (acc, text) {
	    return text.split('-').length > 1 ? text.split('-').reduce(function (acc1, text1) {
	      return Math.max(getEstTextLength(text1, fontStyle), acc1);
	    }, 0) : Math.max(getEstTextLength(text, fontStyle), acc);
	  }, 0);
	}
	
	/**
	 * Escapes HTML tags in a string of characters
	 * https://gist.github.com/cvan/2817d07ef5f17fb66365
	 *
	 * @param {String} str A string of characters.
	 * @param {Boolean} escapeQuotes (optional) Whether to escape quotation marks.
	 * @return {String} The HTML-escaped string.
	 */
	function escapeHTML(str, escapeQuotes) {
	  if (!str || typeof str !== 'string') {
	    return '';
	  }
	
	  var escaped = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	
	  if (escapeQuotes) {
	    return escaped.replace(/"/g, '&quot;').replace(/'/g, '&apos;');
	  }
	
	  return escaped;
	}

/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Returns a map for nested columns
	 *
	 * @param {array} sheet - The flattened google document
	 * @param {hashMap} config - Global config options parsed from the google document
	 * @param {object} options - The current state ie router.currentParams
	 *
	 * @return {object} A nested map of parent column objects
	 */
	
	
	exports.default = function (sheet, config, options) {
	  var context = _mori2.default.getIn(config, ['globalRules', 'Context'], false);
	  var label = context ? context[1] : 'States';
	
	  var buildColumns = function buildColumns(data) {
	    return _mori2.default.toJs(_mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (group) {
	      return _mori2.default.hashMap(_mori2.default.first(group), _mori2.default.first(group) === 'nested' ? _mori2.default.hashMap((0, _slugify2.default)(label), _mori2.default.hashMap('children', buildBaseColumns(_mori2.default.first(_mori2.default.rest(group)), options, config), 'label', label)) : buildBaseColumns(_mori2.default.first(_mori2.default.rest(group)), options, config)
	      // create the base column selector for each row
	      );
	    },
	    // nested vs wrapups
	    _mori2.default.groupBy(function (row) {
	      return isWrapup(row);
	    }, _mori2.default.dropWhile(function (x) {
	      return !x[0];
	    }, data)))));
	  };
	
	  return {
	    columns: buildColumns((0, _transducers.getOneSheet)(sheet)),
	    columnsAll: sheet
	    // Reduce to a map of {Shee_name: {headers}}
	    .reduce(function (acc, curr) {
	      return _extends(_defineProperty({}, curr[0], _extends({}, buildColumns((0, _transducers.getOneSheet)([curr])))), acc);
	    }, {})
	  };
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _transducers = __webpack_require__(73);
	
	var _config = __webpack_require__(71);
	
	var _slugify = __webpack_require__(79);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Create base column selectors for each row. These looks a little different
	 * depending on the nesting level of the indicator sheet.
	 *
	 * @example single-level-geographical data
	 * { nested: { Alabama: { selected: bool } } }
	 *
	 * @example n-plus-level-geographical data
	 * { nested: { Alabama: { children: { [Child]: { selected: bool } } } } }
	 *
	 * @example summary rows
	 * { nested: { Alabama: { selected: bool, summary: { Alabama (All): {} } } } }
	 */
	function buildBaseColumns(items, options, config) {
	  var isGeomulti = _mori2.default.getIn(config, ['globalRules', 'Geomulti'], false);
	
	  // group by base column, normalizing summary rows
	  var byState = _mori2.default.groupBy(function (row) {
	    return summaryItem(row, isGeomulti) ? _mori2.default.first(row).replace(_config.appDefault.isSummaryRow, '') : _mori2.default.first(row);
	  }, items);
	  return _mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (row) {
	    if (!isGeomulti) {
	      return _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(row)), _mori2.default.hashMap('label', _mori2.default.first(row)));
	    }
	    return _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(row)), _mori2.default.into(_mori2.default.hashMap('label', _mori2.default.first(row)), _mori2.default.map(function (item) {
	      return buildNested(item);
	    }, _mori2.default.groupBy(function (item) {
	      return summaryItem(item, isGeomulti) ? 'summary' : 'children';
	    }, _mori2.default.last(row)))));
	  }, byState));
	}
	
	/**
	 * Builds the tree of subitems in the column selector tree
	 *
	 * @param {vector} item The subgroup of rows for summary or children
	 *
	 * @return {hashMap} Node with summary and children collections
	 */
	function buildNested(item) {
	  if (_mori2.default.first(item) === 'summary') {
	    return _mori2.default.hashMap('summary', _mori2.default.hashMap('label', 'Summary'));
	  }
	  return _mori2.default.hashMap('children', _mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (child) {
	    return _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(_mori2.default.rest(child))), _mori2.default.hashMap('label', _mori2.default.first(_mori2.default.rest(child))));
	  }, _mori2.default.last(item))));
	}
	
	/**
	 * Test whether a row is a wrapup row
	 *
	 * @param {vector|array} x The current row
	 *
	 * @return {bool} isWrapup?
	 */
	function isWrapup(x) {
	  return _config.appDefault.specialWrapups.indexOf(_mori2.default.first(x)) > -1 ? 'wrapups' : 'nested';
	}
	
	/**
	 * Test whether a row is a summary row
	 *
	 * @param {vector|array} x The current row
	 * @param {bool} isGeomulti If we're in a geomulti indicator
	 *
	 * @return {bool} isSummaryItem?
	 */
	function summaryItem(x, isGeomulti) {
	  return isGeomulti && _config.appDefault.isSummaryRow.test(_mori2.default.first(x));
	}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = slugify;
	/** Used Angular-slugify as a basis: https://github.com/paulsmith/angular-slugify/blob/master/angular-slugify.js */
	
	/**
	 * Unicode (non-control) characters in the Latin-1 Supplement and Latin
	 * Extended-A blocks, transliterated into ASCII characters.
	 * Disabling eslint due to weirdness's around ASCII chars
	 */
	/* eslint-disable quotes */
	var charmap = {
	  ' ': " ", '¡': "!", '¢': "c", '£': "lb", '¥': "yen", '¦': "|", '§': "SS",
	  '¨': "\"", '©': "(c)", 'ª': "a", '«': "<<", '¬': "not", '­': "-", '®': "(R)",
	  '°': "^0", '±': "+/-", '²': "^2", '³': "^3", '´': "'", 'µ': "u", '¶': "P",
	  '·': ".", '¸': ",", '¹': "^1", 'º': "o", '»': ">>", '¼': " 1/4 ",
	  '½': " 1/2 ", '¾': " 3/4 ", '¿': "?", 'À': "`A", 'Á': "'A", 'Â': "^A",
	  'Ã': "~A", 'Ä': '"A', 'Å': "A", 'Æ': "AE", 'Ç': "C", 'È': "`E", 'É': "'E",
	  'Ê': "^E", 'Ë': '"E', 'Ì': "`I", 'Í': "'I", 'Î': "^I", 'Ï': '"I', 'Ð': "D",
	  'Ñ': "~N", 'Ò': "`O", 'Ó': "'O", 'Ô': "^O", 'Õ': "~O", 'Ö': '"O', '×': "x",
	  'Ø': "O", 'Ù': "`U", 'Ú': "'U", 'Û': "^U", 'Ü': '"U', 'Ý': "'Y", 'Þ': "Th",
	  'ß': "ss", 'à': "`a", 'á': "'a", 'â': "^a", 'ã': "~a", 'ä': '"a', 'å': "a",
	  'æ': "ae", 'ç': "c", 'è': "`e", 'é': "'e", 'ê': "^e", 'ë': '"e', 'ì': "`i",
	  'í': "'i", 'î': "^i", 'ï': '"i', 'ð': "d", 'ñ': "~n", 'ò': "`o", 'ó': "'o",
	  'ô': "^o", 'õ': "~o", 'ö': '"o', '÷': ":", 'ø': "o", 'ù': "`u", 'ú': "'u",
	  'û': "^u", 'ü': '"u', 'ý': "'y", 'þ': "th", 'ÿ': '"y', 'Ā': "A", 'ā': "a",
	  'Ă': "A", 'ă': "a", 'Ą': "A", 'ą': "a", 'Ć': "'C", 'ć': "'c", 'Ĉ': "^C",
	  'ĉ': "^c", 'Ċ': "C", 'ċ': "c", 'Č': "C", 'č': "c", 'Ď': "D", 'ď': "d",
	  'Đ': "D", 'đ': "d", 'Ē': "E", 'ē': "e", 'Ĕ': "E", 'ĕ': "e", 'Ė': "E",
	  'ė': "e", 'Ę': "E", 'ę': "e", 'Ě': "E", 'ě': "e", 'Ĝ': "^G", 'ĝ': "^g",
	  'Ğ': "G", 'ğ': "g", 'Ġ': "G", 'ġ': "g", 'Ģ': "G", 'ģ': "g", 'Ĥ': "^H",
	  'ĥ': "^h", 'Ħ': "H", 'ħ': "h", 'Ĩ': "~I", 'ĩ': "~i", 'Ī': "I", 'ī': "i",
	  'Ĭ': "I", 'ĭ': "i", 'Į': "I", 'į': "i", 'İ': "I", 'ı': "i", 'Ĳ': "IJ",
	  'ĳ': "ij", 'Ĵ': "^J", 'ĵ': "^j", 'Ķ': "K", 'ķ': "k", 'Ĺ': "L", 'ĺ': "l",
	  'Ļ': "L", 'ļ': "l", 'Ľ': "L", 'ľ': "l", 'Ŀ': "L", 'ŀ': "l", 'Ł': "L",
	  'ł': "l", 'Ń': "'N", 'ń': "'n", 'Ņ': "N", 'ņ': "n", 'Ň': "N", 'ň': "n",
	  'ŉ': "'n", 'Ō': "O", 'ō': "o", 'Ŏ': "O", 'ŏ': "o", 'Ő': '"O', 'ő': '"o',
	  'Œ': "OE", 'œ': "oe", 'Ŕ': "'R", 'ŕ': "'r", 'Ŗ': "R", 'ŗ': "r", 'Ř': "R",
	  'ř': "r", 'Ś': "'S", 'ś': "'s", 'Ŝ': "^S", 'ŝ': "^s", 'Ş': "S", 'ş': "s",
	  'Š': "S", 'š': "s", 'Ţ': "T", 'ţ': "t", 'Ť': "T", 'ť': "t", 'Ŧ': "T",
	  'ŧ': "t", 'Ũ': "~U", 'ũ': "~u", 'Ū': "U", 'ū': "u", 'Ŭ': "U", 'ŭ': "u",
	  'Ů': "U", 'ů': "u", 'Ű': '"U', 'ű': '"u', 'Ų': "U", 'ų': "u", 'Ŵ': "^W",
	  'ŵ': "^w", 'Ŷ': "^Y", 'ŷ': "^y", 'Ÿ': '"Y', 'Ź': "'Z", 'ź': "'z", 'Ż': "Z",
	  'ż': "z", 'Ž': "Z", 'ž': "z", 'ſ': "s"
	};
	/* eslint-enable quotes */
	
	function slugify(text) {
	  return !text ? '' : Array(text.length).fill('').reduce(function (acc, i, idx) {
	    var charcode = text.charCodeAt(idx);
	    if (charcode < 0x180) {
	      acc.push(charmap[String.fromCharCode(charcode)] || String.fromCharCode(charcode));
	    }
	    return acc;
	  }, []).join('').replace(/[^\w\s-]/g, '').trim().toLowerCase().replace(/[-\s]+/g, '-');
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (sheets) {
	  return _mori2.default.intoArray(_mori2.default.transduce(_mori2.default.comp(
	  // exclude config sheets
	  _mori2.default.filter(function (x) {
	    return _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) === -1;
	  }), _mori2.default.map(function (x) {
	    return x[0];
	  })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), sheets));
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (headers, config, headersAll) {
	  // parse the display order
	  var displayOrder = _mori2.default.getIn(config, ['settings', 'globalSettings', 'Display Order'], '').split(',').map(function (dataview) {
	    return dataview.trim();
	  });
	
	  return {
	    immutableDataviews: getDataViews(headers, displayOrder),
	    immutableDataviewsAll: Object.keys(headersAll).reduce(function (acc, curr) {
	      return _extends(_defineProperty({}, curr, {
	        immutableDataviews: getDataViews(headersAll[curr].immutableHeaders, displayOrder)
	      }), acc);
	    }, {})
	  };
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getDataViews(headers, displayOrder) {
	  // pluck dataviews from headers where applicable
	  var foundDataviews = _mori2.default.toJs(_mori2.default.distinct(_mori2.default.map(function (header) {
	    return _mori2.default.hashMap('label', _mori2.default.get(header, 'label'), 'type', _mori2.default.get(header, 'type'));
	  }, _mori2.default.rest(headers))));
	
	  // sort the views that are listed in the display order
	  var sorted = foundDataviews.filter(function (dataview) {
	    return displayOrder.indexOf(dataview.label) > -1;
	  }).sort(function (a, b) {
	    return displayOrder.indexOf(a.label) - displayOrder.indexOf(b.label);
	  });
	
	  // add any more views that don't have a specified display order
	  return sorted.concat(foundDataviews.filter(function (dataview) {
	    return displayOrder.indexOf(dataview.label) === -1;
	  }));
	}
	
	/**
	 * A transducer that creates the dataview list
	 *
	 * @param {array} sheets - The headers array
	 * @return {array} A list of available dataviews
	 */

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (headers) {
	  var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var headersAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var distributions = function distributions(headerItems) {
	    return _mori2.default.distinct(_mori2.default.map(function (header) {
	      var characteristic = _mori2.default.get(header, 'characteristic');
	      var headerGroup = _mori2.default.get(header, 'headerGroup');
	      // nested distributions need a complex slug
	      var identifier = headerGroup ? headerGroup + '__' + characteristic : '' + characteristic;
	      var slug = (0, _slugify2.default)(identifier.replace('%', 'percent'));
	      return _mori2.default.hashMap('label', identifier.replace('__', ', '), 'characteristic', characteristic, 'slug', slug, 'selected', selected.indexOf(slug) > -1, 'headerGroup', headerGroup, 'exclude', mapExcludedViews(header));
	    }, _mori2.default.rest(headerItems)));
	  };
	
	  return {
	    immutableDistributions: distributions(headers),
	    immutableDistributionsAll: Object.keys(headersAll).reduce(function (acc, curr) {
	      return _extends(_defineProperty({}, curr, {
	        immutableDistributions: distributions(headersAll[curr].immutableHeaders)
	      }), acc);
	    }, {})
	  };
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _slugify = __webpack_require__(79);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var viewTypes = _mori2.default.vector('Map', 'Graph');
	
	// Map the views where this distribution should not be shown
	function mapExcludedViews(header) {
	  return _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (view) {
	    return ('' + _mori2.default.get(header, view, false)).toLowerCase() === 'no';
	  }), _mori2.default.map(function (view) {
	    return view.toLowerCase();
	  })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), viewTypes);
	}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data) {
	  // @TODO make county data processor
	  // the easiest way is probably to do some conditional processing of these
	  // medicare json files in place of the other function assignments in
	  // buildSpreadsheetData. The json is ~close to what you need, but will
	  // require some massaging.
	
	  /**
	   * Lets format sheetData into a wonderful style of:
	   * mori.vector(
	   *   mori.hashMap(
	   *     'year', 0000,
	   *     'location', XXXX
	   *     'value', 000000000
	   *   )
	   * )
	   */
	  var timeframes = _mori2.default.toClj(data.data.timeframes);
	
	  var immutableHeaders = getHeaders(_mori2.default.first(timeframes));
	
	  var _getDatacenterDistrib = (0, _distributionFilters2.default)(immutableHeaders),
	      immutableDistributions = _getDatacenterDistrib.immutableDistributions;
	
	  var sheetData = _mori2.default.flatten(_mori2.default.map(function (parent) {
	    return _mori2.default.map(function (row) {
	      return _mori2.default.hashMap('year', _mori2.default.get(parent, 'timeframe_title'), 'label', _mori2.default.first(row).toString() === 'Dist. of Columbia' ? 'District of Columbia' : _mori2.default.first(row).toString(), 'values', _mori2.default.zipmap(_mori2.default.map(function (item) {
	        return _mori2.default.set([_mori2.default.get(item, 'characteristic'), _mori2.default.get(item, 'type')]);
	      }, _mori2.default.sort(function (a, b) {
	        return _mori2.default.get(a, 'idx') - _mori2.default.get(b, 'idx');
	      }, _mori2.default.rest(immutableHeaders))), _mori2.default.map(function (item) {
	        return (0, _util.kffIsNumber)(item) ? (0, _util.kffNumericValue)(item) : item;
	      }, _mori2.default.rest(row))));
	    }, _mori2.default.drop(2, _mori2.default.get(parent, 'grid')));
	  }, timeframes));
	
	  /**
	   * Flatten out the sheet definitions so we can pluck them later...
	   */
	  var definitions = buildGeoDefinitions(sheetData, _mori2.default.toClj(data.geoDefinitions));
	
	  var flatData = _mori2.default.groupBy(function (item) {
	    return _mori2.default.get(item, 'year');
	  }, _mori2.default.filter(
	  // need to check to remove any data sets without definitions
	  function (item) {
	    return !(!_mori2.default.hasKey(item, 'header') && /\d/.test(_mori2.default.get(item, 'label')));
	  }, _mori2.default.map(function (item) {
	    return _mori2.default.merge(item, _mori2.default.get(definitions, _mori2.default.get(item, 'label')));
	  }, sheetData)));
	
	  var immutableData = buildData(flatData);
	  var columns = buildColumnData(flatData);
	  var config = _mori2.default.hashMap('notesSources', _mori2.default.hashMap('Notes', _mori2.default.set([_mori2.default.hashMap('Data Format', null, 'Distribution', null, 'Geography', null, 'Note', data.data.notes, 'Timeframe', 'any', 'Type', 'Notes')]), 'Sources', _mori2.default.set([_mori2.default.hashMap('Data Format', null, 'Distribution', null, 'Geography', null, 'Note', data.data.source, 'Timeframe', 'any', 'Type', 'Sources')]), 'Definitions', _mori2.default.set([_mori2.default.hashMap('Data Format', null, 'Distribution', null, 'Geography', null, 'Note', data.data.definitions, 'Timeframe', 'any', 'Type', 'Definitions')])), 'globalRules', _mori2.default.hashMap('medicare', true, 'Locked', false, 'Graph', false, 'Map', true), 'settings', _mori2.default.hashMap('globalSettings', _mori2.default.hashMap('Precision', '1', 'hasDataviews', false)));
	
	  return {
	    config: config,
	    immutableHeaders: immutableHeaders,
	    immutableData: immutableData,
	    immutableDataviews: [{
	      'label': 'default',
	      'type': 'default'
	    }],
	    immutableDistributions: immutableDistributions,
	    columns: columns,
	    timeframes: _mori2.default.intoArray(_mori2.default.map(function (item) {
	      return _mori2.default.get(item, 'timeframe_title').toString();
	    }, timeframes)),
	    globalRules: _mori2.default.toJs(_mori2.default.get(config, 'globalRules')),
	    globalSettings: _mori2.default.toJs(_mori2.default.getIn(config, ['settings', 'globalSettings'])),
	    distributionCount: _mori2.default.count(immutableDistributions)
	  };
	  // return data;
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _distributionFilters = __webpack_require__(82);
	
	var _distributionFilters2 = _interopRequireDefault(_distributionFilters);
	
	var _config = __webpack_require__(71);
	
	var _util = __webpack_require__(76);
	
	var _slugify = __webpack_require__(79);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Build the list of geodefinitions to use
	 * @param  {mori func} sheetData      sheet data (parse labels out of it)
	 * @param  {mori func} geoDefinitions geo definition hashmap
	 * @return {mori func}                map of geo definitions which are valid
	 */
	function buildGeoDefinitions(sheetData, geoDefinitions) {
	  return _mori2.default.reduce(function (acc, row) {
	    return _mori2.default.conj(acc, reduceDefinitions(row, _mori2.default.map(function (next) {
	      return _mori2.default.get(next, 'label');
	    }, sheetData)));
	  }, _mori2.default.hashMap(), geoDefinitions);
	}
	
	/**
	 * Build the column data
	 * @param  {mori func} flatData     datasheet
	 * @return { nested, wrapups}       nested and wrapups
	 */
	function buildColumnData(flatData) {
	  var nested = _mori2.default.toJs(_mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, ['Counties', 'MSAs'].indexOf(_mori2.default.first(item)) < 0 ? _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(item)), _mori2.default.hashMap('label', _mori2.default.first(item), 'children', _mori2.default.reduce(function (acc1, next) {
	      return _mori2.default.conj(acc1, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.get(next, 'label')), _mori2.default.hashMap('label', _mori2.default.get(next, 'label'))));
	    }, _mori2.default.hashMap(), _mori2.default.last(item)))) : _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(item)), _mori2.default.hashMap('label', _mori2.default.first(item), 'children', _mori2.default.reduce(function (acc1, next) {
	      return _mori2.default.conj(acc1, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(next)), _mori2.default.hashMap('label', _mori2.default.first(next), 'children', _mori2.default.reduce(function (acc2, next1) {
	        return _mori2.default.conj(acc2, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.get(next1, 'label')), _mori2.default.hashMap('colLabel', _mori2.default.get(next1, 'label'), 'label', _mori2.default.first(item) !== 'Counties' ? _mori2.default.get(next1, 'label') : _mori2.default.first(next) + ', ' + _mori2.default.get(next1, 'label'))));
	      }, _mori2.default.hashMap(), _mori2.default.last(next)))));
	    }, _mori2.default.hashMap(), _mori2.default.groupBy(function (nest) {
	      return _mori2.default.get(nest, 'state');
	    },
	    // Map data items to get list of all states in which each item exists
	    _mori2.default.flatten(_mori2.default.map(function (item1) {
	      return _mori2.default.map(function (state) {
	        return _mori2.default.into(item1, _mori2.default.hashMap('state', state));
	      }, _mori2.default.get(item1, 'states'));
	    },
	    // All data associated with each column section: MSA,, Counties, PDPs, etc
	    _mori2.default.last(item))))))));
	  }, _mori2.default.hashMap(), _mori2.default.groupBy(function (item) {
	    return _mori2.default.get(item, 'header') || 'States';
	  }, _mori2.default.filter(function (item) {
	    return _config.appDefault.specialWrapups.indexOf(_mori2.default.get(item, 'label')) === -1;
	  }, _mori2.default.first(_mori2.default.rest(_mori2.default.first(flatData)))))));
	
	  var wrapups = _mori2.default.toJs(_mori2.default.reduce(function (acc, next) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.get(next, 'label')), _mori2.default.hashMap('label', _mori2.default.get(next, 'label'))));
	  }, _mori2.default.hashMap(), _mori2.default.filter(function (item) {
	    return _config.appDefault.specialWrapups.indexOf(_mori2.default.get(item, 'label')) > -1;
	  }, _mori2.default.first(_mori2.default.rest(_mori2.default.first(flatData))))));
	
	  return { nested: nested, wrapups: wrapups };
	}
	
	/**
	 * Assemble the data in a way which DC expects it
	 * @param  {mori obj} data    flat data sheet
	 * @return {mori obj}         immutable data setup
	 */
	function buildData(data) {
	  return _mori2.default.reduce(function (acc, item1) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(item1).toString(), _mori2.default.flatten(_mori2.default.map(function (item2) {
	      return _mori2.default.map(function (item3) {
	        return _mori2.default.into(_mori2.default.hasKey(item3, 'states') && _mori2.default.get(item3, 'header') === 'Counties' ? _mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), _mori2.default.first(_mori2.default.get(item3, 'states')) + ', ' + _mori2.default.get(item3, 'label')) : _mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), _mori2.default.get(item3, 'label')), _mori2.default.get(item3, 'values'));
	      }, item2);
	    }, _mori2.default.rest(item1)))));
	  }, _mori2.default.hashMap(), data);
	}
	
	/**
	 * Get the headers, using only the first sheet
	 * @param  {mori func} timeframe    single timeframe/datasheet
	 * @return {mori func}              immutable headers map
	 */
	function getHeaders(timeframe) {
	  return _mori2.default.reduce(function (acc, next) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap('type', _mori2.default.count(acc) === 0 ? 'geography' : _mori2.default.get(_mori2.default.nth(_mori2.default.get(timeframe, 'grid'), 1), _mori2.default.count(acc)).toLowerCase(), 'label', _mori2.default.count(acc) === 0 ? 'Geography' : _mori2.default.get(_mori2.default.nth(_mori2.default.get(timeframe, 'grid'), 1), _mori2.default.count(acc)).toLowerCase(), 'characteristic', next === '' ? 'Location' : next, 'Precision', '1', 'idx', _mori2.default.count(acc)));
	  }, _mori2.default.vector(), _mori2.default.first(_mori2.default.get(timeframe, 'grid')));
	}
	
	/**
	 * Take in a definition row, and return it mapped to data
	 * @param  {mori object} row              Geo Definition row
	 * @param  {mori function} existingIds    IDs which exist in the dataset
	 * @return {mori function}                Mapped IDs w/ Props
	 */
	function reduceDefinitions(row, existingIds) {
	  // Check if nested
	  if (_mori2.default.isMap(_mori2.default.first(_mori2.default.rest(_mori2.default.first(_mori2.default.first(_mori2.default.rest(row))))))) {
	    return _mori2.default.reduce(function (acc, row1) {
	      return _mori2.default.conj(acc, _mori2.default.reduce(function (acc1, item) {
	        return _mori2.default.some(function (id) {
	          return id === _mori2.default.first(item);
	        }, existingIds) ? _mori2.default.conj(acc1, _mori2.default.hashMap(_mori2.default.first(item), _mori2.default.hashMap('label', _mori2.default.last(item), 'states', _mori2.default.into(_mori2.default.get(_mori2.default.get(acc, _mori2.default.first(item)), 'states', _mori2.default.list()), _mori2.default.list(_mori2.default.first(row1))), 'header', _mori2.default.first(row)))) : acc1;
	      }, _mori2.default.hashMap(), _mori2.default.last(row1)));
	    }, _mori2.default.hashMap(), _mori2.default.last(row));
	  }
	
	  // Else do this simple remap
	  return _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.some(function (id) {
	      return id === _mori2.default.first(item);
	    }, existingIds) ? _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(item), _mori2.default.hashMap('label', _mori2.default.last(item), 'header', _mori2.default.first(row)))) : acc;
	  }, _mori2.default.hashMap(), _mori2.default.first(_mori2.default.rest(row)));
	}

/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  RouterConfig.$inject = ['$stateProvider'];
	  function RouterConfig($stateProvider) {
	    $stateProvider
	    // Abstract state lets us use query params in the application without
	    // reloading components
	    .state('datacenter', {
	      abstract: true,
	      url: '' + _appJs2.default.base
	    }).state('datacenter.main', {
	      views: {
	        '@': {
	          template: '<datacenter-wrapper></datacenter-wrapper>'
	        }
	      },
	      url: '?' + queryParams.join('&'),
	      reloadOnSearch: false
	    });
	  }
	  return RouterConfig;
	};
	
	var _appJs = __webpack_require__(86);
	
	var _appJs2 = _interopRequireDefault(_appJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// these query params encapsulate application state
	var queryParams = ['state', 'dataView', 'activeTab', 'currentTimeframe', 'startTimeframe', 'selectedDistributions', 'override_key', 'print', '{selectedRows:json}', '{sortModel:json}']; /**
	                                                                                                                                                                                          * Add a few basic routes to ui-router for our components
	                                                                                                                                                                                          */

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = appJs;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {},
	    templateUrl: _datacenterWrapper2.default,
	    controller: mainController,
	    controllerAs: 'dc'
	  };
	};
	
	__webpack_require__(88);
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _datacenterWrapper = __webpack_require__(90);
	
	var _datacenterWrapper2 = _interopRequireDefault(_datacenterWrapper);
	
	var _renderData = __webpack_require__(91);
	
	var _renderData2 = _interopRequireDefault(_renderData);
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	var _processTableDataForDownload = __webpack_require__(147);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // CSS
	
	// JS Imports
	
	
	mainController.$inject = ['$scope', '$ngRedux', '$window', '$location', '$timeout', '$interval', 'datacenterSheet'];
	function mainController($scope, $ngRedux, $window, $location, $timeout, $interval, datacenterSheet) {
	  var _this = this;
	
	  var disconnect = $ngRedux.connect(function (state) {
	    return {
	      router: state.router,
	      sheet: state.data,
	      globalRules: state.data.globalRules,
	      globalSettings: state.data.globalSettings,
	      distributionCount: state.data.distributionCount
	    };
	  })(this);
	
	  $scope.$on('$destroy', disconnect);
	
	  this.data = {};
	  this.title = $window.document.title;
	
	  // bootstrap the data
	  $ngRedux.dispatch(datacenterSheet.buildSheetData());
	
	  // For renderData... so we can access that state
	  var reduxCallback = function reduxCallback(payload) {
	    $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', payload));
	  };
	
	  // update view when url changes
	  $scope.$on('$locationChangeStart', function (event, newval, oldval) {
	    _this.bypassLocationChangeEvent = newval.replace(oldval, '').indexOf('#note') > -1;
	  });
	
	  $scope.$on('$locationChangeSuccess', function () {
	    if (_this.bypassLocationChangeEvent) {
	      _this.bypassLocationChangeEvent = false;
	      _this.highlightFootnote();
	      return;
	    }
	
	    _this.clearNoteHighlight();
	
	    // If there are no keys, or only selectedRows (inter-indicator linking),
	    // go back a page in the browser's history
	    if (Object.keys($location.search()).filter(function (x) {
	      return x !== 'selectedRows';
	    }).length === 0) {
	      window.history.back();
	      return;
	    }
	    if (Object.keys(_this.data).length > 0) {
	      (0, _renderData2.default)(_this.sheet, _this.data, _this.router.currentParams, reduxCallback);
	    }
	  });
	
	  // render after initial data load
	  var initialWatch = $scope.$watch(function () {
	    return _this.sheet.immutableData;
	  }, function (newval) {
	    if (newval === undefined) {
	      return;
	    }
	
	    (0, _renderData2.default)(_this.sheet, _this.data, _this.router.currentParams, reduxCallback);
	
	    var slugify = angular.injector(['ng', 'slugifier']).get('slugifyFilter');
	
	    if (_this.router.currentParams.state) {
	      var stateSlug = slugify(_config.appDefault.stateLookup[_this.router.currentParams.state.toUpperCase()]);
	      $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	        selectedRows: {
	          'states': _defineProperty({}, stateSlug, {})
	        },
	        state: undefined
	      }));
	    }
	
	    // stop watching
	    initialWatch();
	  });
	
	  this.clearNoteHighlight = function () {
	    Array.prototype.forEach.call(document.querySelectorAll('#footnote-holder li p'), function (el) {
	      return el.classList.remove('note-hilight');
	    });
	  };
	
	  this.highlightFootnote = function () {
	    var _this2 = this;
	
	    this.clearNoteHighlight();
	
	    if (!!$location.hash()) {
	      $timeout(function () {
	        $window.scrollTo($window.scrollX, $window.scrollY - document.querySelector('header').clientHeight - ((document.getElementById('wpadminbar') || {}).clientHeight || 0));
	        _this2.cachedScrollY = $window.scrollY;
	      });
	
	      document.querySelector('#' + $location.hash() + ' p').classList.add('note-hilight');
	    }
	  };
	
	  this.notesButtonClick = function () {
	    this.bypassLocationChangeEvent = true;
	    if (this.cachedScrollY) {
	      $window.scrollTo($window.scrollX, this.cachedScrollY);
	    }
	  };
	
	  // Export data as csv, for options
	  // see: https://www.ag-grid.com/angular-grid-export/
	  //
	  // @TODO this entire thing needs to be refactored
	  // (also just move it to it's own file)
	  this.downloadData = function () {
	    var _this3 = this;
	
	    /* eslint-disable no-alert */
	
	    // @TODO: Refactor this to a service
	    // Get footnotes, sources, notes, etc for the timeframe
	    var notes = _mori2.default.intoArray(this.data.notes).reduce(function (prev, curr) {
	      return prev + ('"' + curr.name + '"\n' + curr.val.reduce(function (prev1, curr1) {
	        return prev1 + ('"' + (0, _processTableDataForDownload.escapeCSVQuotes)(curr1.Note).split('\n').join('"\n"') + '"\n');
	      }, '') + '\n');
	    }, '\n');
	
	    var footnotes = [];
	    if (_mori2.default.count(this.data.footnotes) > 0) {
	      footnotes = _mori2.default.intoArray(this.data.footnotes).sort(function (_ref, _ref2) {
	        var aLabel = _ref.label;
	        var bLabel = _ref2.label;
	        return aLabel - bLabel;
	      }).map(function (_ref3) {
	        var label = _ref3.label,
	            note = _ref3.note;
	        return {
	          label: label,
	          note: '' + (0, _processTableDataForDownload.escapeNewLines)((0, _processTableDataForDownload.escapeCSVQuotes)(note))
	        };
	      }).reduce(function (prev, _ref4) {
	        var label = _ref4.label,
	            note = _ref4.note;
	        return prev + '"' + label + '. ' + note + '"\n';
	      }, 'Footnotes\n');
	    }
	
	    var timeframes = this.router.currentParams.activeTab === 'graph' ? ['' + this.sheet.timeframes[this.router.currentParams.startTimeframe], '' + this.sheet.timeframes[this.router.currentParams.currentTimeframe]].join(' - ') : '' + this.sheet.timeframes[this.router.currentParams.currentTimeframe];
	
	    var customHeader = ['"Title: ' + document.title + '"', '"Timeframe: ' + timeframes + '"', ''].join('\n');
	
	    var headers = _mori2.default.filter(function (item) {
	      return _mori2.default.get(item, 'type') === 'Location' || _mori2.default.get(item, 'type') === _mori2.default.get(_this3.sheet.immutableDataviews, _this3.router.currentParams.dataView || 0).type;
	    }, this.sheet.immutableHeaders);
	
	    var customFooter = [notes, footnotes].join('\n');
	
	    var dataAsCsv = this.data.table.api.getDataAsCsv({
	      customFooter: customFooter,
	      customHeader: customHeader,
	      processCellCallback: (0, _processTableDataForDownload.processCellCallback)(headers),
	      processHeaderCallback: function processHeaderCallback(_ref5) {
	        var column = _ref5.column;
	        return column.colId;
	      }
	    });
	
	    (0, _processTableDataForDownload.downloader)('raw_data.csv',
	    // No need to clean CSV if we have no footnotes!
	    footnotes.length > 0 ? (0, _processTableDataForDownload.cleanCSV)(dataAsCsv) : dataAsCsv);
	  };
	
	  this.printWindow = function () {
	    $window.open([$location.absUrl().split('?')[0], 'view/print/?print=true&', $location.url().split('?')[1]].join(''), 'Print Window | ' + this.title, 'toolbar=no, menubar=no, resizable=yes, location=no, scrollbars=yes');
	  };
	}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/css-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/autoprefixer-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/sass-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/app/js/directives/datacenterWrapper/datacenterWrapper.scss", function() {
			var newContent = require("!!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/css-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/autoprefixer-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/node_modules/sass-loader/index.js!/Users/darylldoyle/Herd/kff/wp-content/themes/kff-org-modern/build/apps/datacenter/app/js/directives/datacenterWrapper/datacenterWrapper.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	exports.push([module.id, "header{background:#e9e9e9;margin:0 auto}header .header-inner{max-width:1185px;overflow:auto;padding:15px 30px;width:100%}header .header-inner h1.logo{width:65px;height:30px;float:left;margin:6px 20px 50px 0}header .header-inner h2{color:#1a3863;font:32px/36px \"Source Sans Pro\",Georgia,serif;position:relative}header .header-inner h4{color:#e26c00;font-family:\"Source Sans Pro\",helvetica,sans-serif;font-size:20px;margin-top:10px}header .header-inner h4 span{color:#1a3863}.print-view{padding:0 30px}.print-view .ag-root{border-right:1px solid #ccc}.print-view .ag-root .ag-header-container .ag-header-cell:last-of-type{border-right:none!important}.print-view .plus-btn{display:none!important}.dyn-wrapper .table-wrapper.ng-hide{display:block!important;height:0;visibility:hidden!important}.geomulti li{display:-ms-flexbox;display:flex;list-style:none}.geomulti li:before{content:attr(data-list-character);margin-right:10px}", ""]);

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	var path = 'directives/datacenterWrapper/datacenterWrapper.html';
	var html = "<h4 class=\"option timeframe\" ng-hide=dc.router.currentParams.print>Timeframe&#58; <span datacenter-display-timeframe=\"\" timeframes=::dc.sheet.timeframes class=\"selection context-timeframe\"></span></h4><div ng-show=dc.router.currentParams.print><header><div class=header-inner><h1 class=logo><svg xmlns=http://www.w3.org/2000/svg width=64 height=26 viewbox=\"0 0 530.409 216\"><path d=\"M123.163 0 58.18 93.161h-.62V0H0v216h57.56v-93.161h.62L123.162 216h69.317L112.63 108 192.479 0zM213.835 0v216h57.563v-86.958h83.238V88.193h-83.238V40.849h86.955V0zM385.896 0v216h57.559v-86.958h83.243V88.193h-83.243V40.849h86.954V0z\" fill=#000></svg></h1><h2>{{ dc.title }}</h2><h4>Timeframe&#58; <span datacenter-display-timeframe=\"\" timeframes=::dc.sheet.timeframes class=\"selection context-timeframe\"></span></h4></div></header></div><div ng-class=\"{'print-view': dc.router.currentParams.print}\"><div id=refine-results-wrapper ng-hide=dc.router.currentParams.print><div id=refine-results-header-top><div class=results-first-header-box><h4>Refine Results</h4></div></div><div id=refine-results-left-box class=box-dropshadow><div datacenter-refine-timeframe=\"\" timeframes=::dc.sheet.timeframes></div><div datacenter-refine-dataviews=\"\" dataviews=::dc.sheet.immutableDataviews ng-if=\"dc.globalSettings.hasDataviews && !dc.globalRules.Locked\"></div><div datacenter-refine-distributions=\"\" ng-show=\"dc.distributionCount >= 2 &&\n          (!dc.globalRules.Geomulti ||\n            (dc.globalRules.Geomulti && dc.router.currentParams.activeTab !== 'map')) &&\n          (!dc.globalRules.Locked ||\n            (dc.globalRules.Locked && dc.router.currentParams.activeTab)) ||\n\t\t\t\t\t(dc.distributionCount > 0 && dc.globalRules.Locked &&\n\t\t\t\t\t\tdc.router.currentParams.activeTab === 'map')\" locked=dc.globalRules.Locked></div><div datacenter-refine-columns=\"\" columns=::dc.sheet.columns context=::dc.globalRules.Context view=\"{{ dc.router.currentParams.activeTab }}\"></div></div></div><div class=right-double-column><p class=table-meta ng-hide=dc.router.currentParams.print><label>Tools&#58;</label><a href=#notes ng-click=dc.notesButtonClick() id=table-notes class=table-btn title=Notes></a> <a href=\"\" ng-click=dc.downloadData() id=table-raw-data class=table-btn title=\"Download Raw Data\"></a> <a save-as-image=\"\" ng-if=\"dc.router.currentParams.activeTab !== undefined\" ng-click=saveImage() href=# id=save-image class=table-btn style=\"display: inline-block\" title=\"Save Image\"></a> <a href=\"\" ng-click=dc.printWindow() id=table-new-window class=table-btn title=\"View Table in New Window\"></a></p><ul datacenter-tabs=\"\" rules=::dc.globalRules active-tab=dc.router.currentParams.activeTab class=\"tabs dc-tabs\" ng-hide=dc.router.currentParams.print></ul><div class=\"box full-post\"><div class=\"tab-container ngDcCtrl\"><div id=table-container class=tab-contentx><div ng-if=\"dc.router.currentParams.activeTab === 'graph'\"><linechart ng-if=dc.data.graphHasData immutable-data=dc.data.graph></linechart><div class=graph-missing-wrapper ng-if=!dc.data.graphHasData><div class=graph-missing><h2>Trend Graph</h2><p>To display the trend graph check some options in the sidebar.</p></div></div></div><div ng-if=\"dc.router.currentParams.activeTab === 'map'\"><div datamap=\"\" map=dc.data.mapData.data plugins=dc.data.mapData.plugins></div></div><div class=dyn-wrapper style=\"clear: both\"><div class=table-wrapper ng-show=dc.data.table.rowData.length><div ng-if=dc.data.table ag-grid=dc.data.table ng-style=\"{'height': (dc.router.currentParams.print) ? '100%' : dc.data.table.height, 'width': '100%'}\" class=ag-datacenter></div></div><div class=graph-missing-wrapper ng-hide=dc.data.table.rowData.length><div class=graph-missing><h2>Data Table</h2><p>To view data, please select some geographies from the sidebar.</p></div></div></div></div></div></div></div><div class=\"full-post datacenter-notes right-double-column\" ng-if=dc.sheet.config.notesSources><div class=accordion-wrapper><dl class=accordionShow><dt><a href=\"\"><h5>notes</h5></a><a href=\"\" class=\"plus-btn active\"></a></dt><dd id=notes><div ng-repeat=\"(key, group) in ::dc.sheet.config.notesSources\"><h6>{{ key }}</h6><p ng-repeat=\"note in group\" ng-bind-html=\"note.Note | markdown\"></p></div></dd></dl></div></div><div class=right-double-column id=notes-holder notes=\"\" data=dc.data.notes></div><div class=right-double-column id=footnote-holder footnotes=\"\" data=dc.data.footnotes geomulti=dc.globalRules.Geomulti></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (sheetData, render) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var reduxCallback = arguments[3];
	
	  if (!render.table) {
	    render.table = {};
	  }
	
	  var baseContext = _mori2.default.getIn(sheetData.config, ['globalRules', 'Context'], [])[0] || false;
	
	  // @TODO - add a check/default for options.selectedRows.  Main reason
	  // being that we are checking if it exists || {} in a number of places.
	
	  var filteredData = (0, _dataFromOptions.filterByTimeframe)(sheetData, options);
	  var filteredMetaData = (0, _dataFromOptions.filterMetaDataByTimeframe)(sheetData, options);
	  var combinedFilters = (0, _getCombinedFilters2.default)(sheetData, options, filteredMetaData);
	  var isMultiGeo = _mori2.default.get(combinedFilters[4], [1], false);
	
	  // Gets the first key in the selected rows tree
	  var treeContextSlug = Object.keys(options.selectedRows || {})[0] || false;
	
	  var footnotes = (0, _getFootnotes2.default)(sheetData, filteredMetaData, options, filteredData, combinedFilters);
	
	  function footnoteCb(key) {
	    return (0, _footnoteCallback2.default)(key, footnotes.labeledFootnotes, !!(options.currentTimeframe && options.startTimeframe));
	  }
	
	  // The table is built on every tab, including graph, because the grid
	  // lives outside the tab switch in datacenterWrapper.html.
	  _tableData2.default.bind(render.table)(sheetData, filteredMetaData, options, filteredData, [_mori2.default.set(), // All columns
	  _mori2.default.concat(_mori2.default.vector(combinedFilters[4][0]), (0, _getSelectedDistributions2.default)(sheetData, filteredMetaData, filteredMetaData.immutableDistributions, sheetData.globalSettings.hasDataviews && !_mori2.default.getIn(sheetData.config, ['globalRules', 'Locked'], false) ? _mori2.default.nth(filteredMetaData.immutableDataviews, +(options.dataView || 0)) : false)), filteredMetaData.immutableDistributions, combinedFilters[3], combinedFilters[4]], function () {
	    // Ready callback
	    // This is added to the API so we can access it when building CSV data
	    render.table.api.baseColumnContext = baseContext;
	    render.table.api.isMultiGeo = isMultiGeo;
	    render.table.api.footnoteCallback = footnoteCb;
	
	    render.table.filterDistributions(combinedFilters[1], options, _mori2.default.intoArray(_mori2.default.map(function (item) {
	      return _mori2.default.first(item);
	    }, filteredData)));
	    render.table.filterData(!isMultiGeo ? combinedFilters[0] : null);
	    render.table.api.setSortModel([options.sortModel || {
	      colId: isMultiGeo ? baseContext : 'Location',
	      sort: 'asc'
	    }]);
	  }, combinedFilters[0], // Selected Keys
	  isMultiGeo, reduxCallback,
	  // Callback general post X actions
	  function (table) {
	    table.filterDistributions(combinedFilters[1], options, _mori2.default.intoArray(_mori2.default.map(function (item) {
	      return _mori2.default.first(item);
	    }, filteredData)));
	
	    table.filterData(!isMultiGeo ? combinedFilters[0] : null);
	
	    if (table.api && options.activeTab === 'graph') {
	      table.api.setSortModel([options.sortModel || {
	        colId: isMultiGeo ? baseContext : 'Location',
	        sort: 'asc'
	      }]);
	    }
	  });
	  if (footnoteHash !== _mori2.default.hash(footnotes.labeledFootnotes) && render.table.api) {
	    render.table.api.footnoteCallback = footnoteCb;
	    footnoteHash = _mori2.default.hash(footnotes.labeledFootnotes);
	    render.table.api.refreshHeader();
	    render.table.api.refreshView();
	    if (render.table.onAfterFilterChanged) {
	      render.table.onAfterFilterChanged(); // We need to fire this to reset headers
	    }
	  }
	
	  render.footnotes = (_mori2.default.toJs(footnotes.filteredFootnotes) || []).reduce(function (acc, curr) {
	    if (acc.filter(function (_ref) {
	      var id = _ref.id;
	      return id === curr.id;
	    }).length) {
	      return acc;
	    }
	    acc.push(curr);
	    return acc;
	  }, []).sort(function (_ref2, _ref3) {
	    var a = _ref2.weight;
	    var b = _ref3.weight;
	    return a - b;
	  });
	
	  // We want to build the map data if we are on the map tab
	  // and certain options have changed
	  if (options.activeTab === 'map' && (typeof render.mapData === 'undefined' || // check that map has rendered at least once
	  isMultiGeo || // force map refresh if multigeo as selection could have changed
	  options.dataView !== cachedOptions.dataView || options.selectedDistributions !== cachedOptions.selectedDistributions || options.currentTimeframe !== cachedOptions.currentTimeframe)) {
	    render.mapData = _mapData2.default.apply(undefined, [sheetData, filteredMetaData, options, treeContextSlug, filteredData].concat(_toConsumableArray(combinedFilters)));
	  } else if (options.activeTab === 'graph') {
	    render.graph = _linechartData2.default.apply(undefined, [sheetData, options, filteredData].concat(_toConsumableArray(combinedFilters)));
	    // can't use ng-if on an immutable
	    render.graphHasData = !_mori2.default.isEmpty(render.graph);
	  }
	
	  render.notes = renderNotes(sheetData.config, sheetData.timeframes, options);
	
	  cachedOptions = _extends({}, options);
	
	  // From getSelectedColumns:  If the selected rows is invalid,
	  // we need to reset the selectedRows tree in the URL
	  var validSelection = treeContextSlug !== 'nested' && (!!sheetData.columns[treeContextSlug] || !!sheetData.columns.nested[treeContextSlug]);
	
	  if (!validSelection) {
	    reduxCallback({ selectedRows: undefined });
	    return;
	  }
	};
	
	exports.renderNotes = renderNotes;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _mapData = __webpack_require__(92);
	
	var _mapData2 = _interopRequireDefault(_mapData);
	
	var _linechartData = __webpack_require__(112);
	
	var _linechartData2 = _interopRequireDefault(_linechartData);
	
	var _tableData = __webpack_require__(113);
	
	var _tableData2 = _interopRequireDefault(_tableData);
	
	var _getCombinedFilters = __webpack_require__(132);
	
	var _getCombinedFilters2 = _interopRequireDefault(_getCombinedFilters);
	
	var _getSelectedDistributions = __webpack_require__(106);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _getFootnotes = __webpack_require__(137);
	
	var _getFootnotes2 = _interopRequireDefault(_getFootnotes);
	
	var _footnoteCallback = __webpack_require__(146);
	
	var _footnoteCallback2 = _interopRequireDefault(_footnoteCallback);
	
	var _dataFromOptions = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint id-length: [2, {"exceptions":["a","b","i"]}] */
	
	
	var cachedOptions = {};
	var footnoteHash = null;
	
	/**
	 * Given the confige, timeframes, and options, find which notes should be shown
	 *
	 * @param  {object} config        Datasheet config
	 * @param  {array} allTimeframes  Datasheet timeframes
	 * @param  {object} options       Options object
	 * @return {array}                Array of notes to show
	 */
	function renderNotes(config, allTimeframes, options) {
	  return _mori2.default.toJs(_mori2.default.map(function (item) {
	    return _mori2.default.hashMap('name', _mori2.default.first(item), 'val', _mori2.default.filter(function (val) {
	      return _mori2.default.count(_mori2.default.intersection(_mori2.default.conj(_mori2.default.set(allTimeframes.slice(+options.currentTimeframe || 0, (+options.currentTimeframe || 0) + 1).map(function (curr) {
	        return curr.replace(/\s+/g, '');
	      })), 'any', ''), _mori2.default.set((_mori2.default.get(val, 'Timeframe', '') || '').replace(/\s+/g, '').split(',')))) > 0;
	    }, _mori2.default.last(item)));
	  }, _mori2.default.get(config, 'notesSources')));
	}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data, metaData, options, treeContextSlug, timeframes) {
	  // Get geography code map from topojson
	  var geoContext = 'usa';
	  var geoCodeMap = maps.getGeoCodeMap(geoContext);
	  var mapConfig = _mori2.default.toJs(maps.mapDefault(geoContext));
	  var isLocked = _mori2.default.getIn(data.config, ['globalRules', 'Locked'], false);
	  var isGeomulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	  var mapBaseColumn = _mori2.default.getIn(data.config, ['globalRules', 'Map Base Column'], false);
	  var baseColumn = void 0;
	
	  // Get the current data view object by index
	  var dataviewType = data.globalSettings.hasDataviews && !isLocked ? _mori2.default.nth(metaData.immutableDataviews, +(options.dataView || 0)) : false;
	
	  // Currently selected distributions by matching slugs, or all
	  var distributions = options.selectedDistributions ? _mori2.default.filter(function (x) {
	    return options.selectedDistributions === _mori2.default.get(x, 'slug');
	  }, metaData.immutableDistributions) : metaData.immutableDistributions;
	
	  // Create sets as keys for data
	  var selected = (0, _getSelectedDistributions2.default)(data, metaData, distributions, dataviewType, isGeomulti);
	
	  // Map selected headers by distribution name and type
	  // Pluck distribution names from the selected distributions array
	  var distributionNames = _mori2.default.set(_mori2.default.map(function (characteristic) {
	    return _mori2.default.get(characteristic, 'characteristic');
	  }, distributions));
	  var selectedHeader = _mori2.default.first(_mori2.default.rest(_mori2.default.filter(function (header) {
	    return _mori2.default.get(header, 'idx') === 0 || _mori2.default.hasKey(distributionNames, _mori2.default.get(header, 'characteristic')) && (!dataviewType || dataviewType.type === _mori2.default.get(header, 'type') || dataviewType.label === _mori2.default.get(header, 'label'));
	  }, metaData.immutableHeaders)));
	
	  // Normally the base column is just the first
	  if (!isGeomulti) {
	    baseColumn = _mori2.default.vector(_mori2.default.set([_mori2.default.get(_mori2.default.first(metaData.immutableHeaders), 'characteristic'), _mori2.default.get(_mori2.default.first(metaData.immutableHeaders), 'label')]));
	    // otherwise get the base column specified by config
	  } else {
	    baseColumn = _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (header) {
	      return _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.getIn(data.config, ['globalRules', 'Link Column']));
	    }), _mori2.default.map(function (header) {
	      var dataviewLabel = dataviewType ? dataviewType.label : _mori2.default.get(header, 'label');
	      return _mori2.default.set([_mori2.default.get(header, 'characteristic'), dataviewLabel]);
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), metaData.immutableHeaders);
	  }
	
	  // Make an array of selected/parent selection rows
	  var parentColumns = isGeomulti ? _mori2.default.map(function (row) {
	    var rowKey = _mori2.default.first(row);
	    var columns = metaData.columns.nested[treeContextSlug] || {};
	    var currentChild = (columns.children || {})[rowKey];
	    return currentChild.label || rowKey;
	  }, _mori2.default.toClj((options.selectedRows || {})[treeContextSlug] || {})) : false;
	
	  // Join the base column and the selected sets
	  var selectedSetKeys = _mori2.default.into(baseColumn, selected);
	
	  // Set map constructor values
	  mapConfig.scope = geoContext;
	  mapConfig.data = buildMapData(timeframes, selectedSetKeys, geoCodeMap, selectedHeader, baseColumn, parentColumns, isGeomulti, mapBaseColumn);
	  mapConfig.setProjection = maps.setMapProjection(geoContext, mapConfig);
	  mapConfig.fills = {};
	
	  // Calculate and apply fill and legend
	
	  var _buildMapFills = buildMapFills(mapConfig.fills, mapConfig.data),
	      fills = _buildMapFills.fills,
	      labels = _buildMapFills.labels,
	      mapDataProcessed = _buildMapFills.mapDataProcessed;
	
	  mapConfig.fills = fills;
	  mapConfig.labels = labels;
	  mapConfig.labels.defaultFill = mapBaseColumn ? 'Firm is Not Operating in State' : mapConfig.labels.defaultFill;
	  mapConfig.data = mapDataProcessed;
	
	  return {
	    data: mapConfig,
	    plugins: buildMapPlugins(geoContext)
	  };
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	var _maps = __webpack_require__(93);
	
	var maps = _interopRequireWildcard(_maps);
	
	var _util = __webpack_require__(76);
	
	var util = _interopRequireWildcard(_util);
	
	var _jenks = __webpack_require__(105);
	
	var _jenks2 = _interopRequireDefault(_jenks);
	
	var _getSelectedDistributions = __webpack_require__(106);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _filters = __webpack_require__(107);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _switchFilter = __webpack_require__(110);
	
	var _switchFilter2 = _interopRequireDefault(_switchFilter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	
	/* eslint id-length: [2, {"exceptions": ["a","b","t","m","x"]}] */
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  //  This is react's territory
	  filterSwitch = (0, _switchFilter2.default)();
	}
	
	function buildMapData(timeframes, selected, codes, selectedHeader, baseColumn, parentColumns, isGeomulti, mapBaseColumn) {
	  var firstKey = _mori2.default.first(selected);
	  var secondKey = _mori2.default.first(_mori2.default.rest(selected));
	
	  var baseKey = isGeomulti ? secondKey : firstKey;
	  var dataKey = isGeomulti ? firstKey : secondKey;
	
	  return _mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (x) {
	    // geomulti datapoints are simply the header title as the value in all
	    // states that exist
	    if (isGeomulti) {
	      var title = _mori2.default.get(selectedHeader, 'characteristic');
	
	      var value = mapBaseColumn ? _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap(_mori2.default.get(x, dataKey), _mori2.default.map(function (item) {
	        return _mori2.default.hashMap(_mori2.default.first(item), _mori2.default.get(x, item));
	      }, _mori2.default.filter(function (item) {
	        return _mori2.default.first(item) !== _mori2.default.first(baseKey) && _mori2.default.first(item) !== _mori2.default.first(dataKey);
	      }, _mori2.default.keys(x))))) : title;
	
	      return _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap('value', value, 'raw', mapBaseColumn ? 'Firm is Operating in State' : title, 'formatted', mapBaseColumn ? 'Firm is Operating in State' : title, 'mapBaseColumn', mapBaseColumn));
	    }
	    var rawNum = util.kffNumericValue(_mori2.default.get(x, dataKey));
	    if (rawNum !== null && /^percent/.test(_mori2.default.get(selectedHeader, 'type'))) {
	      // @TODO replace with built in filter
	      rawNum = util.numberPrecision(rawNum, util.getPrecision(_mori2.default.toJs(selectedHeader)), true);
	    }
	    var formatted = filterSwitch(_mori2.default.get(x, dataKey), _mori2.default.toJs(selectedHeader));
	    return _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap('value', _mori2.default.get(x, dataKey), 'raw', rawNum !== null ? rawNum : _mori2.default.get(x, dataKey), 'formatted', formatted));
	  }, _mori2.default.filter(function (x) {
	    return !parentColumns ?
	    // filter by actual states
	    codes[_mori2.default.get(x, baseKey)] :
	    // filter by selected row values
	    _mori2.default.equals(_mori2.default.get(x, _mori2.default.first(baseColumn)), _mori2.default.first(parentColumns));
	  }, _mori2.default.first(_mori2.default.rest(_mori2.default.first(timeframes))))));
	}
	
	/**
	 * Apply fill and legend calculation for datamap constructor
	 */
	function buildMapFills(mapFills, mapData) {
	  // Calculate breaks using jenks
	  var breaks = buildBreaks(mapData);
	
	  // Build fills and legend using breaks data
	
	  var _buildLegend = buildLegend(breaks, mapFills),
	      fills = _buildLegend.fills,
	      labels = _buildLegend.labels;
	
	  // Apply fills to map data
	
	
	  var mapDataProcessed = annotateData(mapData, breaks);
	
	  return { fills: fills, labels: labels, mapDataProcessed: mapDataProcessed };
	}
	
	/**
	 * Apply the correct fill keys to map data objects
	 */
	function annotateData(data, breaks) {
	  return _mori2.default.toJs(_mori2.default.transduce(_mori2.default.map(function (x) {
	    var _x = _mori2.default.hashMap(_mori2.default.first(x), _mori2.default.first(_mori2.default.rest(x)));
	    var fillKey = getFillKey(_mori2.default.get(breaks, 'useTextForFill') ? _mori2.default.get(_mori2.default.first(_mori2.default.rest(x)), 'formatted') : _mori2.default.get(_mori2.default.first(_mori2.default.rest(x)), 'raw'), breaks);
	    _x = _mori2.default.assocIn(_x, [_mori2.default.first(x), 'fillKey'], fillKey);
	    return _x;
	  }), _mori2.default.completing(_mori2.default.conj), _mori2.default.hashMap(), data));
	}
	
	/**
	 * Get the fill key for given data value
	 */
	function getFillKey(value, breaks) {
	  if (_mori2.default.some(function (val) {
	    return val === value;
	  }, _mori2.default.get(breaks, 'text'))) {
	    return _config.appDefault.dataNotAvailable.indexOf(value) > -1 || !value ? 'defaultFill' : value;
	  } else if (_mori2.default.get(breaks, 'useTextForFill') && _mori2.default.intoArray(_mori2.default.get(breaks, 'text')).indexOf(value) > -1) {
	    return _mori2.default.intoArray(_mori2.default.get(breaks, 'text')).indexOf(value);
	  } else if (!isNaN(value)) {
	    // If we have fewer than the max number of breaks,
	    // we need to map data to the break points exactly.
	    // This way, we are not grouping small data sets into
	    // one break point.
	    //
	    // If there are more than max breaks, we need to build a
	    // set of ranges.
	    var breakIndex = _mori2.default.intoArray(_mori2.default.get(breaks, 'fewerThanMaxBreaks') ? _mori2.default.get(breaks, 'values') : _mori2.default.rest(_mori2.default.get(breaks, 'values'))).reduce(function (acc, point, index) {
	      if (_mori2.default.get(breaks, 'fewerThanMaxBreaks')) {
	        return +value === point && acc < 0 ? index : acc;
	      }
	      return +value < point && acc < 0 ? index : acc;
	    }, -1);
	    if (breakIndex === -1) {
	      return _mori2.default.count(_mori2.default.get(breaks, 'values')) - 2;
	    }
	    return '' + breakIndex;
	  }
	  return 'defaultFill';
	}
	
	/**
	 * Constuct breaks arrays for numerical and text values,
	 * so they can be combined.
	 */
	function buildBreaks(data) {
	  var values = _mori2.default.groupBy(function (value) {
	    return util.kffIsNumber(_mori2.default.get(value, 'raw')) ? 'numeric' : 'text';
	  }, _mori2.default.map(function (row) {
	    return _mori2.default.first(_mori2.default.rest(row));
	  }, data));
	
	  // sort numeric
	  values = _mori2.default.assocIn(values, ['numeric'], _mori2.default.sort(function (a, b) {
	    return _mori2.default.get(a, 'raw') - _mori2.default.get(b, 'raw');
	  }, _mori2.default.get(values, 'numeric')));
	
	  var textBreaks = _mori2.default.distinct(_mori2.default.map(function (value) {
	    return _config.appDefault.dataNotAvailable.indexOf(_mori2.default.get(value, 'raw')) > -1 ? 'N/A' : _mori2.default.get(value, 'raw');
	  }, _mori2.default.get(values, 'text')));
	
	  var numeralBreaks = [];
	
	  // If we have few than 5 numeric values, we need to let
	  // the fillKey lookup code know that it has to look at
	  // the rawValues for data, else no key would be found
	  var useTextForFill = _mori2.default.count(_mori2.default.get(values, 'numeric')) < 5;
	
	  if (useTextForFill) {
	    textBreaks = _mori2.default.into(textBreaks, _mori2.default.distinct(_mori2.default.map(function (value) {
	      return _mori2.default.get(value, 'formatted');
	    }, _mori2.default.get(values, 'numeric'))));
	  } else {
	    var separated = _mori2.default.groupBy(function (value) {
	      return +_mori2.default.get(value, 'raw') < 0 ? 'negative' : 'positive';
	    }, _mori2.default.get(values, 'numeric'));
	    var offset = _mori2.default.hasKey(separated, 'negative') ? 1 : 0;
	
	    // Get Positive Breaks
	    var positiveNumeralBreaks = _mori2.default.count(_mori2.default.distinct(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive')))) < _config.appDefault.maxBreaks ? _mori2.default.toJs(_mori2.default.distinct(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive')))) : (0, _jenks2.default)(_mori2.default.toJs(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive'))), _config.appDefault.maxBreaks - offset) || [];
	
	    numeralBreaks = positiveNumeralBreaks.concat(offset ? (0, _jenks2.default)(_mori2.default.toJs(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'negative'))), _config.appDefault.maxBreaks - _mori2.default.count(_mori2.default.distinct(positiveNumeralBreaks.filter(function (x) {
	      return x || x === 0;
	    })))) : []).sort(function (a, b) {
	      return a > b;
	    });
	  }
	
	  // in case the sample is too small, or doesn't have unique values
	  // TODO: test if this is necessary
	  var realBreaks = _mori2.default.distinct(numeralBreaks.filter(function (x) {
	    return x || x === 0;
	  }));
	
	  if (_mori2.default.count(realBreaks) >= 1) {
	    // Find the longest decimal position, so we can pad all values
	    var numeralPrecisionMax = numeralBreaks.reduce(function (max, curr) {
	      var stringValue = curr + '';
	      if (stringValue.indexOf('.') === -1) {
	        return max;
	      }
	      var precision = stringValue.split('.')[1].length;
	      if (precision > max) {
	        return precision;
	      }
	      return max;
	    }, 0);
	    // Pad
	    numeralBreaks = _mori2.default.distinct(_mori2.default.map(function (value) {
	      return value === 0 || typeof value === 'undefined' ? 0 : +value.toFixed(numeralPrecisionMax);
	    }, numeralBreaks));
	  }
	
	  return _mori2.default.hashMap('text', textBreaks, 'values', numeralBreaks, 'rawValues', values, 'useTextForFill', useTextForFill, 'fewerThanMaxBreaks', _mori2.default.count(numeralBreaks) < _config.appDefault.maxBreaks);
	}
	
	/**
	 * Process breaks for legend and fills, combining if necessary.
	 */
	function buildLegend(breaks, fills) {
	  var labels = {};
	  // Don't include default fills
	  var textBreaks = _mori2.default.filter(function (x) {
	    return x && x.length && _config.appDefault.dataNotAvailable.indexOf(x) === -1;
	  }, _mori2.default.get(breaks, 'text'));
	
	  var lengthOffset = _mori2.default.get(breaks, 'fewerThanMaxBreaks') ? 0 : 1;
	
	  var legendLength = (!_mori2.default.isEmpty(_mori2.default.get(breaks, 'values')) ? _mori2.default.count(_mori2.default.get(breaks, 'values')) - lengthOffset : 0) + _mori2.default.count(textBreaks);
	  var colorIndex = 0;
	
	  if (legendLength > 6) {
	    legendLength = 'full';
	  }
	
	  // Map breaks for numerical values to legend + fills
	  if (!_mori2.default.isEmpty(_mori2.default.get(breaks, 'values'))) {
	    // Group values by breakpoint
	    var grouped = _mori2.default.toJs(_mori2.default.groupBy(function (row) {
	      var group = _mori2.default.peek(_mori2.default.into(_mori2.default.vector(), _mori2.default.takeWhile(function (breakValue) {
	        return breakValue <= _mori2.default.get(row, 'raw');
	      }, _mori2.default.get(breaks, 'values'))));
	      // The last breakpoint is a bound, not a group
	      if (!_mori2.default.get(breaks, 'fewerThanMaxBreaks') && group === _mori2.default.last(_mori2.default.get(breaks, 'values'))) {
	        return _mori2.default.count(_mori2.default.get(breaks, 'values')) - 2;
	      }
	      return _mori2.default.toJs(_mori2.default.get(breaks, 'values')).indexOf(group);
	    }, _mori2.default.getIn(breaks, ['rawValues', 'numeric'])));
	
	    Object.keys(grouped).forEach(function (idx) {
	      var startBreak = grouped[idx][0].formatted;
	      var endBreak = grouped[idx][grouped[idx].length - 1].formatted;
	      labels[idx] = '' + startBreak;
	      if (startBreak !== endBreak) {
	        labels[idx] += '- ' + endBreak;
	      }
	      fills[idx] = maps.mapColors[legendLength][colorIndex];
	      colorIndex++;
	    });
	  }
	
	  // Map breaks for text values to legend + fills
	  if (_mori2.default.count(_mori2.default.get(breaks, 'text'))) {
	    _mori2.default.each(_mori2.default.sort(function (a, b) {
	      return a.localeCompare(b);
	    }, _mori2.default.filter(function (x) {
	      return x && _config.appDefault.dataNotAvailable.indexOf(x) === -1 && x.length;
	    }, _mori2.default.get(breaks, 'text'))), function (x) {
	      labels[_mori2.default.count(_mori2.default.get(breaks, 'values')) + colorIndex] = x;
	      fills[x] = maps.mapColors[legendLength][colorIndex];
	      colorIndex++;
	    });
	  }
	
	  // Make sure we set the defaultFill
	  fills.defaultFill = maps.mapColors.defaultColor;
	  labels.defaultFill = 'N/A';
	
	  return { fills: fills, labels: labels };
	}
	
	/**
	 * Set up plugins object for the map
	 */
	function buildMapPlugins(geoContext) {
	  var plugins = {
	    mapCustomLegend: maps.mapCustomLegend
	  };
	  if (geoContext === 'usa') {
	    plugins.mapCustomLabels = maps.mapCustomLabels;
	  }
	  return plugins;
	}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapColors = undefined;
	exports.mapDefault = mapDefault;
	exports.getGeoCodeMap = getGeoCodeMap;
	exports.setMapProjection = setMapProjection;
	exports.mapCustomLegend = mapCustomLegend;
	exports.mapCustomLabels = mapCustomLabels;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _d = __webpack_require__(77);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _datamaps = __webpack_require__(94);
	
	var _datamaps2 = _interopRequireDefault(_datamaps);
	
	var _d3 = __webpack_require__(97);
	
	var _d4 = _interopRequireDefault(_d3);
	
	var _config = __webpack_require__(71);
	
	var _countryMapCodes = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapColors = exports.mapColors = {
	  'defaultColor': '#b6b6b6',
	  '1': ['#014f87'],
	  '2': ['#99ddff', '#014f87'],
	  '3': ['#99ddff', '#014f87', '#13283c'],
	  '4': ['#99ddff', '#2a91c2', '#014f87', '#13283c'],
	  '5': ['#d6f1ff', '#99ddff', '#2a91c2', '#014f87', '#13283c'],
	  '6': ['#d6f1ff', '#99ddff', '#2a91c2', '#0b69c1', '#014f87', '#13283c'],
	  'full': ['#d6f1ff', '#99ddff', '#47c2ff', '#2a91c2', '#0d7ee7', '#0b69c1', '#014f87', '#13283c']
	};
	
	// Datamaps default configs
	
	// Country Codes for World Map
	function mapDefault(scope) {
	  return _mori2.default.toClj({
	    geographyConfig: {
	      highlightBorderColor: '#FFFFFF',
	      popupTemplate: function popupTemplate(geography, data) {
	        var geoValue = (data || {}).formatted || 'N/A';
	        var geoName = scope === 'usa' ? geography.properties.name : _countryMapCodes.countries[_countryMapCodes.countryCodes[geography.id]];
	
	        if (data.mapBaseColumn && data.value) {
	          var nonGeoMapData = data.value[geography.id];
	
	          var items = '' + Object.keys(nonGeoMapData).map(function (key) {
	            return '<strong>' + key + '</strong><br/>' + nonGeoMapData[key].map(function (item) {
	              return '<em>' + Object.keys(item)[0] + ':</em>\n                  ' + item[Object.keys(item)[0]];
	            }).join('<br/>');
	          });
	
	          // @TODO - find better markup for these tooltips
	          return '<div class="datamaps-hover wide">\n          <span><span><p class="mapBaseColumn"><span>\n            ' + items + '\n          </span></p></span></span>\n          </div>';
	        }
	
	        return '\n  <div class="datamaps-hover">\n  <span><span>\n  <p><span>' + geoName + ': ' + geoValue + '</span></p>\n  </span></span>\n  </div>';
	      },
	      borderWidth: 1,
	      highlightBorderWidth: 2
	    },
	    options: {
	      labels: false,
	      legend: false,
	      width: 753,
	      height: 452,
	      legendHeight: 100
	    },
	    fills: {}
	  });
	}
	
	// Map the geography codes so we can assign them properly
	function getGeoCodeMap(geoContext) {
	  return _datamaps2.default.prototype[geoContext + 'Topo'].objects[geoContext].geometries.reduce(function (acc, curr) {
	    acc[curr.properties.name] = curr.id;
	    return acc;
	  }, {});
	}
	
	/**
	 * Return the proper projection for the map
	 */
	function setMapProjection(geoContext, mapConfig) {
	  if (geoContext === 'world') {
	    return function setProjection(element) {
	      var projection = _d2.default.geo.vanDerGrinten3().center([0, 10]).scale(129).translate([element.offsetWidth / 2 - 10, element.offsetHeight / 2]);
	      var path = _d2.default.geo.path().projection(projection);
	      return { path: path, projection: projection };
	    };
	  }
	  return function setProjection() {
	    var projection = _d2.default.geo.albersUsa().scale(mapConfig.options.width * 1.3).translate([mapConfig.options.width / 2, mapConfig.options.height / 2]);
	    var path = _d2.default.geo.path().projection(projection);
	    return { path: path, projection: projection };
	  };
	}
	
	/**
	 * Sets up the custom legend for KFF
	 */
	
	function mapCustomLegend() {
	  var _this2 = this;
	
	  _d2.default.select(this.options.element).select('.datamaps-legend').remove();
	
	  if (!this.options.fills) {
	    return;
	  }
	
	  var legendItems = Object.keys(this.options.fills).reduce(function (out, fillKey) {
	    var label = '';
	    if (fillKey === 'defaultFill') {
	      if (!_this2.options.labels[fillKey] || _this2.options.labels[fillKey] === 'N/A') {
	        return out;
	      }
	      label = _this2.options.labels[fillKey];
	    } else {
	      if (_this2.options.labels && _this2.options.labels[parseInt(fillKey, 10)]) {
	        label = _this2.options.labels[parseInt(fillKey, 10)];
	      } else {
	        label = fillKey;
	      }
	    }
	    out.push({
	      'name': label,
	      'color': _this2.options.fills[fillKey]
	    });
	
	    return out;
	  }, []);
	
	  var hasNoDataItems = !!Object.keys(this.options.data).filter(function (key) {
	    return _config.appDefault.dataNotAvailable.indexOf(_this2.options.data[key].raw) >= 0;
	  }).length;
	  if (hasNoDataItems && this.options.labels.hasOwnProperty('defaultFill')) {
	    legendItems.push({
	      'name': 'N/A',
	      'color': this.options.fills.defaultFill
	    });
	  }
	
	  var margin = { top: 5, right: 0, bottom: 5, left: 0 };
	  var width = 753;
	  var top = 460;
	  var left = 10;
	  var height = legendItems.length % 4 === 0 ? legendItems.length / 4 * 50 : (Math.floor(legendItems.length / 4) + 1) * 50;
	
	  (0, _d4.default)(this.options.element.children[0], legendItems, {
	    margin: margin,
	    width: width,
	    height: height,
	    top: top,
	    left: left,
	    wrapper: 'g',
	    isMap: true
	  });
	
	  var legendHeight = _d2.default.select(this.options.element.children[0]).select('.datamaps-legend').node().getBBox().height + margin.top;
	
	  // Update Height
	  _d2.default.select(this.options.element.children[0]).attr('height', top + Math.max(height, legendHeight));
	
	  // Remove bottom padding
	  var padding = height >= 100 ? 20 : 100 - height;
	  this.options.element.style.paddingBottom = padding + 'px';
	}
	
	/**
	 * Sets up custom state labels for outside boxes
	 */
	function mapCustomLabels(layer) {
	  var _this = this;
	  var labelStartCoodinates = _this.projection([-67.707617, 42.722131]);
	
	  _d2.default.selectAll('.datamaps-subunit').attr('data-foo', function (d) {
	    var center = _this.path.centroid(d);
	    var smallStateIndex = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC', 'HI'].indexOf(d.id);
	    var xOffset = 7.5;
	    var yOffset = 5;
	    var x = void 0;
	    var y = void 0;
	
	    if (['FL', 'KY', 'MI'].indexOf(d.id) > -1) {
	      xOffset = -2.5;
	    }
	    if (d.id === 'NY') {
	      xOffset = -1;
	    }
	    if (d.id === 'MI') {
	      yOffset = 18;
	    }
	    if (d.id === 'LA') {
	      xOffset = 13;
	    }
	    if (d.id === 'HI') {
	      xOffset = 30;
	    }
	
	    x = center[0] - xOffset;
	    y = center[1] + yOffset;
	
	    if (smallStateIndex > -1) {
	      if (d.id !== 'HI') {
	        var yStart = labelStartCoodinates[1];
	        x = labelStartCoodinates[0];
	        y = yStart + smallStateIndex * (2 + (_this.options.fontSize || 12));
	        layer.append('line').attr('x1', x - 3).attr('y1', y - 5).attr('x2', center[0]).attr('y2', center[1]).style('stroke', _this.options.labelColor || '#DDD').style('stroke-width', _this.options.lineWidth || 1);
	      }
	
	      layer.append('rect').attr('width', '24px').attr('height', '16px').attr('fill', _this.options.fills[(_this.options.data[d.id] || {}).fillKey] || _this.options.fills.defaultFill).attr('x', x - 4).attr('y', y - 12).attr('data-info', JSON.stringify(_this.options.data[d.id])).on('mouseover', function () {
	        var $this = _d2.default.select(this).attr('data-info', JSON.stringify(_this.options.data[d.id]));
	
	        _this.options.popupTemplate = _this.options.geographyConfig.popupTemplate;
	        _this.updatePopup($this, d, _this.options, _this.svg);
	
	        var $state = _this.svg.select('.' + d.id);
	        var prevAttr = {
	          'fill': $state.style('fill'),
	          'stroke': $state.style('stroke'),
	          'stroke-width': $state.style('stroke-width'),
	          'fill-opacity': $state.style('fill-opacity')
	        };
	
	        $this.style('fill', _this.options.bubblesConfig.highlightFillColor).style('fill-opacity', _this.options.bubblesConfig.highlightFillOpacity);
	
	        $state.style('fill', _this.options.bubblesConfig.highlightFillColor).style('stroke', _this.options.bubblesConfig.highlightBorderColor).style('stroke-width', _this.options.bubblesConfig.highlightBorderWidth).style('fill-opacity', _this.options.bubblesConfig.highlightFillOpacity).attr('data-previousAttributes', JSON.stringify(prevAttr));
	      }).on('mouseout', function () {
	        var $this = _d2.default.select(this);
	        var $state = _this.svg.select('.' + d.id);
	        var prevAttr = JSON.parse($state.attr('data-previousAttributes'));
	        for (var attr in prevAttr) {
	          if (attr) {
	            $state.style(attr, prevAttr[attr]);
	            if (attr === 'fill' || attr === 'fill-opacity') {
	              $this.style(attr, prevAttr[attr]);
	            }
	          }
	        }
	        _d2.default.selectAll('.datamaps-hoverover').style('display', 'none');
	      });
	    }
	
	    layer.append('text').attr('x', x).attr('y', y).style('font-size', _this.options.fontSize || 12).style('font-weight', 'bold').style('font-family', _this.options.fontFamily || 'Arial, Helvetica, sans-serif').style('fill', ['#99ddff', '#d6f1ff'].indexOf(_this.options.fills[(_this.options.data[d.id] || {}).fillKey]) !== -1 ? '#13283c' : _this.options.labelColor || '#FFF').style('pointer-events', 'none').text(d.id);
	  });
	}

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // This is a custom legend for KFF Datacenter
	
	/**
	 * Function which builds the d3 legend
	 * @param  {string} selector  dom element which should contain the svg
	 * @param  {array} data       array of data objects to setup legend
	 * @param  {object} options   sepecific option types
	 * @return {null}
	 *
	 */
	
	
	exports.default = function (selector, data) {
	  var inputOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  // Setup default options and information needed for the build
	  var options = _extends({}, _legend.legendOptions, inputOptions);
	
	  options.availableWidth = options.width - options.margin.left - options.margin.right;
	
	  options.columnWidth = Math.floor(options.availableWidth / options.maxSplit);
	
	  // Initialize the legend
	  init(selector, util.buildData(data, options), options);
	};
	
	var _d = __webpack_require__(77);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _rows = __webpack_require__(98);
	
	var _rows2 = _interopRequireDefault(_rows);
	
	var _util = __webpack_require__(100);
	
	var util = _interopRequireWildcard(_util);
	
	var _legend = __webpack_require__(103);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init(selector, data, options) {
	  if (!options.isMap) {
	    _d2.default.select(selector).select(options.wrapper).remove();
	  } else {
	    _d2.default.select(selector).select('g.datamaps-legend').remove();
	  }
	
	  var container = _d2.default.select(selector).append(options.wrapper).classed('datamaps-legend', function () {
	    return options.isMap;
	  }).attr('width', options.width).attr('transform', 'translate(' + options.left + ', ' + options.top + ')');
	
	  var legend = container.selectAll('g.legend').data(data);
	
	  var legendEnter = legend.enter().append('g').classed('legend', true).attr('transform', 'translate(' + options.margin.right + ', ' + options.margin.top + ')');
	
	  // draw distribution selections for linechart
	  if (!options.isMap) {
	    (0, _rows2.default)(legendEnter, options, true);
	  }
	
	  // draw both base column selections
	  (0, _rows2.default)(legendEnter, options);
	
	  util.wrapText(legendEnter.selectAll('text'), options.columnWidth - 30, options);
	
	  util.heightizer(legendEnter, options);
	
	  container.attr('height', legend.node().getBBox().height + options.margin.top + options.margin.bottom);
	}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (legendEnter, options) {
	  var isDistribution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var row = legendEnter.selectAll(isDistribution ? '.legend-row.legend-row-distribution' : '.legend-row.legend-row-item').data(function (d) {
	    return isDistribution ? d.distributions : d.states;
	  });
	
	  var rowEnter = row.enter().append('g').classed({
	    'legend-row': true,
	    'legend-row-item': !isDistribution,
	    'legend-row-distribution': isDistribution
	  });
	
	  (0, _items2.default)(rowEnter, options, isDistribution);
	  row.exit();
	};
	
	var _items = __webpack_require__(99);
	
	var _items2 = _interopRequireDefault(_items);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (rowEnter, options) {
	  var isDistribution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var item = rowEnter.selectAll('.legend-item').data(function (d) {
	    return d;
	  });
	
	  var itemEnter = item.enter().append('g').classed('legend-item', true).attr('transform', function (d, i) {
	    var x = i % 4 * options.columnWidth;
	    return 'translate(' + x + ',0)';
	  });
	
	  var itemText = itemEnter.append('text').classed({
	    'legend-text': true,
	    'legend-text-distribution': isDistribution
	  }).attr('fill', '#000').attr('transform', 'translate(' + options.textPadding.left + ', ' + options.textPadding.top + ')').style(options.font);
	
	  itemEnter.append('g').classed({
	    'legend-symbol': true,
	    'legend-symbol-distribution': isDistribution
	  }).attr('height', 30).attr('width', 30).style({
	    'stroke-width': 0
	  });
	
	  var itemSymbol = itemEnter.select('.legend-symbol');
	
	  if (isDistribution) {
	    itemText.text(function (d) {
	      return d.characteristic;
	    });
	
	    itemSymbol.append('path').classed('distributions-symbol', true).attr('transform', 'translate(10, 11)').attr('d', _d2.default.svg.symbol().type(function (d) {
	      return d.shape;
	    }).size(15)).attr('fill', '#fff').attr('stroke', '#000').style({
	      'stroke-width': 2
	    });
	  } else {
	    itemText.text(function (d) {
	      return d.state || d.name;
	    });
	
	    itemSymbol.append('rect').classed('legend-symbol-bg', true).attr('height', 20).attr('width', 20).attr('transform', 'translate(3,3)').style({
	      'stroke-width': 0,
	      'fill': '#e7e7e7'
	    });
	
	    itemSymbol.append('rect').classed('legend-symbol', true).attr('height', 20).attr('width', 20).attr('transform', 'translate(0,0)').style({
	      'fill': function fill(d) {
	        return d.color;
	      },
	      'stroke-width': 0
	    });
	  }
	
	  item.exit();
	};
	
	var _d = __webpack_require__(77);
	
	var _d2 = _interopRequireDefault(_d);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.heightizer = heightizer;
	exports.wrapText = wrapText;
	exports.buildData = buildData;
	
	var _d = __webpack_require__(77);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _geoSort = __webpack_require__(101);
	
	var _geoSort2 = _interopRequireDefault(_geoSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 * Set proper heights so spacing works
	 */
	function heightizer(container, options) {
	  var siblingAdjustment = 0;
	  var legendRows = container.selectAll('g.legend-row');
	  legendRows.each(function (d, idx) {
	    var actingRow = _d2.default.select(this);
	    actingRow.attr('transform', 'translate(0, ' + (idx !== 0 ? siblingAdjustment : 0) + ')');
	
	    var legendItems = actingRow.selectAll('g.legend-item');
	    legendItems.each(function () {
	      var actingItem = _d2.default.select(this);
	      var childSiblingAdjustment = options.rowSpacing;
	      childSiblingAdjustment += actingItem.select('.legend-text').node().getBBox().height;
	    });
	
	    siblingAdjustment += actingRow.node().getBBox().height + options.rowSpacing;
	  });
	}
	
	function wrapText(texts, width, options) {
	  texts.each(function () {
	    var text = _d2.default.select(this);
	    // check if we even need to do wrapping
	    if (text.node().getComputedTextLength() > width) {
	      var words = text.text().split(/\s+/);
	      var line = [];
	      var lineHeight = 1.1; // ems
	      var y = text.attr('y');
	      var dy = parseFloat(text.attr('dy')) || 0;
	      var tspan = text.text(null).append('tspan').attr('x', 0).attr('y', y).attr('dy', dy + 'em');
	
	      words.forEach(function (word) {
	        line.push(word);
	        tspan.text(line.join(' '));
	        if (tspan.node().getComputedTextLength() > width) {
	          text.attr('transform', 'translate(' + options.textPadding.left + ', ' + options.textPadding.top + ')');
	          line.pop();
	          tspan.text(line.join(' '));
	          line = [word];
	          tspan = text.append('tspan').attr('x', 0).attr('y', y).attr('dy', lineHeight + dy + 'em').text(word);
	        }
	      });
	    }
	  });
	}
	
	/**
	 * Sorts the data and transforms it into:
	
	 * [
	 *   {
	 *     'states': [
	 *       {
	 *         'state': 'Texas'
	 *         'color': '#e7e7e7',
	 *       },
	 *       {..},
	 *       {..},
	 *     ]
	 *   }, {
	 *     'characteristic': [
	 *       {
	 *         'characteristic': 'Average GDP',
	 *         'shape': 'circle',
	 *       },
	 *       {..},
	 *       {..},
	 *     ]
	 *   }
	 * ]
	 *
	 * *****************************
	 * ** OR if generating for a map legend **
	 * *****************************
	 *
	 * [
	 *   {
	 *     'states': [
	 *       {
	 *         'state': 'Texas'
	 *         'color': '#e7e7e7',
	 *         'characteristics': [
	 *           {
	 *             'characteristic': 'Average GDP',
	 *             'shape': 'circle',
	 *             'color': '#e7e7e7',
	 *           },
	 *           {..},
	 *           {..},
	 *         ],
	 *       },
	 *       {..},
	 *       {..},
	 *     ]
	 *   }
	 * ]
	*/
	function buildData(data, options) {
	  if (options.isMap) {
	    return [{ 'states': _splitData(data, options.maxSplit) }];
	  }
	
	  var distributionsMap = data.reduce(function (acc, item) {
	    return angular.extend({}, acc, _defineProperty({}, item.characteristic, item.shape));
	  }, {});
	  var statesMap = data.reduce(function (acc, item) {
	    return angular.extend({}, acc, _defineProperty({}, item.state, item.color));
	  }, {});
	
	  var states = Object.keys(statesMap).map(function (val) {
	    return {
	      state: val,
	      color: statesMap[val]
	    };
	  }).sort(function (a, b) {
	    return (0, _geoSort2.default)(a.state, b.state, {
	      // Default header for geos...
	      characteristic: 'Location',
	      type: 'geography',
	      'label': 'Geography',
	      idx: 0
	    }, false, a.state, b.state);
	  });
	
	  var distributions = Object.keys(distributionsMap).map(function (val) {
	    return {
	      characteristic: val,
	      shape: distributionsMap[val]
	    };
	  });
	
	  return [{
	    states: _splitData(states, options.maxSplit),
	    distributions: _splitData(distributions, options.maxSplit)
	  }];
	}
	
	/* Converts Array into 2d array
	 * w/ split = 2...
	 * [1,2,3,4,5]
	 * to
	 * [[1,2],[3,4],[5]]
	 */
	function _splitData(data) {
	  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var newArray = [];
	  for (var i = 0; i < data.length; i += split) {
	    newArray.push(data.slice(i, i + split));
	  }
	  return newArray;
	}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = geoSorter;
	
	var _util = __webpack_require__(102);
	
	var _config = __webpack_require__(71);
	
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	/**
	 * Geography columns are hard, here are a bunch of special cases to sort through/for
	 */
	function geoSorter(a, b, column, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
	  var aProps = (0, _util.buildRowProperties)(a, column);
	  var bProps = (0, _util.buildRowProperties)(b, column);
	
	  // @TODO - remove the unneeded multiplication here
	  // @TODO - not a bad idea to revisit this sorter and the others
	
	  aProps.isSummary = aIsSummary;
	  bProps.isSummary = bIsSummary;
	
	  // Wrapups pushed to the top
	  if (aProps.wrapup && bProps.wrapup) {
	    return _config.appDefault.specialWrapups.indexOf(a) - _config.appDefault.specialWrapups.indexOf(b);
	  } else if (aProps.wrapup && !bProps.wrapup) {
	    return isInverted ? 1 : -1;
	  } else if (!aProps.wrapup && bProps.wrapup) {
	    return isInverted ? -1 : 1;
	  }
	
	  if (a.indexOf('MA Region') > -1 && b.indexOf('MA Region') > -1) {
	    return parseInt(a.split(' ')[2], 10) - parseInt(b.split(' ')[2], 10);
	  }
	
	  // For special (numbered) geos, sort by the numerical value in the characteristic
	  if (aProps.isSpecialGeo && bProps.isSpecialGeo) {
	    var anum = parseInt(a.replace(/^\D+/g, ''), 10);
	    var bnum = parseInt(b.replace(/^\D+/g, ''), 10);
	    return anum - bnum;
	  } else if (aProps.isSpecialGeo && !bProps.isSpecialGeo) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.isSpecialGeo && !aProps.isSpecialGeo) {
	    return isInverted ? 1 : -1;
	  }
	
	  // State categories (All Rural Counties, etc) pushed to the top
	  if (aProps.isStateCategory && !bProps.isStateCategory) {
	    return (isInverted ? 1 : -1) * 1;
	  } else if (bProps.isStateCategory && !aProps.isStateCategory) {
	    return (isInverted ? 1 : -1) * 1;
	    // Territories pushed to the bottom, only in US context
	  } else if (aProps.isTerritory && bProps.isTerritory) {
	    return aProps.value.localeCompare(bProps.value);
	  } else if (aProps.isTerritory && !bProps.isTerritory) {
	    return (isInverted ? -1 : 1) * 1;
	  } else if (bProps.isTerritory && !aProps.isTerritory) {
	    return (isInverted ? -1 : 1) * -1;
	  }
	
	  // Summary rows float up without matching groups
	  var aClippedValue = aProps.value.replace(_config.appDefault.isSummaryRow, '');
	  var bClippedValue = bProps.value.replace(_config.appDefault.isSummaryRow, '');
	  if (aClippedValue === bClippedValue && aProps.isSummary) {
	    return (isInverted ? -1 : 1) * -1;
	  } else if (aClippedValue === bClippedValue && bProps.isSummary) {
	    return (isInverted ? 1 : -1) * -1;
	  } else if (aClippedValue === bClippedValue) {
	    return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
	  }
	
	  return aProps.value.localeCompare(bProps.value);
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildRowProperties = buildRowProperties;
	exports.sortArbitrary = sortArbitrary;
	
	var _util = __webpack_require__(76);
	
	var _config = __webpack_require__(71);
	
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	/**
	 * Add properties to each row object so we know how to sort them
	 */
	function buildRowProperties(value) {
	  var props = {};
	  var val = value !== 0 && !value ? '' : value.toString();
	  var hasWords = /([a-z\s].*?\s?){1,}/i;
	  var numberVal = val.toString().replace(/[^0-9-\.]/g, '');
	  props.isTerritory = _config.appDefault.kffTerritories.indexOf(val) !== -1;
	  props.isStateCategory = _config.appDefault.isStateCategory.test(val);
	  props.isSpecialGeo = _config.appDefault.isSpecialGeo.test(val);
	  props.wrapup = _config.appDefault.specialWrapups.indexOf(val) > -1;
	  props.isSummary = _config.appDefault.isSummaryRow.test(val.toString());
	  props.naData = _config.appDefault.dataNotAvailable.indexOf(val) > -1;
	  props.rawValue = (0, _util.kffIsNumber)(numberVal) && !hasWords.test(value) ? +numberVal : false;
	
	  if (props.isSummary) {
	    props.value = val.replace(/\s+\(All\)$/, '');
	  } else {
	    props.value = val;
	  }
	
	  return props;
	}
	
	function sortArbitrary(a, b, order) {
	  var isInverted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var aForceSortIndex = order.indexOf(a);
	  var bForceSortIndex = order.indexOf(b);
	  if (aForceSortIndex && bForceSortIndex && aForceSortIndex !== bForceSortIndex) {
	    return (isInverted ? -1 : 1) * (aForceSortIndex > bForceSortIndex ? 1 : -1);
	  } else if (aForceSortIndex) {
	    return 1;
	  } else if (bForceSortIndex) {
	    return -1;
	  }
	  return false;
	}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var legendOptions = exports.legendOptions = {
	  width: 758,
	  height: 30, // Default height of without multiple distributions
	  margin: {
	    bottom: 20,
	    top: 5,
	    right: 0,
	    left: 0
	  },
	  wrapper: 'svg',
	  top: 0,
	  left: 0,
	  isMap: false,
	  maxSplit: 4,
	  distributions: 1,
	  textPadding: {
	    top: 15,
	    left: 30
	  },
	  rowSpacing: 10,
	  font: {
	    'font-size': '12px',
	    'font-weight': 'bold',
	    'font-family': 'Arial, Helvetica, sans-serif'
	  }
	};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var countries = exports.countries = {
	  'AD': 'Andorra',
	  'AE': 'United Arab Emirates',
	  'AF': 'Afghanistan',
	  'AG': 'Antigua and Barbuda',
	  'AI': 'Anguilla',
	  'AL': 'Albania',
	  'AM': 'Armenia',
	  'AO': 'Angola',
	  'AQ': 'Antarctica',
	  'AR': 'Argentina',
	  'AS': 'American Samoa',
	  'AT': 'Austria',
	  'AU': 'Australia',
	  'AW': 'Aruba',
	  'AX': 'Åland Islands',
	  'AZ': 'Azerbaijan',
	  'BA': 'Bosnia and Herzegovina',
	  'BB': 'Barbados',
	  'BD': 'Bangladesh',
	  'BE': 'Belgium',
	  'BF': 'Burkina Faso',
	  'BG': 'Bulgaria',
	  'BH': 'Bahrain',
	  'BI': 'Burundi',
	  'BJ': 'Benin',
	  'BL': 'Saint Barthélemy',
	  'BM': 'Bermuda',
	  'BN': 'Brunei Darussalam',
	  'BO': 'Bolivia, Plurinational State of',
	  'BQ': 'Bonaire, Sint Eustatius and Saba',
	  'BR': 'Brazil',
	  'BS': 'Bahamas',
	  'BT': 'Bhutan',
	  'BV': 'Bouvet Island',
	  'BW': 'Botswana',
	  'BY': 'Belarus',
	  'BZ': 'Belize',
	  'CA': 'Canada',
	  'CC': 'Cocos (Keeling) Islands',
	  'CD': 'Congo, the Democratic Republic of the',
	  'CF': 'Central African Republic',
	  'CG': 'Congo',
	  'CH': 'Switzerland',
	  'CI': 'Côte d\'Ivoire',
	  'CK': 'Cook Islands',
	  'CL': 'Chile',
	  'CM': 'Cameroon',
	  'CN': 'China',
	  'CO': 'Colombia',
	  'CR': 'Costa Rica',
	  'CU': 'Cuba',
	  'CV': 'Cape Verde',
	  'CW': 'Curaçao',
	  'CX': 'Christmas Island',
	  'CY': 'Cyprus',
	  'CZ': 'Czech Republic',
	  'DE': 'Germany',
	  'DJ': 'Djibouti',
	  'DK': 'Denmark',
	  'DM': 'Dominica',
	  'DO': 'Dominican Republic',
	  'DZ': 'Algeria',
	  'EC': 'Ecuador',
	  'EE': 'Estonia',
	  'EG': 'Egypt',
	  'EH': 'Western Sahara',
	  'ER': 'Eritrea',
	  'ES': 'Spain',
	  'ET': 'Ethiopia',
	  'FI': 'Finland',
	  'FJ': 'Fiji',
	  'FK': 'Falkland Islands (Malvinas)',
	  'FM': 'Micronesia, Federated States of',
	  'FO': 'Faroe Islands',
	  'FR': 'France',
	  'GA': 'Gabon',
	  'GB': 'United Kingdom',
	  'GD': 'Grenada',
	  'GE': 'Georgia',
	  'GF': 'French Guiana',
	  'GG': 'Guernsey',
	  'GH': 'Ghana',
	  'GI': 'Gibraltar',
	  'GL': 'Greenland',
	  'GM': 'Gambia',
	  'GN': 'Guinea',
	  'GP': 'Guadeloupe',
	  'GQ': 'Equatorial Guinea',
	  'GR': 'Greece',
	  'GS': 'South Georgia and the South Sandwich Islands',
	  'GT': 'Guatemala',
	  'GU': 'Guam',
	  'GW': 'Guinea-Bissau',
	  'GY': 'Guyana',
	  'HK': 'Hong Kong',
	  'HM': 'Heard Island and McDonald Islands',
	  'HN': 'Honduras',
	  'HR': 'Croatia',
	  'HT': 'Haiti',
	  'HU': 'Hungary',
	  'ID': 'Indonesia',
	  'IE': 'Ireland',
	  'IL': 'Israel',
	  'IM': 'Isle of Man',
	  'IN': 'India',
	  'IO': 'British Indian Ocean Territory',
	  'IQ': 'Iraq',
	  'IR': 'Iran, Islamic Republic of',
	  'IS': 'Iceland',
	  'IT': 'Italy',
	  'JE': 'Jersey',
	  'JM': 'Jamaica',
	  'JO': 'Jordan',
	  'JP': 'Japan',
	  'KE': 'Kenya',
	  'KG': 'Kyrgyzstan',
	  'KH': 'Cambodia',
	  'KI': 'Kiribati',
	  'KM': 'Comoros',
	  'KN': 'Saint Kitts and Nevis',
	  'KP': 'Korea, Democratic People\'s Republic of',
	  'KR': 'Korea, Republic of',
	  'KW': 'Kuwait',
	  'KY': 'Cayman Islands',
	  'KZ': 'Kazakhstan',
	  'LA': 'Lao People\'s Democratic Republic',
	  'LB': 'Lebanon',
	  'LC': 'Saint Lucia',
	  'LI': 'Liechtenstein',
	  'LK': 'Sri Lanka',
	  'LR': 'Liberia',
	  'LS': 'Lesotho',
	  'LT': 'Lithuania',
	  'LU': 'Luxembourg',
	  'LV': 'Latvia',
	  'LY': 'Libya',
	  'MA': 'Morocco',
	  'MC': 'Monaco',
	  'MD': 'Moldova, Republic of',
	  'ME': 'Montenegro',
	  'MF': 'Saint Martin (French part)',
	  'MG': 'Madagascar',
	  'MH': 'Marshall Islands',
	  'MK': 'Macedonia, the former Yugoslav Republic of',
	  'ML': 'Mali',
	  'MM': 'Myanmar',
	  'MN': 'Mongolia',
	  'MO': 'Macao',
	  'MP': 'Northern Mariana Islands',
	  'MQ': 'Martinique',
	  'MR': 'Mauritania',
	  'MS': 'Montserrat',
	  'MT': 'Malta',
	  'MU': 'Mauritius',
	  'MV': 'Maldives',
	  'MW': 'Malawi',
	  'MX': 'Mexico',
	  'MY': 'Malaysia',
	  'MZ': 'Mozambique',
	  'NA': 'Namibia',
	  'NC': 'New Caledonia',
	  'NE': 'Niger',
	  'NF': 'Norfolk Island',
	  'NG': 'Nigeria',
	  'NI': 'Nicaragua',
	  'NL': 'Netherlands',
	  'NO': 'Norway',
	  'NP': 'Nepal',
	  'NR': 'Nauru',
	  'NU': 'Niue',
	  'NZ': 'New Zealand',
	  'OM': 'Oman',
	  'PA': 'Panama',
	  'PE': 'Peru',
	  'PF': 'French Polynesia',
	  'PG': 'Papua New Guinea',
	  'PH': 'Philippines',
	  'PK': 'Pakistan',
	  'PL': 'Poland',
	  'PM': 'Saint Pierre and Miquelon',
	  'PN': 'Pitcairn',
	  'PR': 'Puerto Rico',
	  'PS': 'Palestinian Territory, Occupied',
	  'PT': 'Portugal',
	  'PW': 'Palau',
	  'PY': 'Paraguay',
	  'QA': 'Qatar',
	  'RE': 'Réunion',
	  'RO': 'Romania',
	  'RS': 'Serbia',
	  'RU': 'Russian Federation',
	  'RW': 'Rwanda',
	  'SA': 'Saudi Arabia',
	  'SB': 'Solomon Islands',
	  'SC': 'Seychelles',
	  'SD': 'Sudan',
	  'SE': 'Sweden',
	  'SG': 'Singapore',
	  'SH': 'Saint Helena, Ascension and Tristan da Cunha',
	  'SI': 'Slovenia',
	  'SJ': 'Svalbard and Jan Mayen',
	  'SK': 'Slovakia',
	  'SL': 'Sierra Leone',
	  'SM': 'San Marino',
	  'SN': 'Senegal',
	  'SO': 'Somalia',
	  'SR': 'Suriname',
	  'SS': 'South Sudan',
	  'ST': 'Sao Tome and Principe',
	  'SV': 'El Salvador',
	  'SX': 'Sint Maarten (Dutch part)',
	  'SY': 'Syrian Arab Republic',
	  'SZ': 'Swaziland',
	  'TC': 'Turks and Caicos Islands',
	  'TD': 'Chad',
	  'TF': 'French Southern Territories',
	  'TG': 'Togo',
	  'TH': 'Thailand',
	  'TJ': 'Tajikistan',
	  'TK': 'Tokelau',
	  'TL': 'Timor-Leste',
	  'TM': 'Turkmenistan',
	  'TN': 'Tunisia',
	  'TO': 'Tonga',
	  'TR': 'Turkey',
	  'TT': 'Trinidad and Tobago',
	  'TV': 'Tuvalu',
	  'TW': 'Taiwan, Province of China',
	  'TZ': 'Tanzania, United Republic of',
	  'UA': 'Ukraine',
	  'UG': 'Uganda',
	  'UM': 'United States Minor Outlying Islands',
	  'US': 'United States',
	  'UY': 'Uruguay',
	  'UZ': 'Uzbekistan',
	  'VA': 'Holy See (Vatican City State)',
	  'VC': 'Saint Vincent and the Grenadines',
	  'VE': 'Venezuela, Bolivarian Republic of',
	  'VG': 'Virgin Islands, British',
	  'VI': 'Virgin Islands, U.S.',
	  'VN': 'Viet Nam',
	  'VU': 'Vanuatu',
	  'WF': 'Wallis and Futuna',
	  'WS': 'Samoa',
	  'YE': 'Yemen',
	  'YT': 'Mayotte',
	  'ZA': 'South Africa',
	  'ZM': 'Zambia',
	  'ZW': 'Zimbabwe'
	};
	
	var countryCodes = exports.countryCodes = {
	  'AFG': 'AF',
	  'ALA': 'AX',
	  'ALB': 'AL',
	  'DZA': 'DZ',
	  'ASM': 'AS',
	  'AGO': 'AO',
	  'AIA': 'AI',
	  'ATA': 'AQ',
	  'ATG': 'AG',
	  'ARG': 'AR',
	  'ARM': 'AM',
	  'ABW': 'AW',
	  'AUS': 'AU',
	  'AUT': 'AT',
	  'AZE': 'AZ',
	  'BHS': 'BS',
	  'BHR': 'BH',
	  'BGD': 'BD',
	  'BRB': 'BB',
	  'BLR': 'BY',
	  'BEL': 'BE',
	  'BLZ': 'BZ',
	  'BEN': 'BJ',
	  'BMU': 'BM',
	  'BTN': 'BT',
	  'BOL': 'BO',
	  'BES': 'BQ',
	  'BIH': 'BA',
	  'BWA': 'BW',
	  'BVT': 'BV',
	  'BRA': 'BR',
	  'IOT': 'IO',
	  'BRN': 'BN',
	  'BGR': 'BG',
	  'BFA': 'BF',
	  'BDI': 'BI',
	  'KHM': 'KH',
	  'CMR': 'CM',
	  'CAN': 'CA',
	  'CPV': 'CV',
	  'CYM': 'KY',
	  'CAF': 'CF',
	  'TCD': 'TD',
	  'CHL': 'CL',
	  'CHN': 'CN',
	  'CXR': 'CX',
	  'CCK': 'CC',
	  'COL': 'CO',
	  'COM': 'KM',
	  'COG': 'CG',
	  'COD': 'CD',
	  'COK': 'CK',
	  'CRI': 'CR',
	  'CIV': 'CI',
	  'HRV': 'HR',
	  'CUB': 'CU',
	  'CUW': 'CW',
	  'CYP': 'CY',
	  'CZE': 'CZ',
	  'DNK': 'DK',
	  'DJI': 'DJ',
	  'DMA': 'DM',
	  'DOM': 'DO',
	  'ECU': 'EC',
	  'EGY': 'EG',
	  'SLV': 'SV',
	  'GNQ': 'GQ',
	  'ERI': 'ER',
	  'EST': 'EE',
	  'ETH': 'ET',
	  'FLK': 'FK',
	  'FRO': 'FO',
	  'FJI': 'FJ',
	  'FIN': 'FI',
	  'FRA': 'FR',
	  'GUF': 'GF',
	  'PYF': 'PF',
	  'ATF': 'TF',
	  'GAB': 'GA',
	  'GMB': 'GM',
	  'GEO': 'GE',
	  'DEU': 'DE',
	  'GHA': 'GH',
	  'GIB': 'GI',
	  'GRC': 'GR',
	  'GRL': 'GL',
	  'GRD': 'GD',
	  'GLP': 'GP',
	  'GUM': 'GU',
	  'GTM': 'GT',
	  'GGY': 'GG',
	  'GIN': 'GN',
	  'GNB': 'GW',
	  'GUY': 'GY',
	  'HTI': 'HT',
	  'HMD': 'HM',
	  'VAT': 'VA',
	  'HND': 'HN',
	  'HKG': 'HK',
	  'HUN': 'HU',
	  'ISL': 'IS',
	  'IND': 'IN',
	  'IDN': 'ID',
	  'IRN': 'IR',
	  'IRQ': 'IQ',
	  'IRL': 'IE',
	  'IMN': 'IM',
	  'ISR': 'IL',
	  'ITA': 'IT',
	  'JAM': 'JM',
	  'JPN': 'JP',
	  'JEY': 'JE',
	  'JOR': 'JO',
	  'KAZ': 'KZ',
	  'KEN': 'KE',
	  'KIR': 'KI',
	  'PRK': 'KP',
	  'KOR': 'KR',
	  'KWT': 'KW',
	  'KGZ': 'KG',
	  'LAO': 'LA',
	  'LVA': 'LV',
	  'LBN': 'LB',
	  'LSO': 'LS',
	  'LBR': 'LR',
	  'LBY': 'LY',
	  'LIE': 'LI',
	  'LTU': 'LT',
	  'LUX': 'LU',
	  'MAC': 'MO',
	  'MKD': 'MK',
	  'MDG': 'MG',
	  'MWI': 'MW',
	  'MYS': 'MY',
	  'MDV': 'MV',
	  'MLI': 'ML',
	  'MLT': 'MT',
	  'MHL': 'MH',
	  'MTQ': 'MQ',
	  'MRT': 'MR',
	  'MUS': 'MU',
	  'MYT': 'YT',
	  'MEX': 'MX',
	  'FSM': 'FM',
	  'MDA': 'MD',
	  'MCO': 'MC',
	  'MNG': 'MN',
	  'MNE': 'ME',
	  'MSR': 'MS',
	  'MAR': 'MA',
	  'MOZ': 'MZ',
	  'MMR': 'MM',
	  'NAM': 'NA',
	  'NRU': 'NR',
	  'NPL': 'NP',
	  'NLD': 'NL',
	  'NCL': 'NC',
	  'NZL': 'NZ',
	  'NIC': 'NI',
	  'NER': 'NE',
	  'NGA': 'NG',
	  'NIU': 'NU',
	  'NFK': 'NF',
	  'MNP': 'MP',
	  'NOR': 'NO',
	  'OMN': 'OM',
	  'PAK': 'PK',
	  'PLW': 'PW',
	  'PSE': 'PS',
	  'PAN': 'PA',
	  'PNG': 'PG',
	  'PRY': 'PY',
	  'PER': 'PE',
	  'PHL': 'PH',
	  'PCN': 'PN',
	  'POL': 'PL',
	  'PRT': 'PT',
	  'PRI': 'PR',
	  'QAT': 'QA',
	  'REU': 'RE',
	  'ROU': 'RO',
	  'RUS': 'RU',
	  'RWA': 'RW',
	  'BLM': 'BL',
	  'SHN': 'SH',
	  'KNA': 'KN',
	  'LCA': 'LC',
	  'MAF': 'MF',
	  'SPM': 'PM',
	  'VCT': 'VC',
	  'WSM': 'WS',
	  'SMR': 'SM',
	  'STP': 'ST',
	  'SAU': 'SA',
	  'SEN': 'SN',
	  'SRB': 'RS',
	  'SYC': 'SC',
	  'SLE': 'SL',
	  'SGP': 'SG',
	  'SXM': 'SX',
	  'SVK': 'SK',
	  'SVN': 'SI',
	  'SLB': 'SB',
	  'SOM': 'SO',
	  'ZAF': 'ZA',
	  'SGS': 'GS',
	  'SSD': 'SS',
	  'ESP': 'ES',
	  'LKA': 'LK',
	  'SDN': 'SD',
	  'SUR': 'SR',
	  'SJM': 'SJ',
	  'SWZ': 'SZ',
	  'SWE': 'SE',
	  'CHE': 'CH',
	  'SYR': 'SY',
	  'TWN': 'TW',
	  'TJK': 'TJ',
	  'TZA': 'TZ',
	  'THA': 'TH',
	  'TLS': 'TL',
	  'TGO': 'TG',
	  'TKL': 'TK',
	  'TON': 'TO',
	  'TTO': 'TT',
	  'TUN': 'TN',
	  'TUR': 'TR',
	  'TKM': 'TM',
	  'TCA': 'TC',
	  'TUV': 'TV',
	  'UGA': 'UG',
	  'UKR': 'UA',
	  'ARE': 'AE',
	  'GBR': 'GB',
	  'USA': 'US',
	  'UMI': 'UM',
	  'URY': 'UY',
	  'UZB': 'UZ',
	  'VUT': 'VU',
	  'VEN': 'VE',
	  'VNM': 'VN',
	  'VGB': 'VG',
	  'VIR': 'VI',
	  'WLF': 'WF',
	  'ESH': 'EH',
	  'YEM': 'YE',
	  'ZMB': 'ZM',
	  'ZWE': 'ZW'
	};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (data, n_classes) {
	
	    if (n_classes > data.length) return null;
	
	    // sort data in numerical order, since this is expected
	    // by the matrices function
	    data = data.slice().sort(function (a, b) {
	        return a - b;
	    });
	
	    // get our basic matrices
	    var matrices = jenksMatrices(data, n_classes),
	
	    // we only need lower class limits here
	    lower_class_limits = matrices.lower_class_limits;
	
	    // extract n_classes out of the computed matrices
	    return jenksBreaks(data, lower_class_limits, n_classes);
	};
	
	// ## Compute Matrices for Jenks
	//
	// Compute the matrices required for Jenks breaks. These matrices
	// can be used for any classing of data with `classes <= n_classes`
	function jenksMatrices(data, n_classes) {
	
	    // in the original implementation, these matrices are referred to
	    // as `LC` and `OP`
	    //
	    // * lower_class_limits (LC): optimal lower class limits
	    // * variance_combinations (OP): optimal variance combinations for all classes
	    var lower_class_limits = [],
	        variance_combinations = [],
	
	    // loop counters
	    i,
	        j,
	
	    // the variance, as computed at each step in the calculation
	    variance = 0;
	
	    // Initialize and fill each matrix with zeroes
	    for (i = 0; i < data.length + 1; i++) {
	        var tmp1 = [],
	            tmp2 = [];
	        // despite these arrays having the same values, we need
	        // to keep them separate so that changing one does not change
	        // the other
	        for (j = 0; j < n_classes + 1; j++) {
	            tmp1.push(0);
	            tmp2.push(0);
	        }
	        lower_class_limits.push(tmp1);
	        variance_combinations.push(tmp2);
	    }
	
	    for (i = 1; i < n_classes + 1; i++) {
	        lower_class_limits[1][i] = 1;
	        variance_combinations[1][i] = 0;
	        // in the original implementation, 9999999 is used but
	        // since Javascript has `Infinity`, we use that.
	        for (j = 2; j < data.length + 1; j++) {
	            variance_combinations[j][i] = Infinity;
	        }
	    }
	
	    for (var l = 2; l < data.length + 1; l++) {
	
	        // `SZ` originally. this is the sum of the values seen thus
	        // far when calculating variance.
	        var sum = 0,
	
	        // `ZSQ` originally. the sum of squares of values seen
	        // thus far
	        sum_squares = 0,
	
	        // `WT` originally. This is the number of
	        w = 0,
	
	        // `IV` originally
	        i4 = 0;
	
	        // in several instances, you could say `Math.pow(x, 2)`
	        // instead of `x * x`, but this is slower in some browsers
	        // introduces an unnecessary concept.
	        for (var m = 1; m < l + 1; m++) {
	
	            // `III` originally
	            var lower_class_limit = l - m + 1,
	                val = data[lower_class_limit - 1];
	
	            // here we're estimating variance for each potential classing
	            // of the data, for each potential number of classes. `w`
	            // is the number of data points considered so far.
	            w++;
	
	            // increase the current sum and sum-of-squares
	            sum += val;
	            sum_squares += val * val;
	
	            // the variance at this point in the sequence is the difference
	            // between the sum of squares and the total x 2, over the number
	            // of samples.
	            variance = sum_squares - sum * sum / w;
	
	            i4 = lower_class_limit - 1;
	
	            if (i4 !== 0) {
	                for (j = 2; j < n_classes + 1; j++) {
	                    // if adding this element to an existing class
	                    // will increase its variance beyond the limit, break
	                    // the class at this point, setting the `lower_class_limit`
	                    // at this point.
	                    if (variance_combinations[l][j] >= variance + variance_combinations[i4][j - 1]) {
	                        lower_class_limits[l][j] = lower_class_limit;
	                        variance_combinations[l][j] = variance + variance_combinations[i4][j - 1];
	                    }
	                }
	            }
	        }
	
	        lower_class_limits[l][1] = 1;
	        variance_combinations[l][1] = variance;
	    }
	
	    // return the two matrices. for just providing breaks, only
	    // `lower_class_limits` is needed, but variances can be useful to
	    // evaluate goodness of fit.
	    return {
	        lower_class_limits: lower_class_limits,
	        variance_combinations: variance_combinations
	    };
	}
	
	// ## Pull Breaks Values for Jenks
	//
	// the second part of the jenks recipe: take the calculated matrices
	// and derive an array of n breaks.
	function jenksBreaks(data, lower_class_limits, n_classes) {
	
	    var k = data.length - 1,
	        kclass = [],
	        countNum = n_classes;
	
	    // the calculation of classes will never include the upper and
	    // lower bounds, so we need to explicitly set them
	    kclass[n_classes] = data[data.length - 1];
	    kclass[0] = data[0];
	
	    // the lower_class_limits matrix is used as indices into itself
	    // here: the `k` variable is reused in each iteration.
	    while (countNum > 1) {
	        kclass[countNum - 1] = data[lower_class_limits[k][countNum] - 2];
	        k = lower_class_limits[k][countNum] - 1;
	        countNum--;
	    }
	
	    return kclass;
	}
	
	// # [Jenks natural breaks optimization](http://en.wikipedia.org/wiki/Jenks_natural_breaks_optimization)
	//
	// Implementations: [1](http://danieljlewis.org/files/2010/06/Jenks.pdf) (python),
	// [2](https://github.com/vvoovv/djeo-jenks/blob/master/main.js) (buggy),
	// [3](https://github.com/simogeo/geostats/blob/master/lib/geostats.js#L407) (works)
	//
	// Depends on `jenksBreaks()` and `jenksMatrices()`

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data, metaData, distributions, type, isGeomulti) {
	  if (isGeomulti) {
	    return _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (distribution) {
	      return _mori2.default.equals(_mori2.default.getIn(data.config, ['globalRules', 'Map Base Column']), _mori2.default.get(distribution, 'characteristic'));
	    }), _mori2.default.map(function (distribution) {
	      return distributionSelector(data, distribution, type);
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), metaData.immutableDistributions);
	  }
	  return _mori2.default.map(function (distribution) {
	    return distributionSelector(data, metaData, distribution, type);
	  }, distributions);
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function distributionSelector(data, metaData, distribution, type) {
	  // use the globally selected dataview, or get the column specific one
	  var dataviewLabel = type ? type.label : _mori2.default.get(_mori2.default.first(_mori2.default.filter(function (header) {
	    // If the distribution has a headerGroup,
	    // match the headerGroup AND the characteristic,
	    // else, characteristic only.
	    return _mori2.default.get(distribution, 'headerGroup', false) ? _mori2.default.equals(_mori2.default.get(header, 'headerGroup'), _mori2.default.get(distribution, 'headerGroup')) && _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.get(distribution, 'characteristic')) : _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.get(distribution, 'characteristic'));
	  }, metaData.immutableHeaders)), 'label');
	  return _mori2.default.get(distribution, 'headerGroup') === null ? _mori2.default.set([_mori2.default.get(distribution, 'characteristic'), dataviewLabel]) : _mori2.default.set([_mori2.default.get(distribution, 'headerGroup'), _mori2.default.get(distribution, 'characteristic'),
	  // If label and char. are the same, make label more unique
	  // Label/Char will be same if Doc uses only Year values (2016, etc.)
	  // TODO: Find a way to handle this better.
	  // See: dataReducer.js L109
	  dataviewLabel === _mori2.default.get(distribution, 'characteristic') ? '_' + dataviewLabel : dataviewLabel]);
	}
	
	/**
	 * Generates an array of distributions for selecting data based on context
	 */

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _territorySortFilter = __webpack_require__(108);
	
	var _territorySortFilter2 = _interopRequireDefault(_territorySortFilter);
	
	var _markdownFilter = __webpack_require__(109);
	
	var _markdownFilter2 = _interopRequireDefault(_markdownFilter);
	
	var _switchFilter = __webpack_require__(110);
	
	var _switchFilter2 = _interopRequireDefault(_switchFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	/**
	 * Check if angular is being resolved,
	 * if it isn't then this doesn't matter... because react
	 */
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  __webpack_require__(111);
	}
	
	
	/**
	 * Check if angular is being resolved,
	 * if it isn't then this doesn't matter... because react
	 */
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  module.exports = angular.module('datacenterFilters', ['slugifier']).filter('filterSwitch', _switchFilter2.default).filter('markdown', _markdownFilter2.default).filter('territorySort', _territorySortFilter2.default).filter('percent', function () {
	    return function (value) {
	      return value + '%';
	    };
	  }).filter('rawCurrency', function () {
	    return function (value) {
	      return '$' + value;
	    };
	  }).name;
	} else {
	  module.exports = function (filterName) {
	    return {
	      filterSwitch: _switchFilter2.default,
	      markdown: _markdownFilter2.default,
	      territorySort: _territorySortFilter2.default,
	      percent: function percent(value) {
	        return value + '%';
	      },
	      rawCurrency: function rawCurrency(value) {
	        return '$' + value;
	      }
	    }[filterName];
	  };
	}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function () {
	    var column = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return Object.keys(column).sort(territorySort);
	  };
	};
	
	exports.territorySort = territorySort;
	
	var _config = __webpack_require__(71);
	
	/* eslint id-length:[2, {"exceptions":["a", "b"]}] */
	function territorySort(a, b) {
	  var aIsTerritory = _config.appDefault.kffTerritories.indexOf(a) > -1 || _config.appDefault.normalizedKffTerritories.indexOf(a) > -1;
	  var bIsTerritory = _config.appDefault.kffTerritories.indexOf(b) > -1 || _config.appDefault.normalizedKffTerritories.indexOf(b) > -1;
	
	  // Check if MA Region
	  if (a.indexOf('ma-region') >= 0 && b.indexOf('ma-region') >= 0) {
	    return parseInt(a.split('-')[2], 10) - parseInt(b.split('-')[2], 10);
	  }
	
	  if (aIsTerritory && bIsTerritory) {
	    return a.localeCompare(b);
	  } else if (aIsTerritory || bIsTerritory) {
	    return aIsTerritory ? 1 : -1;
	  }
	
	  return a.localeCompare(b);
	}
	
	/**
	 * Does custom sorting for the checkbox lists with territories
	 */

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = markdown;
	/**
	 * Cribbed from datacenter.js. Parses simple markdown.
	 * @param {string} txt - Directly from the google sheet cell
	 * @param {string} el - El to wrap around the markdown
	 * @return {string} - markdown->html string
	 */
	function markdown() {
	  return function (txt) {
	    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'p';
	    var styleString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	    if (txt === null) {
	      return txt;
	    }
	
	    var _txt = txt;
	    // parse the string otherwise do it recursively
	    if (typeof _txt !== 'string') {
	      Object.keys(_txt).forEach(function (i) {
	        _txt[i] = markdown()(_txt[i]);
	      });
	      return _txt;
	    }
	    _txt = _txt.replace(/(^|\W)\*(.*?)\*($|\W)/mg, '$1<strong>$2</strong>$3').replace(/(^|\W)_(.*?)_($|\W)/mg, '$1<em>$2</em>$3').replace(/\[(.*?)\]\((.*?)\)/mg, '<a href="$2" target="_self">$1</a>').replace(/\n\s*\n\s*/mg, '</' + el + '><' + el + ' style="' + styleString + '">');
	    var openingTag = el ? '<' + el + ' style="' + styleString + '">' : '';
	    var closingTag = el ? '</' + el + '>' : '';
	    return '' + openingTag + _txt + closingTag;
	  };
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = filterSwitch;
	
	var _config = __webpack_require__(71);
	
	var _util = __webpack_require__(76);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* global __webpack_modules__ */
	
	/**
	 * Formats data point values according to the column settings and/or
	 * primitive parsing conditionals
	 */
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  filterSwitch.$inject = ['$filter'];
	}
	function filterSwitch($filter) {
	  if (!__webpack_require__.m[/*require.resolve*/(10)]) {
	    /* eslint-disable no-param-reassign */
	    $filter = function $filter(filter) {
	      return {
	        currency: function currency(i, sym, precision) {
	          return (0, _util.commatize)(+(0, _util.numberPrecision)(i, precision, false), sym);
	        },
	        percent: function percent(i) {
	          return i + '%';
	        },
	        number: function number(_number, precision) {
	          // Taken from 'formatNumber' in angular.js
	          var fraction = ('' + _number).split('.');
	          var formattedText = fraction[0];
	          fraction = fraction[1] || '';
	
	          // Format fraction
	          fraction = '' + fraction + [].concat(_toConsumableArray(Array(precision - fraction.length))).map(function () {
	            return '0';
	          }).join('');
	
	          if (precision && precision !== '0') {
	            formattedText += '.' + fraction.substr(0, precision);
	          }
	
	          return (0, _util.commatize)(formattedText);
	        }
	      }[filter];
	    };
	    /* eslint-enable no-param-reassign */
	  }
	
	  return function (value, column) {
	    var precision = (0, _util.getPrecision)(column);
	    var valueIsString = typeof value === 'string';
	    var prefixChar = valueIsString ? value.charAt(0) : '';
	    var isPrefixed = ['<', '>'].indexOf(prefixChar) > -1;
	    // These are blank cells. Leave them blank
	    if (!value && isNaN(value) || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === undefined || typeof value === 'boolean' || value === null) {
	      return '';
	      // If it has a pipe, just return it
	    } else if (value.toString().indexOf('|') > -1) {
	      return value;
	      // Format special < or > Currency numbers
	    } else if (column.type.indexOf('currency') > -1 && valueIsString && isPrefixed) {
	      return prefixChar + $filter('currency')(value.substring(1), '$', precision);
	      // Format special < or > Percent numbers
	    } else if (/^percent/.test(column.type) && valueIsString && isPrefixed) {
	      return prefixChar + $filter('percent')((+(0, _util.numberPrecision)(value.substring(1), precision, true)).toFixed(precision));
	      // Format special < or > Regular numbers
	    } else if (/^number/.test(column.type) && valueIsString && isPrefixed) {
	      return prefixChar + $filter('number')((0, _util.numberPrecision)(value.substring(1), precision), precision);
	      // If datatype is defined, but doesn't need to be formatted
	    } else if (column.type === 'geography' || column.type === 'text' || column.type === 'year' || _config.appDefault.dataNotAvailable.indexOf(value) > -1 || isNaN(value)) {
	      return value;
	      // Percent types with possible args
	    } else if (/^percent/.test(column.type)) {
	      // @TODO replace with built in filter
	      return $filter('percent')((+(0, _util.numberPrecision)(value, precision, true)).toFixed(precision));
	      // Currency types with possible args
	    } else if (/^currency/.test(column.type)) {
	      return $filter('currency')(value, '$', precision);
	    }
	
	    var number = $filter('number')((0, _util.numberPrecision)(value, precision), precision);
	    if (column.Prefix) {
	      number = column.Prefix + number;
	    }
	    if (column.Suffix) {
	      number = number + column.Suffix;
	    }
	    if (number[number.length - 1] === '.') {
	      number = number.slice(0, -1);
	    }
	    return number;
	  };
	}

/***/ }),
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data, options, timeframes, combined, selected, distributions) {
	  var selectedHeaders = _mori2.default.filter(function (header) {
	    var characteristic = _mori2.default.get(header, 'characteristic');
	    var label = _mori2.default.get(header, 'label');
	
	    return _mori2.default.some(function (currentSelected) {
	      return _mori2.default.first(currentSelected) === characteristic && _mori2.default.last(currentSelected) === label;
	    }, _mori2.default.rest(selected));
	  }, data.immutableHeaders);
	
	  return _mori2.default.count(distributions) ? buildGraphData(timeframes, selected, combined, selectedHeaders) : [];
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(76);
	
	var _filters = __webpack_require__(107);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterSwitch = null; /* global __webpack_modules__ */
	
	/* eslint id-length: [2, {"exceptions":["a","b","x","y"]}] */
	
	
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  filterSwitch = _filters2.default;
	}
	/**
	 * Output should appear like:
	 * Options from ../config/linechart
	 * @example:
	   var graph.data = [{
	     key: 'State Name - Distribution',
	     state: 'State Name',
	     characteristic: 'Distribution',
	     values: [
	       { x: [x], y: [value] },
	       { x: [x], y: [value] }
	     ]
	   },
	   {
	     key: 'State Name - Distribution',
	     state: 'State Name',
	     characteristic: 'Distribution',
	     values: []
	   }];
	 */
	function buildGraphData(timeframes, keys, combined, selectedHeaders) {
	  // Filter timeframe data by baseColumn selections
	  return _mori2.default.mapcat(function (baseColumn) {
	    return _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (distribution) {
	      var sheetIndex = 0;
	      var formatted = _mori2.default.first(_mori2.default.filter(function (header) {
	        return _mori2.default.get(header, 'characteristic') === _mori2.default.first(distribution);
	      }, selectedHeaders));
	      var state = _mori2.default.last(_mori2.default.last(_mori2.default.first(baseColumn)));
	      return _mori2.default.hashMap('key', state + ' - ' + _mori2.default.first(distribution), 'state', state, 'characteristic', _mori2.default.first(distribution), 'type', _mori2.default.last(distribution).toLowerCase(), 'Prefix', _mori2.default.get(_mori2.default.first(selectedHeaders), 'Prefix'), 'Precision', _mori2.default.get(_mori2.default.first(selectedHeaders), 'Precision'), 'tickValues', _mori2.default.map(function (timeframe) {
	        return _mori2.default.first(timeframe);
	      }, _mori2.default.reverse(timeframes)), 'selectedHeader', _mori2.default.first(selectedHeaders), 'values', _mori2.default.sort(function (a, b) {
	        return _mori2.default.get(a, 'x') - _mori2.default.get(b, 'x');
	      }, _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (timeframe) {
	        return _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (row) {
	          return _mori2.default.every(function (selected) {
	            return _mori2.default.equals(_mori2.default.last(_mori2.default.first(selected)), _mori2.default.get(row, _mori2.default.first(_mori2.default.first(selected))));
	          }, baseColumn);
	        }), _mori2.default.map(function (row) {
	          var value = _mori2.default.get(row, distribution);
	          // pulled from switchFilter.js
	          var prefixChar = typeof value === 'string' ? value.charAt(0) : '';
	          var isPrefixed = ['<', '>'].indexOf(prefixChar) > -1;
	
	          var y = (value === 0 ? '0' : false) || (0, _util.kffNumericValue)(value) || null;
	          return _mori2.default.hashMap('x', sheetIndex++, 'y', !y ? undefined : (0, _util.kffNumericValue)(filterSwitch(y, _mori2.default.toJs(formatted))) / (_mori2.default.toJs(formatted).type === 'percent' ? 100 : 1), 'formatted', '' + (isPrefixed ? prefixChar : '') + filterSwitch(y, _mori2.default.toJs(formatted)));
	        })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), _mori2.default.last(timeframe));
	      }, _mori2.default.reverse(timeframes)))));
	    }, _mori2.default.rest(keys)));
	  }, combined);
	}
	
	// passes in sheets

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** This file handles table data & interactions */
	
	
	exports.default = function (sheetData, metaData, options, filteredData, // Data organized by timeframe
	combinedFilters, readyCb, selectedKeys) // Won't add Index into notes anchors if in stand-along SHF Indicator
	{
	  var isMultiGeo = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	  var reduxCallback = arguments[8];
	  var generalCallback = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
	  var tableIndex = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : -1;
	
	  // Hash for seeing changing table data
	  this.tableHash = this.tableHash || false;
	  this.tableInit = this.tableInit || false;
	  // If no table (table init),
	  // or isDirty, lets reload the data... time to PIVOT (but not a real pivot)!
	  var isDirty = isTableDirty.bind(this)(filteredData, combinedFilters);
	
	  // Need the base context of the table to accurately get the footnotes when calculating row height
	  var baseContext = _mori2.default.getIn(sheetData.config, ['globalRules', 'Context'], [])[0] || false;
	  if (this.tableInit === false || isDirty) {
	    // Load the config
	    var _getData = getData(sheetData, metaData, options, filteredData, combinedFilters, tableIndex),
	        rowData = _getData.rowData,
	        columnDefs = _getData.columnDefs;
	
	    // Set filter for columnDefs
	    // If not multigeo, setup location filter.
	    // Multigeo filtering is handled by external filtering function
	
	
	    if (!isMultiGeo) {
	      columnDefs[0] = _extends({}, {
	        filter: _table.LocationFilter,
	        filterParams: {
	          apply: false,
	          newRowsAction: 'keep'
	        }
	      }, columnDefs[0]);
	    }
	
	    // Check if table has not been initialized using a known prop
	    if (!this.tableInit) {
	      this.tableInit = true;
	      // Table not initialized, so lets resetup
	      _extends(this, {}, _table2.default, {
	        rowData: rowData,
	        columnDefs: columnDefs,
	        'datacenterColumnKeys': _mori2.default.toJs(_mori2.default.map(function (item) {
	          return _mori2.default.first(item);
	        }, _mori2.default.filter(function (item) {
	          return item;
	        }, combinedFilters[4]))),
	        'isExternalFilterPresent': function isExternalFilterPresent() {
	          return isMultiGeo;
	        },
	        'forPrint': options.print === 'true',
	        'trend': options.activeTab === 'graph'
	      });
	
	      tableSetup.bind(this)(readyCb, isMultiGeo, baseContext);
	    } else {
	      // Is Dirty
	      // If the view has changed we need to reinit column defs as well
	      // Table is already initied;
	      this.api.setRowData(rowData);
	      // @TODO, limit this to only triggger on view
	      // changes between graph/(table || map)
	      this.api.setColumnDefs(columnDefs);
	      // Refreshing
	      this.api.refreshHeader();
	      this.api.refreshView();
	      // Re-set whether this is a trend graph view
	      this.trend = options.activeTab === 'graph';
	    }
	  }
	
	  this.doesExternalFilterPass = doesExternalFilterPass.bind(this)(selectedKeys);
	  if (reduxCallback) {
	    this.reduxCallback = reduxCallback;
	  }
	  if (generalCallback) {
	    generalCallback(this);
	  }
	  return this;
	};
	
	exports.filterData = filterData;
	exports.filterDistributions = filterDistributions;
	exports.onAfterFilterChanged = onAfterFilterChanged;
	exports.onAfterSortChanged = onAfterSortChanged;
	exports.getRowHeight = getRowHeight;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _dataFromOptions = __webpack_require__(114);
	
	var _table = __webpack_require__(130);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _util = __webpack_require__(76);
	
	var _util2 = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// Store for table
	var defaultHeight = '';
	
	/**
	 * Filter data
	 *
	 * Can either be imported into a file, OR they can be used via `table.X`
	 */
	function filterData() {
	  var _this = this;
	
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var callback = arguments[1];
	
	  if (!this.api) {
	    return;
	  } else if (data) {
	    this.datacenterColumnKeys.forEach(function (columnKey) {
	      var filter = _this.api.getFilterApi(columnKey);
	
	      var filtered = _mori2.default.intoArray(_mori2.default.flatten(_mori2.default.reduce(function (acc, item) {
	        return _mori2.default.conj(acc, _mori2.default.last(_mori2.default.last(_mori2.default.first(_mori2.default.filter(function (test) {
	          return _mori2.default.first(_mori2.default.first(_mori2.default.first(test))) === columnKey;
	        }, item)))));
	      }, _mori2.default.vector(), data)));
	      // Check that there is actually filtered response
	      if (filtered.length > 0 && filtered[0] !== null) {
	        filter.setModel(filtered);
	      } else {
	        filter.setModel([]);
	      }
	    });
	  }
	  this.api.onFilterChanged();
	  if (callback) {
	    callback();
	  }
	}
	
	/**
	 * Column hiding/showing
	 * Can either be imported into a file, OR they can be used via `table.X`
	 */
	function filterDistributions(distributions, options, timeframes, callback) {
	  if (!this.columnApi) {
	    return;
	  }
	
	  var test = _mori2.default.intoArray(_mori2.default.map(function (item) {
	    return _mori2.default.count(item) === 3 ? _mori2.default.first(item) + '__' + _mori2.default.first(_mori2.default.rest(item)) : _mori2.default.first(item);
	  }, distributions));
	
	  if (options.activeTab === 'graph') {
	    test = test.concat(timeframes.reduce(function (acc, curr) {
	      return acc.concat.apply(acc, _toConsumableArray(test.filter(function (item) {
	        return item !== 'Location';
	      }).map(function (item) {
	        return curr + '__' + item;
	      })));
	    }, []));
	  }
	
	  var columns = [].concat.apply([], (this.columnApi.getAllColumns() || []).map(function (item) {
	    return item.children ? item.children.map(function (child) {
	      return child.colId;
	    }) : item.colId;
	  }));
	
	  var hidden = columns.filter(function (def) {
	    return test.indexOf(def) === -1;
	  });
	
	  var visible = columns.filter(function (def) {
	    return test.indexOf(def) !== -1;
	  });
	
	  if (hidden.indexOf((this.api.getSortModel()[0] || { colId: [] }).colId) > -1) {
	    this.api.setSortModel([{
	      colId: 'Location',
	      sort: 'asc'
	    }]);
	  }
	
	  this.columnApi.setColumnsVisible(hidden, false);
	  this.columnApi.setColumnsVisible(visible, true);
	
	  if (callback) {
	    callback();
	  }
	}
	
	/**
	 * Based on what the user has selected, see if the table rows
	 * contain each column key for the multi-geo table
	 *
	 * This filter is used only for multi-geo tables.
	 * @param  {object}  selectedKeys    the column keys that were selected by
	 *  the user
	 * @return {Function}
	 */
	function doesExternalFilterPass(selectedKeys) {
	  // Build the filter keys based on what's been selected
	  // We default to an '@' as some cell values are null, which causes filtering
	  // to break
	  var filteredKeys = this.datacenterColumnKeys.reduce(function (acc, columnKey) {
	    acc.push({
	      key: columnKey,
	      selected: _mori2.default.intoArray(_mori2.default.flatten(_mori2.default.reduce(function (acc1, item) {
	        return _mori2.default.conj(acc1, _mori2.default.last(_mori2.default.last(_mori2.default.first(_mori2.default.filter(function (test) {
	          return _mori2.default.first(_mori2.default.first(_mori2.default.first(test))) === columnKey;
	        }, item)) || '@')));
	      }, _mori2.default.vector(), selectedKeys)))
	    });
	    return acc;
	  }, []);
	
	  // If nothing's selected, we have no need to filter.
	  var noFiltering = _mori2.default.count(selectedKeys) === 0 ? true : false;
	
	  // The filtering function.
	  return function (node) {
	    if (noFiltering) {
	      return true;
	    }
	    var passes = false;
	    var lastFilterKey = filteredKeys[filteredKeys.length - 1];
	    // For each selected item, see if the following is true:
	    // 1.  The data in the table equals what has been selected
	    // 2.  Or, the selected from the last filter is the '@' character -
	    //     This indicates we want to match on only the first column.
	    filteredKeys[0].selected.forEach(function (selectedItem, index) {
	      if (node.data[filteredKeys[0].key] === selectedItem.split(' (All)')[0] && (node.data[lastFilterKey.key] === lastFilterKey.selected[index] || lastFilterKey.selected[index] === '@')) {
	        passes = true;
	      }
	    });
	    return passes;
	  };
	}
	
	/**
	 * Table Setup
	 * Access the `table` file global directly (it's scoped to this file)
	 */
	function tableSetup(readyCb, isMultiGeo, baseContext) {
	  // The initial setup for tableheight is 75% of the window's height
	  defaultHeight = window.innerHeight * 0.75;
	  // Set Iniital Height
	  this.height = defaultHeight;
	
	  // Assign functions for modification
	  this.filterDistributions = filterDistributions.bind(this);
	  this.filterData = filterData.bind(this);
	
	  this.onGridReady = readyCb;
	  this.onAfterFilterChanged = onAfterFilterChanged.bind(this);
	  this.onAfterSortChanged = onAfterSortChanged.bind(this);
	  this.getRowHeight = function (params) {
	    return getRowHeight(params, isMultiGeo, baseContext);
	  };
	}
	
	function onAfterFilterChanged() {
	  // We need to reset the width of the body
	  // immediately after filter change so the table renders correctly
	  if (!this.forPrint) {
	    this.api.gridPanel.eBody.style.width = '';
	  }
	
	  var gridPanel = this.api.gridPanel;
	
	  // Given the displayed columns, generate a unique list of header names
	  var displayedHeaderNames = (this.columnApi.getAllDisplayedColumns() || []).reduce(function (acc, column) {
	    if (acc.indexOf(column.colId.split('__')[0]) === -1) {
	      acc.push(column.colId.split('__')[0]);
	    }
	    return acc;
	  }, []);
	
	  this.displayedHeaders = (this.columnApi.getAllDisplayedColumns() || []).reduce(function (acc, column) {
	    if (column.colId.indexOf('__') === -1) {
	      acc.push(column.colDef);
	      return acc;
	    }
	
	    var headerGroup = column.colId.split('__')[0];
	    var headerIndex = displayedHeaderNames.indexOf(headerGroup);
	
	    acc[headerIndex] = acc[headerIndex] || {
	      headerName: headerGroup,
	      children: []
	    };
	    acc[headerIndex].children.push(column.colDef);
	    return acc;
	  }, []);
	
	  // Using the above header names, build a list of headers (and children)
	  // This will allow us to calculate header height on only the visible headers
	  var headerHeight = resizeHeader.bind(this)({
	    columns: this.displayedHeaders,
	    forPrint: this.forPrint
	  });
	
	  if (!this.forPrint) {
	    // Ensure top row is visible post header height adjustment
	    this.api.ensureIndexVisible(0);
	
	    // 20 is added to adjust for possible x-overflow
	    var gridHeight = Math.round(gridPanel.eBodyContainer.getBoundingClientRect().height + headerHeight + 20);
	
	    this.height = gridHeight > defaultHeight ? defaultHeight : gridHeight;
	
	    // @TODO: Hacky.  If it's a short dataset, the y-scroll will appear
	    // likely due to a height calc issue due to borders :-/
	    gridPanel.eBodyViewport.style.overflowY = gridHeight > defaultHeight ? 'auto' : 'hidden';
	
	    setBodySize(this);
	    (0, _util2.calcScrollShadow)(this);
	  }
	
	  this.api.refreshRows(this.api.getRenderedNodes());
	}
	
	function onAfterSortChanged() {
	  if (!this.forPrint) {
	    this.api.ensureIndexVisible(0);
	  }
	  if (this.reduxCallback) {
	    var sortModel = this.api.getSortModel()[0];
	    this.reduxCallback({ sortModel: sortModel });
	  }
	  this.api.refreshRows(this.api.getRenderedNodes());
	}
	
	function getRowHeight(params, isMultiGeo, baseContext) {
	  var footnoteWeight = isMultiGeo ? '700' : 'normal';
	  var footnoteFontFamily = 'arial, sans-serif';
	  var context = params.node.data.Location && 'Location' || baseContext || 'State';
	  var footnoteFontString = footnoteWeight + ' 11px/0 ' + footnoteFontFamily;
	  var fontStyleString = '13px/20px "Source Sans Pro", helvetica, sans-serif';
	  var rowDefaultHeight = 20;
	  var padding = 10; // 5px left & right + border
	  var height = rowDefaultHeight;
	  // Assign directly rather than Object.assign-ing a fresh literal per
	  // column. This runs for every row, so the temporary objects added up to
	  // tens of thousands of short-lived allocations on a full trend table.
	  var displayedColumns = params.api.columnController.allDisplayedColumns.reduce(function (acc, curr) {
	    acc[curr.colId] = curr.colDef.width;
	    return acc;
	  }, {});
	  Object.keys(params.node.data).filter(function (node) {
	    return displayedColumns.hasOwnProperty(node);
	  }).forEach(function (key) {
	    // Get normal width...
	    var colWidth = displayedColumns[key] - padding;
	    var width = (0, _util.getEstTextLength)(params.node.data[key], fontStyleString);
	    var string = params.node.data[key];
	    // In english:
	    //  footnoteCallback() & sortMobel() are both existing
	    //  current key is a geo (location/state)
	    //  sorted row is not geo (so geo is then ranked)
	    if (params.api.footnoteCallback && params.api.getSortModel && (key === 'Location' || key === 'State') && (params.api.getSortModel()[0] || { colId: null }).colId !== key) {
	      string = '1. ' + string;
	      width = (0, _util.getEstTextLength)(string, fontStyleString);
	    }
	
	    // Get footnotes
	    if (params.api.footnoteCallback) {
	      var footnoteKey = [params.node.data[context], key];
	      if (isMultiGeo) {
	        footnoteKey.push(params.node.data[key]);
	      }
	
	      var footnotes = params.api.footnoteCallback(footnoteKey).map(function (_ref) {
	        var label = _ref.label;
	        return ' ' + label;
	      });
	      var footnotesString = footnotes.join(footnotes.length > 1 ? ', ' : ' ');
	      // 6 is a a magic number for the `/s` char
	      width = width + (0, _util.getEstTextLength)(footnotesString, footnoteFontString) + 6;
	      string = string + ' ' + footnotes;
	    }
	
	    // For the edge case where there is a fraction of a pixel difference
	    // we want to see if the width difference is less than 1, not 0.
	    if (colWidth - width < 1) {
	      // Lets actually calculate the height in this case so we know it will work fine.
	      var heightMultiplier = (0, _util.getEstTextRows)(string, fontStyleString, colWidth);
	      height = Math.max(rowDefaultHeight * heightMultiplier, height);
	    }
	  });
	  return height + 10; // add padding
	}
	
	/**
	 * Set body size contain when needed based on visible columns
	 *
	 * @param  {array}  displayedColumns    Array of columns currently displayed in the table
	 */
	function setBodySize(table) {
	  // Container width needs to be set.
	  // Body width should only be set if it is more narrow
	  // than the overall table wrapper.
	  var displayedColumns = table.columnApi.getAllDisplayedColumns();
	  var containerWidth = _mori2.default.intoArray(_mori2.default.rest(displayedColumns)).reduce(function (acc, curr) {
	    return acc + curr.colDef.width;
	  }, 0);
	  var bodyWidth = displayedColumns[0].colDef.width + containerWidth;
	
	  table.api.gridPanel.eBodyContainer.style.width = containerWidth + 'px';
	
	  // We need to reset the width in order for headers and table
	  // to display correctly.
	  if (bodyWidth < document.querySelector('.table-wrapper').clientWidth) {
	    table.api.gridPanel.eBody.style.width = bodyWidth + 18 + 'px';
	  }
	}
	
	/**
	 * Resize Header
	 */
	function resizeHeader(params) {
	  var parentElm = this.api.gridCore.eGridDiv.offsetParent;
	
	  // If there are no 'with-group' headers, but we have 'no-group' headers,
	  // we need to adjust the parentHeight below
	  var adjustParentHeight = !!!parentElm.querySelector('.ag-header-group-cell-with-group') && !!parentElm.querySelector('.ag-header-group-cell-no-group');
	  // Used to adjust parentHeight.  If our header container has more than
	  // 1 row, we're grouping headers.
	  var hasGroupedHeader = parentElm.querySelector('.ag-header-container').querySelectorAll('.ag-header-row').length > 1;
	  var fontStyleString = this.headerStyle ? this.headerStyle : 'bold 14px/20px "Source Sans Pro", helvetica, sans-serif';
	  var baseHeaderHeight = 20;
	  var heightAdjust = 10; // Adjustment for after height is calculated
	  var padding = 30;
	
	  var _reduce = (params.columns || []).reduce(function (_ref2, column) {
	    var header = _ref2.header,
	        parent = _ref2.parent;
	
	    if (column.children) {
	      // After header height calculation for parent/grouped row
	      var _heightMultiplier = (0, _util.getEstTextRows)(column.headerName, fontStyleString, column.children.reduce(function (acc, _ref3) {
	        var width = _ref3.width;
	        return acc + width;
	      }, 0) - 16);
	      var groupHeight = Math.max(parent, baseHeaderHeight * _heightMultiplier);
	      return {
	        // For each child, find the largest height for the header
	        header: column.children.reduce(function (acc, child) {
	          var childHeightMultiplier = (0, _util.getEstTextRows)(child.headerName, fontStyleString, child.width - padding);
	
	          return Math.max(acc, baseHeaderHeight * childHeightMultiplier);
	        }, header),
	        parent: groupHeight
	      };
	    }
	    // Else
	    var heightMultiplier = (0, _util.getEstTextRows)(column.headerName, fontStyleString, column.width - padding);
	    return {
	      header: Math.max(header, baseHeaderHeight * heightMultiplier),
	      parent: parent
	    };
	  }, { header: baseHeaderHeight, parent: 0 }),
	      headerHeight = _reduce.header,
	      parentHeight = _reduce.parent;
	
	  headerHeight += heightAdjust;
	
	  parentHeight = parentHeight !== 0 && parentHeight < baseHeaderHeight ? baseHeaderHeight + heightAdjust : parentHeight + (parentHeight !== 0 ? heightAdjust : 0);
	
	  // Sets value for parent height.  Used in maps tab where headers can
	  // get very tall if parentHeight is kept at 0.
	  parentHeight = adjustParentHeight && hasGroupedHeader ? baseHeaderHeight : parentHeight;
	
	  this.api.setHeaderHeight(parentHeight !== 0 ? (parentHeight + headerHeight) / 2 : headerHeight);
	
	  // If there is a parent height, we need to adjust node heights
	  // as AG-Grid does not handle this for us.
	  if (parentHeight !== 0) {
	    // Set parent height on first header row
	    [].forEach.call(parentElm.querySelectorAll('.ag-header-row:first-child'), function (row) {
	      return row.style.height = parentHeight + 'px';
	    });
	    // Set height and top on 2nd row below parent row
	    [].forEach.call(parentElm.querySelectorAll('.ag-header-row:last-child'), function (row) {
	      row.style.height = headerHeight + 'px';
	      row.style.top = parentHeight + 'px';
	
	      // If we are printing, we need to set height on
	      // All cells in the last row when there is a parent row.
	      if (params.forPrint) {
	        [].forEach.call(row.querySelectorAll('.ag-header-cell'), function (cell) {
	          return cell.style.height = headerHeight + 'px';
	        });
	      }
	    });
	
	    if (params.forPrint) {
	      [].forEach.call(parentElm.querySelectorAll('.ag-header-group-cell-with-group'), function (groupHeader) {
	        return groupHeader.style.height = parentHeight + 'px';
	      });
	    }
	  }
	
	  return parentHeight + headerHeight;
	}
	
	/**
	 * Get and set the table data
	 */
	function getData(sheetData, metaData, options, filteredData, combinedFilters, tableIndex) {
	  var data = _mori2.default.toJs(_dataFromOptions.buildTable.apply(undefined, [sheetData, metaData, options, filteredData].concat(_toConsumableArray(combinedFilters), [tableIndex])));
	
	  return {
	    'rowData': data.tableData.rowData,
	    'columnDefs': data.tableData.columnDefs
	  };
	}
	
	/**
	 * See if the table actually needs to be rebuilt, uses the tablehash var
	 * 1. Change of timeframe
	 * 2. Change of datatype
	 * 3. Change of Tab (Timeframe's changing signal this due to length)
	 *   a. Table/Map -> Graph
	 *   b. Graph -> Table/Map
	 * @param  {string}  view    the current tab view ('graph', 'map', 'table')
	 * @param  {object}  filters the combined filters
	 * @return {Boolean}
	 */
	function isTableDirty(timeframes, filters) {
	  var tempHash = _mori2.default.hash(_mori2.default.into(_mori2.default.vector(filters[0]), _mori2.default.into(_mori2.default.vector(filters[3]), _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, _mori2.default.first(item));
	  }, _mori2.default.vector(), timeframes))));
	
	  if (this.tableHash && this.tableHash === tempHash) {
	    return false;
	  }
	  this.tableHash = tempHash;
	  return true;
	}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterMetaDataByTimeframe = filterMetaDataByTimeframe;
	exports.filterByTimeframe = filterByTimeframe;
	exports.buildTable = buildTable;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _table = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	function filterMetaDataByTimeframe(data, options) {
	  var metaData = data.metaData;
	
	  // If no metaData, we are rendering a Medicare indicator
	
	  if (!metaData) {
	    var columns = data.columns,
	        immutableDataviews = data.immutableDataviews,
	        immutableHeaders = data.immutableHeaders,
	        immutableDistributions = data.immutableDistributions;
	
	
	    return {
	      columns: columns,
	      immutableDataviews: immutableDataviews,
	      immutableHeaders: immutableHeaders,
	      immutableDistributions: immutableDistributions
	    };
	  }
	
	  var activeTab = options.activeTab,
	      startTimeframe = options.startTimeframe,
	      currentTimeframe = options.currentTimeframe;
	
	  var activeTimeframe = +(currentTimeframe || 0);
	  activeTimeframe = activeTab === 'graph' && !startTimeframe ? 0 : activeTimeframe;
	
	  var metaDataYear = data.timeframes[activeTimeframe];
	
	  return metaData[metaDataYear];
	}
	
	/**
	 * [filterByTimeframe description]
	 * @TODO build out doc
	 * @param  {[type]} data    [description]
	 * @param  {[type]} options [description]
	 * @return {[type]}         [description]
	 */
	
	// import { getDefaultStates } from '../config/table';
	function filterByTimeframe(data, options) {
	  // Get the list of selected timeframes by name
	  // @TODO logic for selecting by timeframe gets a little weird for defaults
	  // and range vs single, could refactor this
	  var activeTimeframe = +(options.currentTimeframe || 0);
	  var endTimeframeOffset = 1;
	  if (options.activeTab === 'graph') {
	    if (!options.startTimeframe) {
	      activeTimeframe = 0;
	    }
	    var startTimeframe = +(options.startTimeframe || 0) + 1;
	    endTimeframeOffset = options.startTimeframe ? startTimeframe : data.timeframes.length;
	  } else {
	    endTimeframeOffset = +(options.startTimeframe || activeTimeframe + 1);
	  }
	
	  var timeframes = _mori2.default.set((data.timeframes || [0]).slice(activeTimeframe, endTimeframeOffset));
	
	  return _mori2.default.filter(function (sheet) {
	    return _mori2.default.hasKey(timeframes, _mori2.default.first(sheet));
	  }, data.immutableData);
	}
	
	/**
	 * [buildTable description]
	 * @TODO build out doc
	 * @param  {[type]} data            [description]
	 * @param  {[type]} options         [description]
	 * @param  {[type]} timeframes      [description]
	 * @param  {[type]} combinedColumns [description]
	 * @param  {[type]} selectedSetKeys [description]
	 * @param  {[type]} distributions   [description]
	 * @param  {[type]} dataviewType    [description]
	 * @param  {[type]} columnKeys      [description]
	 * @param  number   tableIndex      Number identifying which table this is in a page with many tables
	 * @return {[type]}                 [description]
	 */
	function buildTable(data, metaData, options, timeframes, combinedColumns, selectedSetKeys, distributions, dataviewType, columnKeys, tableIndex) {
	  var trend = _mori2.default.count(timeframes) > 1;
	
	  var geoMulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	
	  var mapBaseColumn = _mori2.default.getIn(data.config, ['globalRules', 'Map Base Column'], false);
	
	  var linkContext = _mori2.default.getIn(data.config, ['globalRules', 'Context'], [])[1] || 'states';
	
	  // Will be passed into cellRenderer to check for existance of footnotes for each cell
	  var baseContext = _mori2.default.getIn(data.config, ['globalRules', 'Context'], [])[0] || false;
	
	  var builtRowData = (0, _table.buildRowData)(timeframes, selectedSetKeys, combinedColumns, trend);
	
	  // Build the column headers and variables for agGrid
	  var columnDefs = (0, _table.getAgColumns)(metaData.immutableHeaders, distributions, _mori2.default.getIn(data.config, ['globalRules', 'Link Column'], false), _mori2.default.getIn(data.config, ['globalRules', 'Link Target'], false), linkContext, dataviewType, timeframes, trend, _mori2.default.first(columnKeys[0]), geoMulti && mapBaseColumn ? mapBaseColumn : false, geoMulti, baseContext, tableIndex);
	
	  return _mori2.default.hashMap('tableData', _mori2.default.hashMap('rowData', builtRowData.rowData || [], 'columnDefs', columnDefs, 'selectedSetKeys', selectedSetKeys));
	}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _buildHeader = __webpack_require__(116);
	
	Object.defineProperty(exports, 'buildHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buildHeader).default;
	  }
	});
	
	var _buildRowData = __webpack_require__(123);
	
	Object.defineProperty(exports, 'buildRowData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buildRowData).default;
	  }
	});
	
	var _cellRenderer = __webpack_require__(124);
	
	Object.defineProperty(exports, 'cellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cellRenderer).default;
	  }
	});
	
	var _getAgColumns = __webpack_require__(125);
	
	Object.defineProperty(exports, 'getAgColumns', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getAgColumns).default;
	  }
	});
	
	var _getApplicableFootnotes = __webpack_require__(126);
	
	Object.defineProperty(exports, 'getApplicableFootnotes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getApplicableFootnotes).default;
	  }
	});
	
	var _getDataRankings = __webpack_require__(127);
	
	Object.defineProperty(exports, 'getDataRankings', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDataRankings).default;
	  }
	});
	
	var _filterByRow = __webpack_require__(128);
	
	Object.defineProperty(exports, 'filterByRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_filterByRow).default;
	  }
	});
	
	var _valueGetter = __webpack_require__(129);
	
	Object.defineProperty(exports, 'valueGetter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_valueGetter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (header, linkColumn, linkTarget, linkContext, timeframe, trend, baseDistribution, mapBaseColumn, geoMulti, baseContext, tableIndex) {
	  var selectedHeaders = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
	  var headerGroupTitle = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
	  var currentGroup = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
	
	  var currentHeader = _mori2.default.toJs(header);
	  var characteristic = currentHeader.characteristic;
	
	  // align numeric columns right
	  var numericColumn = ['number', 'percent', 'currency', 'year', 'rate', 'default'].indexOf(currentHeader.type) > -1 || currentHeader.Prefix || currentHeader.Suffix;
	
	  // Take into account space needed for sorting arrows in columns
	  var colWidthAdjust = 35;
	
	  var field = (trend ? _mori2.default.first(timeframe) + '__' : '') + characteristic;
	
	  // Font style used to more accurately estimate width of text in headers
	  var fontStyleString = 'bold 14px/20px "Source Sans Pro", helvetica, sans-serif';
	
	  // For Grouped Headers, we need to accurately account for long words
	  // in the header group cell.  We'll find the longest word and adjust
	  // the widths of the header group children appropriately.
	
	  // Find base width for the current header
	  var baseHeaderWidth = _config.appDefault.defaultWidths[currentHeader.type][currentHeader.width || 'default'] || _config.appDefault.defaultWidths[currentHeader.type].default;
	
	  // Find the longest word in the group header
	  var estHeaderGroupWidth = currentHeader.headerGroup ? (0, _util.maxWordWidth)(currentHeader.headerGroup, fontStyleString) + colWidthAdjust : 0;
	
	  // Find the width of all children columns under a header group.
	  // This is needed, to ensure we size children columns correctly.
	  // Reduce the group of children columns down to a cummulative default width.
	  var defaultHeaderGroupWidth = _mori2.default.reduce(function (acc, item) {
	    return acc + _config.appDefault.defaultWidths[_mori2.default.get(item, 'type')][_mori2.default.get(item, 'width') || 'default'] || _config.appDefault.defaultWidths[_mori2.default.get(item, 'type')].default;
	  }, 0, currentGroup);
	
	  // Get the proportion of the current header width to the group's width
	  var headerWidthFactor = baseHeaderWidth / (defaultHeaderGroupWidth || 1);
	
	  // If longest word in group header is wider than entire header group
	  // compare which is wider:
	  // 1.  The base header width plus a proporition of the width difference
	  // 2.  The widest word in the current header
	  var estWidth = Math.max(defaultHeaderGroupWidth > estHeaderGroupWidth ? 0 : baseHeaderWidth + (estHeaderGroupWidth - defaultHeaderGroupWidth) * headerWidthFactor, (0, _util.maxWordWidth)(characteristic, fontStyleString) + colWidthAdjust);
	
	  var comparator = (0, _sortComparator2.default)(currentHeader, baseDistribution, mapBaseColumn);
	
	  var agHeader = _mori2.default.hashMap('cellRenderer', _.cellRenderer, 'field', headerGroupTitle ? headerGroupTitle + '__' + field : field, 'headerName', characteristic, 'sortingOrder', _config.appDefault.descSortFirst.indexOf(currentHeader.type) !== -1 ? ['desc', 'asc'] : ['asc', 'desc'], 'cellStyle', function () {
	    // Some times prefix/suffix get added to geo headers and appear "Numeric"
	    return numericColumn && currentHeader.type !== 'geography' && currentHeader.idx !== 0 ? { 'text-align': 'right' } : null;
	  }, 'width', estWidth > baseHeaderWidth ? estWidth : baseHeaderWidth, 'cellRendererParams', _mori2.default.hashMap('currentHeader', currentHeader, 'linkTarget', linkTarget, 'linkColumn', linkColumn, 'linkContext', linkContext, 'selectedHeaders', selectedHeaders, 'geoMulti', geoMulti, 'baseContext', baseContext, 'tableIndex', tableIndex), 'comparator', comparator, 'valueGetter', _.valueGetter);
	
	  if (characteristic === baseDistribution) {
	    agHeader = _mori2.default.assoc(agHeader, 'pinned', 'left');
	  }
	
	  if (characteristic === 'Location' || characteristic === 'State' && currentHeader.idx === 0) {
	    agHeader = _mori2.default.assoc(_mori2.default.assoc(agHeader, 'width', 160), 'suppressSizeToFit', true);
	  }
	
	  return agHeader;
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	var _ = __webpack_require__(115);
	
	var _util = __webpack_require__(76);
	
	var _sortComparator = __webpack_require__(117);
	
	var _sortComparator2 = _interopRequireDefault(_sortComparator);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortComparator;
	
	var _sorters = __webpack_require__(118);
	
	var _sorters2 = _interopRequireDefault(_sorters);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortComparator(currentHeader, baseDistribution, mapBaseColumn) {
	  return function (_ref, _ref2, data1, data2, isInverted) {
	    var val1 = _ref.text;
	    var val2 = _ref2.text;
	
	    var datacenterSortResult = (0, _sorters2.default)(val1, val2, currentHeader, isInverted, data1.data[baseDistribution], data2.data[baseDistribution], data1.data.isSummary, data2.data.isSummary);
	
	    // @TODO - build geo-sorting tied no-data vals into each sort
	    var noDataSort = val1 === val2 && _config.appDefault.dataNotAvailable.indexOf(val1) > -1 && _config.appDefault.dataNotAvailable.indexOf(val2) > -1;
	
	    // If the sort returns a 0, we've tied.
	    // If we are also comparing on a header that is not the base,
	    // then we are to re-sort based on geography.
	    if ((datacenterSortResult === 0 || noDataSort) && baseDistribution !== currentHeader.characteristic) {
	      return (isInverted ? -1 : 1) * (0, _sorters2.default)(data1.data[baseDistribution], data2.data[baseDistribution], { type: 'geography' }, isInverted, data1.data[baseDistribution], data2.data[baseDistribution], data1.data.isSummary, data2.data.isSummary);
	    }
	
	    // If there is mapBaseColumn, we are in a multiGeo indicator
	    // In that case, see if we are sorting on the base distribution.
	    // If we are, then sort on geo after sorting on base w/result of 0.
	    // This indicates that sorting on base didn't change anything, but we
	    // still need to sort on geography.
	    if (mapBaseColumn && baseDistribution === currentHeader.characteristic) {
	      return datacenterSortResult === 0 ? (0, _sorters2.default)(data1.data[mapBaseColumn], data2.data[mapBaseColumn], { type: 'geography' }, isInverted, data1.data[mapBaseColumn], data2.data[mapBaseColumn], data1.data.isSummary, data2.data.isSummary) : datacenterSortResult;
	    }
	
	    // @TODO - find a better way to send in summary info
	    // this problem arises from removing the (All) string from
	    // the data for rendering purposes.  We already added an
	    // isSummary prop to the data, so we're using it here
	    return (0, _sorters2.default)(val1, val2, currentHeader, isInverted, data1.data[baseDistribution], data2.data[baseDistribution], data1.data.isSummary, data2.data.isSummary);
	  };
	}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
	  // console.log({
	  //   a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary
	  // });
	  switch (header.type) {
	    case 'geography':
	      return (0, _geoSort2.default)(a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary);
	    case 'number':
	    case 'percent':
	    case 'currency':
	      return (0, _numberSort2.default)(a, b, header, isInverted, aBase, bBase);
	    case 'text':
	      return (0, _textSort2.default)(a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary);
	    case 'date-format':
	      return (0, _dateSort2.default)(a, b, header, isInverted);
	    default:
	      return (0, _mixedSort2.default)(a, b, header, isInverted, aBase, bBase);
	  }
	};
	
	var _geoSort = __webpack_require__(101);
	
	var _geoSort2 = _interopRequireDefault(_geoSort);
	
	var _textSort = __webpack_require__(119);
	
	var _textSort2 = _interopRequireDefault(_textSort);
	
	var _numberSort = __webpack_require__(121);
	
	var _numberSort2 = _interopRequireDefault(_numberSort);
	
	var _mixedSort = __webpack_require__(120);
	
	var _mixedSort2 = _interopRequireDefault(_mixedSort);
	
	var _dateSort = __webpack_require__(122);
	
	var _dateSort2 = _interopRequireDefault(_dateSort);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = textSorter;
	
	var _util = __webpack_require__(102);
	
	var _mixedSort = __webpack_require__(120);
	
	var _mixedSort2 = _interopRequireDefault(_mixedSort);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function textSorter(a, b, column, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
	  var aProps = (0, _util.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util.buildRowProperties)(b, column, _config.appDefault);
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  if (!a.localeCompare || !b.localeCompare || a === b) {
	    return (0, _mixedSort2.default)(a, b, column, isInverted, aBase, bBase);
	  }
	
	  // Summary rows float up without matching groups
	  if (a === b && aIsSummary) {
	    return (isInverted ? -1 : 1) * -1;
	  } else if (a === b && bIsSummary) {
	    return (isInverted ? 1 : -1) * -1;
	  } else if (a === b) {
	    return a.localeCompare(b);
	  }
	
	  // Umm, and if there is an arbitrary display order, sort that way
	  if ((column.sortOrder || []).length) {
	    var _sorted = (0, _util.sortArbitrary)(a, b, column.sortOrder);
	    if (_sorted) {
	      return (isInverted ? -1 : 1) * _sorted;
	    }
	  }
	
	  if (a === b && aBase !== undefined && bBase !== undefined) {
	    return aBase.localeCompare(bBase);
	  }
	
	  return a.localeCompare(b);
	} /* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	/**
	 * Text columns are easy, just push N/A data to the bottom
	 */

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mixedSorter;
	
	var _util = __webpack_require__(76);
	
	var _util2 = __webpack_require__(102);
	
	var _config = __webpack_require__(71);
	
	function mixedSorter(a, b, column, isInverted, aBase, bBase) {
	  var aProps = (0, _util2.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util2.buildRowProperties)(b, column, _config.appDefault);
	
	  // Wrapups pushed to the top
	  if (aProps.wrapup && bProps.wrapup) {
	    return (isInverted ? -1 : 1) * aProps.value.localeCompare(bProps.value);
	  } else if (aProps.wrapup) {
	    return isInverted ? 1 : -1;
	  } else if (bProps.wrapup) {
	    return isInverted ? -1 : 1;
	  }
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util2.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  // If there is an arbitrary display order, sort that way
	  if ((column.sortOrder || []).length) {
	    var _sorted = (0, _util2.sortArbitrary)(aProps.value, bProps.value, column.sortOrder);
	    if (_sorted) {
	      return _sorted;
	    }
	  }
	
	  if (aProps.value === bProps.value) {
	    if (aBase && bBase) {
	      return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
	    }
	    return 0;
	  }
	
	  // Is column needed?
	  if (aProps.rawValue !== false && bProps.rawValue !== false) {
	    var anum = parseFloat(aProps.rawValue);
	    var bnum = parseFloat(bProps.rawValue);
	
	    // Is column having < or >
	    if (!(0, _util.kffIsNumber)(a) && /<|>/g.test(a) && anum === bnum) {
	      anum = />/g.test(a) ? ++anum : anum;
	      anum = /</g.test(a) ? --anum : anum;
	    } else if (!(0, _util.kffIsNumber)(b.value) && /<|>/g.test(b) && bnum === anum) {
	      bnum = />/g.test(b) ? ++bnum : bnum;
	      bnum = /</g.test(b) ? --bnum : bnum;
	    }
	
	    return bnum - anum;
	  } else if (aProps.rawValue !== false) {
	    return -1;
	  } else if (bProps.rawValue !== false) {
	    return 1;
	  }
	
	  // Finally, push symbols below others
	  var testStr = /^[a-z0-9\s].*[a-z0-9\s]+$/i;
	  var oneWordAtStart = /^([a-z0-9\s].*?\s?){1,}/i;
	  if (testStr.test(aProps.value) && !testStr.test(bProps.value) && !oneWordAtStart.test(bProps.value)) {
	    return -1;
	  } else if (testStr.test(bProps.value) && !testStr.test(aProps.value) && !oneWordAtStart.test(aProps.value)) {
	    return 1;
	  }
	
	  // Finally give up and fallback to localeCompare
	  return aProps.value.localeCompare(bProps.value);
	} /* eslint id-length: [2, {"exceptions":["a","b"]}] */

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = numberSort;
	
	var _util = __webpack_require__(76);
	
	var _util2 = __webpack_require__(102);
	
	var _config = __webpack_require__(71);
	
	function numberSort(a, b, column, isInverted, aBase, bBase) {
	  var aNumber = (0, _util.kffNumericValue)(a);
	  var bNumber = (0, _util.kffNumericValue)(b);
	  var aNotAvailable = _config.appDefault.dataNotAvailable.indexOf(a) !== -1;
	  var bNotAvailable = _config.appDefault.dataNotAvailable.indexOf(b) !== -1;
	  // KFF-2244 If we do not check for null, +null will equal 0 lower
	  // lower in the function, causing an improper sort
	  var aInvalid = isNaN(aNumber) || aNumber === null || aNotAvailable;
	  var bInvalid = isNaN(bNumber) || bNumber === null || bNotAvailable;
	  var aProps = (0, _util2.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util2.buildRowProperties)(b, column, _config.appDefault);
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util2.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  if (aInvalid && bInvalid) {
	    return (isInverted ? 1 : -1) * a.localeCompare(b);
	  } else if (aInvalid) {
	    return (isInverted ? -1 : 1) * 1;
	  } else if (bInvalid) {
	    return (isInverted ? -1 : 1) * -1;
	  }
	
	  if (!(0, _util.kffIsNumber)(a) && /<|>/g.test(a) && aNumber === bNumber) {
	    aNumber = />/g.test(a) ? ++aNumber : aNumber;
	    aNumber = /</g.test(a) ? --aNumber : aNumber;
	  } else if (!(0, _util.kffIsNumber)(b) && /<|>/g.test(b) && bNumber === aNumber) {
	    bNumber = />/g.test(b) ? ++bNumber : bNumber;
	    bNumber = /</g.test(b) ? --bNumber : bNumber;
	  }
	
	  if (+aNumber === +bNumber) {
	    return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
	  }
	
	  return +aNumber - +bNumber;
	} /* eslint id-length: [2, {"exceptions":["a","b"]}] */

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dateSort;
	
	var _util = __webpack_require__(102);
	
	var _config = __webpack_require__(71);
	
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	function dateSort(a, b, column, isInverted) {
	  var aVal = Date.parse(a);
	  var bVal = Date.parse(b);
	  var aNotAvailable = _config.appDefault.dataNotAvailable.indexOf(a) !== -1;
	  var bNotAvailable = _config.appDefault.dataNotAvailable.indexOf(b) !== -1;
	  var aInvalid = isNaN(aVal) || aNotAvailable;
	  var bInvalid = isNaN(bVal) || bNotAvailable;
	  var aProps = (0, _util.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util.buildRowProperties)(b, column, _config.appDefault);
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  if (aInvalid && bInvalid) {
	    return (isInverted ? 1 : -1) * a.localeCompare(b);
	  } else if (aInvalid) {
	    return (isInverted ? -1 : 1) * 1;
	  } else if (bInvalid) {
	    return (isInverted ? -1 : 1) * -1;
	  }
	
	  return aVal - bVal;
	}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (timeframes, keys, combined, trend) {
	  // Build a map of footnotes ids by order of assignment in the table
	  var shouldFilter = !_mori2.default.isEmpty(combined);
	  var withSummary = _mori2.default.some(function (base) {
	    return _mori2.default.reduce(function (acc, sel) {
	      return acc ? acc : _config.appDefault.isSummaryRow.test(_mori2.default.last(_mori2.default.first(sel)));
	    }, false, base);
	  }, combined) || false;
	
	  var test = _mori2.default.map(function (timeframe) {
	    return _mori2.default.transduce(_mori2.default.comp(_mori2.default.map(function (row) {
	      return _config.appDefault.isSummaryRow.test(_mori2.default.get(row, _mori2.default.first(_mori2.default.keys(row)))) ? _mori2.default.assoc(_mori2.default.assoc(row, _mori2.default.first(_mori2.default.keys(row)), _mori2.default.get(row, _mori2.default.first(_mori2.default.keys(row))).replace(_config.appDefault.isSummaryRow, '')), 'isSummary', true) : row;
	    }), _mori2.default.filter(function (row) {
	      return (0, _.filterByRow)(row, combined, shouldFilter, withSummary);
	    }), _mori2.default.map(function (row) {
	      return _mori2.default.assoc(_mori2.default.into(_mori2.default.hashMap(_mori2.default.first(_mori2.default.first(keys)), _mori2.default.get(row, _mori2.default.first(keys))), _mori2.default.map(function (select) {
	        return _mori2.default.hashMap((trend ? _mori2.default.first(timeframe) + '__' : '') + (_mori2.default.count(select) === 3 ? _mori2.default.first(select) + '__' + _mori2.default.first(_mori2.default.rest(select)) : _mori2.default.first(select)), _mori2.default.get(row, select));
	      }, _mori2.default.rest(keys))), 'isSummary', _mori2.default.get(row, 'isSummary'));
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), _mori2.default.last(timeframe));
	  }, timeframes);
	
	  // Filter timeframe data by baseColumn selections
	  var rowData = _mori2.default.map(function (group) {
	    return _mori2.default.into(_mori2.default.hashMap(), _mori2.default.toClj(group));
	  }, _mori2.default.map.apply(_mori2.default, [_mori2.default.vector].concat(_toConsumableArray(_mori2.default.toJs(test)))));
	
	  return _mori2.default.toJs(_mori2.default.hashMap('rowData', rowData));
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	var _ = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * [buildRowData description]
	 * @TODO finish documenting this out
	 * @param  {[type]} timeframes    [description]
	 * @param  {[type]} keys          [description]
	 * @param  {[type]} combined      [description]
	 * @param  {[type]} footnotes     [description]
	 * @param  {[type]} trend         [description]
	 * @param  {[type]} distributions [description]
	 * @return {[type]}               [description]
	 */

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var api = _ref.api,
	      value = _ref.value,
	      column = _ref.column,
	      rowIndex = _ref.rowIndex,
	      linkTarget = _ref.linkTarget,
	      linkColumn = _ref.linkColumn,
	      linkContext = _ref.linkContext,
	      currentHeader = _ref.currentHeader,
	      selectedHeaders = _ref.selectedHeaders,
	      geoMulti = _ref.geoMulti,
	      baseContext = _ref.baseContext,
	      tableIndex = _ref.tableIndex;
	  var text = value.text,
	      data = value.data,
	      child = value.child,
	      group = value.group;
	  var characteristic = currentHeader.characteristic;
	
	  var context = data.Location && 'Location' || baseContext || 'State';
	
	  var footnotes = [];
	  if (api.footnoteCallback) {
	    var key = [data[context], child !== false ? [group, child] : group];
	
	    if (data[context] && data[context] !== text) {
	      key.push('' + text);
	    }
	    footnotes = api.footnoteCallback(key);
	  }
	
	  var notes = footnotes.sort(function (_ref2, _ref3) {
	    var a = _ref2.label;
	    var b = _ref3.label;
	    return a - b;
	  }).map(function (note) {
	    return footnoteMark(note, tableIndex);
	  }).join(', ');
	
	  var formattedValue = filterSwitch(text, currentHeader);
	  var cellAnchor = linkTarget && linkColumn && linkColumn === characteristic ? getLinkTargetUrl(linkTarget, linkContext, formattedValue) : null;
	
	  // Only rank geos w/ sorting on different column
	  // If column.sort is null it means it's sorted on different column
	  var rank = '';
	  if (currentHeader.idx === 0 && column.sort === null) {
	    var colIdx = 0;
	    var sortDir = void 0;
	    var headerName = void 0;
	    var rowsToDisplay = api.rowModel.rowsToDisplay.length;
	    var isWrapup = _config.appDefault.specialWrapups.indexOf(text) >= 0;
	    var currentSortColumn = api.columnController.allDisplayedColumns.reduce(function (acc, curr, index) {
	      return curr.sort && !acc ? (colIdx = index) && (headerName = curr.colDef.headerName) && (sortDir = curr.sort) && curr.colId : acc;
	    }, false);
	    if (!currentSortColumn) {
	      rank = '';
	    } else {
	      var dataValue = api.rowModel.rowsToDisplay[rowIndex].data[currentSortColumn];
	
	      var isNaData = _config.appDefault.dataNotAvailable.indexOf(dataValue !== null ? dataValue : '') >= 0;
	      var sortKey = currentSortColumn + '-' + sortDir;
	
	      // Catches for Linechart data maps
	      if (_mori2.default.count(selectedHeaders) - 1 < colIdx) {
	        colIdx = colIdx % (_mori2.default.count(selectedHeaders) - 1) + 1;
	      }
	
	      // Check if rankings for this sort exist, and store the length.
	      // If the # of rows to render has changed (not equal to rankings)
	      // we need to re-rank, as we cannot tell exactly what changed.
	      var rankingsExist = !!cellRendererVars.rankings[sortKey];
	      var rankingsLength = rankingsExist ? cellRendererVars.rankings[sortKey].length : 0;
	      cellRendererVars.rankings[sortKey] = rankingsExist && rankingsLength === rowsToDisplay ? cellRendererVars.rankings[sortKey] : (0, _.getDataRankings)(api, currentSortColumn, _mori2.default.toJs(
	      // Getting the nth selectedHeader is not reliable if we are
	      // on the trend graph view.  We want to get the header
	      // based on what the current sort column is - using headerName.
	      _mori2.default.first(_mori2.default.filter(function (item) {
	        return item.characteristic === headerName;
	      }, selectedHeaders))));
	
	      rank = isWrapup || isNaData ? '' : cellRendererVars.rankings[sortKey][rowIndex] + '. ';
	    }
	  }
	
	  // Remove HTML tags from title for span
	  var strippedTitle = typeof formattedValue === 'string' ? formattedValue.replace(/<[^>]+>/g, '') : formattedValue;
	
	  return '<span title="' + strippedTitle + '">\n      ' + rank + (cellAnchor ? cellAnchor : '') + '\n      ' + formattedValue + ' <sup>' + notes + '</sup>\n      ' + (cellAnchor ? '</a>' : '') + '\n    </span>';
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _ = __webpack_require__(115);
	
	var _filters = __webpack_require__(107);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _config = __webpack_require__(71);
	
	var _slugify2 = __webpack_require__(79);
	
	var _slugify3 = _interopRequireDefault(_slugify2);
	
	var _switchFilter = __webpack_require__(110);
	
	var _switchFilter2 = _interopRequireDefault(_switchFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* global __webpack_modules__ */
	
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  //  This is react's territory
	  filterSwitch = (0, _switchFilter2.default)();
	}
	
	var cellRendererVars = {
	  rankings: {}
	};
	
	function getLinkTargetUrl(url, linkContext, value) {
	  var tree = encodeURIComponent(JSON.stringify(_defineProperty({}, (0, _slugify3.default)(linkContext), _defineProperty({}, (0, _slugify3.default)(value), {}))));
	
	  return '<a href="' + url + '?selectedRows=' + tree + '" target="_self">';
	}
	
	function footnoteMark(_ref4, tableIndex) {
	  var id = _ref4.id,
	      label = _ref4.label;
	
	  // If -1 is sent in, there has been no tableIndex passed to the data-parsing code.
	  // If that is the case, we are likely on a stand-alone SHF Indicator.
	  // Do not add in the table index if that is the case.
	  var index = tableIndex >= 0 ? tableIndex + '-' : '';
	  return '<a href="#note-' + index + id + '">' + label + '</a>';
	}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (headers, distributions, linkColumn, linkTarget, linkContext, type, timeframes, trend, baseDistribution, mapBaseColumn, geoMulti, baseContext, tableIndex) {
	  // Pluck distribution names from the selected distributions array
	  var distributionNames = _mori2.default.set(_mori2.default.map(function (characteristic) {
	    return _mori2.default.get(characteristic, 'characteristic');
	  }, distributions));
	  var headerGroups = _mori2.default.set(_mori2.default.map(function (group) {
	    return _mori2.default.get(group, 'headerGroup', false);
	  }, distributions));
	
	  // Map selected headers by distribution name and type
	  var selectedHeaders = _mori2.default.filter(function (header) {
	    return _mori2.default.get(header, 'idx') === 0 || (_mori2.default.hasKey(header, 'headerGroup') && _mori2.default.get(header, 'headerGroup', null) !== null ? _mori2.default.hasKey(distributionNames, _mori2.default.get(header, 'characteristic')) && _mori2.default.hasKey(headerGroups, _mori2.default.get(header, 'headerGroup')) : _mori2.default.hasKey(distributionNames, _mori2.default.get(header, 'characteristic'))) && (!type || type.type === 'default' || type.label === _mori2.default.get(header, 'label'));
	  }, headers);
	
	  // Build the header object required by ag-grid
	  var columnDefs = void 0;
	  var initialColumn = (0, _.buildHeader)(_mori2.default.first(selectedHeaders), linkColumn, linkTarget, linkContext, _mori2.default.first(timeframes), undefined, baseDistribution, mapBaseColumn, geoMulti, baseContext, tableIndex, selectedHeaders);
	
	  // clusters the timeframe header groups
	  if (trend) {
	    columnDefs = _mori2.default.into(_mori2.default.vector(initialColumn), _mori2.default.map(function (timeframe) {
	      return _mori2.default.hashMap('headerName', _mori2.default.first(timeframe), 'children', _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (header) {
	        return (0, _.buildHeader)(header, linkColumn, linkTarget, linkContext, timeframe, trend, baseDistribution, mapBaseColumn, geoMulti, baseContext, tableIndex);
	      }, _mori2.default.rest(selectedHeaders))));
	    }, _mori2.default.reverse(timeframes)));
	  } else {
	    var isGrouped = _mori2.default.some(function (header) {
	      return _mori2.default.hasKey(header, 'headerGroup');
	    }, _mori2.default.rest(selectedHeaders));
	    if (!isGrouped) {
	      columnDefs = _mori2.default.into(_mori2.default.vector(initialColumn), _mori2.default.mapcat(function (header) {
	        return _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (timeframe) {
	          return (0, _.buildHeader)(header, linkColumn, linkTarget, linkContext, timeframe, trend, baseDistribution, mapBaseColumn, geoMulti, baseContext, tableIndex);
	        }, _mori2.default.reverse(timeframes)));
	      }, _mori2.default.rest(selectedHeaders)));
	    } else {
	      var groupedHeaders = [];
	      columnDefs = _mori2.default.into(_mori2.default.vector(initialColumn), _mori2.default.mapcat(function (header) {
	        var headerGroup = _mori2.default.get(header, 'headerGroup');
	        if (!headerGroup) {
	          return _mori2.default.vector((0, _.buildHeader)(header, linkColumn, linkTarget, linkContext, _mori2.default.first(timeframes), trend, baseDistribution, mapBaseColumn, geoMulti, baseContext, tableIndex));
	        }
	
	        if (groupedHeaders.indexOf(headerGroup) < 0) {
	          groupedHeaders.push(headerGroup);
	          return _mori2.default.vector(_mori2.default.hashMap('headerName', headerGroup, 'children', _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (headerItem) {
	            return (0, _.buildHeader)(headerItem, linkColumn, linkTarget, linkContext, _mori2.default.first(timeframes), trend, baseDistribution, mapBaseColumn, geoMulti, baseContext, tableIndex, null, headerGroup, _mori2.default.filter(function (item) {
	              return _mori2.default.get(item, 'headerGroup') === headerGroup;
	            }, _mori2.default.rest(selectedHeaders)));
	          }, _mori2.default.filter(function (item) {
	            return _mori2.default.get(item, 'headerGroup') === headerGroup;
	          }, _mori2.default.rest(selectedHeaders))))));
	        }
	      }, _mori2.default.rest(selectedHeaders)));
	    }
	  }
	
	  return columnDefs;
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _ = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (footnotes, row, keys, select, timeframe, distributions) {
	  var footnotesForTimeframe = _mori2.default.reduce(function (acc, curr) {
	    return _mori2.default.hasKey(acc, _mori2.default.first(curr)) ? _mori2.default.conj(acc, _mori2.default.assoc(acc, _mori2.default.first(curr), _mori2.default.reduce(function (acc1, curr1) {
	      return _mori2.default.hasKey(acc1, _mori2.default.first(_mori2.default.first(curr1))) ? _mori2.default.updateIn(acc1, [_mori2.default.first(_mori2.default.first(curr1))], function () {
	        return _mori2.default.flatten(_mori2.default.into(_mori2.default.get(acc1, _mori2.default.first(_mori2.default.first(curr1))), _mori2.default.rest(_mori2.default.first(curr1))));
	      }) : _mori2.default.conj(acc1, curr1);
	    }, _mori2.default.get(acc, _mori2.default.first(curr)), _mori2.default.rest(curr)))) : _mori2.default.conj(acc, curr);
	  }, _mori2.default.get(footnotes, 'any', _mori2.default.hashMap()), _mori2.default.get(footnotes, _mori2.default.first(timeframe), _mori2.default.hashMap()));
	
	  var foundFootnotes = _mori2.default.getIn(footnotesForTimeframe, [_mori2.default.get(row, _mori2.default.first(keys)), _mori2.default.first(select)], _mori2.default.vector());
	
	  if (_mori2.default.some(function (curr) {
	    return _mori2.default.get(curr, 'headerGroup') === _mori2.default.first(select);
	  }, distributions)) {
	    foundFootnotes = _mori2.default.flatten(_mori2.default.conj(foundFootnotes, _mori2.default.getIn(footnotesForTimeframe, [_mori2.default.get(row, _mori2.default.first(keys)), _mori2.default.first(_mori2.default.rest(select))], _mori2.default.vector()), _mori2.default.getIn(footnotesForTimeframe, [_mori2.default.get(row, _mori2.default.first(keys)), _mori2.default.hashMap(_mori2.default.first(select), _mori2.default.first(_mori2.default.rest(select)))], _mori2.default.vector())));
	  }
	
	  return _mori2.default.toJs(foundFootnotes);
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (api, sortColumn, sortHeader) {
	  var groupRankArray = [];
	  var wrapupsArray = [];
	  var accountForWrapup = false;
	  var currItem = void 0;
	
	  // Switch to using the event `afterSortChanged`
	  return api.rowModel.rowsToDisplay.map(function (row) {
	    var formatted = filterSwitch(row.data[sortColumn], sortHeader);
	    var isWrapup = _config.appDefault.specialWrapups.indexOf(row.data.Location) >= 0;
	
	    if (!isWrapup) {
	      groupRankArray.push(currItem !== formatted ? 0 : 1);
	      wrapupsArray.push(0);
	    } else {
	      groupRankArray.push(1);
	      wrapupsArray.push(1);
	    }
	
	    var groupRankSubset = groupRankArray.slice(0, row.childIndex + 1);
	
	    var tieRank = groupRankSubset.reduce(function (acc, curr) {
	      return acc + curr;
	    }, 0);
	
	    var tieRankRowAdjust = groupRankSubset.slice(0, groupRankSubset.lastIndexOf(0)).reduce(function (acc, curr) {
	      return acc + curr;
	    }, 0);
	
	    accountForWrapup = accountForWrapup ? true : tieRank === tieRankRowAdjust && wrapupsArray.indexOf(1) > -1;
	
	    var wrapupAdjust = accountForWrapup ? wrapupsArray.slice(0, row.childIndex + 1).reduce(function (acc, curr) {
	      return acc + curr;
	    }, 0) : 0;
	
	    currItem = isWrapup ? currItem : formatted;
	
	    return row.childIndex + 1 - tieRank + tieRankRowAdjust - wrapupAdjust;
	  });
	};
	
	var _config = __webpack_require__(71);
	
	var _filters = __webpack_require__(107);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  filterSwitch = (0, _filters2.default)('filterSwitch');
	}
	
	/**
	 * getDataRankings function
	 * @TODO finish building this out
	 * @param  {[type]} api       [description]
	 * @param  {[type]} sortColumn [description]
	 * @param  {[type]} sortHeader [description]
	 * @return {[type]}            [description]
	 */

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (row, combined, shouldFilter, withSummary) {
	  return shouldFilter ? _mori2.default.some(function (baseColumn) {
	    return _mori2.default.every(function (selected) {
	      return _mori2.default.equals(_mori2.default.last(_mori2.default.first(selected)), _mori2.default.get(row, _mori2.default.first(_mori2.default.first(selected)))) || _mori2.default.get(row, 'isSummary', false) && withSummary && _mori2.default.equals(_mori2.default.last(_mori2.default.first(_mori2.default.first(baseColumn))).replace(_config.appDefault.isSummaryRow, ''), _mori2.default.get(row, _mori2.default.first(_mori2.default.first(_mori2.default.first(baseColumn)))));
	    }, baseColumn);
	  }, combined) : row;
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = valueGetter;
	function valueGetter(_ref) {
	  var data = _ref.data,
	      colDef = _ref.colDef;
	
	  var _colDef$field$split = colDef.field.split('__'),
	      _colDef$field$split2 = _slicedToArray(_colDef$field$split, 2),
	      group = _colDef$field$split2[0],
	      _colDef$field$split2$ = _colDef$field$split2[1],
	      child = _colDef$field$split2$ === undefined ? false : _colDef$field$split2$;
	
	  return {
	    data: data,
	    group: group,
	    child: child,
	    text: typeof data[colDef.field] !== 'undefined' ? data[colDef.field] : ''
	  };
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultStates = getDefaultStates;
	exports.LocationFilter = LocationFilter;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  columnDefs: [],
	  rowData: null,
	  enableSorting: true,
	  enableFilter: true,
	  enableColResize: false,
	  suppressAutoSize: true,
	  suppressMultiSort: true,
	  autoSizePadding: 50,
	  forPrint: false,
	  minColWidth: 50,
	  colWidth: 200,
	  headerHeight: 30,
	  rowBuffer: 50,
	  // Only remove if you have a good reason. Allows periods in field names
	  suppressFieldDotNotation: true,
	  // no more dragging column headers
	  suppressMovableColumns: true,
	  // Can't select cells
	  suppressCellSelection: true,
	  // Don't hide the menu
	  suppressMenuHide: true,
	  // It's faster NOT to use angluar to compile table stuff
	  angularCompileHeaders: false,
	  angularCompileRows: false,
	  unSortIcon: true,
	  icons: {
	    sortAscending: function sortAscending() {
	      return '<span />';
	    },
	    sortDescending: function sortDescending() {
	      return '<span />';
	    },
	    sortUnSort: function sortUnSort() {
	      return '<span />';
	    }
	  },
	  getRowClass: function getRowClass(params) {
	    var classes = [];
	    // @TODO We can test for summary rows in Location or State context, but
	    // not for multigeo cases base column is Parent Firm or other.
	    // Could use some expensive extended cases here, or figure out how to
	    // access the base column header context
	    var baseDistribution = params.data.Location || params.data.State;
	
	    if (_config.appDefault.specialWrapups.indexOf(baseDistribution) >= 0 || _config.appDefault.isSummaryRow.test(baseDistribution) || params.data.isSummary) {
	      classes.push('wrapup');
	    }
	
	    if (params.node.rowHeight > 30) {
	      classes.push('multiline');
	    }
	
	    return classes;
	  }
	};
	function getDefaultStates(columns) {
	  // Super hacky, but hey it works ¯\_(ツ)_/¯
	  // Convert US, and States in data.columns to
	  // #{"Location" "Geography"}: "[Label]"
	  return _mori2.default.into(_mori2.default.vector(_mori2.default.vector(_mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), 'United States'))), _mori2.default.map(function (item) {
	    return _mori2.default.vector(_mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), _mori2.default.get(_mori2.default.last(item), 'label')));
	  }, _mori2.default.toClj(columns.nested.states.children)));
	}
	
	// This is the locationFiltering function
	function LocationFilter() {}
	LocationFilter.prototype.init = function (params) {
	  this.field = params.colDef.field;
	  this.valueGetter = params.valueGetter;
	};
	// Required, but not used
	LocationFilter.prototype.getGui = function () {
	  return '';
	};
	LocationFilter.prototype.isFilterActive = function () {
	  return this.value.length > 0;
	};
	LocationFilter.prototype.doesFilterPass = function (params) {
	  return this.value.indexOf(params.data[this.field]) > -1;
	};
	LocationFilter.prototype.getApi = function () {
	  var _this = this;
	  return {
	    getField: function getField() {
	      return _this.field;
	    },
	    getModel: function getModel() {
	      return { 'value': _this.value };
	    },
	    setModel: function setModel(model) {
	      _this.value = model.map(function (curr) {
	        return curr.indexOf(' (All)') > -1 ? curr.split(' (All)')[0] : curr;
	      });
	    }
	  };
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcScrollShadow = calcScrollShadow;
	/**
	 * This file contains utils specifically for the table.
	 */
	
	/*
	 * Adds scroll shadow divs and an event listener to adjust shadow opacity
	 * @param  {object} table The table object
	 */
	function calcScrollShadow(table) {
	  var height = table.height,
	      container = table.container;
	
	  // We want to get the last instantiated grid as a backup.
	
	  var grids = document.querySelectorAll('.ag-datacenter');
	  var gridElm = grids.length ? grids[grids.length - 1] : false;
	
	  // If the container isn't defined, then we use the last grid.
	  var parentElm = container || gridElm;
	
	  // If neither is defined, then we want to exit out.
	  if (!parentElm) {
	    return;
	  }
	  var bodyContainer = parentElm.querySelector('.ag-body-container');
	  var vp = parentElm.querySelector('.ag-body-viewport');
	
	  // If there is any of the shadow elements present, we've already
	  // initialized the shadow elements and scroll event
	  if (!!parentElm.querySelector('.ag-scroll-shadow-right')) {
	    parentElm.querySelector('.ag-scroll-shadow-bottom').style.opacity = bodyContainer.clientHeight - height <= 0 ? 0 : 1;
	
	    parentElm.querySelector('.ag-scroll-shadow-right').style.opacity = bodyContainer.clientWidth - vp.clientWidth <= 0 ? 0 : 1;
	    return;
	  }
	
	  var shadowRight = parentElm.querySelector('.ag-scroll-shadow-right');
	  var shadowLeft = parentElm.querySelector('.ag-scroll-shadow-left');
	  var shadowTop = parentElm.querySelector('.ag-scroll-shadow-top');
	  var shadowBottom = parentElm.querySelector('.ag-scroll-shadow-bottom');
	  var marginLeft = parentElm.querySelector('.ag-body-viewport-wrapper').style.marginLeft;
	
	  // 10 = width/height of shadow elements in CSS
	  var shadowLeftAdjust = marginLeft.replace('px', '') - 10;
	  var shadowTopAdjust = -10;
	
	  shadowTop = document.createElement('div');
	  shadowTop.className = 'ag-scroll-shadow-top';
	  shadowTop.style.width = bodyContainer.style.width;
	  shadowTop.style['z-index'] = 9999999;
	  shadowBottom = document.createElement('div');
	  shadowBottom.className = 'ag-scroll-shadow-bottom';
	  shadowBottom.style.width = bodyContainer.style.width;
	  shadowBottom.style['z-index'] = 9999999;
	  shadowRight = document.createElement('div');
	  shadowRight.className = 'ag-scroll-shadow-right';
	  shadowLeft = document.createElement('div');
	  shadowLeft.className = 'ag-scroll-shadow-left';
	  vp.appendChild(shadowTop);
	  vp.appendChild(shadowBottom);
	  vp.appendChild(shadowRight);
	  vp.appendChild(shadowLeft);
	  shadowTop.style.opacity = 0;
	  shadowLeft.style.opacity = 0;
	
	  vp.addEventListener('scroll', function () {
	    shadowBottom.style.width = bodyContainer.style.width;
	    shadowTop.style.width = bodyContainer.style.width;
	    var scrollRight = bodyContainer.clientWidth - vp.clientWidth - vp.scrollLeft;
	    var scrollBottom = bodyContainer.clientHeight - vp.clientHeight - vp.scrollTop;
	    shadowRight.style.opacity = scrollRight / 20 > 1 ? 1.0 : scrollRight / 20;
	    shadowLeft.style.opacity = vp.scrollLeft / 20 > 1 ? 1.0 : vp.scrollLeft / 20;
	    shadowTop.style.opacity = vp.scrollTop / 20 > 1 ? 1.0 : vp.scrollTop / 20;
	    shadowBottom.style.opacity = scrollBottom / 20 > 1 ? 1.0 : scrollBottom / 20;
	  });
	
	  shadowBottom.style.opacity = bodyContainer.clientHeight - height <= 0 ? 0 : 1;
	
	  shadowRight.style.opacity = bodyContainer.clientWidth - vp.clientWidth <= 0 ? 0 : 1;
	
	  shadowLeft.style.left = shadowLeftAdjust + 'px';
	  shadowTop.style.top = shadowTopAdjust + 'px';
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data, options, metaData) {
	  var isLocked = _mori2.default.getIn(data.config, ['globalRules', 'Locked'], false);
	
	  var shouldGetDistributions = options.selectedDistributions && (!isLocked || options.activeTab);
	
	  // Get the current data view object by index
	  var dataviewType = (data.globalSettings || {}).hasDataviews && !isLocked ? _mori2.default.nth(metaData.immutableDataviews, +(options.dataView || 0)) : false;
	
	  // Get currently selected distributions, or all
	  var distributions = shouldGetDistributions ? (0, _dataFilters.getCurrentDistributions)(metaData.immutableDistributions, options) : metaData.immutableDistributions;
	
	  // Create sets as keys for data
	  var selected = (0, _getSelectedDistributions2.default)(data, metaData, distributions, dataviewType);
	
	  var columnKeys = (0, _getColumnKeys2.default)(data, metaData);
	
	  // Join the base column and the selected sets
	  var selectedSetKeys = _mori2.default.concat(_mori2.default.vector(columnKeys[0]), selected);
	
	  // due to nesting we need to fix select all boxes...
	  if (options.selectedRows) {
	    options.selectedRows = assembleAllRows(metaData.columns, options.selectedRows);
	  }
	  // Return an array of arguments so we can apply it to other rendering
	  // functions by using ...spread
	  return [_getSelectedColumns2.default.apply(undefined, [data, metaData, options].concat(_toConsumableArray(columnKeys))), selectedSetKeys, distributions, dataviewType, columnKeys];
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _dataFilters = __webpack_require__(133);
	
	var _getSelectedDistributions = __webpack_require__(106);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _getSelectedColumns = __webpack_require__(134);
	
	var _getSelectedColumns2 = _interopRequireDefault(_getSelectedColumns);
	
	var _getColumnKeys = __webpack_require__(136);
	
	var _getColumnKeys2 = _interopRequireDefault(_getColumnKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Generates selection keys and filters which are used by rendering functions
	 *
	 * @param {object} data The data store
	 * @param {object} options Options from the url
	 *
	 * @return {array}
	 */
	
	
	// this rewrites nested select alls
	function assembleAllRows(columns, rows) {
	  var newTree = {};
	  Object.keys(rows).forEach(function (curr) {
	    if (rows[curr].hasOwnProperty('all')) {
	      var children = columns.nested && curr !== 'nested' ? columns.nested[curr].children : columns[curr].children;
	      if (typeof children === 'undefined' || !children[Object.keys(children)[0]].hasOwnProperty('children')) {
	        newTree[curr] = rows[curr];
	      } else {
	        newTree[curr] = Object.keys(children).reduce(function (acc, item) {
	          acc[item] = { all: {} };
	          return acc;
	        }, {});
	      }
	    } else {
	      newTree[curr] = rows[curr];
	    }
	  });
	  return newTree;
	}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCurrentDistributions = getCurrentDistributions;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCurrentDistributions(distributions, options) {
	  // Currently selected distributions by matching slugs, or all
	  return _mori2.default.count(distributions) === 0 && (options.activeTab !== 'graph' || _mori2.default.count(distributions) === 1) ? distributions : _mori2.default.filter(function (x) {
	    return options.selectedDistributions ? [].concat(options.selectedDistributions.split('--')).indexOf(_mori2.default.get(x, 'slug')) > -1 : false;
	  }, distributions);
	}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data, metaData, options, baseColumn, childColumn) {
	  var isGeoMulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	
	  var isMedicare = _mori2.default.getIn(data.config, ['globalRules', 'medicare'], false);
	
	  var rootSelection = Object.keys(options.selectedRows || {})[0] || false;
	  var validSelection = rootSelection !== 'nested' && (!rootSelection || metaData.columns[rootSelection] || metaData.columns.nested[rootSelection] || false);
	  var selectedRows = validSelection ? options.selectedRows || {} : null;
	  var parentColumns = void 0;
	  if (isGeoMulti) {
	    // Get Summary Values (for lookups...)
	    var summaries = _mori2.default.reduce(function (acc, sheet) {
	      return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(sheet), _mori2.default.reduce(function (acc1, row) {
	        return _mori2.default.conj(acc1, _mori2.default.hashMap(_mori2.default.get(row, baseColumn), _mori2.default.get(row, childColumn)));
	      }, _mori2.default.hashMap(), _mori2.default.remove(function (row) {
	        return _mori2.default.every(function (item) {
	          return (_mori2.default.first(_mori2.default.rest(item)) || '').toString().indexOf('(All)') < 0;
	        }, row);
	      }, _mori2.default.first(_mori2.default.rest(sheet))))));
	    }, _mori2.default.hashMap(), data.immutableData);
	
	    parentColumns = _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (group) {
	      return _mori2.default.mapcat(function (row) {
	        var selectAll = _mori2.default.first(_mori2.default.first(_mori2.default.last(row))) === 'all';
	        var nestedObject = (data.columns[_mori2.default.first(group)] ? metaData.columns[_mori2.default.first(group)][_mori2.default.first(row)] : metaData.columns.nested[_mori2.default.first(group)].children[_mori2.default.first(row)]) || {};
	
	        var base = _mori2.default.hashMap(baseColumn, nestedObject.label);
	        return _mori2.default.isEmpty(_mori2.default.last(row)) || selectAll ? _mori2.default.vector(_mori2.default.vector(base)) : _mori2.default.map(function (child) {
	          // summary rows gets a rewrite
	          if (_mori2.default.first(child) === 'summary') {
	            return _mori2.default.set([_mori2.default.hashMap(baseColumn, nestedObject.label + ' (All)'), _mori2.default.hashMap(childColumn, _mori2.default.getIn(summaries, [data.timeframes[options.currentTimeframe], nestedObject.label + ' (All)'], null))]);
	          }
	          return _mori2.default.set([base, _mori2.default.hashMap(childColumn, nestedObject.children[_mori2.default.first(child)].label)]);
	        }, _mori2.default.last(row));
	      },
	      // do territory sort here
	      _mori2.default.sort(function (a, b) {
	        return (0, _territorySortFilter.territorySort)(_mori2.default.first(a), _mori2.default.first(b));
	      }, _mori2.default.filter(function (rowObj) {
	        return _mori2.default.first(rowObj) !== 'all';
	      }, _mori2.default.last(group))));
	    }, _mori2.default.toClj(Object.keys(selectedRows || {}).reduce(function (selected, group) {
	      return angular.extend({}, selected, _defineProperty({}, group, Object.keys(selectedRows[group] || {}).reduce(function (acc, column) {
	        return angular.extend({}, acc, _defineProperty({}, column, Object.keys(selectedRows[group][column] || {}).reduce(function (acc1, child) {
	          return angular.extend({}, acc1, _defineProperty({}, child, {}));
	        }, {})));
	      }, {})));
	    }, {}))));
	  } else {
	    // Medicare has a special default state... US wrapup & States
	    if (isMedicare && Object.keys(selectedRows).length === 0) {
	      var hasStates = !!metaData.columns.nested.states;
	      var hasWrapups = !!metaData.columns.wrapups;
	      if (hasStates && hasWrapups) {
	        selectedRows = {
	          'states': { 'all': {} },
	          'wrapups': { 'united-states': {} }
	        };
	      }
	    }
	    // Make an array of selected/parent selection rows
	    parentColumns = _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (group) {
	      return _mori2.default.mapcat(function (row) {
	        return (0, _getSelectedColumnsRecursive2.default)(data, metaData, baseColumn, childColumn, row, group);
	      },
	      // do territory sort here
	      _mori2.default.sort(function (a, b) {
	        return (0, _territorySortFilter.territorySort)(_mori2.default.first(a), _mori2.default.first(b));
	      }, _mori2.default.filter(function (rowObj) {
	        return _mori2.default.first(rowObj) !== 'all';
	      }, _mori2.default.last(group))));
	    }, _mori2.default.toClj(Object.keys(selectedRows || {}).reduce(function (selected, group) {
	      return angular.extend({}, selected, _defineProperty({}, group, getSelectedColumns(selectedRows, group)));
	    }, {}))));
	  }
	
	  var wrapupColumns = _mori2.default.set(_mori2.default.mapcat(function (val) {
	    return _mori2.default.set([_mori2.default.first(val)]);
	  }, _mori2.default.filter(function (row) {
	    return _mori2.default.get(_mori2.default.first(_mori2.default.rest(row)), 'selected');
	  }, _mori2.default.toClj(metaData.columns.wrapups))));
	
	  /**
	   * Digs into selected columns to produce required data for getSelected
	   * to continue processing, it has a req of the data.columns that
	   * can't be passed in via attr since recursion is a pain...
	   * @param {object} Object to dig into
	   * @param {string} Initial key to dig
	   * @param {...string} parent keys
	   * @return {object} Object of all selectedColumns
	   */
	  function getSelectedColumns() {
	    var args = Array.prototype.slice.call(arguments);
	    var rows = args[0];
	    var key = args[1];
	    var keys = args.slice(1, args.length);
	
	    if (rows[key].all) {
	      // data.columns needs to be curried into from above
	      return Object.keys(_util.digColumnValue.apply(undefined, [data.columns].concat(_toConsumableArray(keys.reverse()))) || {}).reduce(function (acc, column) {
	        return angular.extend({}, acc, _defineProperty({}, column, {}));
	      }, {});
	    } else if (Object.keys(rows[key]).length) {
	      return Object.keys(rows[key]).reduce(function (selected, nested) {
	        return angular.extend({}, selected, _defineProperty({}, nested, getSelectedColumns.apply(undefined, [rows[key], nested].concat(_toConsumableArray(keys)))));
	      }, {});
	    }
	    // If all else doesn't matter, just return the rows/key
	    return rows[key]; // This SHOULD have a label...
	  }
	
	  return _mori2.default.into(parentColumns, wrapupColumns);
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _territorySortFilter = __webpack_require__(108);
	
	var _getSelectedColumnsRecursive = __webpack_require__(135);
	
	var _getSelectedColumnsRecursive2 = _interopRequireDefault(_getSelectedColumnsRecursive);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedColumnsRecursive;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * @param data
	 * @param metaData
	 * @param baseColumn
	 * @param childColumn
	 * @param ...key
	 */
	function getSelectedColumnsRecursive() {
	  var args = Array.prototype.slice.call(arguments);
	  var data = args[0];
	  var metaData = args[1];
	  var baseColumn = args[2];
	  var childColumn = args[3];
	  var keys = args.slice(4, args.length);
	
	  if (_mori2.default.count(_mori2.default.keys(_mori2.default.last(keys[0]))) > 0) {
	    return _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (row) {
	      return getSelectedColumnsRecursive.apply(undefined, [data, metaData, baseColumn, childColumn, row].concat(_toConsumableArray(keys)));
	    }, _mori2.default.last(keys[0])));
	  }
	  var nestedObject = _util.digColumnValue.apply(undefined, [metaData.columns].concat(_toConsumableArray(keys.map(function (item) {
	    return _mori2.default.first(item);
	  }).reverse()))) || {};
	
	  // KFF-2245.  If no label, the key does not exist in the data.
	  // Simply return to prevent parsing `undefined` later
	  if (!nestedObject.label) {
	    return null;
	  }
	
	  return getColumn(keys[0], nestedObject, baseColumn, childColumn);
	}
	
	function getColumn(row, nestedObject, baseColumn, childColumn) {
	  var base = _mori2.default.hashMap(baseColumn, nestedObject.label);
	  return _mori2.default.isEmpty(_mori2.default.last(row)) ? _mori2.default.vector(_mori2.default.vector(base)) : _mori2.default.map(function (child) {
	    // summary rows gets a rewrite
	    if (_mori2.default.first(child) === 'summary') {
	      return _mori2.default.set([_mori2.default.hashMap(baseColumn, nestedObject.label + ' (All)'), _mori2.default.hashMap(childColumn, null)]);
	    }
	    return _mori2.default.set([base, _mori2.default.hashMap(childColumn, nestedObject.children[_mori2.default.first(child)].label)]);
	  }, _mori2.default.last(row));
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data, metaData) {
	  // The base column is just a version of the first header column
	  var baseColumn = _mori2.default.set([_mori2.default.get(_mori2.default.first(metaData.immutableHeaders), 'characteristic'), _mori2.default.get(_mori2.default.first(metaData.immutableHeaders), 'label')]);
	
	  // For Geomulti indicators, the second column is the child, so we also need
	  // that selector
	  var childColumn = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti']) ? _mori2.default.set([_mori2.default.get(_mori2.default.nth(metaData.immutableHeaders, 1), 'characteristic'), _mori2.default.get(_mori2.default.nth(metaData.immutableHeaders, 1), 'label')]) : false;
	
	  return [baseColumn, childColumn];
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFootnotes;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _composeFootnotes = __webpack_require__(138);
	
	var _composeFootnotes2 = _interopRequireDefault(_composeFootnotes);
	
	var _getActiveFootnotes = __webpack_require__(139);
	
	var _getActiveFootnotes2 = _interopRequireDefault(_getActiveFootnotes);
	
	var _getDistributions = __webpack_require__(140);
	
	var _getDistributions2 = _interopRequireDefault(_getDistributions);
	
	var _getLocations = __webpack_require__(141);
	
	var _getLocations2 = _interopRequireDefault(_getLocations);
	
	var _getRelevantRows = __webpack_require__(142);
	
	var _getRelevantRows2 = _interopRequireDefault(_getRelevantRows);
	
	var _getTimeframes = __webpack_require__(143);
	
	var _getTimeframes2 = _interopRequireDefault(_getTimeframes);
	
	var _labelFootnotes = __webpack_require__(144);
	
	var _labelFootnotes2 = _interopRequireDefault(_labelFootnotes);
	
	var _sortRows = __webpack_require__(145);
	
	var _sortRows2 = _interopRequireDefault(_sortRows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get footnotes for the current "view"
	 *
	 * If the tab is table, the footnotes need to be:
	 *   #{year, #{parent-column, child-column}, location}
	 *
	 * If the tab is map or graph, the footnotes need to be:
	 *   #{#{parent-column, child-column}, location}
	 *
	 * Parent-column or child-column can be null
	 */
	function getFootnotes(sheetData, metaData, options, filteredData, combinedFilters) {
	  var footnotes = _mori2.default.getIn(sheetData.config, ['footnotes', 'footnotes'], false);
	
	  // Get the base context and use it if it exists.
	  // This is needed to accurately calculate weights for
	  // footnote labels
	  var baseContext = _mori2.default.getIn(sheetData.config, ['globalRules', 'Context'], [])[0] || 'Location';
	
	  var isGeoMulti = _mori2.default.getIn(sheetData.config, ['globalRules', 'Geomulti'], false);
	
	  // If there are no footnotes, just return an empty hashMap
	  if (!footnotes) {
	    return _mori2.default.hashMap();
	  }
	  // Get the timeframes, locations, and distributions
	  var timeframes = (0, _getTimeframes2.default)(filteredData);
	  var locations = (0, _getLocations2.default)(combinedFilters[0]);
	  var distributions = (0, _getDistributions2.default)(combinedFilters[1]);
	  // Using the actives above, get the footnotes
	  var activeFootnotes = (0, _getActiveFootnotes2.default)(footnotes, timeframes, locations, distributions);
	  // Is a trend graph when there is more than two timeframes (timeframe & any)
	  var isTrendGraph = _mori2.default.count(timeframes) > 2;
	  // Pull out active locations (locations with footnotes);
	  var activeLocations = _mori2.default.keys(activeFootnotes);
	
	  var mergedLocationsDistributions = _mori2.default.map(function (note) {
	    var geography = _mori2.default.first(note);
	    var distribution = _mori2.default.first(_mori2.default.first(_mori2.default.first(_mori2.default.rest(note))));
	    var distributionValue = _mori2.default.get(_mori2.default.first(_mori2.default.first(_mori2.default.vals(_mori2.default.first(_mori2.default.rest(note))))), 'value', null);
	
	    if (distributionValue) {
	      return _mori2.default.hashMap('geography', geography, 'distribution', distribution, 'distributionValue', distributionValue);
	    }
	
	    return _mori2.default.hashMap('geography', geography, 'distribution', distribution);
	  }, activeFootnotes);
	
	  // Pull out rows of data that have active locations
	  var relevantRows = (0, _getRelevantRows2.default)(filteredData, activeLocations, mergedLocationsDistributions);
	  // Sort the data, to match the table sort
	  var sortedRows = _mori2.default.reduce(function (acc, row) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(row), _mori2.default.last(row)));
	  }, _mori2.default.hashMap(), (0, _sortRows2.default)(options.sortModel || {}, relevantRows, metaData.immutableHeaders, combinedFilters[3].type, baseContext, isGeoMulti));
	  // Compose the footnotes over the sorted data
	  var composedFootnotes = _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, item);
	  }, _mori2.default.hashMap(), _mori2.default.filter(function (note) {
	    return !locations || _mori2.default.some(function (loc) {
	      return loc === _mori2.default.first(_mori2.default.rest(_mori2.default.first(_mori2.default.first(note))));
	    }, locations);
	  }, (0, _composeFootnotes2.default)(footnotes, timeframes, distributions)));
	
	  if (isTrendGraph) {
	    // If trendGraph view we need to do a secondary compose
	    composedFootnotes = _mori2.default.reduceKV(function (acc, key, val) {
	      return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.last(_mori2.default.rest(key)) !== 'Location' ? _mori2.default.set([_mori2.default.first(key), _mori2.default.first(_mori2.default.rest(key)), _mori2.default.hashMap(_mori2.default.first(key), _mori2.default.last(_mori2.default.rest(key)))]) : key, val));
	    }, _mori2.default.hashMap(), composedFootnotes);
	  }
	  // Go though and label the footnotes
	  var labeledFootnotes = (0, _labelFootnotes2.default)(composedFootnotes, sortedRows, metaData.immutableHeaders, timeframes, baseContext, isGeoMulti);
	
	  // Filter (dedup), the footnotes for other useage.
	  var filteredFootnotes = _mori2.default.reduceKV(function (acc, key, val) {
	    return _mori2.default.into(acc, val);
	  }, _mori2.default.set(), labeledFootnotes);
	
	  // Uncomment and add `import { log } from '../../util/util';` at top to debug
	  // log('IND: timeframes', timeframes);
	  // log('IND: locations', locations);
	  // log('IND: distributions', distributions);
	  // log('IND: activeFootnotes', activeFootnotes);
	  // log('IND: activeLocations', activeLocations);
	  // log('IND: relevantRows', relevantRows);
	  // log('IND: sortedRows', sortedRows);
	  // log('IND: composedFootnotes', composedFootnotes);
	  // log('IND: labeledFootnotes', labeledFootnotes);
	
	  return {
	    labeledFootnotes: labeledFootnotes,
	    filteredFootnotes: filteredFootnotes
	  };
	}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = composeFootnotes;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Compose the footnotes into an array of hashmaps with the following keys:
	 * Should be a composed key:
	 * * [year, location, headergroup]
	 * * [year, location, header]
	 * * [year, location, #{headergroup, header}]
	 *
	 * @param  {mori.vector} footnotes  [footnotes from config]
	 * @param  {mori.vector} timeframes [active timeframes to use]
	 * @param  {mori.vector} distributions [active distributions to use]
	 * @return {mori.vector}            [vector of composed footnote keys]
	 */
	function composeFootnotes(footnotes, timeframes, distributions) {
	  var getLocationSplit = function getLocationSplit(location) {
	    return location.match(/^([^[]+)\[(.*)\]$/);
	  };
	
	  return _mori2.default.reduceKV(function (acc, year, yearData) {
	    return (0, _util.indexOf)(timeframes, year) ? _mori2.default.into(acc, _mori2.default.reduceKV(function (acc1, state, stateData) {
	      return _mori2.default.into(acc1, _mori2.default.reduceKV(function (acc2, dist, distData) {
	        if ((0, _util.indexOf)(distributions, dist)) {
	          // For footnotes with:  California[Exact_value]
	          // Split the state and send back the value as well
	          // to match on the exact table cell for the footnote;
	          var locationSplit = getLocationSplit(state);
	          return _mori2.default.conj(acc2, _mori2.default.hashMap(locationSplit ? _mori2.default.set([year, locationSplit[1], dist, locationSplit[2]]) : _mori2.default.set([year, state, dist]), distData));
	        }
	
	        return acc2;
	      }, _mori2.default.vector(), stateData));
	    }, _mori2.default.vector(), yearData)) : acc;
	  }, _mori2.default.vector(), footnotes);
	}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getActiveFootnotes;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the active footnotes
	 * @param  {mori.vector} footnotes     [footnotes from sheetData]
	 * @param  {mori.vector} timeframes    [active timeframes]
	 * @param  {mori.vector} locations     [active locations]
	 * @param  {mori.vector} distributions [active distributions]
	 * @return {mori.vector}               [active footnotes]
	 */
	function getActiveFootnotes(footnotes, timeframes, locations, distributions) {
	  return _mori2.default.reduceKV(function (acc, key, val) {
	    return _mori2.default.merge(acc, val);
	  }, _mori2.default.hashMap(), _mori2.default.reduce(function (acc0, item0) {
	    return _mori2.default.assoc(acc0, _mori2.default.first(item0), _mori2.default.reduce(function (acc1, item1) {
	      return _mori2.default.assoc(acc1, _mori2.default.first(item1), _mori2.default.last(item1));
	    }, _mori2.default.hashMap(), _mori2.default.last(item0)));
	  }, _mori2.default.hashMap(), _mori2.default.filter(function (item) {
	    return (0, _util.indexOf)(timeframes, _mori2.default.first(item));
	  }, _mori2.default.reduce(function (acc0, curr0) {
	    return _mori2.default.conj(acc0, _mori2.default.vector(_mori2.default.first(curr0), _mori2.default.filter(function (item) {
	      return locations ? (0, _util.indexOf)(locations, _mori2.default.first(item).replace(/(.*?)\[.*\]/, function (match, p1) {
	        return p1;
	      })) : true;
	    }, _mori2.default.zipmap(_mori2.default.map(function (key) {
	      return key.replace(/(.*?)\[.*\]/, function (match, p1) {
	        return p1;
	      });
	    }, _mori2.default.keys(_mori2.default.last(curr0))), _mori2.default.map(function (item) {
	      return _mori2.default.reduceKV(function (acc1, key, curr1) {
	        return !!(0, _util.indexOf)(distributions, key) ? _mori2.default.assoc(acc1, key, curr1) : acc1;
	      }, _mori2.default.hashMap(), item);
	    }, _mori2.default.vals(_mori2.default.last(curr0)))))));
	  }, _mori2.default.vector(), footnotes))));
	}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDistributions;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get active columns (distributions) then reduce them down into:
	 *  > header group
	 *  > column
	 *  > headergroup | column
	 * @param  {[type]} distributions [description]
	 * @return {[type]}               [description]
	 */
	function getDistributions(distributions) {
	  return _mori2.default.flatten(_mori2.default.map(function (item) {
	    return _mori2.default.isVector(item) ? _mori2.default.set([_mori2.default.first(item), _mori2.default.last(item)]) : item;
	  }, _mori2.default.distinct(_mori2.default.reduce(function (acc, curr) {
	    return _mori2.default.get(curr, 0) !== null ? _mori2.default.conj(_mori2.default.conj(_mori2.default.conj(acc, _mori2.default.get(curr, 0), _mori2.default.get(curr, 1)), _mori2.default.conj(curr))) : _mori2.default.conj(acc, _mori2.default.get(curr, 1));
	  }, _mori2.default.vector(), _mori2.default.reduce(function (acc1, curr1) {
	    return _mori2.default.count(curr1) > 2 ? _mori2.default.conj(acc1, _mori2.default.vector(_mori2.default.first(curr1), _mori2.default.first(_mori2.default.rest(curr1)))) : _mori2.default.conj(acc1, _mori2.default.vector(null, _mori2.default.first(curr1)));
	  }, _mori2.default.vector(), distributions)))));
	}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getLocations;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get active locations or false for all
	 * @param  {mori.vector} locations [locations from combinedFilters[0]]
	 * @return {mori.vector || false}  [active locations]
	 */
	function getLocations(locations) {
	  return _mori2.default.count(locations) > 0 ? _mori2.default.map(function (item) {
	    return _mori2.default.first(_mori2.default.vals(_mori2.default.count(item) > 1 ? _mori2.default.first(item) : item));
	  }, _mori2.default.flatten(locations)) : false;
	}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getRelevantRows;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Filter the filtered data (again), to only
	 * retain rows (locations) we are interested in
	 * @param  {mori.vector} filteredData        [filtered data]
	 * @param  {mori.vector} activeLocations     [active locations in footnotes]
	 * @return {mori.vector}                     [relevent data]
	 */
	function getRelevantRows(filteredData, activeLocations, mergedLocationsDistributions) {
	  return _mori2.default.map(function (sheet) {
	    return _mori2.default.vector(_mori2.default.first(sheet), _mori2.default.filter(function (item) {
	      return _mori2.default.some(function (locationDistribution) {
	        var geo = _mori2.default.get(locationDistribution, 'geography', false);
	        var distribution = _mori2.default.get(locationDistribution, 'distribution', false);
	        var distributionValue = _mori2.default.get(locationDistribution, 'distributionValue', false);
	
	        var itemKey = _mori2.default.first(_mori2.default.filter(function (key) {
	          return distribution === _mori2.default.first(key);
	        }, _mori2.default.keys(item)));
	
	        // Get the geography from the table data
	        // Note: this should take the context into account.
	        // It should not rely on State or Location only
	        var itemGeo = _mori2.default.get(item, _mori2.default.set(['Location', 'Geography']), false) || _mori2.default.get(item, _mori2.default.set(['State', 'Geography'])) || _mori2.default.get(item, _mori2.default.set(itemKey), false);
	
	        var itemKeyVal = _mori2.default.get(item, itemKey);
	
	        // `itemGeo` may be a summary row
	        var summaryItem = (geo || '').toLocaleLowerCase() === (itemGeo || '').toLocaleLowerCase().replace('(all)', '').trim();
	
	        return (geo === itemGeo || summaryItem) && (distributionValue ? distributionValue === itemKeyVal : true);
	      }, mergedLocationsDistributions);
	    }, _mori2.default.flatten(_mori2.default.rest(sheet))));
	  }, filteredData);
	}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimeframes;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the active timeframes from the filteredData
	 * and then append on 'any'
	 * @param  {mori.vector} data [filteredData]
	 * @return {mori.vector}      [any active timeframes + `any`]
	 */
	function getTimeframes(data) {
	  return _mori2.default.conj(_mori2.default.reduce(function (acc, curr) {
	    return _mori2.default.conj(acc, _mori2.default.first(curr));
	  }, _mori2.default.vector(), data), 'any');
	}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = labelFootnotes;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Label the footnotes with numbers weighted by reused, row, and cell
	 * @param  {mori.hashmap} footnotes [composed footnotes to access]
	 * @param  {mori.hashmap} rows      [relevant rows to use]
	 * @param  {mori.vector} headers    [headers]
	 * @param  {mori.vector} timeframes [active timeframes]
	 * @param  {mori.vector} baseContext [current geography context (Location, States, etc)]
	 * @param  {bool} isGeoMulti whether the indicator data is geo-multi
	 * @return {mori.hashmap}           [labeled footnotes]
	 */
	function labelFootnotes(footnotes, rows, headers, timeframes, baseContext, isGeoMulti) {
	  // This is an object map of note hashes to labels
	  var usedFootnotes = {};
	
	  var isTrendGraph = _mori2.default.count(timeframes) > 2;
	
	  var getFootnoteSymbol = function getFootnoteSymbol(index) {
	    var footnoteSymbols = _config.appDefault.footnoteSymbols;
	
	    var instances = Math.ceil((index + 1) / footnoteSymbols.length);
	    var newIndex = index - (instances - 1) * footnoteSymbols.length;
	    return {
	      label: footnoteSymbols[newIndex].repeat(instances),
	      weight: index + instances
	    };
	  };
	
	  // Push a footnote into usedFootnotes
	  var pushFootnote = function pushFootnote(hash) {
	    var notesCount = Object.keys(usedFootnotes).length;
	    usedFootnotes[hash] = isGeoMulti ? _extends({}, getFootnoteSymbol(notesCount)) : { label: notesCount + 1, weight: notesCount };
	    return usedFootnotes[hash];
	  };
	
	  // Returns the label and symbol weight, if applicable
	  // { label: 'int|str', weight: int }
	  var getLabel = function getLabel(noteHash) {
	    return _extends({}, usedFootnotes[noteHash] ? usedFootnotes[noteHash] : pushFootnote(noteHash));
	  };
	
	  // Returns the label
	  // const getLabel = (noteHash) => usedFootnotes[noteHash] ?
	  //   usedFootnotes[noteHash] :
	  //   pushFootnote(noteHash);
	
	  var labeledFootnotes = _mori2.default.map(function (footnote) {
	    var notes = _mori2.default.toJs(_mori2.default.last(footnote));
	    var labeledNotes = notes.map(function (note) {
	      return _extends({}, note, getLabel(_mori2.default.hash(note.note)));
	    });
	
	    return _mori2.default.hashMap(
	    // Lets update the notes with labels now
	    _mori2.default.first(footnote), _mori2.default.toClj(labeledNotes));
	  },
	  // Sort It!
	  _mori2.default.sortBy(
	  // Lets grab the weights
	  function (item) {
	    var keys = _mori2.default.first(item);
	    var row = _mori2.default.count(_mori2.default.takeWhile(function (rowItem) {
	      return !_mori2.default.isSubset(_mori2.default.set([_mori2.default.get(rowItem, _mori2.default.set([baseContext, 'Geography']), false) || _mori2.default.get(rowItem, _mori2.default.first(_mori2.default.keys(rowItem)))].map(function (x) {
	        return x.replace('(All)', '').trim();
	      })), keys);
	    }, _mori2.default.get(rows, _mori2.default.first(keys))));
	    var column = _mori2.default.get(_mori2.default.first(_mori2.default.filter(
	    // If the 3rd key is a map we need to be very specific,
	    // otherwise we don't care
	    function (columnItem) {
	      return _mori2.default.isMap(_mori2.default.last(keys) && !isTrendGraph) ? _mori2.default.equals(_mori2.default.last(keys), _mori2.default.hashMap(_mori2.default.get(columnItem, 'headerGroup'), _mori2.default.get(columnItem, 'characteristic'))) : _mori2.default.last(keys) === _mori2.default.get(columnItem, 'headerGroup', false) || _mori2.default.last(keys) === _mori2.default.get(columnItem, 'characteristic', false) || _mori2.default.last(_mori2.default.last(_mori2.default.last(keys))) === _mori2.default.get(columnItem, 'characteristic', false);
	    }, headers)), 'idx');
	    var year = false;
	    if (isTrendGraph) {
	      // If the timeframe is not "any", and if the last key
	      // item is not a set, it's a column title.
	      // We do not want to take the year weight into account.
	      // Else, compute the year weight with timeframes.  We are adding 1
	      // to break JavaScript's 0 = falsey.
	      year = _mori2.default.first(_mori2.default.first(_mori2.default.last(keys))) !== 'any' && _mori2.default.isMap(_mori2.default.last(keys)) ? 1 + _mori2.default.count(_mori2.default.takeWhile(function (yearItem) {
	        return yearItem !== _mori2.default.first(keys);
	      }, _mori2.default.rest(_mori2.default.reverse(timeframes)) // cut off 'any'
	      )) : false;
	    }
	    return { keys: keys, row: row, column: column, year: year };
	  },
	  // Lets actually do the sorting
	  function (_ref, _ref2) {
	    var aRow = _ref.row,
	        aColumn = _ref.column,
	        _ref$year = _ref.year,
	        aYear = _ref$year === undefined ? false : _ref$year;
	    var bRow = _ref2.row,
	        bColumn = _ref2.column,
	        _ref2$year = _ref2.year,
	        bYear = _ref2$year === undefined ? false : _ref2$year;
	
	    // If the row weights are equal and there are year weights that are
	    // not equal, sort by year weights
	    if (aRow === bRow && aYear && bYear && aYear !== bYear) {
	      return aYear - bYear;
	    }
	
	    // Else, check if we should weigh by column or row.
	    return aRow === bRow ? aColumn - bColumn : aRow - bRow;
	  },
	  // Convert it to a collection
	  _mori2.default.reduceKV(function (acc, key, val) {
	    return _mori2.default.conj(acc, _mori2.default.vector(key, val));
	  }, _mori2.default.set(), prepForReduction(footnotes, timeframes))));
	  // Convert it back to a hashmap
	  return _mori2.default.reduce(function (acc, note) {
	    return _mori2.default.conj(acc, note);
	  }, _mori2.default.hashMap(), labeledFootnotes);
	}
	
	/**
	 * prep footnotes for reduction by replacing 'any' with years
	 * @param  {mori.hashMap} footnotes  [current footnotes]
	 * @param  {mori.vector} timeframes  [timeframes]
	 * @return {mori.hashMap}            [hashMap removed of 'any']
	 */
	function prepForReduction(footnotes, timeframes) {
	  return _mori2.default.reduceKV(function (acc, key, val) {
	    // If timeframes count = 2 it's just a single one, ex: [2017, 'any']
	    if (_mori2.default.first(key) !== 'any' || _mori2.default.first(key) === 'any' && _mori2.default.count(timeframes) === 2) {
	      // If 'any' use the timeframes...
	      var actualKey = _mori2.default.first(key) !== 'any' ? key : _mori2.default.set([_mori2.default.first(timeframes), _mori2.default.first(_mori2.default.rest(key)), _mori2.default.last(_mori2.default.rest(key)), _mori2.default.first(_mori2.default.rest(_mori2.default.rest(key)))]);
	      // KFF-2902 - if we have a distribution value via: California[VALUE]
	      if (_mori2.default.count(key) === 4) {
	        actualKey = _mori2.default.conj(actualKey, _mori2.default.last(key));
	      }
	      // If only one timeframe count is 2. ex: [2016, 'any']
	      if (!_mori2.default.get(acc, actualKey, false)) {
	        return _mori2.default.merge(acc, _mori2.default.hashMap(actualKey, val));
	      }
	      // If 'any' we use the 'actual' set key instead
	      return _mori2.default.merge(acc, _mori2.default.hashMap(actualKey, _mori2.default.into(_mori2.default.get(acc, actualKey), val)));
	    }
	
	    // Key is any and timeframes are > 1
	    return _mori2.default.merge(acc, _mori2.default.reduce(function (acc1, time) {
	      var actualKey = _mori2.default.set([time, _mori2.default.first(_mori2.default.rest(key)), _mori2.default.last(_mori2.default.rest(key))]);
	
	      // If it exists in acc, we need to combine it
	      if (_mori2.default.get(acc, actualKey, false)) {
	        return _mori2.default.merge(acc1, _mori2.default.hashMap(actualKey, _mori2.default.into(_mori2.default.get(acc, actualKey, false), val)));
	      }
	      // Else we can just toss it in
	      return _mori2.default.merge(acc1, _mori2.default.hashMap(actualKey, val));
	    }, _mori2.default.hashMap(), _mori2.default.filter(function (time) {
	      return time !== 'any';
	    }, timeframes)));
	  }, _mori2.default.hashMap(), footnotes);
	}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = sortRows;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(71);
	
	var _sortComparator = __webpack_require__(117);
	
	var _sortComparator2 = _interopRequireDefault(_sortComparator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sort the rows
	 * @param  {String} options.colId: sortedKey      [the sort key of the column]
	 * @param  {String} options.sort                  [the sort direction]
	 * @param  {mori.vector} rows                     [the rows]
	 * @param  {mori.vector} headers                  [the immutable headers]
	 * @param  {string} dataType                      [combinedFilters[3].type (active datatype)]
	 * @param  {string} baseColumn                    [text for first column]
	 * @param  {string} isGeoMulti                    [whether this is a multi-geo indicator]
	 * @return {mori.vector}                          [the sorted rows]
	 */
	function sortRows(_ref, rows, headers, dataType, baseColumn, isGeoMulti) {
	  var _ref$colId = _ref.colId,
	      sortedKey = _ref$colId === undefined ? 'Location' : _ref$colId,
	      _ref$sort = _ref.sort,
	      sort = _ref$sort === undefined ? 'asc' : _ref$sort;
	
	  var _sortedKey$split$reve = sortedKey.split('__').reverse(),
	      _sortedKey$split$reve2 = _slicedToArray(_sortedKey$split$reve, 2),
	      characteristic = _sortedKey$split$reve2[0],
	      _sortedKey$split$reve3 = _sortedKey$split$reve2[1],
	      headerGroup = _sortedKey$split$reve3 === undefined ? false : _sortedKey$split$reve3;
	
	  // Get the sort column (there should only be one...) and convert it to JS
	
	
	  var sortColumn = _mori2.default.toJs(_mori2.default.first(_mori2.default.filter(function (col) {
	    return (!dataType || _mori2.default.get(col, 'type') === 'geography' || _mori2.default.get(col, 'type') === dataType) && (_mori2.default.get(col, 'headerGroup') === headerGroup && _mori2.default.get(col, 'characteristic') === characteristic || _mori2.default.get(col, 'characteristic') === characteristic);
	  }, headers))) || {}; // handle null case for sortcolumn
	
	  var isInverted = _config.appDefault.descSortFirst.indexOf(sortColumn.type) >= 0 ? sort === 'asc' : sort === 'desc';
	
	  var comparator = (0, _sortComparator2.default)(sortColumn, baseColumn, isGeoMulti ? baseColumn : null);
	
	  // sortComparator is a factory function
	  // let comparator = sortComparator(
	  //   sortColumn,
	  //   'Location',
	  //   null
	  // );
	  // Check for geomulti tables (use 'State' instead of 'Location')
	  // if (
	  // and this is why nested immutables are occasionally annoying... sorry
	  //   mori.first(mori.first(mori.first(mori.first(mori.last(mori.first(rows))))))
	  //     === 'State'
	  // ) {
	  //   comparator = sortComparator(
	  //     sortColumn,
	  //     'State',
	  //     'State'
	  //   );
	  // }
	
	  return _mori2.default.map(function (sheet) {
	    return _mori2.default.vector(_mori2.default.first(sheet), _mori2.default.sortBy(function (row) {
	      return _mori2.default.vector(_mori2.default.get(row, _mori2.default.set(sortColumn.headerGroup ? [sortColumn.headerGroup, sortColumn.characteristic, sortColumn.label] : [sortColumn.characteristic, sortColumn.label])), _mori2.default.get(row, _mori2.default.set(['Location', 'Geography']), false) || _mori2.default.get(row, _mori2.default.set(['State', 'Geography'])));
	    }, function (a, b) {
	      // We need to check for wrapups... because
	      // comparator is not doing it...
	      // and we always need to push wrapups to the top
	      if (sortColumn.type === 'geography') {
	        if (_config.appDefault.specialWrapups.indexOf(_mori2.default.first(a)) > -1 && _config.appDefault.specialWrapups.indexOf(_mori2.default.first(b)) === -1) {
	          return -1;
	        } else if (_config.appDefault.specialWrapups.indexOf(_mori2.default.first(a)) === -1 && _config.appDefault.specialWrapups.indexOf(_mori2.default.first(b)) > -1) {
	          return 1;
	        }
	      }
	      // Now once that's over we can sort normally...
	      // If you notice `Location` & `State` have the same value,
	      // that's fine, the reason we don't just use one
	      // (and adjust the comparator) is we are trying to keep it
	      // as close to the table sort as possible, and if we
	      // just used multiple comparator() funcs to swap between geomutli
	      // and not, it would be lots of duplicate code
	      return comparator({ text: _mori2.default.first(a) }, { text: _mori2.default.first(b) }, { data: {
	          Location: _mori2.default.first(_mori2.default.rest(a)),
	          State: _mori2.default.first(_mori2.default.rest(a)),
	          isSummary: _config.appDefault.isSummaryRow.test(a) || null
	        } }, { data: {
	          Location: _mori2.default.first(_mori2.default.rest(b)),
	          State: _mori2.default.first(_mori2.default.rest(b)),
	          isSummary: _config.appDefault.isSummaryRow.test(b) || null
	        } },
	      // Weird inverted/anti invert logic... I'm sorry
	      _config.appDefault.descSortFirst.indexOf(sortColumn.type) >= 0 ? !isInverted : isInverted) * (
	      // What follows is even more weird invert logic...
	      // this was a big headache, again I'm sorry
	      isInverted && (
	      // Because Geos don't actually sort...
	      sortColumn.type === 'geography' || sortColumn.type === 'text') || !isInverted && _config.appDefault.descSortFirst.indexOf(sortColumn.type) >= 0 ? -1 : 1);
	    }, _mori2.default.flatten(_mori2.default.rest(sheet))));
	  }, rows);
	}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = footnoteCallback;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// footnoteCallback runs once per table cell, and ag-grid makes several
	// passes over the grid per render. Both the set of footnoted locations
	// and the per-key result depend only on the footnotes collection, which
	// is immutable and stable for the life of a render, so both are cached
	// and invalidated together when that collection changes.
	var noFootnotesCached = {};
	var cachedFootnotes = noFootnotesCached;
	var cachedLocations = [];
	var cachedResults = Object.create(null);
	var cachedBuckets = Object.create(null);
	var cachedUnbucketed = _mori2.default.vector();
	
	/**
	 * Filter footnotes per cell and flatten them
	 * @param  {Array} key                [key array for footnotes]
	 * @param  {mori.hashMap} footnotes   [footnotes]
	 * @return {Array}                    [footnotes for key]
	 */
	function footnoteCallback(key, footnotes) {
	  var isTrend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!isLocationInFootnotes(key, footnotes)) {
	    // Location isn't in footnotes
	    return [];
	  }
	
	  // key[1] can itself be an array, so stringify rather than join.
	  var cacheKey = isTrend + '\0' + JSON.stringify(key);
	  var cached = cachedResults[cacheKey];
	  if (cached !== undefined) {
	    // cellRenderer sorts the result in place, so never hand out the
	    // cached instance itself.
	    return Array.isArray(cached) ? cached.slice() : cached;
	  }
	
	  // Only notes that mention this location can match. Every branch of the
	  // predicate below requires key[0] somewhere in the note's key, so the
	  // bucket is a safe narrowing of the full set.
	  var bucket = cachedBuckets[key[0]];
	  var candidates = bucket ? _mori2.default.concat(bucket, cachedUnbucketed) : cachedUnbucketed;
	
	  var result = _mori2.default.toJs(_mori2.default.distinct(_mori2.default.flatten(_mori2.default.map(function (row) {
	    return _mori2.default.flatten(_mori2.default.rest(row));
	  }, _mori2.default.filter(function (note) {
	    // If key[2], then we are coming from cellRenderer and we are on a geoMulti indicator
	    // We will match on the entire key - State, Dist., Value
	    // We will then attemp to match on just State and Dist.
	    if (key[2] && _mori2.default.count(_mori2.default.first(note)) === 4) {
	      return _mori2.default.isSubset(_mori2.default.set(key), _mori2.default.first(note));
	      // No key[2] means we proceed as normal
	    } else if (!Array.isArray(key[1])) {
	      return _mori2.default.isSubset(_mori2.default.set(key[2] ? key.slice(0, 2) : key), _mori2.default.first(note));
	    }
	    return (
	      // We need to include only headerGroup, only columnTile, and combined
	      _mori2.default.isSubset(_mori2.default.set([key[0], _mori2.default.hashMap(key[1][0], key[1][1])]), _mori2.default.first(note)) || _mori2.default.isSubset(_mori2.default.set([key[0], key[1][0]]), !isTrend ? _mori2.default.first(note) : _mori2.default.rest(_mori2.default.first(note))) || _mori2.default.isSubset(_mori2.default.set([key[0], key[1][1]]), !isTrend ? _mori2.default.first(note) : _mori2.default.rest(_mori2.default.first(note))) || _mori2.default.first(_mori2.default.first(_mori2.default.last(_mori2.default.first(note)))) === 'any' && _mori2.default.equals(_mori2.default.set([key[0], key[1][1]]), _mori2.default.set([_mori2.default.first(_mori2.default.rest(_mori2.default.first(note))), _mori2.default.last(_mori2.default.last(_mori2.default.last(_mori2.default.first(note))))]) // set
	      ) // equals
	
	    );
	  }, candidates)))));
	
	  cachedResults[cacheKey] = result;
	  return Array.isArray(result) ? result.slice() : result;
	}
	
	/**
	 * Check if location is in footnotes
	 * @param  {Array} key                [key array for footnotes]
	 * @param  {mori.hashMap} footnotes   [footnotes]
	 * @return {Boolean}                  [if location is in footnotes]
	 */
	function isLocationInFootnotes(key, footnotes) {
	  if (footnotes !== cachedFootnotes) {
	    cachedFootnotes = footnotes;
	    cachedResults = Object.create(null);
	    buildBuckets(footnotes);
	    cachedLocations = _mori2.default.intoArray(_mori2.default.distinct(_mori2.default.reduceKV(
	    // accumulator, key, value (value isn't needed here)
	    function (acc, rKey) {
	      return _mori2.default.conj(acc, _mori2.default.first(_mori2.default.rest(rKey)));
	    }, _mori2.default.vector(), footnotes)));
	  }
	
	  // indexOf matches the strict equality the previous mori.filter used.
	  return cachedLocations.indexOf(key[0]) > -1;
	}
	
	/**
	 * Collect every scalar reachable inside a converted note key, so a note
	 * can be found by any value it mentions, however deeply nested.
	 *
	 * @param  {*}     node Plain JS value produced by mori.toJs.
	 * @param  {Array} out  Accumulator.
	 * @return {Array}      out
	 */
	function collectValues(node, out) {
	  if (node === null || node === undefined) {
	    return out;
	  }
	  if (typeof node === 'string' || typeof node === 'number') {
	    var value = String(node);
	    if (out.indexOf(value) === -1) {
	      out.push(value);
	    }
	    return out;
	  }
	  if (Array.isArray(node)) {
	    node.forEach(function (item) {
	      return collectValues(item, out);
	    });
	    return out;
	  }
	  if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object') {
	    Object.keys(node).forEach(function (prop) {
	      collectValues(prop, out);
	      collectValues(node[prop], out);
	    });
	  }
	  return out;
	}
	
	/**
	 * Index the footnotes by every value their key mentions. Scanning all of
	 * them per cell was the dominant cost of ag-grid's row height pass.
	 *
	 * @param {mori.hashMap} footnotes The labelled footnotes for this render.
	 */
	function buildBuckets(footnotes) {
	  var buckets = Object.create(null);
	  var unbucketed = [];
	
	  _mori2.default.each(footnotes, function (note) {
	    var values = [];
	    try {
	      values = collectValues(_mori2.default.toJs(_mori2.default.first(note)), []);
	    } catch (error) {
	      values = [];
	    }
	    if (!values.length) {
	      // Could not classify it, so it has to be scanned every time.
	      unbucketed.push(note);
	      return;
	    }
	    values.forEach(function (value) {
	      if (!buckets[value]) {
	        buckets[value] = [];
	      }
	      buckets[value].push(note);
	    });
	  });
	
	  Object.keys(buckets).forEach(function (value) {
	    buckets[value] = _mori2.default.into(_mori2.default.vector(), buckets[value]);
	  });
	
	  cachedBuckets = buckets;
	  cachedUnbucketed = _mori2.default.into(_mori2.default.vector(), unbucketed);
	}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.processCellCallback = processCellCallback;
	exports.cleanCSV = cleanCSV;
	exports.downloader = downloader;
	exports.escapeCSVQuotes = escapeCSVQuotes;
	exports.escapeNewLines = escapeNewLines;
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(76);
	
	var _fileSaver = __webpack_require__(148);
	
	var _config = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processCellCallback(columnDefs) {
	  var defs = _mori2.default.toJs(columnDefs).reduce(function (prev, curr) {
	    prev[curr.headerGroup ? curr.headerGroup + '__' + curr.characteristic : curr.characteristic] = curr;
	    return prev;
	  }, {});
	
	  return function (params) {
	    var colId = params.column.colId.replace(/^[0-9]{4}-/g, '');
	    var colDef = _extends({}, {
	      // Defaults to prevent undefined issues
	      type: '',
	      Precision: '',
	      Suffix: ''
	    }, defs[colId]);
	
	    var _params$value = params.value;
	    _params$value = _params$value === undefined ? {} : _params$value;
	    var textValue = _params$value.text;
	
	    // Strip out any HTML used for styling purposes from the google sheet
	
	    var value = textValue && textValue.replace ? textValue.replace(/<[^>]+?>/g, '') : textValue;
	    var precision = (0, _util.getPrecision)(colDef);
	
	    if (_config.appDefault.dataNotAvailable.indexOf(value) > -1 || params.column.colId === 'Location') {
	      return escapeNewLines(attachFootnotes(escapeCSVQuotes(value), params));
	    }
	
	    if (colDef.type === 'percent') {
	      // 2 Additional places are added to account for the decimal
	      // place difference between raw and formatted percent values.
	      var percentPrecision = precision === 0 && value < 0.1 ? 2 : precision + 2;
	      if (!(0, _util.kffIsNumber)(value)) {
	        return escapeNewLines(attachFootnotes(escapeCSVQuotes(value), params));
	      }
	      value = (0, _util.numberPrecision)(value, percentPrecision, false).toFixed(percentPrecision);
	    } else if (colDef.Precision) {
	      value = (0, _util.numberPrecision)(value, (0, _util.getPrecision)(colDef), false);
	    }
	
	    if (colDef.type === 'currency' && !isNaN(value)) {
	      return escapeNewLines(attachFootnotes('$' + escapeCSVQuotes((0, _util.numberPrecision)(value, precision, false).toFixed(precision)), params));
	    }
	
	    if (colDef.Suffix) {
	      value = value + colDef.Suffix;
	    }
	
	    return escapeNewLines(attachFootnotes(escapeCSVQuotes(value), params));
	  };
	}
	
	// export function processHeaderCallback() {
	//   return ({ column }) => colId)}
	//   //   return params.column.colId
	//   //     .replace('__', '\n')
	//   //     .replace(/^([0-9]{4})-(.*)/, '$1\n$2');
	//   // };
	// }
	
	/**
	 * Attach footnotes to each applicable cell... yay!
	 * @param  {string} value  cell value
	 * @param  {object} params ag grid params object
	 * @return {string}        string with footnotes attached (if applicable)
	 */
	function attachFootnotes(value, params) {
	  if (params.api.footnoteCallback) {
	    var _params$value2 = params.value,
	        data = _params$value2.data,
	        group = _params$value2.group,
	        child = _params$value2.child,
	        text = _params$value2.text;
	
	    var context = data.Location && 'Location' || params.api.baseColumnContext || 'State';
	    var key = [data[context], child !== false ? [group, child] : group];
	
	    if (data[context] && params.api.isMultiGeo) {
	      key.push('' + text);
	    }
	
	    var footnotes = params.api.footnoteCallback(key).map(function (_ref) {
	      var label = _ref.label;
	      return label;
	    });
	
	    if (footnotes.length > 0) {
	      return value + '#!#' + footnotes.join(',') + '#!#';
	    }
	    return value;
	  }
	}
	
	/**
	 * Clean up and modify the CSV as needed
	 * @param  {string} csv csv string
	 * @return {[type]}     [description]
	 */
	function cleanCSV(csv) {
	  // Split csv on new line
	  // Iterate through each line
	  // check line for existance of `#!#`
	  // if has existance, split on `#!#`
	  // take split into two array
	  // dedupe second, prepend to end of first with a `,`
	  // join('')
	  return csv.split('\n').map(function (line, idx) {
	    // headers are the 3rd row
	    if (idx === 2) {
	      return line.replace(/^([0-9]{4})-(.*)/g, '$1\n$2').slice(0, -1) // remove `\n` at end of line
	      + ',Footnotes';
	    }
	    if (line.match(/#!#/g) !== null) {
	      var _splitArray = splitArray(line.split('#!#')),
	          _splitArray2 = _slicedToArray(_splitArray, 2),
	          data = _splitArray2[0],
	          notes = _splitArray2[1];
	
	      var dataJoined = data.join('');
	      var lastCharIsEnter = dataJoined.charCodeAt(dataJoined.length - 1) === 13;
	      var footnotes = notes.reduce(function (prev, note) {
	        return prev.concat(note.split(','));
	      }, []).filter(function (note, key, self) {
	        return self.indexOf(note) === key;
	      }) // dedup
	      .sort(function (a, b) {
	        return a - b;
	      }) // sort
	      .join(', ');
	      return dataJoined.slice(0, lastCharIsEnter ? -1 : dataJoined.length) + ',"' + footnotes + '"';
	    }
	
	    // Strip HTML tags
	    return line.replace(/<[^>]+>/g, '');
	  }).join('\n');
	}
	
	/**
	 * Creator and downloader for the csv data (taken from AG-grids implimentation)
	 * @param  {string} fileName [filename]
	 * @param  {string} content  [content for file (csv, json, etc)]
	 */
	function downloader(fileName, content) {
	  var blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
	  (0, _fileSaver.saveAs)(blob, fileName);
	}
	
	/**
	 * Escape CSV quotes
	 * @param  {string} str [string to escape]
	 * @return {string}     [escaped string]
	 */
	function escapeCSVQuotes(str) {
	  if (typeof str !== 'string') {
	    return str;
	  }
	  return str.replace(/"|“|”|\u201C|\u201D/g, '""');
	}
	
	/**
	 * Check string for newlines, if they exist wrap in quotes
	 * @param  {string} str [string to check]
	 * @return {string}     [string wrapped in quotes]
	 */
	function escapeNewLines(str) {
	  if (typeof str !== 'string') {
	    return str;
	  }
	  if (str.match('\n|\r')) {
	    return str.replace(/(\r\n|\n|\r)/gm, ' ');
	  }
	  return str;
	}
	
	/**
	 * Convience function for splitting an array every other item
	 * @param  {array} arr array to split
	 * @return {array}     2d array, first one is the evens (including 0), second is odds (not including 0)
	 */
	function splitArray(arr) {
	  return [arr.filter(function (item, idx) {
	    return idx % 2 === 0;
	  }), arr.filter(function (item, idx) {
	    return idx % 2 !== 0;
	  })];
	}

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(152);
	
	var _datacenterSheet = __webpack_require__(153);
	
	var _datacenterSheet2 = _interopRequireDefault(_datacenterSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('datacenterServices', ['angularDatacenterLoader']).service('datacenterSheet', _datacenterSheet2.default).name;

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = datacenterSheet;
	
	var _appJs = __webpack_require__(86);
	
	var _appJs2 = _interopRequireDefault(_appJs);
	
	var _constants = __webpack_require__(70);
	
	var types = _interopRequireWildcard(_constants);
	
	var _actions = __webpack_require__(154);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	datacenterSheet.$inject = ['$q', '$location', '$ngRedux', 'Loader']; /* eslint new-cap: [2, {"capIsNewExceptions":["Map"]}] */
	function datacenterSheet($q, $location, $ngRedux, Loader) {
	  this.$ngRedux = $ngRedux;
	  this.$location = $location;
	  this.$q = $q;
	  this.Loader = Loader;
	}
	
	/**
	 * Async Loader callback where you can customize the sheet request for cache
	 * bypass, local json, etc.
	 *
	 * @param {object} appJs The javascript config object from post-indicator.php
	 *
	 * @return {promise} A promise object for the indicator data
	 */
	datacenterSheet.prototype.loadDataFromSource = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _appJs2.default;
	
	  var noCache = this.$location.search().noCache || options.is_preview;
	
	  this.Loader.URL = '/wp-json/kff/v1/google-sheets-full?id=' + (options.gdocs_key || options.gdocsKey);
	  if (noCache) {
	    this.Loader.URL += '&noCache=true';
	  }
	  return this.$q.when(this.Loader.get());
	};
	
	/**
	 * An async action creator which bootstraps the spreadsheet data for this
	 * indicator
	 *
	 * @return {function} A redux async action
	 */
	datacenterSheet.prototype.buildSheetData = function () {
	  var _this = this;
	
	  this.$ngRedux.dispatch((0, _actions2.default)(types.LOADING_DATA));
	  return function (dispatch, getState) {
	    var state = getState();
	    // Only fetch if data has not already been filled
	    if (state.data.immutableData) {
	      return;
	    }
	    // This should prevent double requests
	    if (_appJs2.default.gdocsObject && !_appJs2.default.is_preview) {
	      dispatch((0, _actions2.default)(types.BUILD_DATA, {
	        data: _appJs2.default.gdocsObject,
	        options: state.router.currentParams
	      }));
	      return;
	    }
	    // Removing this for load issues for the time being
	    _this.loadDataFromSource().then(function (data) {
	      dispatch((0, _actions2.default)(types.BUILD_DATA, {
	        data: data,
	        options: state.router.currentParams
	      }));
	    });
	  };
	};

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = actionTrigger;
	// A reuseable basic action which just passes type and data to the reducers
	function actionTrigger(type, data) {
	  return { type: type, data: data };
	}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(156);
	
	__webpack_require__(157);
	
	__webpack_require__(159);
	
	var _refineColumns = __webpack_require__(160);
	
	var _refineColumns2 = _interopRequireDefault(_refineColumns);
	
	var _refineDistributions = __webpack_require__(170);
	
	var _refineDistributions2 = _interopRequireDefault(_refineDistributions);
	
	var _refineTimeframe = __webpack_require__(172);
	
	var _refineTimeframe2 = _interopRequireDefault(_refineTimeframe);
	
	var _displayTimeframe = __webpack_require__(174);
	
	var _displayTimeframe2 = _interopRequireDefault(_displayTimeframe);
	
	var _refineDataviews = __webpack_require__(176);
	
	var _refineDataviews2 = _interopRequireDefault(_refineDataviews);
	
	var _sidebarBlockHeader = __webpack_require__(178);
	
	var _sidebarBlockHeader2 = _interopRequireDefault(_sidebarBlockHeader);
	
	var _navTabs = __webpack_require__(181);
	
	var _navTabs2 = _interopRequireDefault(_navTabs);
	
	var _linechart = __webpack_require__(183);
	
	var _linechart2 = _interopRequireDefault(_linechart);
	
	var _chartLegend = __webpack_require__(186);
	
	var _chartLegend2 = _interopRequireDefault(_chartLegend);
	
	var _saveAsImage = __webpack_require__(187);
	
	var _saveAsImage2 = _interopRequireDefault(_saveAsImage);
	
	var _footnotes = __webpack_require__(188);
	
	var _footnotes2 = _interopRequireDefault(_footnotes);
	
	var _notes = __webpack_require__(190);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('datacenterDirectives', ['ngAnimate', 'datamaps', 'RecursionHelper', 'nvd3']).directive('datacenterRefineColumns', _refineColumns2.default).directive('datacenterRefineDistributions', _refineDistributions2.default).directive('datacenterRefineTimeframe', _refineTimeframe2.default).directive('datacenterDisplayTimeframe', _displayTimeframe2.default).directive('datacenterRefineDataviews', _refineDataviews2.default).directive('datacenterTabs', _navTabs2.default).directive('sidebarBlockHeader', _sidebarBlockHeader2.default).directive('linechart', _linechart2.default).directive('chartLegend', _chartLegend2.default).directive('saveAsImage', _saveAsImage2.default).directive('footnotes', _footnotes2.default).directive('notes', _notes2.default).name;

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {
	      columns: '=',
	      context: '='
	    },
	    templateUrl: _refineColumns2.default,
	    link: Link,
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	};
	
	var _refineColumns = __webpack_require__(161);
	
	var _refineColumns2 = _interopRequireDefault(_refineColumns);
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	var _config = __webpack_require__(71);
	
	var _util = __webpack_require__(162);
	
	var _util2 = __webpack_require__(102);
	
	var _iterateOverChildNodes = __webpack_require__(164);
	
	var _iterateOverChildNodes2 = _interopRequireDefault(_iterateOverChildNodes);
	
	var _events = __webpack_require__(165);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _slugify = __webpack_require__(79);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _util3 = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	Controller.$inject = ['$scope', '$ngRedux'];
	function Controller($scope, $ngRedux) {
	  var _this = this;
	
	  var disconnect = $ngRedux.connect(function (state) {
	    return {
	      router: state.router,
	      sheet: state.data,
	      selectedRows: state.router.currentParams.selectedRows,
	      getRows: function getRows() {
	        return state.router.currentParams.selectedRows;
	      }
	    };
	  }, function (dispatch) {
	    return { dispatch: dispatch };
	  })(this);
	  $scope.$on('$destroy', disconnect);
	
	  // Custom title for the columns
	  this.title = this.context ? this.context : ['Locations', 'States', 'State'];
	
	  var isGeoMulti = _mori2.default.getIn(this.sheet.config, ['globalRules', 'Geomulti'], false);
	
	  this.treeContextSlug = (0, _slugify2.default)(this.title[1]);
	  var treeContext = isGeoMulti ? this.columns.nested[this.treeContextSlug] : {};
	
	  this.geoMultiChildren = isGeoMulti ? Object.keys(treeContext.children).map((0, _util.mapToArray)(treeContext.children)).sort(function (_ref, _ref2) {
	    var a = _ref.label;
	    var b = _ref2.label;
	    return a.localeCompare(b);
	  }) : [];
	
	  $scope.$watch(function () {
	    return _this.router.currentParams.activeTab;
	  }, function (newVal) {
	    _this.isGeoMultiMap = newVal === 'map' && isGeoMulti;
	    var selectedRows = _this.selectedRows || {};
	    if (!_this.isGeoMultiMap) {
	      return;
	    }
	
	    // Set the initial multigeoSelection.
	    // Get the selected rows, then the treeContextSlug
	    // Else, just go with an empty object.
	    // Failing that, default to the first key in the children array
	    _this.multigeoSelection = Object.keys(selectedRows[_this.treeContextSlug] || {}).sort()[0] || _this.geoMultiChildren[0].key;
	
	    _this.selectGeoMultiMap(_this.multigeoSelection);
	  });
	
	  this.selectGeoMultiMap = function (key) {
	    var parentSlug = _this.treeContextSlug + '--' + key;
	    var checked = true;
	    var allCheckbox = document.querySelector('input[id=' + parentSlug + '-all]') || {};
	    var allCheckboxLabel = document.querySelector('label[for=' + parentSlug + '-all]') || {};
	    // Clear all selected checkboxes
	    document.dispatchEvent(new Event('clearAll'));
	
	    $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	      selectedRows: _defineProperty({}, _this.treeContextSlug, _defineProperty({}, key, { all: {} }))
	    }));
	
	    allCheckbox.checked = true;
	    allCheckboxLabel.innerHTML = (0, _util3.escapeHTML)(dcStrings.unselectAll);
	
	    var event = new CustomEvent('selectAll', {
	      detail: {
	        parentSlug: parentSlug,
	        checked: checked,
	        wrapups: []
	      }
	    });
	    document.dispatchEvent(event);
	  };
	}
	
	function Link(scope, element /* , attr */) {
	  // Use columnSelector/columnSelectorAll
	  // @TODO make sure to sort the rows...
	  var unregister = scope.$watchCollection('vm', function (vm) {
	    if (typeof vm.columns === 'undefined') {
	      return;
	    }
	    unregister(); // Stop watching we only want to do this once
	
	    var isMedicare = _mori2.default.getIn(scope.vm.sheet.config, ['globalRules', 'medicare'], false);
	
	    if (vm.columns.wrapups) {
	      (0, _iterateOverChildNodes2.default)({
	        container: element[0].querySelector('#main-geo p'),
	        map: scope.vm.columns.wrapups,
	        selectedRows: scope.vm.getRows(), // Currently selected rows
	        parentSlug: 'wrapups',
	        sortMethod: function sortMethod(_ref3, _ref4) {
	          var a = _ref3.label;
	          var b = _ref4.label;
	          return _config.appDefault.wrapupOrder.indexOf(b) - _config.appDefault.wrapupOrder.indexOf(a);
	        },
	        events: (0, _events2.default)(scope.vm.dispatch, scope.vm.getRows)
	      });
	    }
	    if (vm.columns.nested) {
	      (0, _iterateOverChildNodes2.default)({
	        container: element[0].querySelector('#main-subgeo'),
	        map: Object.keys(scope.vm.columns.nested).map((0, _util.mapToArray)(scope.vm.columns.nested)).sort(function (_ref5, _ref6) {
	          var a = _ref5.key;
	          var b = _ref6.key;
	          return _config.appDefault.countyOrder.indexOf(a.toLowerCase()) - _config.appDefault.countyOrder.indexOf(b.toLowerCase());
	        }),
	        parentSlug: '',
	        selectedRows: scope.vm.getRows(), // Currently selected rows
	        wrapups: vm.columns.wrapups,
	        sortMethod: function sortMethod(_ref7, _ref8) {
	          var a = _ref7.label;
	          var b = _ref8.label;
	
	          var aProps = (0, _util2.buildRowProperties)(a);
	          var bProps = (0, _util2.buildRowProperties)(b);
	          // For special (numbered) geos, sort by the numerical value in the characteristic
	          if (aProps.isSpecialGeo && bProps.isSpecialGeo) {
	            var anum = parseInt(a.replace(/^\D+/g, ''), 10);
	            var bnum = parseInt(b.replace(/^\D+/g, ''), 10);
	
	            return anum - bnum;
	          }
	
	          return a.localeCompare(b);
	        }, // A-Z order
	        events: (0, _events2.default)(scope.vm.dispatch, scope.vm.getRows, vm.columns.nested),
	        isMedicare: isMedicare
	      });
	    }
	  });
	}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	var path = 'directives/refineColumns/refineColumns.html';
	var html = "<sidebar-block-header name=\"{{ vm.title[0] }}\" view=\"{{ vm.router.currentParams.activeTab }}\"></sidebar-block-header><div class=\"check-boxes geo-selectors\"><fieldset class=fieldset id=main-geo><p></p></fieldset><fieldset ng-show=!vm.isGeoMultiMap id=main-subgeo class=\"dropdown-field chr-cbs\"></fieldset><fieldset ng-show=vm.isGeoMultiMap id=main-subgeo class=\"dropdown-field chr-cbs\"><p ng-repeat=\"value in vm.geoMultiChildren\"><input type=radio name=column id=\"{{ value.key }}\" value=\"{{ value.key }}\" ng-model=vm.multigeoSelection ng-change=vm.selectGeoMultiMap(value.key)><label for=\"{{ value.key }}\">{{ value.label }}</label></p></fieldset></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setAttributes = setAttributes;
	exports.toggleClass = toggleClass;
	exports.mapToArray = mapToArray;
	exports.mapEventsToColumnSelector = mapEventsToColumnSelector;
	exports.buildParent = buildParent;
	
	var _columnSelector = __webpack_require__(163);
	
	var _util = __webpack_require__(76);
	
	/**
	 * Helper function for setting multiple attributes
	 * @param {Node} element [dom element to set attributes on]
	 * @param {object} options [attributes to set key is attribute name]
	 */
	function setAttributes(element, options) {
	  Object.keys(options).forEach(function (option) {
	    element.setAttribute(option, options[option]);
	  });
	  return element;
	}
	
	/**
	 * Native JS version of $.toggleClass
	 * shamelessy borrowed from youmightnotneedjquery.com
	 * @param  {node}   node      [element to toggle class on]
	 * @param  {string} className [class to toggle]
	 */
	function toggleClass(node, className) {
	  if (node.classList) {
	    node.classList.toggle(className);
	    return;
	  }
	  var classes = node.className.split(' ');
	  var existingIdx = classes.indexOf(className);
	
	  if (existingIdx >= 0) {
	    classes.splice(existingIdx, 1);
	  } else {
	    classes.push(className);
	  }
	
	  node.className = classes.join(' ');
	}
	
	/**
	 * Convert a map to an array (using Object.keys(map).map(mapToArray(map)))
	 * @param  {object} map [map to convert to array]
	 * @return {function}   [function which maps over]
	 */
	function mapToArray(map) {
	  return function (key) {
	    return _extends({}, map[key], { key: key });
	  };
	}
	
	/**
	 * Map object to column selector (with keyed events)
	 * @param {function} events     [events to map into object]
	 * @param {string}   key        [key for the column selector]
	 * @param {string}   label      [label for the column selector]
	 * @param {string}   parentSlug [slug of the parents]
	 * @param {bool}     isSelected [if column selector should be selected on pageload]
	 * @return {node}               [columnSelector node]
	 */
	function mapEventsToColumnSelector(events, key, label, parentSlug) {
	  var isSelected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  return (0, _columnSelector.columnSelector)({
	    key: key,
	    parentSlug: parentSlug,
	    label: label,
	    isSelected: isSelected,
	    events: events(key, parentSlug)
	  });
	}
	
	/**
	 * Build the parent dropdown for nested
	 * @param  {string} text    [parent name]
	 * @param  {number} depth   [current depth of the parent]
	 * @param {function} events [events to map into object]
	 * @return {node}           [dom object]
	 */
	function buildParent(text, depth, _ref) {
	  var clearAll = _ref.clearAll;
	  var active = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var wrapper = document.createElement('dt');
	  var label = document.createElement('span');
	  var btn = document.createElement('span');
	
	  label.setAttribute('class', 'accordion-title serif');
	  label.innerHTML = '' + (0, _util.escapeHTML)(text);
	  wrapper.appendChild(label);
	
	  btn.setAttribute('class', 'plus-btn-tan ' + (active ? 'active' : ''));
	
	  btn.addEventListener('click', function (evt) {
	    evt.preventDefault;
	    toggleClass(btn, 'active');
	    toggleClass(wrapper.parentNode.querySelector('.check-boxes-dropdown-scroller'), 'ng-hide');
	  });
	
	  wrapper.appendChild(btn);
	
	  // Only display on first children
	  if (depth === 0 && clearAll) {
	    var clear = document.createElement('span');
	    clear.setAttribute('class', 'clear-selections');
	    clear.innerHTML = dcStrings.clearAllSelections;
	    clear.addEventListener('click', clearAll);
	    wrapper.appendChild(clear);
	  }
	
	  return wrapper;
	}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.columnSelector = columnSelector;
	
	var _util = __webpack_require__(162);
	
	var _util2 = __webpack_require__(76);
	
	/**
	 * Basic column selector
	 * @param  {string} options.key         [key of the selector]
	 * @param  {string} options.label       [user visible label]
	 * @param  {object} options.events      [object of callback functions]
	 * @param  {object} options.isSelected  [if item is selected]
	 * @param  {object} options.isAll       [if item is an all value]
	 * @return {DOM}                        [dom element]
	 */
	function columnSelector(_ref) {
	  var key = _ref.key,
	      parentSlug = _ref.parentSlug,
	      label = _ref.label,
	      events = _ref.events,
	      _ref$isSelected = _ref.isSelected,
	      isSelected = _ref$isSelected === undefined ? false : _ref$isSelected,
	      _ref$isAll = _ref.isAll,
	      isAll = _ref$isAll === undefined ? false : _ref$isAll;
	
	  var pWrapper = document.createElement('p');
	  if (isAll) {
	    pWrapper.setAttribute('class', 'select-all');
	  }
	  var wrapper = document.createElement('column-selector');
	  wrapper.classList.add('column-selector');
	  if (isAll) {
	    wrapper.classList.add('select-all');
	  }
	
	  var attr = {
	    type: 'checkbox',
	    name: 'chk',
	    class: 'styled ' + (isAll ? 'select-all' : ''),
	    id: key,
	    value: key
	  };
	
	  var input = (0, _util.setAttributes)(document.createElement('input'), attr);
	
	  if (isSelected) {
	    input.checked = true;
	  }
	
	  Object.keys(events).forEach(function (event) {
	    if (event === 'toggleSingleSelect' && !isAll) {
	      input.addEventListener('click', events[event]);
	    } else if (event === 'toggleAllSelect' && isAll) {
	      input.addEventListener('click', events[event]);
	    }
	  });
	
	  document.addEventListener('clearAll', function () {
	    if (input.classList.contains('select-all')) {
	      var event = new CustomEvent('selectAllOff', {
	        detail: {
	          keys: [input.id.replace('-all', '')]
	        }
	      });
	      document.dispatchEvent(event);
	      return;
	    }
	    input.checked = false;
	  });
	
	  if (isAll) {
	    document.addEventListener('selectAllOff', function (evt) {
	      if (evt.detail.keys.join('--').indexOf(key.replace('-all', '')) > -1) {
	        input.checked = false;
	        document.querySelector('label[for="' + key + '"]').innerHTML = (0, _util2.escapeHTML)(dcStrings.selectAll);
	      }
	    });
	  }
	
	  document.addEventListener('selectAll', function (evt) {
	    // If a parent causes this
	    if ((parentSlug || []).indexOf(evt.detail.parentSlug) > -1 || evt.detail.wrapups.indexOf(key) > -1) {
	      input.checked = evt.detail.checked;
	    }
	  });
	
	  wrapper.appendChild(input);
	  wrapper.appendChild(labelTemplate({ key: key, label: label, isAll: isAll, isSelected: isSelected }));
	  pWrapper.appendChild(wrapper);
	  return pWrapper;
	}
	
	/**
	 * Create the template label for the columnSelector
	 * @param  {string}  options.key        [key for the input]
	 * @param  {string}  options.label      [label]
	 * @param  {Boolean} options.isAll      [if the selector is an all]
	 * @param  {Boolean} options.isSelected [if it's selected (or should be)]
	 * @return {string}                     [interpolated string]
	 */
	function labelTemplate(_ref2) {
	  var key = _ref2.key,
	      label = _ref2.label,
	      _ref2$isAll = _ref2.isAll,
	      isAll = _ref2$isAll === undefined ? false : _ref2$isAll,
	      _ref2$isSelected = _ref2.isSelected,
	      isSelected = _ref2$isSelected === undefined ? false : _ref2$isSelected;
	
	  var elm = document.createElement('label');
	  elm.setAttribute('for', key);
	  if (isAll) {
	    // elm.innerHTML = `${isSelected ? 'Unselect' : 'Select'} All`;
	    elm.innerHTML = (0, _util2.escapeHTML)(isSelected ? dcStrings.unselectAll : dcStrings.selectAll);
	  } else {
	    elm.innerHTML = (0, _util2.escapeHTML)(label);
	  }
	  return elm;
	}
	
	// Default export for testing
	exports.default = {
	  columnSelector: columnSelector,
	  labelTemplate: labelTemplate
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = iterateOverChildNodes;
	
	var _util = __webpack_require__(162);
	
	var _columnSelector = __webpack_require__(163);
	
	var _util2 = __webpack_require__(76);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Iterate over child nodes and append to the container
	 * @param  {object} options.selectedRows    [currently selected rows]
	 * @param  {object || array} options.map    [map to start with]
	 * @param  {function} options.sortMethod    [sort function to use]
	 * @param  {function} options.events        [(key) => {} function to use for events]
	 * @param  {node} options.container         [container to append items to]
	 * @param  {String} options.parentSlug      [slug of the parent]
	 * @param  {Number} options.depth           [current depth of recursion]
	 * @param  {Object} options.wrapups         [wrapups]
	 * @return {node}                           [container with appened items]
	 */
	function iterateOverChildNodes(_ref) {
	  var selectedRows = _ref.selectedRows,
	      map = _ref.map,
	      sortMethod = _ref.sortMethod,
	      events = _ref.events,
	      container = _ref.container,
	      _ref$parentSlug = _ref.parentSlug,
	      parentSlug = _ref$parentSlug === undefined ? '' : _ref$parentSlug,
	      _ref$depth = _ref.depth,
	      depth = _ref$depth === undefined ? 0 : _ref$depth,
	      _ref$wrapups = _ref.wrapups,
	      wrapups = _ref$wrapups === undefined ? {} : _ref$wrapups,
	      _ref$isMedicare = _ref.isMedicare,
	      isMedicare = _ref$isMedicare === undefined ? false : _ref$isMedicare;
	
	  // if map is an array no need to convert to one... we can also assume already sorted
	  return (Array.isArray(map) ? map : Object.keys(map).map((0, _util.mapToArray)(map)).sort(sortMethod)).reduce(function (acc, _ref2) {
	    var key = _ref2.key,
	        label = _ref2.label,
	        children = _ref2.children;
	
	    // Set the parent keys to the split slug
	    var parentKeys = parentSlug.length ? parentSlug.split('--') : [];
	
	    if (children) {
	      var wrapper = document.createElement('div');
	      wrapper.setAttribute('class', 'accordion-wrapper');
	      var childWrapper = document.createElement('dl');
	      childWrapper.setAttribute('class', 'accordionShow');
	
	      // If the currently selected rows have any child keys that
	      // belong to this parent, we need have that parent 'active'
	      // and have its children visible
	      var parentIsActive = !isMedicare || !isMedicare && depth === 0 || (0, _util2.deepFind)([].concat(_toConsumableArray(parentKeys), [key]), selectedRows) !== false || (0, _util2.deepFind)([].concat(_toConsumableArray(parentKeys), ['all']), selectedRows) !== false;
	
	      childWrapper.appendChild((0, _util.buildParent)(label, depth, events(key), parentIsActive), depth);
	
	      var childContainerWrapper = document.createElement('dd');
	      var hiddenDropdown = !parentIsActive;
	      childContainerWrapper.setAttribute('class',
	      // Reusing style for now... so reason for ng-hide
	      'check-boxes-dropdown-scroller ' + (hiddenDropdown ? 'ng-hide' : ''));
	
	      var childContainer = document.createElement('fieldset');
	      childContainer.setAttribute('class', 'check-boxes-dropdown-field');
	
	      // Summary Check
	      // if summary && depth !== 0
	      // All Check
	      var nestedParentSlug = '' + parentSlug + (parentSlug.length ? '--' : '') + key;
	      var selectAllKey = nestedParentSlug + '-all';
	
	      childContainer.appendChild((0, _columnSelector.columnSelector)({
	        key: selectAllKey,
	        parentSlug: parentSlug,
	        label: '',
	        isAll: true,
	        events: events(selectAllKey, nestedParentSlug, depth === 0 ? wrapups : {}),
	        isSelected: (0, _util2.deepFind)([].concat(_toConsumableArray(parentKeys), [key, 'all']), // Check for select all
	        selectedRows) !== false || (0, _util2.deepFind)([].concat(_toConsumableArray(parentKeys), ['all']), // Check for select all in parent
	        selectedRows) !== false
	      }));
	
	      // Iterate over this map's children
	      childContainer = iterateOverChildNodes({
	        container: childContainer,
	        map: children,
	        parentSlug: nestedParentSlug,
	        depth: depth + 1,
	        events: events,
	        selectedRows: selectedRows,
	        sortMethod: sortMethod,
	        wrapups: wrapups,
	        isMedicare: isMedicare
	      });
	
	      childContainerWrapper.appendChild(childContainer);
	      childWrapper.appendChild(childContainerWrapper);
	      wrapper.appendChild(childWrapper);
	      acc.appendChild(wrapper);
	    } else {
	      var isSelected = (0, _util2.deepFind)([].concat(_toConsumableArray(parentKeys), [key]), selectedRows) !== false ||
	      // Ignore wrapups
	      parentSlug.indexOf('wrapup') === -1 && (0, _util2.deepFind)([].concat(_toConsumableArray(parentKeys), ['all']), // Check for select all
	      selectedRows) !== false ||
	      // Go up a level to see if we need to select this
	      (0, _util2.deepFind)([].concat(_toConsumableArray(parentKeys.slice(0, 1)), ['all']), selectedRows) !== false;
	
	      acc.appendChild((0, _util.mapEventsToColumnSelector)(events, key, label, parentSlug, isSelected));
	    }
	    return acc;
	  }, container);
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _clearAllEvent = __webpack_require__(166);
	
	var _clearAllEvent2 = _interopRequireDefault(_clearAllEvent);
	
	var _toggleAllSelectEvent = __webpack_require__(167);
	
	var _toggleAllSelectEvent2 = _interopRequireDefault(_toggleAllSelectEvent);
	
	var _toggleSingleSelectEvent = __webpack_require__(169);
	
	var _toggleSingleSelectEvent2 = _interopRequireDefault(_toggleSingleSelectEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function curry(fn) {
	  return function (x) {
	    return function (y) {
	      return function (evt) {
	        return fn(x, y, evt);
	      };
	    };
	  };
	}
	
	exports.default = function (dispatch, getRows, tree) {
	  return function (key, parentSlug, wrapups) {
	    var x = { dispatch: dispatch, getRows: getRows, tree: tree };
	    var y = { key: key, parentSlug: parentSlug, wrapups: wrapups };
	
	    return {
	      toggleSingleSelect: curry(_toggleSingleSelectEvent2.default)(x)(y),
	      toggleAllSelect: curry(_toggleAllSelectEvent2.default)(x)(y),
	      clearAll: curry(_clearAllEvent2.default)(x)(y)
	    };
	  };
	};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clearAllEvent;
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clearAllEvent(_ref, key, evt) {
	  var dispatch = _ref.dispatch;
	
	  evt.preventDefault();
	  dispatch((0, _stateGo2.default)('datacenter.main', { selectedRows: {} }));
	
	  var event = new Event('clearAll');
	  document.dispatchEvent(event);
	}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = toggleAllSelectEvent;
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	var _selectAction = __webpack_require__(168);
	
	var _selectAction2 = _interopRequireDefault(_selectAction);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function toggleAllSelectEvent(_ref, _ref2, evt) {
	  var dispatch = _ref.dispatch,
	      getRows = _ref.getRows;
	  var key = _ref2.key,
	      parentSlug = _ref2.parentSlug,
	      _ref2$wrapups = _ref2.wrapups,
	      wrapups = _ref2$wrapups === undefined ? {} : _ref2$wrapups;
	  var checked = evt.target.checked;
	  // Use get rows to get the current rows in the slug, and build the new tree
	
	  var active = getRows() || {};
	  var keys = [].concat(_toConsumableArray(parentSlug.split('--')), ['all']);
	
	  // If we've selected 'all', do an unsafe delete on the active
	  // tree to ensure only {all: {}} exists in the tree.
	  (0, _util.safeDeepDelete)(keys.slice(0, -1), active, checked);
	
	  var selected = selectWrapups((0, _selectAction2.default)(active, keys, checked), checked, key, wrapups);
	
	  dispatch((0, _stateGo2.default)('datacenter.main', {
	    selectedRows: _extends({}, selected)
	  }));
	
	  var event = new CustomEvent('selectAll', {
	    detail: {
	      parentSlug: parentSlug,
	      checked: checked,
	      wrapups: getRelativeWrapups(wrapups, key)
	    }
	  });
	  document.dispatchEvent(event);
	  document.querySelector('label[for="' + key + '"]').innerHTML = (0, _util.escapeHTML)(checked ? dcStrings.unselectAll : dcStrings.selectAll);
	
	  return;
	}
	
	/**
	 * Select wrapups from wrapup object
	 * @param  {object} tree    [currently selected tree]
	 * @param  {bool} select    [is currently selected]
	 * @param  {string} key     [current key]
	 * @param  {object} wrapups [wrapups on page]
	 * @return {object}         [modified tree]
	 */
	function selectWrapups(tree, select, key, wrapups) {
	  var relativeWrapups = getRelativeWrapups(wrapups, key);
	
	  if (!select) {
	    // All Unselected
	    relativeWrapups.forEach(function (wrapup) {
	      ['wrapups', wrapup].reverse().some(function (itemKey, idx, arr) {
	        return (0, _util.safeDeepDelete)([].concat(_toConsumableArray(arr.slice(idx + 1).reverse()), [itemKey]), tree, arr.length === 1);
	      });
	    });
	    return tree;
	  }
	  // All select
	  var wrapupTree = relativeWrapups.reduce(function (acc, wrapup) {
	    acc[wrapup] = {};
	    return acc;
	  }, {});
	  var hasWrapUpTree = !!Object.keys(wrapupTree).length;
	  return _extends(tree, hasWrapUpTree ? { wrapups: wrapupTree } : {});
	}
	
	/** Get relative wrapups based on key */
	function getRelativeWrapups(wrapups, key) {
	  return Object.keys(wrapups).filter(function (wrapup) {
	    return wrapup.indexOf(key.replace('-all', '')) > -1;
	  } // gotta remove that '-all' slug for matching...
	  );
	}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = selectAction;
	
	var _util = __webpack_require__(76);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// @TODO this needs knowledge of wrapups and the entire tree for selecting off/on
	
	/**
	 * Select the clicked item
	 * @param  {object} tree  [getRows tree]
	 * @param  {array} keys   [applicable keys]
	 * @param  {bool} checked [if action was a check or uncheck]
	 * @return {object}       [modified tree]
	 */
	function selectAction(tree, keys, check) {
	  if (check) {
	    // Bunch of pass by reference magic here
	    var temp = tree;
	    keys.forEach(function (itemKey) {
	      if (temp[itemKey]) {
	        temp = temp[itemKey];
	      } else {
	        temp[itemKey] = {};
	        temp = temp[itemKey];
	      }
	    });
	  } else {
	    var unselectAll = false;
	    if (keys[keys.length - 1] === 'all') {
	      unselectAll = true;
	      keys.pop(); // We don't want to care about all if it's the key, just kill everything
	    }
	    // Iterate over for side effect to gain tree deletion
	    keys.slice().reverse().some(function (itemKey, idx, arr) {
	      return (0, _util.safeDeepDelete)([].concat(_toConsumableArray(arr.slice(idx + 1).reverse()), [itemKey]), tree, arr.length === 1 || unselectAll);
	    });
	  }
	  return tree;
	}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = toggleSingleSelectEvent;
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	var _util = __webpack_require__(76);
	
	var _selectAction = __webpack_require__(168);
	
	var _selectAction2 = _interopRequireDefault(_selectAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function toggleSingleSelectEvent(_ref, _ref2, evt) {
	  var dispatch = _ref.dispatch,
	      getRows = _ref.getRows,
	      tree = _ref.tree;
	  var key = _ref2.key,
	      parentSlug = _ref2.parentSlug;
	  var checked = evt.target.checked;
	  // Use get rows to get the current rows in the slug, and build the new tree
	
	  var active = getRows() || {};
	  var parentKeys = parentSlug.length ? parentSlug.split('--') : [];
	  var keys = [].concat(_toConsumableArray(parentKeys), [key]);
	
	  // Perform select action
	  dispatch((0, _stateGo2.default)('datacenter.main', {
	    selectedRows: (0, _selectAction2.default)(active, keys, checked)
	  }));
	
	  // This is a select all off
	  if (!(0, _util.isUrlSelected)(keys, active)) {
	    var event = new CustomEvent('selectAllOff', {
	      detail: {
	        keys: parentKeys
	      }
	    });
	    document.dispatchEvent(event);
	
	    // Go though the tree, fine the parent of the unselected item and select
	    // all it's children, EXCEPT for the item
	
	    // Parent locator is all but last key
	    // Ignore item === last key
	    var urlParent = (0, _util.deepFind)(parentKeys, active);
	    if (urlParent && urlParent.all) {
	      (0, _util.deepDelete)(parentKeys, active);
	      var selectedSiblings = Object.keys(parentKeys.reduce(function (acc, curr) {
	        return acc[curr] ? acc[curr].children : tree[curr].children;
	      }, {})).filter(function (x) {
	        return x !== key;
	      }).reduce(function (acc, x) {
	        return _extends(acc, _defineProperty({}, x, {}));
	      }, {});
	
	      // Build a new tree object with the necessary siblings of what
	      // was de-selected.
	      var newSelection = void 0;
	      var tempObj = newSelection = {};
	      parentKeys.forEach(function (parentKey, idx) {
	        if (!parentKeys[idx + 1]) {
	          if (Object.keys(selectedSiblings).length === 0) {
	            return;
	          }
	          tempObj[parentKey] = selectedSiblings;
	        } else {
	          tempObj = tempObj[parentKey] = {};
	        }
	      });
	
	      // Update the tree by performing a deep merge on what exists
	      // in the tree, with the new selection.
	      dispatch((0, _stateGo2.default)('datacenter.main', {
	        selectedRows: (0, _util.deepMerge)(active, newSelection)
	      }));
	    }
	  }
	
	  return;
	}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {},
	    templateUrl: _refineDistributions2.default,
	    controller: Controller,
	    controllerAs: 'distributions',
	    bindToController: {
	      locked: '='
	    }
	  };
	};
	
	var _refineDistributions = __webpack_require__(171);
	
	var _refineDistributions2 = _interopRequireDefault(_refineDistributions);
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint max-len:0 */
	Controller.$inject = ['$scope', '$attrs', '$filter', '$ngRedux'];
	function Controller($scope, $attrs, $filter, $ngRedux) {
	  var _this = this;
	
	  this.$ngRedux = $ngRedux;
	
	  var disconnect = $ngRedux.connect(function (state) {
	    return {
	      router: state.router,
	      sheet: state.data
	    };
	  })(this);
	
	  $scope.$on('$destroy', disconnect);
	
	  var loadDistributions = $scope.$watch(function () {
	    return _mori2.default.hash(_this.sheet.immutableDistributions);
	  }, function (val) {
	    // Zero hash means it was null
	    if (val !== 0) {
	      var metaTimeframe = _this.sheet.timeframes[_this.router.currentParams.currentTimeframe];
	      _this.distributions = _mori2.default.toJs(_this.sheet.metaData ? _this.sheet.metaData[metaTimeframe].immutableDistributions : _this.sheet.immutableDistributions);
	      _this.buildItems(_this.router.currentParams.selectedDistributions);
	      // Remove self after firing
	      loadDistributions();
	    }
	  });
	
	  // reset distributions if timeframe changes
	  $scope.$watch(function () {
	    return _this.router.currentParams.currentTimeframe;
	  }, function (newval, oldval) {
	    // don't update if no change
	    // don't update if no timeframes defined
	    if (newval === oldval && _this.router.currentParams.selectedDistributions || !_this.sheet.timeframes || !_this.sheet.metaData) {
	      return;
	    }
	
	    _this.clearSelectedDistributions();
	    var metaTimeframe = _this.sheet.timeframes[_this.router.currentParams.currentTimeframe];
	    _this.distributions = _mori2.default.toJs(_this.sheet.metaData[metaTimeframe].immutableDistributions);
	    _this.items = null;
	    _this.buildItems(_this.router.currentParams.selectedDistributions);
	    if (_this.router.currentParams.activeTab === 'map' || _this.router.currentParams.activeTab === 'graph' && _this.locked) {
	      $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	        selectedDistributions: _this.getFirstAvailableDistribution(newval).slug || _this.distributions[0].slug
	      }));
	    }
	  });
	
	  // reset selections on table view for locked indicators
	  $scope.$watch(function () {
	    return _this.router.currentParams.activeTab;
	  }, function (newval, oldval) {
	    // don't update if no change
	    if (newval === oldval && _this.router.currentParams.selectedDistributions) {
	      return;
	    }
	    // clear selections in table view when coming from another tab
	    if (newval === undefined && oldval !== undefined && _this.locked) {
	      _this.clearSelectedDistributions();
	      // select first available when radio buttons are in use
	    } else if (newval === 'map' || newval === 'graph' && _this.locked) {
	      $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	        selectedDistributions: _this.getFirstAvailableDistribution(newval).slug || _this.distributions[0].slug
	      }));
	    }
	  });
	
	  // Hide items which should be shown for map
	  // @TODO share this with exclude for graph
	  $scope.$watch(function () {
	    return _this.router.currentParams.selectedDistributions;
	  }, this.buildItems.bind(this));
	}
	
	Controller.prototype.isRadioSelected = function () {
	  return this.router.currentParams.activeTab === 'map' || this.locked && this.router.currentParams.activeTab === 'graph';
	};
	
	Controller.prototype.getFirstAvailableDistribution = function (view) {
	  var included = _mori2.default.filter(function (item) {
	    return item.exclude.indexOf(view) === -1 || view === 'table';
	  }, this.items);
	
	  return _mori2.default.first(_mori2.default.filter(function (item) {
	    return item.selected;
	  }, included)) || _mori2.default.first(included);
	};
	
	Controller.prototype.clearSelectedDistributions = function () {
	  this.$ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	    selectedDistributions: undefined
	  }));
	};
	
	// update when a checkbox item is selected
	Controller.prototype.checkboxUpdate = function () {
	  var selected = this.items.filter(function (item) {
	    return item.selected;
	  }).map(function (item) {
	    return item.slug;
	  });
	
	  this.$ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	    selectedDistributions: selected.join('--')
	  }));
	};
	
	// update when the selected radio changes. will trigger the watch on items
	Controller.prototype.updateRadio = function (slug) {
	  this.$ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	    selectedDistributions: slug
	  }));
	};
	
	Controller.prototype.buildItems = function (selectedDistributions) {
	  if (!this.items) {
	    this.items = this.distributions;
	  }
	
	  this.items = this.items && this.items.map(function (item) {
	    return angular.extend({}, item, {
	      selected: [].concat((selectedDistributions || '').split('--')).indexOf(item.slug) > -1
	    });
	  });
	};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	var path = 'directives/refineDistributions/refineDistributions.html';
	var html = "<sidebar-block-header name=Distributions view=\"{{ vm.view }}\"></sidebar-block-header><div class=check-boxes ng-class=\"{'clear': distributions.router.currentParams.activeTab !== 'map'}\" ng-switch=distributions.isRadioSelected()><div ng-show=\"distributions.router.currentParams.activeTab !== 'map'\" class=clear-selections><span ng-click=distributions.clearSelectedDistributions()>Clear All Selections</span></div><fieldset ng-switch-when=true class=\"dropdown-field chr-cbs\"><p ng-repeat=\"item in distributions.items\" ng-if=\"item.exclude.indexOf(distributions.router.currentParams.activeTab) === -1\"><input type=radio name=characteristic id=\"chr-{{ $index }}\" ng-value=item.slug ng-model=distributions.router.currentParams.selectedDistributions ng-change=distributions.updateRadio(item.slug) ng-hide=\"item.map.toLowerCase() === 'no' || item['trend graph'].toLowerCase() === 'no'\"><label for=\"chr-{{ $index }}\">{{ item.label }}</label></p></fieldset><fieldset ng-switch-default=\"\" class=\"dropdown-field chr-cbs\"><p ng-repeat=\"item in distributions.items\" ng-if=\"item.exclude.indexOf(distributions.router.currentParams.activeTab) === -1\"><input type=checkbox name=characteristic id=\"chr-{{ $index }}\" ng-value=item.slug ng-model=item.selected ng-change=distributions.checkboxUpdate()><label for=\"chr-{{ $index }}\">{{ item.label }}</label></p></fieldset></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    replace: true,
	    scope: {
	      timeframes: '='
	    },
	    templateUrl: 'directives/refineTimeframe/refineTimeframe.html',
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	};
	
	__webpack_require__(173);
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	Controller.$inject = ['$scope', '$ngRedux'];
	function Controller($scope, $ngRedux) {
	  var _this = this;
	
	  var disconnect = $ngRedux.connect(function (state) {
	    return {
	      router: state.router
	    };
	  })(this);
	
	  $scope.$on('$destroy', disconnect);
	
	  // Initialize timeframe state
	  var timeframeLength = this.timeframes ? this.timeframes.length - 1 : 1;
	
	  // Update url when timeframe selection changes
	  ['currentTimeframe', 'startTimeframe'].forEach(function (select) {
	    $scope.$watch(function () {
	      return _this[select];
	    }, function (newval, oldval) {
	      var noStartTimeframe = !_this.router.currentParams.activeTab || _this.router.currentParams.activeTab !== 'graph';
	
	      // We want to return if there is no value change
	      // and if current and start timeframes are already set.
	      if (newval === oldval && _this.router.currentParams.currentTimeframe && !noStartTimeframe && _this.router.currentParams.startTimeframe) {
	        return;
	      }
	      var newTimeframe = _defineProperty({}, select, newval);
	      if (noStartTimeframe) {
	        newTimeframe = angular.extend({}, newTimeframe, {
	          startTimeframe: undefined
	        });
	      }
	      $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', newTimeframe));
	    });
	  });
	
	  // Onload update...
	  $scope.$watch(function () {
	    return _this.timeframes;
	  }, function (newval) {
	    if (newval !== 'undefined') {
	      ['currentTimeframe', 'startTimeframe'].forEach(function (select) {
	        if (_this.router.currentParams[select]) {
	          _this[select] = _this.router.currentParams[select];
	        }
	      });
	    }
	  });
	
	  this.currentTimeframe = this.router.currentParams.currentTimeframe || '0';
	  this.startTimeframe = this.router.currentParams.startTimeframe || timeframeLength.toString();
	
	  // When switching to graph view, ensure that selections are ordered correctly
	  $scope.$watch(function () {
	    return _this.router.currentParams.activeTab;
	  }, function (newval, oldval) {
	    if (newval === 'graph' && newval !== oldval) {
	      _this.startTimeframe = '' + (_this.timeframes.length - 1);
	      if (parseInt(_this.startTimeframe, 10) === parseInt(_this.currentTimeframe, 10)) {
	        _this.currentTimeframe = '' + (parseInt(_this.currentTimeframe, 10) - 1);
	      }
	      $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	        'currentTimeframe': _this.currentTimeframe,
	        'startTimeframe': _this.startTimeframe
	      }));
	    }
	  });
	}
	
	// Disable selection for new timeframes
	Controller.prototype.disabledStart = function (idx) {
	  return idx <= parseInt(this.currentTimeframe, 10);
	};
	
	// Disable selection for older timeframes
	Controller.prototype.disabledEnd = function (idx) {
	  if (this.router.currentParams.activeTab !== 'graph') {
	    return false;
	  }
	  return idx >= parseInt(this.startTimeframe, 10);
	};

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	var path = 'directives/refineTimeframe/refineTimeframe.html';
	var html = "<div class=timeframe-details ng-show=\"vm.timeframes.length > 1\"><sidebar-block-header name=Timeframe view=\"{{ vm.router.currentParams.activeTab }}\"></sidebar-block-header><div class=check-boxes><div class=indicator-start-wrapper ng-if=\"vm.router.currentParams.activeTab === 'graph'\"><select ng-model=vm.startTimeframe name=indicator-start id=indicator-start ng-options=\"idx as timeframe disable when vm.disabledStart(idx) for (idx, timeframe) in vm.timeframes\"></select><p>to</p></div><select ng-model=vm.currentTimeframe name=indicator-timeframe id=indicator-timeframe ng-options=\"idx as timeframe disable when vm.disabledEnd(idx) for (idx, timeframe) in vm.timeframes\"></select></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    replace: true,
	    scope: {
	      timeframes: '='
	    },
	    templateUrl: 'directives/displayTimeframe/displayTimeframe.html',
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	};
	
	__webpack_require__(175);
	
	Controller.$inject = ['$scope', '$ngRedux'];
	function Controller($scope, $ngRedux) {
	  var _this = this;
	
	  var disconnect = $ngRedux.connect(function (state) {
	    return {
	      router: state.router
	    };
	  })(this);
	
	  $scope.$on('$destroy', disconnect);
	
	  // Initialize timeframe state
	  var timeframeLength = this.timeframes ? this.timeframes.length - 1 : 1;
	  this.currentTimeframe = this.router.currentParams.currentTimeframe || '0';
	  this.startTimeframe = this.router.currentParams.startTimeframe || timeframeLength.toString();
	
	  $scope.$watch(function () {
	    return _this.router.currentParams.startTimeframe;
	  }, function (newval) {
	    return _this.startTimeframe = newval;
	  });
	
	  $scope.$watch(function () {
	    return _this.router.currentParams.currentTimeframe;
	  }, function (newval) {
	    return _this.currentTimeframe = newval;
	  });
	
	  // When switching to graph view, ensure that selections are ordered correctly
	  $scope.$watch(function () {
	    return _this.router.currentParams.activeTab;
	  }, function (newval, oldval) {
	    if (newval === 'graph') {
	      _this.currentOnly = false;
	      if (oldval && newval !== oldval) {
	        _this.startTimeframe = _this.timeframes && _this.timeframes.length - 1;
	        if (_this.startTimeframe === +_this.currentTimeframe) {
	          _this.currentTimeframe--;
	        }
	      }
	    } else {
	      _this.currentTimeframe = _this.router.currentParams.currentTimeframe;
	      _this.currentOnly = true;
	    }
	  });
	}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	var path = 'directives/displayTimeframe/displayTimeframe.html';
	var html = "<span><span ng-show=!vm.currentOnly>{{vm.timeframes[vm.startTimeframe]}} -</span> {{vm.timeframes[vm.currentTimeframe]}}</span>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {
	      dataviews: '='
	    },
	    templateUrl: _refineDataviews2.default,
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	};
	
	var _refineDataviews = __webpack_require__(177);
	
	var _refineDataviews2 = _interopRequireDefault(_refineDataviews);
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Controller.$inject = ['$scope', '$ngRedux']; /* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	function Controller($scope, $ngRedux) {
	  var disconnect = $ngRedux.connect(function (state) {
	    return {
	      activeTab: state.router.currentParams.activeTab,
	      dataView: state.router.currentParams.dataView || 0
	    };
	  })(this);
	
	  $scope.$on('$destroy', disconnect);
	
	  this.updateDataview = function (selected) {
	    // dispatch action to update data type
	    $ngRedux.dispatch((0, _stateGo2.default)('datacenter.main', {
	      dataView: selected
	    }));
	  };
	}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	var path = 'directives/refineDataviews/refineDataviews.html';
	var html = "<sidebar-block-header name=\"Data View\" view=\"{{ vm.activeTab }}\"></sidebar-block-header><div class=check-boxes><fieldset class=\"fieldset dataview-select\"><p ng-repeat=\"view in vm.dataviews\"><input type=radio name=radio-select ng-value=$index id=\"dataview-cb-{{ $index }}\" ng-model=vm.dataView ng-change=vm.updateDataview($index)><label for=\"dataview-cb-{{ $index }}\">{{ view.label }}</label></p></fieldset></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    replace: true,
	    scope: {
	      name: '@',
	      view: '@'
	    },
	    templateUrl: _sidebarBlockHeader2.default,
	    controller: Controller,
	    controllerAs: 'sidebarBlockHeader',
	    bindToController: true
	  };
	};
	
	var _tooltips = __webpack_require__(179);
	
	var _tooltips2 = _interopRequireDefault(_tooltips);
	
	var _sidebarBlockHeader = __webpack_require__(180);
	
	var _sidebarBlockHeader2 = _interopRequireDefault(_sidebarBlockHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Controller() {
	  this.tooltips = _tooltips2.default;
	}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint max-len: 0 */
	/**
	 * Map the copy for available sidebar block tooltips
	 * @TODO connect this text to the [i] buttons in the sidebar
	 */
	exports.default = {
	  'Locations': {
	    'table': 'Use the check boxes to display selected geographies. Not all geographies are available for every indicator.',
	    'graph': 'Use the check boxes to select geographies to display in the graph.',
	    'map': 'Use the check boxes to display data for selected geographies in the table below the map. All available data for the entire United States will be mapped, regardless of geographies selected.'
	  },
	  'Data View': {
	    'table': 'Use the check boxes to display selected geographies. Not all geographies are available for every indicator.',
	    'graph': 'Use the check boxes to select geographies to display in the graph.',
	    'map': 'Use the check boxes to display data for selected geographies in the table below the map. All available data for the entire United States will be mapped, regardless of geographies selected.'
	  },
	  'Distributions': {
	    'table': 'Use the check boxes to select distributions to display.',
	    'graph': 'Use the check boxes to select distributions to display in the graph.',
	    'map': 'Use the check boxes to select distributions to display in the map. Only one distribution can be mapped at a time.'
	  },
	  'Timeframe': {
	    'table': 'Use the dropdown to select a timeframe. If older data are not availale, the dropdown menu option will not appear.',
	    'graph': 'Use the dropdown menus to select a timeframe to graph.',
	    'map': 'Use the dropdown menu to select a timeframe.'
	  }
	};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	var path = 'directives/sidebarBlockHeader/sidebarBlockHeader.html';
	var html = "<div class=left-content-header-container><h1>{{ sidebarBlockHeader.name }}</h1><a href=# class=info-icon ng-mouseover=\"columnsTooltip = true\" ng-mouseleave=\"columnsTooltip = false\"><div class=kff-tooltip ng-show=columnsTooltip><p class=tt-inner><span>{{ sidebarBlockHeader.name }}</span> {{ sidebarBlockHeader.tooltips[sidebarBlockHeader.name][sidebarBlockHeader.view] }}</p></div></a></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {
	      rules: '=',
	      activeTab: '='
	    },
	    controller: function controller() {},
	    controllerAs: 'tabs',
	    bindToController: true,
	    templateUrl: _navTabs2.default
	  };
	};
	
	var _navTabs = __webpack_require__(182);
	
	var _navTabs2 = _interopRequireDefault(_navTabs);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	var path = 'directives/navTabs/navTabs.html';
	var html = "<li ng-class=\"{ active: !tabs.activeTab }\" rel=tab1><a href=\"\" id=table ui-sref=\"datacenter.main({ activeTab: undefined, startTimeframe: undefined })\">Table</a></li><li ng-class=\"{ active: tabs.activeTab === 'map' }\" ng-hide=\"tabs.rules.Map === false || tabs.rules.medicare\" rel=tab2><a href=\"\" id=map ui-sref=\"datacenter.main({ activeTab: 'map', startTimeframe: undefined })\">Map</a></li><li ng-class=\"{ active: tabs.activeTab === 'graph' }\" ng-hide=\"tabs.rules.Graph === false  || tabs.rules.medicare\" rel=tab3><a href=\"\" id=graph ui-sref=\"datacenter.main({ activeTab: 'graph' })\">Trend Graph</a></li>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {},
	    templateUrl: _linechart4.default,
	    templateNamespace: 'svg',
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: {
	      immutableData: '='
	    }
	  };
	};
	
	var _d = __webpack_require__(77);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _linechart = __webpack_require__(184);
	
	var _linechart2 = _interopRequireDefault(_linechart);
	
	var _linechart3 = __webpack_require__(185);
	
	var _linechart4 = _interopRequireDefault(_linechart3);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Controller.$inject = ['$scope', '$document', '$filter'];
	function Controller($scope, $document, $filter) {
	  this.options = _linechart2.default;
	  this.legend = {};
	  this.$document = $document;
	  this.$filter = $filter;
	
	  $scope.$watch(function (newval) {
	    return _mori2.default.hash(newval.vm.immutableData);
	  }, this.dataUpdated.bind(this));
	}
	
	Controller.prototype.dataUpdated = function () {
	  this.data = _mori2.default.toJs(this.immutableData);
	
	  if (this.data.length) {
	    this.count = this.data.length;
	
	    this.options = this.optionsFormatter();
	
	    // Show all series for legend.
	    // Filter for entirely empty series for chart
	    this.processedChartLegendData = this.setGraphColorShape(this.data);
	    this.processedGraphData = this.processedChartLegendData.filter(function (series) {
	      return series.values.filter(function (d) {
	        return d.y;
	      }).length;
	    });
	  }
	};
	
	/**
	 * Used to format the options with column definition
	 */
	Controller.prototype.optionsFormatter = function () {
	  var options = angular.copy(this.options);
	  options.chart.y = _linechart.chartY;
	
	  options.chart.forceY = [0, (0, _linechart.roundDown)(_d2.default.min(this.data, function (x) {
	    return _d2.default.min(x.values, function (value) {
	      return value.y;
	    });
	  })), (0, _linechart.roundUp)(_d2.default.max(this.data, function (x) {
	    return _d2.default.max(x.values, function (value) {
	      return value.y;
	    });
	  }))];
	
	  // Build unique array of all chart values
	  var allValues = this.data.reduce(function (acc, curr) {
	    return acc.concat(curr.values.reduce(function (acc1, curr1) {
	      return acc1.concat(curr1.y);
	    }, []));
	  }, []).filter(function (x) {
	    return x !== null;
	  });
	  var unique = allValues.reduce(function (acc, curr) {
	    return acc.indexOf(curr) > -1 ? acc : acc.concat(curr);
	  }, []);
	
	  options.chart.yAxis.ticks = unique.length - 1 < 10 ? unique.length - 1 : 10;
	  options.chart.yAxis.tickFormat = _linechart.yTickFormat.bind(this);
	  options.chart.xAxis.tickFormat = _linechart.xTickFormat.bind(this);
	  options.chart.tooltip.contentGenerator = _linechart.contentGenerator.bind(this);
	  options.chart.margin.left = this.yAxisWidth(this.$filter('filterSwitch')(options.chart.forceY[1], this.data[0].selectedHeader));
	
	  return options;
	};
	
	Controller.prototype.setGraphColorShape = function (graphData) {
	  var graphColors = ['#de5a02', '#f5cd34', '#2a91c2', '#63984f', '#6d3e8d', '#f27d00', '#99ae35', '#9d2d91', '#cf9c5b', '#009a9c', '#a64312', '#1e4784', '#62b36e', '#f09800', '#cc4e8f', '#75521c', '#bf1b00', '#514b9c', '#cbcd00', '#5e9cdb'];
	
	  var graphShapes = ['circle', 'square', 'triangle-down', 'diamond', 'triangle-up'];
	
	  var stateColor = (0, _util.modZip)((0, _util.pluck)(graphData, 'state'), graphColors);
	
	  var characteristicShape = (0, _util.modZip)((0, _util.pluck)(graphData, 'characteristic'), graphShapes);
	
	  return graphData.map(function (d) {
	    return angular.extend({}, d, {
	      color: stateColor[d.state],
	      shape: characteristicShape[d.characteristic],
	      values: d.values.map(function (value) {
	        return angular.extend({}, value, {
	          shape: characteristicShape[d.characteristic]
	        });
	      })
	    });
	  });
	};
	
	Controller.prototype.yAxisWidth = function (text) {
	  var font = 'normal 12px Arial';
	  // re-use canvas object for better performance
	  var canvas = this.yAxisWidth.canvas || (this.yAxisWidth.canvas = this.$document[0].createElement('canvas'));
	  var context = canvas.getContext('2d');
	  context.font = font;
	  var metrics = context.measureText(text);
	  return metrics.width > 25 ? 50 + metrics.width / 2 : 50;
	};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.xTickFormat = xTickFormat;
	exports.yTickFormat = yTickFormat;
	exports.chartY = chartY;
	exports.roundDown = roundDown;
	exports.roundUp = roundUp;
	exports.contentGenerator = contentGenerator;
	
	var _d = __webpack_require__(77);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _filters = __webpack_require__(107);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(10)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  filterSwitch = _filters2.default;
	}
	
	/**
	 * Rounds decimals to one order of significance by converting to int first.
	 *
	 * @param {string} numStr A string representing the right side of a floating
	 * point number
	 * @param {function} cb A Math function to do rounding
	 * @return {number} The rounded decimal
	 *
	 * @example
	 * // up or down
	 * '002167' -> .003 || .002
	 * '000628' -> .0007 || .0006
	 */
	function roundDecimal(numStr, direction) {
	  return roundInt(parseInt(numStr, 10), numStr, direction) / Math.pow(10, numStr.length);
	}
	
	/**
	 * Rounds integers to one order of significance.
	 *
	 * @param {number} num Integer to be rounded
	 * @param {string} numStr String used to calculate the exponential we need
	 * @param {function} cb A Math function to do rounding
	 * @return {number} The rounded integer
	 */
	function roundInt(num, numStr, direction) {
	  var roundingDigit = Math.pow(10, numStr.length - (num > 10 ? 2 : 1));
	  var round = Math[direction](num / roundingDigit) * roundingDigit;
	
	  // Add padding at the least significant digit, excluding cases where values
	  // have previously been rounded, or percentages (0, 100) that shouldn't
	  // be padded
	  if (num === round) {
	    var modifier = Math[direction](1 / roundingDigit) * roundingDigit;
	    var maxMultiplier = numStr.length > 1 ? Math.pow(10, numStr.length) : 1;
	    var modified = round + modifier * (direction === 'floor' ? -1 : 1);
	    if (modified < maxMultiplier && direction === 'ceil' || round !== 0 && direction === 'floor') {
	      return modified;
	    }
	  }
	  return round;
	}
	
	function xTickFormat(d) {
	  return this.data[0].tickValues[d];
	}
	
	function yTickFormat(d) {
	  return filterSwitch(d, this.data[0].selectedHeader);
	}
	
	function chartY(d) {
	  return d.y !== null ? d.y : undefined;
	}
	
	function roundDown(num) {
	  if (isNaN(num)) {
	    return num;
	  }
	
	  var floatPrecision = num.toString().split('.');
	  if (floatPrecision.length === 2 && +floatPrecision[0] > 10 || floatPrecision.length === 1) {
	    return roundInt(num, floatPrecision[0], 'floor');
	  }
	  return roundDecimal(floatPrecision[1], 'floor');
	}
	
	function roundUp(num) {
	  if (isNaN(num)) {
	    return num;
	  }
	
	  var floatPrecision = num.toString().split('.');
	  if (floatPrecision.length === 2 && +floatPrecision[0] > 10 || floatPrecision.length === 1) {
	    return roundInt(num, floatPrecision[0], 'ceil');
	  }
	  return roundDecimal(floatPrecision[1], 'ceil');
	}
	
	function contentGenerator(key) {
	  var y = this.data[0].tickValues[key.value];
	  var value = key.point.formatted === '' ? 0 : key.point.formatted;
	
	  return '\n    <p>' + key.series[0].key.split(' -').reverse().join(', ') + ': ' + value + '\n    <br />\n    ' + y + '</p>';
	}
	
	exports.default = {
	  chart: {
	    type: 'lineChart',
	    height: 375,
	    dispatch: {
	      renderEnd: function renderEnd() {
	        var pathsToRemove = [];
	        // This timeout is necessary to reliably get the DOM elements
	        // necessary to remove the null/NA values.  Without this,
	        // there are times where the chart SVG will not be ready, resulting
	        // in an empty set.
	        window.setTimeout(function () {
	          // Get the group element and how many points are on the line
	          var group = document.querySelector('.nv-scatter .nv-group') || {};
	          var pointsPerSeries = group.children ? group.children.length : 0;
	
	          // For every point, hide a point if it's y-value is null
	          // Then, push the index we removed to an array to use later...
	          _d2.default.selectAll('.nv-point').each(function (d) {
	            var pathIdx = d[0].series * pointsPerSeries + d[1];
	            if (d[0].y === null) {
	              pathsToRemove.push(pathIdx);
	              this.style.display = 'none';
	            }
	          });
	          // This timeout is necessary for when the window resizes.
	          // The paths we want to remove cause the tooltips to be displayed.
	          window.setTimeout(function () {
	            pathsToRemove.forEach(function (x) {
	              return _d2.default.select(document.getElementById('nv-path-' + x)).remove();
	            });
	          }, 100);
	        }, 0);
	      }
	    },
	    margin: {
	      top: 20,
	      right: 20,
	      bottom: 60,
	      left: 50
	    },
	    showValues: true,
	    showLegend: false,
	    valueFormat: function valueFormat(d) {
	      return _d2.default.format(',.4f')(d);
	    },
	    clipEdge: false,
	    tooltip: {
	      distance: '20',
	      gravity: 's',
	      chartContainer: null
	    },
	    transitionDuration: 500,
	    xAxis: {
	      showMinMax: true
	    },
	    yAxis: {
	      axisLabelDistance: 20,
	      tickPadding: 10,
	      ticks: 10
	    }
	  }
	};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	var path = 'directives/linechart/linechart.html';
	var html = "<div><nvd3 data=vm.processedGraphData options=vm.options></nvd3><chart-legend data=vm.processedChartLegendData count=\"{{ vm.count }}\"></chart-legend></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {
	      data: '=',
	      count: '@'
	    },
	    templateNamespace: 'svg',
	    link: Link
	  };
	};
	
	var _d = __webpack_require__(97);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Link(scope, element) {
	  scope.$watch(function () {
	    return scope.data;
	  }, function (data) {
	    if (!data) {
	      return;
	    }
	
	    var width = angular.element(element[0]).parent().width();
	    var options = {
	      width: width,
	      height: 30, // Default height of without multiple distributions
	      margin: {
	        bottom: 20,
	        top: 5,
	        right: 0,
	        left: 0
	      },
	      wrapper: 'svg',
	      top: 0,
	      left: 0,
	      isMap: false,
	      maxSplit: 4,
	      textPadding: {
	        top: 15,
	        left: 30
	      },
	      distributions: +scope.count,
	      rowSpacing: 10,
	      font: {
	        'font-size': '12px',
	        'font-weight': 'bold',
	        'font-family': 'Arial, Helvetica, sans-serif'
	      }
	    };
	
	    if (data) {
	      (0, _d2.default)(element[0], angular.copy(data), options);
	    }
	  }, true);
	}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: false,
	    controller: Controller
	  };
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _fileSaver = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO:  Revisit this to start with a Blob first - we may be able to avoid
	// using middleware to relay the dataURI back to the client
	
	/**
	 * Convert a data URI into a Blob
	 * @param  {dsataURI} string    data URI which needs conversion
	 * @return {Blob}
	 */
	/* eslint no-console: 0 */
	function dataURItoBlob(dataURI) {
	  // convert base64 to raw binary data held in a string
	  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	  var byteString = atob(dataURI.split(',')[1]);
	
	  // write the bytes of the string to an ArrayBuffer
	  var ab = new ArrayBuffer(byteString.length);
	  var ia = new Uint8Array(ab);
	  for (var i = 0; i < byteString.length; i++) {
	    ia[i] = byteString.charCodeAt(i);
	  }
	
	  // write the ArrayBuffer to a blob, and you're done
	  var bb = new Blob([ab]);
	  return bb;
	}
	
	Controller.$inject = ['$scope', '$document', '$window'];
	
	function Controller($scope, $document, $window) {
	  $scope.saveImage = saveImage;
	
	  var doc = $document[0];
	
	  var tabs = {
	    'table': function table() {
	      return;
	    },
	    'graph': function graph() {
	      var image = doc.getElementsByTagName('nvd3')[0].firstElementChild;
	      var legend = doc.getElementsByTagName('chart-legend')[0].firstElementChild;
	      _savePng('graph', image, legend);
	    },
	    'map': function map() {
	      var image = doc.getElementsByClassName('datamap')[0];
	      _savePng('map', image);
	    }
	  };
	
	  function saveImage() {
	    tabs[this.$parent.dc.router.currentParams.activeTab]();
	  }
	
	  // Searches all the stylesheets for styles that are needed,
	  // Also allows selector remapping
	  function _getStyles(el) {
	    var selectorRemap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var supressWarnings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    var css = '';
	    var sheets = doc.styleSheets;
	    for (var i = 0; i < sheets.length; i++) {
	      if (_isExternal(sheets[i].href)) {
	        if (!supressWarnings) {
	          console.warn('Cannot include styles from other hosts: ' + sheets[i].href);
	        }
	        continue;
	      }
	      var rules = sheets[i].cssRules;
	      if (rules !== null) {
	        for (var n = 0; n < rules.length; n++) {
	          var rule = rules[n];
	          if (typeof rule.style !== 'undefined') {
	            var match = null;
	            try {
	              match = el.querySelector(rule.selectorText);
	            } catch (err) {
	              if (!supressWarnings) {
	                console.warn('Invalid CSS selector "' + rule.selectorText + '": err');
	              }
	            }
	            if (match) {
	              var selector = selectorRemap ? selectorRemap(rule.selectorText) : rule.selectorText;
	              css += selector + ' {' + rule.style.cssText + '}';
	            } else if (rule.cssText.match(/^@font-face/)) {
	              css += rule.cssText + '\n';
	            }
	          }
	        }
	      }
	    }
	    return css;
	  }
	
	  // Grabbing and assembling the header's text
	  function _headerText() {
	    var indicatorName = angular.element('.headline-wrapper h2').html().replace('&nbsp;', ' '); // Just in case :-|
	    var state = $scope.$parent.dc.router.currentParams;
	    var immutableDistributions = $scope.$parent.dc.sheet.immutableDistributions;
	    var stateTimeframes = $scope.$parent.dc.sheet.timeframes;
	
	    var selected = (state.selectedDistributions || '').split('--').map(function (x) {
	      return _mori2.default.get(_mori2.default.first(_mori2.default.filter(function (item) {
	        return x === _mori2.default.get(item, 'slug');
	      }, immutableDistributions)), 'characteristic');
	    });
	
	    var firstTimeframe = state.activeTab === 'map' ? state.currentTimeframe : state.startTimeframe;
	    var timeframes = [stateTimeframes[firstTimeframe]];
	
	    if (state.activeTab === 'graph') {
	      timeframes.push(stateTimeframes[state.currentTimeframe]);
	    }
	
	    return [indicatorName + ':', '' + ((selected[0] || '').length ? selected.join(' & ') + ',' : ''), '' + timeframes.join(' - ')].join(' ');
	  }
	
	  // Checks if URL is external
	  function _isExternal(url) {
	    return url && url.lastIndexOf('http', 0) === 0 && url.lastIndexOf($window.location.host) === -1;
	  }
	
	  // Turns SVG -> Canvas and generates a click to download
	  function _savePng(type, svg, svg2) {
	    _svgAsDataUri(type, svg, svg2, function (url) {
	      (0, _fileSaver.saveAs)(dataURItoBlob(url), type + '.png');
	    });
	  }
	
	  function _svgAsDataUri(type, svg) {
	    var svg2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var callBack = arguments[3];
	
	    var xmlns = 'http://www.w3.org/2000/xmlns/';
	
	    var outer = doc.createElement('div');
	    var childrenWrapper = doc.createElement('g');
	    var clone = svg.cloneNode(true);
	    var width = svg.getBoundingClientRect().width;
	    var height = 50 + (!svg2 ? svg.getBoundingClientRect().height : svg.getBoundingClientRect().height + svg2.getBoundingClientRect().height);
	
	    // Wrap clone's children so we can bump them down for the header
	    _wrapAllElements(childrenWrapper, clone.childNodes);
	    childrenWrapper.setAttribute('transform', 'translate(0, 24)');
	
	    // If there is another SVG then drop it below the parent;
	    if (svg2) {
	      var clone2 = doc.createElement('g');
	      clone2.innerHTML = svg2.innerHTML;
	      clone2.setAttribute('transform', 'translate(5, ' + (svg.getBoundingClientRect().height + 16) + ')');
	      clone.appendChild(clone2);
	    }
	
	    // Drop in the header
	    var header = _text(12);
	    header.setAttribute('y', 20);
	
	    angular.element(header).text(_headerText());
	
	    clone.insertBefore(header, clone.firstChild);
	
	    // Drop in the footer
	    var footer = _text(10);
	    footer.setAttribute('y', height - 10);
	
	    // @TODO find where indicatorType is stored and use it
	    // const sourceType =
	    //   $scope.$parent.dc.initData.config.indicatorType === 'usa' ?
	    //   'State' :
	    //   'Global';
	    var sourceType = 'State';
	    angular.element(footer).text('SOURCE: KFF\'s ' + sourceType + ' Health Facts.');
	
	    clone.appendChild(footer);
	
	    // Do MISC styling and attribute setting needed
	    var bkgd = doc.createElement('rect');
	    bkgd.setAttribute('height', '100%');
	    bkgd.setAttribute('width', '100%');
	    bkgd.setAttribute('fill', '#fff');
	
	    clone.insertBefore(bkgd, clone.firstChild);
	
	    clone.setAttribute('version', '1.1');
	    clone.setAttributeNS(xmlns, 'xmlns', 'http://www.w3.org/2000/svg');
	    clone.setAttributeNS(xmlns, 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
	    clone.setAttribute('width', width);
	    clone.setAttribute('height', height);
	    clone.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
	    outer.appendChild(clone);
	
	    var style = doc.createElement('style');
	    var appliedStyles = void 0;
	
	    if (type === 'graph') {
	      appliedStyles = ['.legend-text {color: #000;} ', '.nv-point-paths path {', 'stroke: #aaa; stroke-opacity: 0;', 'fill: #eee; fill-opacity: 0;}'].join('');
	    } else if (type === 'map') {
	      appliedStyles = [].join('');
	    }
	
	    var css = doc.createTextNode(_getStyles(svg) + appliedStyles);
	    style.setAttribute('type', 'text/css');
	    style.appendChild(css);
	    var defs = doc.createElement('defs');
	    defs.appendChild(style);
	    clone.insertBefore(defs, clone.firstChild);
	
	    var doctype = ['<?xml version="1.0" standalone="no"?>', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN"', ' "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">'].join('');
	    var svgText = doctype + outer.innerHTML;
	    // const svgBlob = new Blob([svgText],
	    //   { type: 'image/svg+xml;charset=utf-8' }
	    // );
	
	    var xhr = new XMLHttpRequest();
	    xhr.open('POST', 'https://kff-svg-png-api.herokuapp.com/api/convert', true);
	    xhr.setRequestHeader('Content-Type', 'text/html');
	    xhr.setRequestHeader('height', height);
	    xhr.setRequestHeader('width', width);
	    xhr.onload = function () {
	      if (callBack) {
	        callBack(this.responseText);
	      }
	    };
	    xhr.send(svgText);
	  }
	
	  // Creates and sets default styles for basic <text>
	  function _text(fontSize) {
	    var text = doc.createElement('text');
	    text.setAttribute('height', '12');
	    text.setAttribute('style', ['font-size: ' + fontSize + 'px', 'font-family: Arial, Helvetica, sans-serif', 'font-weight: bold', 'fill: #000'].join(';'));
	    text.setAttribute('x', '5');
	    return text;
	  }
	}
	
	/**
	 * Wraps a list of elmeents with another element
	 * @param  {HTMLNode} wrapper   item that will become wrapper
	 * @param  {Array} elms         Array if HTMLNodes that will be wrapped
	 * @return {NULL}
	 */
	function _wrapAllElements(wrapper, elms) {
	  var el = elms.length ? elms[0] : elms;
	
	  // Cache curr Parent & first sibling
	  var parent = el.parentNode;
	
	  wrapper.appendChild(el);
	
	  while (elms.length) {
	    wrapper.appendChild(elms[0]);
	  }
	
	  parent.appendChild(wrapper);
	}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {},
	    templateUrl: _footnotes2.default,
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: {
	      data: '=',
	      geomulti: '='
	    }
	  };
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _footnotes = __webpack_require__(189);
	
	var _footnotes2 = _interopRequireDefault(_footnotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Controller.$inject = ['$scope'];
	function Controller($scope) {
	  var _this = this;
	
	  $scope.$watch(function () {
	    return _mori2.default.hash(_this.data);
	  }, function () {
	    _this.footnotes = _mori2.default.toJs(_this.data) || [];
	  });
	}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	var path = 'directives/footnotes/footnotes.html';
	var html = "<div class=\"box full-post\" ng-if=vm.footnotes.length ng-class=\"{ geomulti: vm.geomulti }\"><h5>Footnotes</h5><ol><li ng-repeat=\"note in vm.footnotes track by $index\" ng-attr-id=\"{{ 'note-' + note.id }}\" ng-bind-html=\"note.note | markdown\" ng-attr-data-list-character=\"{{ note.label }}\"></li></ol></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    scope: {},
	    templateUrl: _notes2.default,
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: {
	      data: '='
	    }
	  };
	};
	
	var _mori = __webpack_require__(72);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _notes = __webpack_require__(191);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Controller.$inject = ['$scope'];
	function Controller($scope) {
	  var _this = this;
	
	  $scope.$watch(function () {
	    return _mori2.default.hash(_this.data);
	  }, function () {
	    return _this.notes = _mori2.default.toJs(_this.data);
	  });
	}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	var path = 'directives/notes/notes.html';
	var html = "<div class=\"box full-post datacenter-notes\" ng-if=vm.notes><div class=accordion-wrapper><dl class=accordionShow><dt><a href=\"\"><h5>NOTES</h5></a><a href=\"\" class=\"plus-btn active\"></a></dt><dd id=notes><div ng-repeat=\"(key, group) in vm.notes\"><h6 ng-if=group.val.length>{{ group.name }}</h6><p ng-repeat=\"note in group.val\" ng-bind-html=\"note.Note | markdown\"></p></div></dd></dl></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	
	/**
	 * Object().assign() polyfill for IE11
	 */
	if (typeof Object.assign != 'function') {
	  (function () {
	    Object.assign = function (target) {
	      'use strict';
	
	      if (target === undefined || target === null) {
	        throw new TypeError('Cannot convert undefined or null to object');
	      }
	
	      var output = Object(target);
	      for (var index = 1; index < arguments.length; index++) {
	        var source = arguments[index];
	        if (source !== undefined && source !== null) {
	          for (var nextKey in source) {
	            if (source.hasOwnProperty(nextKey)) {
	              output[nextKey] = source[nextKey];
	            }
	          }
	        }
	      }
	      return output;
	    };
	  })();
	}
	
	/**
	 * Array().fill polyfill for IE11
	 */
	if (!Array.prototype.fill) {
	  Array.prototype.fill = function (value) {
	    // Steps 1-2.
	    if (this === null) {
	      throw new TypeError('this is null or not defined');
	    }
	
	    var O = Object(this);
	
	    // Steps 3-5.
	    var len = O.length >>> 0;
	
	    // Steps 6-7.
	    var start = arguments[1];
	    var relativeStart = start >> 0;
	
	    // Step 8.
	    var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
	
	    // Steps 9-10.
	    var end = arguments[2];
	    var relativeEnd = end === undefined ? len : end >> 0;
	
	    // Step 11.
	    var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
	
	    // Step 12.
	    while (k < final) {
	      O[k] = value;
	      k++;
	    }
	
	    // Step 13.
	    return O;
	  };
	}
	
	/**
	 * CustomEvent() polyfill for IE9+
	 */
	if (typeof window.CustomEvent !== "function") {
	  var CustomEvent = function CustomEvent(event, params) {
	    params = params || { bubbles: false, cancelable: false, detail: undefined };
	    var evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	    return evt;
	  };
	
	  CustomEvent.prototype = window.Event.prototype;
	  window.CustomEvent = CustomEvent;
	}

/***/ })
]);


// WEBPACK FOOTER //
// datacenter-2.0.88.bundle.js